webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTopLevelRoute", function() { return getTopLevelRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryWithoutFilters", function() { return queryWithoutFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeFiltersParams", function() { return activeFiltersParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseLocation", function() { return parseLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sanitizeQueries", function() { return sanitizeQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlattenQuery", function() { return getFlattenQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlattenLocation", function() { return getFlattenLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeLink", function() { return makeLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultSortParamForQuery", function() { return defaultSortParamForQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOptionsArrayFromQueryString", function() { return getOptionsArrayFromQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryStringFromOptionsArray", function() { return getQueryStringFromOptionsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryWithoutParam", function() { return getQueryWithoutParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryWithoutOption", function() { return getQueryWithoutOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryWithoutCategory", function() { return getQueryWithoutCategory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_sites__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_searchQueryWhitelist__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_filterParamsConfig__ = __webpack_require__(16);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/**
 * check the top level pathname
 * /category/wordpress -> category
 * /search?category=wordpress -> search
 * /tags/clean -> tags
 * @param  {String} pathname
 * @return {String} top level route name
 */
var getTopLevelRoute = function getTopLevelRoute() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

  return pathname.split('/').slice(1, 2).join('');
};

var QUERY_KEYS_TO_LOWERCASE = ['category', 'tags', 'term', 'attribute_key', 'attribute_value'];

var queryWithoutFilters = function queryWithoutFilters(location) {
  var query = parseLocation(location);
  var filterParamsKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_filterParamsConfig__["default"]);

  return getQueryWithoutParam(query, filterParamsKeys);
};

var activeFiltersParams = function activeFiltersParams(location) {
  var query = parseLocation(location);
  var filterParamsKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_filterParamsConfig__["default"]);
  var paramsList = Object.keys(query);

  return filterParamsKeys.filter(function (param) {
    return paramsList.includes(param);
  });
};

var slugifyQueries = function slugifyQueries(queries) {
  return Object.keys(queries).reduce(function (result, key) {
    if (queries[key]) {
      var slugifiedValue = queries[key].toString();
      if (QUERY_KEYS_TO_LOWERCASE.includes(key)) {
        slugifiedValue = slugifiedValue.toLowerCase();
      }
      if (__WEBPACK_IMPORTED_MODULE_4__constants_searchQueryWhitelist__["searchFrontendParamsSeoTransform"].includes(key)) {
        slugifiedValue = slugifiedValue.replace(/_/g, '-');
      }
      var decodedValue = null;
      try {
        decodedValue = decodeURI(slugifiedValue);
      } catch (e) {
        decodedValue = slugifiedValue;
      }
      result[key] = decodedValue;
    }
    return result;
  }, {});
};

/**
 * a function to parse current location to a query object
 * it should handle all possible url
 * /search?category=wordpress
 * /search?category=wordpres,site-template
 * /search?tags=clean&category=wordpress&sales=rank-3
 * /category/wordpress
 * /category/wordpress/ecomerce
 * /tags/clean
 * /tags/clean,modern
 * /attributes/themeforest-files-included/css-files
 * /attributes/compatible-software/Wordpress 4.5.2
 * @param {Object} The location object from react-router
 * {
 *   pathname: '/',
 *   query: {
 *     term: 'cat'
 *   }
 * }
 * @return {Object} a object of all the seach queries
 */
var parseLocation = function parseLocation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === undefined ? '/search' : _ref$pathname,
      _ref$query = _ref.query,
      query = _ref$query === undefined ? {} : _ref$query;

  var categoryPageRegex = /\/(category)\/+/g;
  var tagsPageRegex = /\/(tags)\/+/g;
  var attributesPageRegex = /\/(attributes)\/+/g;
  var searchPageRegex = /\/(search)\/*/g;

  var topLevelRoute = getTopLevelRoute(pathname);

  // the last win if there are same queries in the url
  var sortedQuery = Object.keys(query).filter(function (param) {
    return query[param] !== null && query[param] !== '';
  }).reduce(function (prev, curr) {
    if (Array.isArray(query[curr])) {
      // colors=red&colors=yellow -> colors=red,yellow
      prev[curr] = query[curr].join(',');
    } else {
      prev[curr] = query[curr];
    }
    return prev;
  }, {});

  var queries = void 0;
  switch (topLevelRoute) {
    case 'category':
      {
        var categoryName = pathname.replace(categoryPageRegex, '');
        queries = Object.assign({}, sortedQuery, {
          category: categoryName
        });
        // when the category is equal to `all` from the url
        // it's passing empty string to search sortedQuery
        if (categoryName === '' || categoryName === 'all') {
          delete queries.category;
        }
        break;
      }

    case 'tags':
      queries = Object.assign({}, sortedQuery, {
        tags: pathname.replace(tagsPageRegex, '')
      });
      break;
    case 'attributes':
      {
        var attributes = pathname.replace(attributesPageRegex, '');
        queries = Object.assign({}, sortedQuery, {
          attribute_key: attributes.split('/')[0],
          attribute_value: attributes.split('/')[1] || ''
        });
        break;
      }

    case 'search':
      {
        var newTerm = sortedQuery.term || pathname.replace(searchPageRegex, '');
        queries = Object.assign({}, sortedQuery, { term: newTerm });
        break;
      }

    default:
      queries = Object.assign({}, sortedQuery);
  }

  var slugifiedQueries = slugifyQueries(queries);

  var sortOption = slugifiedQueries.sort;

  if (sortOption) {
    // in the url we only store the sort filter as `search?sort=trending'
    // but in public-search api it matches to `sort_by` and `sort_direction`
    // so whenever we match `sort` from the url, we have to parse it to
    // `sort_by` and `sort_direction` so we could fetch the correct result
    // this is also used in rendering the selected filters
    if (sortOption.indexOf('price-') >= 0) {
      slugifiedQueries = Object.assign({}, slugifiedQueries, {
        sort_direction: sortOption.split('-')[1],
        sort_by: 'price'
      });
    } else {
      slugifiedQueries = Object.assign({}, slugifiedQueries, {
        sort_by: sortOption
      });
    }
    delete slugifiedQueries.sort;

    /**
     * We should only keep valid sort by options so the server does not
     * throw error
     */
    if (__WEBPACK_IMPORTED_MODULE_4__constants_searchQueryWhitelist__["validSortByOptions"].indexOf(slugifiedQueries.sort_by) === -1) {
      delete slugifiedQueries.sort_by;
    }
  }

  return slugifiedQueries;
};

/**
 * Sanitize queries object by removing params with no value (empty string).
 * @param {Object} queries object
 * @returns {Object} new queries object
 */

var sanitizeQueries = function sanitizeQueries(queries) {
  return Object.keys(queries).reduce(function (prev, curr) {
    if (queries[curr] !== '') {
      prev[curr] = queries[curr];
    }
    return prev;
  }, {});
};

/**
 * Make a copy of the location object which pick the last option if it's an array
 * @param query
 * @returns {*}
 */
var getFlattenQuery = function getFlattenQuery(query) {
  return Object.keys(query).reduce(function (prev, curr) {
    if (Array.isArray(query[curr])) {
      var arrayLength = query[curr].length;
      prev[curr] = query[curr][arrayLength - 1];
    } else {
      prev[curr] = query[curr];
    }
    return prev;
  }, {});
};

var getFlattenLocation = function getFlattenLocation(location) {
  var flattenQuery = getFlattenQuery(location.query);
  var flattenLocation = _extends({}, location, {
    query: flattenQuery
  });
  return flattenLocation;
};

/**
 * Return the most SEO friendly URL
 * prioritise order category > tags > attributes > search queries
 * @param  {Object} queries object
 * @return {String} a SEO friendly URL
 */
var makeLink = function makeLink() {
  var queries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentSite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'defaults';

  var url = '';
  var newQueries = sanitizeQueries(queries);

  /*
    We should not allow to show search results for pages greater than 60 because of the performance.
    So the purpose of this is to set a limit to being able to browser by the user maximum 60 pages.
   */
  if (newQueries.page && Number(newQueries.page) > __WEBPACK_IMPORTED_MODULE_3__config_sites__["default"].defaults.common.max_pages_count) {
    newQueries.page = __WEBPACK_IMPORTED_MODULE_3__config_sites__["default"].defaults.common.max_pages_count;
  }

  /**
   * re-direct colours to color
   */
  if (newQueries.colours) {
    newQueries.colors = newQueries.colours;
    delete newQueries.colours;
  }

  // revert the process of decode sort_by value
  // when there's sort_by or sort_direction
  // we convert them to sort='price-desc'
  if (newQueries.sort_by) {
    if (newQueries.sort_by === 'price' && newQueries.sort_direction) {
      newQueries = Object.assign({}, newQueries, {
        sort: 'price-' + newQueries.sort_direction
      });
      delete newQueries.sort_direction;
    } else {
      newQueries = Object.assign({}, newQueries, {
        sort: newQueries.sort_by
      });
    }
    delete newQueries.sort_by;
  }

  var defaultSortParam = defaultSortParamForQuery(newQueries, currentSite);
  // we don't want default value in the url
  if (newQueries.sort && newQueries.sort === defaultSortParam) {
    delete newQueries.sort;
  }

  if (queries.category) {
    // create a new copy of the current queries object
    var categories = queries.category;
    delete newQueries.category;
    var queriesString = getQueryString(newQueries);
    url = '/category/' + categories + queriesString;
    // if the queries has tags, go to tags page
  } else if (queries.tags) {
    // create a new copy of the current queries object
    var tags = queries.tags;
    delete newQueries.tags;
    var _queriesString = getQueryString(newQueries);
    url = '/tags/' + tags + _queriesString;
    // if the queries has attributes, go to attributes
  } else if (queries.attribute_key && queries.attribute_value) {
    // create a new copy of the current queries object
    var attribute_key = queries.attribute_key; // eslint-disable-line
    var attribute_value = queries.attribute_value; // eslint-disable-line
    delete newQueries.attribute_key;
    delete newQueries.attribute_value;
    var _queriesString2 = getQueryString(newQueries);
    url = '/attributes/' + attribute_key + '/' + attribute_value + _queriesString2; // eslint-disable-line
    // if the query has a term go to the search term page
  } else if (queries.term) {
    var term = queries.term;
    delete newQueries.term;
    var _queriesString3 = getQueryString(newQueries);
    url = '/search/' + term + _queriesString3;
    // else just to go search result page
  } else {
    var _queriesString4 = getQueryString(newQueries);
    url = _queriesString4 === '' ? '/category/all' : '/search' + _queriesString4;
  }
  return encodeURI(url);
};

var getQueryString = function getQueryString(queries) {
  var string = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(queries, { encode: false });
  return string ? '?' + string : '';
};

var defaultSortParamForQuery = function defaultSortParamForQuery(query) {
  var currentSite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'defaults';

  return __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(query.term) ? Object(__WEBPACK_IMPORTED_MODULE_3__config_sites__["getConfigBySite"])(currentSite, 'search_query.defalut_sort_by') : 'relevance';
};

/**
 * get option array from query string
 * @param  {String} option string a,b,c
 * @return {Array} [a, b, c]
 */
var getOptionsArrayFromQueryString = function getOptionsArrayFromQueryString() {
  var optionsString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof optionsString !== 'string') throw new Error('tags should be a string.');
  return optionsString ? optionsString.split(',') : [];
};

/**
 * get option string from query array
 * @param  {Array} option array [a, b, c]
 * @return {String} a,b,c
 */
var getQueryStringFromOptionsArray = function getQueryStringFromOptionsArray() {
  var optionsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!Array.isArray(optionsArray)) throw new Error('tags array should be an array.');
  return optionsArray.join(',');
};

/**
 * Returns query without specified param
 * @param {Object} query
 * @param {String|Array} paramNames
 * @returns {Object}
 */
var getQueryWithoutParam = function getQueryWithoutParam(query, paramNames) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(query, paramNames);
};

/**
 * Returns query without specified option within the query param.
 * Eg. getQueryWithoutOption({t1: 'ab,cd,ef'}, 't1', 'cd') -> {t1: 'ab,ef'}
 * @param {Object} query
 * @param {String} paramName
 * @param {String} optionName
 * @returns {Object}
 */
var getQueryWithoutOption = function getQueryWithoutOption(query, paramName, optionName) {
  var nextQuery = _extends({}, query);
  var options = getOptionsArrayFromQueryString(query[paramName]);
  options = options.filter(function (option) {
    return option !== optionName;
  });
  if (options.length === 0) {
    delete nextQuery[paramName];
  } else {
    nextQuery[paramName] = getQueryStringFromOptionsArray(options);
  }
  return nextQuery;
};

/**
 * Remove specific category and all its subcategories form a category query param
 * @param {Object} query
 * @param {String} paramName
 * @param {String} categoryName
 * @returns {Object}
 */
var getQueryWithoutCategory = function getQueryWithoutCategory(query, paramName, categoryName) {
  var nextQuery = _extends({}, query);
  var categories = nextQuery[paramName].split('/');
  categories = categories.slice(0, categories.indexOf(categoryName));

  if (categories.length === 0) {
    delete nextQuery[paramName];
  } else {
    nextQuery[paramName] = categories.join('/');
  }

  return nextQuery;
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/error/typed.js
var typed = __webpack_require__(396);
var typed_default = /*#__PURE__*/__webpack_require__.n(typed);

// EXTERNAL MODULE: ./node_modules/rollbar/dist/rollbar.umd.min.js
var rollbar_umd_min = __webpack_require__(397);
var rollbar_umd_min_default = /*#__PURE__*/__webpack_require__.n(rollbar_umd_min);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./common/config.ts
var config = __webpack_require__(12);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./common/utils/envHelper.js
var envHelper = __webpack_require__(69);

// CONCATENATED MODULE: ./common/utils/rollbar/ignoredMessages.js
/* harmony default export */ var ignoredMessages = ([
// This error comes from some terrible Norton browser extension. Nope.
'Error calling method on NPObject.',

// NFI. File "(unknown)" line (unknown) in [anonymous] -- not helpful
'Script error.',

// these errors indicate the user has flakey internet. We don't need to be told about that.
'Bad request (Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.)', 'Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc. (Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.)', 'Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.', 'ServiceUnavailableError',

// Firefox error, not helpful 'Exception... "<no message>" nsresult: "0x805e0006 (<unknown>)" location: "JS frame'
// seems to be related to web sockets, happens only for some users, not able to reproduce: https://bugzilla.mozilla.org/show_bug.cgi?id=977020
'NS_ERROR_NOT_CONNECTED', 'NS_ERROR_UNEXPECTED']);
// CONCATENATED MODULE: ./common/utils/rollbar/checkIgnore.js


var ignoredErrorsRegexList = [
// Seems to be chrome bug, happening only on iphone or ipad - https://bugs.chromium.org/p/chromium/issues/detail?id=590375
/__gCrWeb\.autofill\.extractForms/,

// https://github.com/getsentry/raven-js/issues/756
/null is not an object \(evaluating 'elt.parentNode'\)/,

// And this is the kind of crap that makes GTM a horrible idea. Who know's where this came from? it's not our code :/
/SecurityError \(DOM Exception 18\): Blocked a frame with origin/,

// ios safari in private browsing mode causes a storm of errors (many/most of which trace back to the history package we have no control over)
/QuotaExceededError \(DOM Exception 22\)/,

// Appears to be malware
// Stacktrace originates from https://pstatic.bestpriceninja.com/nwp/v0_0_1143/release/Shared/App/SharedApp.js
/t.exec\(\.\.\.\) is null/,

// happens when the user enters and leaves a page with braintree hosted fields before the bt js loads
/FormNapper requires an HTMLFormElement/];

/* harmony default export */ var checkIgnore = (function (isUncaught, args, payload) {
  try {
    if (isUncaught) {
      var errorDescription = Object(lodash["get"])(payload, 'body.trace.exception.description');
      var errorMessage = Object(lodash["get"])(payload, 'body.trace.exception.message');
      return ignoredErrorsRegexList.some(function (regex) {
        return regex.test(errorDescription) || regex.test(errorMessage);
      });
    }
  } catch (e) {
    // noop
  }

  return false;
});
// EXTERNAL MODULE: ./node_modules/titleize/index.js
var titleize = __webpack_require__(27);
var titleize_default = /*#__PURE__*/__webpack_require__.n(titleize);

// CONCATENATED MODULE: ./common/utils/rollbar/transformer.js



/* harmony default export */ var transformer = (function (payload) {
  if (payload.level === 'error' || payload.level === 'critical' || payload.level === 'warning') {
    var exception = Object(lodash["get"])(payload, 'body.trace.exception') || Object(lodash["get"])(payload, 'body.trace_chain.0.exception.description');
    if (!exception) return null;

    var errorClass = exception.class || '';
    var errorDescription = exception.description || exception.message || '';
    var hashBase = '[' + titleize_default()(payload.level) + '] ' + errorClass + ' ' + errorDescription;

    payload.fingerprint = hashBase;
  }
});
// EXTERNAL MODULE: ./common/constants/siteList.js
var siteList = __webpack_require__(114);

// CONCATENATED MODULE: ./common/utils/rollbar/index.js










var rollbarClientSideToken = Object(lodash["get"])(config["config"], 'analytics.rollbar.CLIENT_SIDE_TOKEN');

if (Object(envHelper["isProduction"])() && !rollbarClientSideToken) {
  throw new Error('No rollbar token configured.');
}

var rollbar_payload = {
  environment: 'shopfront-' + "production"

  // Setup for rollbar sourcemap
  // this `GIT_COMMIT_SHA` is generated from `webpack.client.config.js`
  // and defined from DefinePlugin
  // eslint-disable-next-line
};if (true) {
  rollbar_payload.client = {
    javascript: {
      source_map_enabled: true,
      code_version: "a7084c186dcd303a1d378900fe97b4e0ec2e666c", // eslint-disable-line
      guess_uncaught_frames: true
    }
  };
}

var rollbar = new rollbar_umd_min_default.a({
  enabled: Object(envHelper["isProduction"])() || Object(envHelper["isDevelopment"])(),
  accessToken: rollbarClientSideToken,
  verbose: Object(envHelper["isDevelopment"])(),
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: rollbar_payload,
  ignoredMessages: ignoredMessages,
  checkIgnore: checkIgnore,
  transform: transformer,
  hostWhiteList: siteList["a" /* allDomains */]
});

if (Object(envHelper["hasWindow"])()) {
  rollbar.global({
    itemsPerMinute: 30,
    maxItems: 10
  });
}

/* harmony default export */ var utils_rollbar = (rollbar);
// EXTERNAL MODULE: ./node_modules/lodash/isError.js
var isError = __webpack_require__(398);
var isError_default = /*#__PURE__*/__webpack_require__.n(isError);

// CONCATENATED MODULE: ./common/utils/errors.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UndefinedError", function() { return UndefinedError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotAnError", function() { return NotAnError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponseDataError", function() { return ResponseDataError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchOfflineError", function() { return SearchOfflineError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LandingPageNoContentError", function() { return LandingPageNoContentError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LandingPageUnpublishedError", function() { return LandingPageUnpublishedError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetadataGenerationError", function() { return MetadataGenerationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetadataGenerationWarning", function() { return MetadataGenerationWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AxiosNetworkError", function() { return AxiosNetworkError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AxiosTimeoutError", function() { return AxiosTimeoutError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AxiosError", function() { return AxiosError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebSocketError", function() { return WebSocketError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logError", function() { return errors_logError; });




var UndefinedError = typed_default()({
  type: 'undefined',
  message: 'Exception or rejection value was null or undefined'
});

var NotAnError = typed_default()({
  type: 'not-an-error',
  message: 'Exception or rejection value was not an error object',
  value: null
});

var ResponseDataError = typed_default()({
  type: 'response-data-error',
  message: 'response data error'
});

var SearchOfflineError = typed_default()({
  type: 'search.offline',
  message: 'HTTP {statusCode} error, search offline',
  level: 'critical',
  statusCode: null
});

var LandingPageNoContentError = typed_default()({
  type: 'landing-page.no-content',
  level: 'warning',
  statusCode: 404,
  message: 'Content does not exist for landing page'
});

var LandingPageUnpublishedError = typed_default()({
  type: 'landing-page.unpublished',
  level: 'warning',
  statusCode: 404,
  message: 'Landing page is unpublished'
});

var MetadataGenerationError = typed_default()({
  type: 'metadata',
  title: 'Metadata',
  message: '{title}: {origMessage}'
});

var MetadataGenerationWarning = typed_default()({
  type: 'metadata',
  title: 'Metadata',
  message: '{title}: {origMessage}',
  level: 'warning'
});

var AxiosNetworkError = typed_default()({
  type: 'axios.network',
  level: 'warning',
  message: 'Network Error'
});

var AxiosTimeoutError = typed_default()({
  type: 'axios.timeout',
  message: 'Request [{endpoint}] timed out',
  level: 'warning',
  endpoint: '',
  url: '',
  statusCode: null,
  code: null
});

var AxiosError = typed_default()({
  type: 'axios',
  message: 'Request [{endpoint}] failed with status code {statusCode}',
  endpoint: '',
  url: '',
  httpMethod: '',
  statusCode: null,
  statusText: '',
  responseData: null
});

var WebSocketError = typed_default()({
  type: 'websocket',
  message: 'websocket error'
});

/**
 * Log error to rollbar
 * @param {Error} error
 */
var errors_logError = function logError(error) {
  if (isError_default()(error)) {
    var level = [400, 401].includes(error.statusCode) ? 'warning' : error.level;
    if (utils_rollbar[level]) {
      utils_rollbar[level](error.message, error);
    } else {
      utils_rollbar.error(error.message, error);
    }

    return error;
  } else {
    if (error) {
      return logError(NotAnError({ value: error }));
    } else {
      return logError(UndefinedError());
    }
  }
};

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./config/sites/3docean.js
/* harmony default export */ var _docean = ({
  name: '3DOcean',
  abbreviation: '3D',
  domain: '3docean.net',
  google_analytics_id: 'UA-11834194-2',
  google_remarketing_label: '24jqCK2CugMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'eg. low poly building',
  filters: {
    aggregations: {
      poly_count: {
        min: 4000,
        max: 10000,
        avg: 5000
      }
    }
  },
  assets_domains: {
    item_thumbnail: 'thumb-3do.s3.envato.com',
    item_image: 'image-3do.s3.envato.com'
  },
  feeds_categories: ['/category/3d-models', '/category/cg-textures', '/category/materials-and-shaders', '/category/scripts-and-plugins', '/category/2d-concepts', '/category/animation-data', '/category/render-setups']
});
// CONCATENATED MODULE: ./config/sites/audiojungle.js
/* harmony default export */ var audiojungle = ({
  name: 'AudioJungle',
  abbreviation: 'AJ',
  domain: 'audiojungle.net',
  google_analytics_id: 'UA-11834194-4',
  google_remarketing_label: 'SQ7NCLWBugMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'eg. ambient music',
  assets_domains: {
    item_thumbnail: 'thumb-aj.s3.envato.com',
    item_image: 'image-aj.s3.envato.com'
  },
  feeds_categories: ['/category/music', '/category/music-packs', '/category/music-kits', '/category/sound', '/category/source-files', '/category/logos-idents']
});
// CONCATENATED MODULE: ./config/sites/codecanyon.js
/* harmony default export */ var codecanyon = ({
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'eg. ecommerce plugin',
  assets_domains: {
    item_thumbnail: 'thumb-cc.s3.envato.com',
    item_image: 'image-cc.s3.envato.com'
  },
  feeds_categories: ['/category/javascript', '/category/php-scripts', '/category/net', '/category/wordpress', '/category/plugins', '/category/css', '/category/html5', '/category/mobile', '/category/apps', '/category/skins', '/category/edge-animate-templates']
});
// CONCATENATED MODULE: ./config/sites/graphicriver.js
/* harmony default export */ var graphicriver = ({
  name: 'GraphicRiver',
  abbreviation: 'GR',
  domain: 'graphicriver.net',
  google_analytics_id: 'UA-11834194-6',
  google_remarketing_label: 'hJ8ZCL2AugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'eg. brochure template',
  assets_domains: {
    item_thumbnail: 'thumb-gr.s3.envato.com',
    item_image: 'image-gr.s3.envato.com'
  },
  feeds_categories: ['/category/graphics', '/category/print-templates', '/category/epublishing', '/category/textures', '/category/vectors', '/category/infographics', '/category/add-ons', '/category/isolated-objects', '/category/icons', '/category/presentation-templates', '/category/fonts', '/category/web-elements', '/category/logo-templates', '/category/t-shirts', '/category/game-assets']
});
// CONCATENATED MODULE: ./config/sites/photodune.js
/* harmony default export */ var photodune = ({
  name: 'PhotoDune',
  abbreviation: 'PD',
  domain: 'photodune.net',
  google_analytics_id: 'UA-11834194-35',
  google_remarketing_label: 'rsMOCJ2EugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'eg. animals',
  ui: {
    item_list_views: [{
      value: 'grid',
      label: 'Grid'
    }]
  },
  assets_domains: {
    item_thumbnail: 'thumb-pd.s3.envato.com',
    item_image: 'image-pd.s3.envato.com'
  },
  asset_type: 'stock photo',
  search_query: {
    defalut_sort_by: 'trending'
  },
  item_view: {
    footer_link: {
      label: 'Similar images',
      href: '/search?item_id={id}'
    }
  },
  hide_sidebar_by_default: true
});
// CONCATENATED MODULE: ./config/sites/themeforest.js
/* harmony default export */ var themeforest = ({
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'eg. responsive wordpress',
  assets_domains: {
    item_thumbnail: 'thumb-tf.s3.envato.com',
    item_image: 'image-tf.s3.envato.com'
  },
  feeds_categories: ['/category/wordpress', '/category/site-templates', '/category/marketing', '/category/cms-themes', '/category/ecommerce', '/category/muse-templates', '/category/sketch-templates', '/category/psd-templates', '/category/blogging', '/category/courses', '/category/forums', '/category/typeengine-themes']
});
// CONCATENATED MODULE: ./config/sites/videohive.js
/* harmony default export */ var videohive = ({
  name: 'VideoHive',
  abbreviation: 'VH',
  domain: 'videohive.net',
  google_analytics_id: 'UA-11834194-8',
  google_remarketing_label: 'NrSdCMX_uQMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'eg. photo slideshow',
  assets_domains: {
    item_thumbnail: 'thumb-vh.s3.envato.com',
    item_image: 'image-vh.s3.envato.com'
  },
  feeds_categories: ['/category/after-effects-project-files', '/category/apple-motion-templates', '/category/motion-graphics', '/category/stock-footage', '/category/cinema-4d-templates', '/category/add-ons']
});
// EXTERNAL MODULE: ./config/sites/defaults.js
var defaults = __webpack_require__(100);

// CONCATENATED MODULE: ./config/sites/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getConfigBySite", function() { return sites_getConfigBySite; });











var configs = {
  '3docean': _docean,
  audiojungle: audiojungle,
  codecanyon: codecanyon,
  graphicriver: graphicriver,
  photodune: photodune,
  themeforest: themeforest,
  videohive: videohive,
  defaults: defaults["a" /* default */]

  /**
   * Returns specific site config property value with fallback to default one
   * @param currentSite {String}
   * @param configPath {String}
   * @returns {*}
   */
};var sites_getConfigBySite = function getConfigBySite(currentSite, configPath) {
  return Object(lodash["get"])(configs[currentSite], configPath) || Object(lodash["get"])(configs.defaults, configPath);
};

/* harmony default export */ var sites = __webpack_exports__["default"] = (configs);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors__ = __webpack_require__(113);



var axiosVerbose = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  timeout: 10000
});

axiosVerbose.interceptors.response.use(undefined, __WEBPACK_IMPORTED_MODULE_1__interceptors__["b" /* timeoutRetryRejectionInterceptor */]);
axiosVerbose.interceptors.response.use(undefined, __WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* betterErrorsRejectionInterceptor */]);

/* harmony default export */ __webpack_exports__["default"] = (axiosVerbose);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Expose a single entry point where both the client and server can use
 */
exports.config = {
    analytics: {
        affiliate: {
            MARKETPLACE_URL: "https://marketplace.envato.com"
        },
        intercom: {
            APP_ID: "s9exa3j0",
            SECRET: process.env.INTERCOM_SECRET
        },
        newrelic: {
            ENABLED: process.env.NEW_RELIC_ENABLED,
            LICENSE_KEY: process.env.NEW_RELIC_LICENSE_KEY
        },
        rollbar: {
            CLIENT_SIDE_TOKEN: "8146d878f4df4242ae6deb8d3d79b6a4",
            SERVER_SIDE_TOKEN: process.env.ROLLBAR_SERVER_SIDE_TOKEN
        }
    },
    assets: {
        PUBLIC_PATH: "https://assets.shopfront.envato-static.com"
    },
    cache: {
        DISABLE_CACHE: process.env.DISABLE_CACHE
    },
    cors: {
        WHITELIST: process.env.CORS_WHITELIST
            ? (process.env.CORS_WHITELIST || '').split(',')
            : []
    },
    datadog: {
        HOST: process.env.DATADOG_HOST || 'localhost',
        PORT: process.env.DATADOG_PORT || '8125'
    },
    db: {
        REDIS_URL: process.env.REDIS_URL
    },
    discoveryUser: {
        PUBLIC_SEARCH_API_URL: process.env.PUBLIC_SEARCH_API_URL,
        RECOMMENDATION_API_URL: process.env.RECOMMENDATION_API_URL
    },
    eventsApi: {
        URL: "https://events-api.shopfront.envato.com/api"
    },
    experimentsApi: {
        URL: "https://marketplace.envato.com"
    },
    jwt: {
        PUBLIC_KEY: process.env.JWT_PUBLIC_KEY,
        WEBSITES_MARKETPLACE_PUBLIC_KEY: process.env.WEBSITES_MARKETPLACE_PUBLIC_KEY
    },
    marketplaceApi: {
        SECRET: process.env.X_ENVATO_SECRET,
        URL: process.env.MARKETPLACE_API_URL
    },
    sso: {
        API_KEY: process.env.SSO_API_KEY,
        RECAPTCHA_KEY: "6LcigAcTAAAAAAruaW_goIkW3FD2oZR40YqDXgcB",
        SERVER_HOST: "https://account.envato.com"
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var ga = function ga() {
  if (typeof window !== 'undefined' && typeof window.ga == 'function') {
    var _window;

    (_window = window).ga.apply(_window, arguments);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (ga);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "commaStyleString", function() { return commaStyleString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toTitle", function() { return toTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "centlessFormat", function() { return centlessFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPriceVariation", function() { return getPriceVariation; });
/**
 * A util function to convert numbers to more comma style format
 * e.g. `12342353` => `12,342,353`
 * e.g. `123` => `123`
 * e.g. `12` => `12`
 * @param  {String} string or number
 * @return {string} formatted string
 */
var commaStyleString = function commaStyleString(number, separator) {
  separator = typeof separator === 'undefined' ? ',' : '' + separator;

  // Convert to number if it's a non-numeric value
  if (typeof number !== 'number') {
    number = Number(number);
  }

  // NaN => 0
  if (isNaN(number)) {
    number = 0;
  }

  // Return Infinity immediately
  if (!isFinite(number)) {
    return '' + number;
  }

  var stringNumber = ('' + Math.abs(number)).split('').reverse();

  var result = [];
  for (var i = 0; i < stringNumber.length; i++) {
    if (i && i % 3 === 0) {
      result.push(separator);
    }
    result.push(stringNumber[i]);
  }

  // Handle negative numbers
  if (number < 0) {
    result.push('-');
  }

  return result.reverse().join('');
};

/**
 * Convert key-text to be more attractive as a title
 * eg. 'blog-magazine' => 'Blog Magazine'
 *     'blog magazine' => 'Blog Magazine'
 * @param {String} text
 * @returns {String}
 */
var toTitle = function toTitle(key) {
  return key.split(/-|_/).join(' ').replace(/\b\w/g, function (l) {
    return l.toUpperCase();
  });
};

/**
 * $10.00 should be $10
 * $10.15 should be $10.15
 */
var centlessFormat = function centlessFormat(data) {
  var absValue = Math.abs(data);
  var isInt = function isInt(n) {
    return n % 1 === 0;
  };
  return isInt(absValue) ? parseInt(absValue) : absValue.toFixed(2);
};

/**
 * get price variation
 * $12.12 - $5.00
 * should return a centless formatted value
 */
var getPriceVariation = function getPriceVariation(currentPrice, upgradePrice) {
  var intPrice = function intPrice(priceString) {
    return parseFloat(priceString.replace('$', ''));
  };
  var variation = intPrice(upgradePrice) - intPrice(currentPrice);
  if (variation === 0) return '';
  var variationType = variation > 0 ? '+' : '-';
  return variationType + '$' + centlessFormat(variation);
};

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./client/components/icons/folder.js
var folder = __webpack_require__(147);

// EXTERNAL MODULE: ./client/components/icons/tag.js
var tag = __webpack_require__(148);

// EXTERNAL MODULE: ./client/components/icons/dollar.js
var dollar = __webpack_require__(149);

// EXTERNAL MODULE: ./client/components/icons/clock.js
var clock = __webpack_require__(88);

// EXTERNAL MODULE: ./client/components/icons/barChart.js
var barChart = __webpack_require__(45);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-icon-base/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./client/components/icons/star.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var star = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Star' },
      props.title || 'Star'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M256.3 402.4l-157 93.2 40.2-178.1-137.2-120.5 181.8-16.9 72.2-167.7 72.2 167.7 181.8 16.9-137.1 120.5 40.1 178.1z' })
    )
  );
});
// EXTERNAL MODULE: ./client/components/icons/sort.js
var sort = __webpack_require__(150);

// EXTERNAL MODULE: ./client/components/icons/calendar.js
var calendar = __webpack_require__(151);

// CONCATENATED MODULE: ./client/components/icons/host.js
var host__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var host = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    host__extends({ viewBox: '0 0 100 100' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Host' },
      props.title || 'Host'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement(
        'g',
        null,
        react_default.a.createElement('path', { d: 'M91.7,38.3l-80.7,0c-2.6,0 -4.7,2.1 -4.7,4.7l0,15.6c0,2.6 2.1,4.7 4.7,4.7l80.6,0c2.6,0 4.7,-2.1 4.7,-4.7l0,-15.6c0,-2.6 -2.1,-4.7 -4.6,-4.7ZM26.7,52.3c0,0.7 -0.6,1.2 -1.2,1.2l-2.5,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l2.5,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5ZM36.6,52.3c0,0.7 -0.6,1.2 -1.2,1.2l-2.5,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l2.5,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5ZM81.7,52.3c0,0.7 -0.6,1.2 -1.2,1.2l-17.7,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l17.6,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5l0.1,0Z' }),
        react_default.a.createElement('path', { d: 'M91.7,68.8l-80.7,0c-2.6,0 -4.7,2.1 -4.7,4.7l0,15.6c0,2.6 2.1,4.7 4.7,4.7l80.6,0c2.6,0 4.7,-2.1 4.7,-4.7l0,-15.6c0,-2.6 -2.1,-4.7 -4.6,-4.7ZM26.7,82.8c0,0.7 -0.6,1.2 -1.2,1.2l-2.5,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l2.5,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5ZM36.6,82.8c0,0.7 -0.6,1.2 -1.2,1.2l-2.5,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l2.5,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5ZM81.7,82.8c0,0.7 -0.6,1.2 -1.2,1.2l-17.7,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l17.6,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5l0.1,0Z' }),
        react_default.a.createElement('path', { d: 'M91.7,7.8l-80.7,0c-2.6,0 -4.7,2.1 -4.7,4.7l0,15.6c0,2.6 2.1,4.7 4.7,4.7l80.6,0c2.6,0 4.7,-2.1 4.7,-4.7l0,-15.6c0,-2.6 -2.1,-4.7 -4.6,-4.7ZM26.7,21.8c0,0.7 -0.6,1.2 -1.2,1.2l-2.5,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l2.5,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5ZM36.6,21.8c0,0.7 -0.6,1.2 -1.2,1.2l-2.5,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l2.5,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5ZM81.7,21.8c0,0.7 -0.6,1.2 -1.2,1.2l-17.7,0c-0.7,0 -1.2,-0.6 -1.2,-1.2l0,-2.5c0,-0.7 0.6,-1.3 1.2,-1.3l17.6,0c0.7,0 1.2,0.6 1.2,1.3l0,2.5l0.1,0Z' })
      )
    )
  );
});
// EXTERNAL MODULE: ./client/components/icons/code.js
var code = __webpack_require__(103);

// EXTERNAL MODULE: ./client/components/icons/polygon.js
var polygon = __webpack_require__(152);

// CONCATENATED MODULE: ./client/components/icons/frameRotated.js
var frameRotated__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var frameRotated = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    frameRotated__extends({ viewBox: '0 0 100 100' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Frame-Rotated' },
      props.title || 'Frame-Rotated'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M83.203 33.262l3.872 9.348h3.578l-.002 36.817H61.913L39.337 88.78H100V33.26zM0 38.235l67.02-27.76 21.24 51.29-67.014 27.76L0 38.236zM26.305 77.31l49.74-20.602L61.96 22.69 12.215 43.293l14.09 34.016z' })
    )
  );
});
// EXTERNAL MODULE: ./client/components/icons/palette.js
var palette = __webpack_require__(153);

// EXTERNAL MODULE: ./client/components/icons/ruler.js
var ruler = __webpack_require__(154);

// EXTERNAL MODULE: ./client/components/icons/tempo.js
var tempo = __webpack_require__(118);

// EXTERNAL MODULE: ./client/components/icons/vocals.js
var vocals = __webpack_require__(155);

// CONCATENATED MODULE: ./client/components/icons/tv.js
var tv__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var tv = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    tv__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Tv' },
      props.title || 'Tv'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M488 145.6c-44.8-6.4-91.2-11.2-140.8-14.4l83.2-83.2-32-32-112 112h-32l-128-128-32 32 97.6 97.6c-60.8 1.6-118.4 8-171.2 14.4-14.4 54.4-20.8 113.6-20.8 176 0 62.4 8 121.6 20.8 176 72 9.6 150.4 16 235.2 16 84.8 0 163.2-6.4 235.2-16 14.4-54.4 20.8-113.6 20.8-176 0-62.4-11.2-120-24-174.4zm-59.2 292.8c-54.4 6.4-113.6 11.2-176 11.2-62.4 0-121.6-3.2-176-11.2-9.6-35.2-16-75.2-16-116.8 0-41.6 6.4-81.6 16-116.8 54.4-6.4 113.6-11.2 176-11.2 62.4 0 121.6 3.2 176 11.2 9.6 35.2 16 75.2 16 116.8 0 41.6-6.4 81.6-16 116.8z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/film.js
var film__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var film = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    film__extends({ viewBox: '0 0 513 473' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Film' },
      props.title || 'Film'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M477.8.2v49.1h-55v-49.1h-34.8v72.1h-263.2v-72.1h-34.7v49.1h-54.8v-49.1h-34.8v472h34.8v-49.6h54.8v49.6h34.7v-71.6h263.2v71.6h34.8v-49.6h55v49.6h34.7v-472h-34.7zm-387.7 395.8h-54.8v-49.6h54.8v49.6zm0-83.1h-54.8v-49.1h54.8v49.1zm0-91.4h-54.8v-49.1h54.8v49.1zm0-92.3h-54.8v-49.1h54.8v49.1zm34.7 217.2v-217.2h263.2v217.2h-263.2zm353 49.6h-55v-49.6h55v49.6zm0-83.1h-55v-49.1h55v49.1zm0-91.4h-55v-49.1h55v49.1zm0-92.3h-55v-49.1h55v49.1z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/plug.js
var plug__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var plug = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    plug__extends({ viewBox: '0 0 24 24' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Plug' },
      props.title || 'Plug'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M22.69 5.86c.32.32.48.7.48 1.16 0 .46-.16.85-.48 1.18l-5.18 5.17 1.94 1.94-2.07 2.07c-1.41 1.4-3.09 2.21-5.04 2.41-1.95.2-3.72-.23-5.32-1.3l-4.68 4.68h-2.34v-2.34l4.68-4.68c-1.07-1.6-1.5-3.37-1.3-5.32.2-1.95 1.01-3.63 2.41-5.04l2.07-2.07 1.94 1.94 5.17-5.18c.33-.32.72-.48 1.18-.48.46 0 .84.16 1.16.48.32.32.48.71.48 1.17 0 .46-.16.85-.48 1.17l-5.17 5.18 3.03 3.03 5.18-5.17c.33-.32.72-.48 1.18-.48.46 0 .84.16 1.16.48z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/alpha.js
var alpha__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var alpha = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    alpha__extends({ viewBox: '0 0 28 28' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Alpha' },
      props.title || 'Alpha'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M0 14q0-3.3 1.6-6t4.4-4.4 6-1.6 6 1.6 4.4 4.4 1.6 6-1.6 6-4.4 4.4-6 1.6-6-1.6-4.4-4.4-1.6-6zm3.5 0q0 2.3 1.1 4.3t3.1 3.1 4.3 1.1v-17q-2.3 0-4.3 1.1t-3.1 3.1-1.1 4.3z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/looped.js
var looped__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var looped = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    looped__extends({ viewBox: '0 0 100 100' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Looped' },
      props.title || 'Looped'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M58.9 9.6l-1.8 11.1c14 2.3 24.8 14.4 24.8 29.1 0 16.3-13.2 29.5-29.5 29.5s-29.5-13.3-29.5-29.6c0-4.6 1-8.9 2.9-12.7l9.8 9.8 6.2-35.1-34.9 6.4 10.6 10.6c-3.7 6.1-5.8 13.3-5.8 21 0 22.5 18.2 40.7 40.7 40.7 22.5 0 40.7-18.2 40.7-40.7 0-20.2-14.8-37-34.2-40.1z' })
    )
  );
});
// EXTERNAL MODULE: ./client/components/icons/cog.js
var cog = __webpack_require__(119);

// EXTERNAL MODULE: ./client/components/icons/document.js
var icons_document = __webpack_require__(156);

// CONCATENATED MODULE: ./common/constants/filterParamsConfig.js
























/* harmony default export */ var filterParamsConfig = __webpack_exports__["default"] = ({
  category: {
    isMultiple: true,
    delimiter: '/',
    icon: folder["a" /* default */],
    order: 0
  },
  tags: {
    isMultiple: true,
    delimiter: ',',
    icon: tag["a" /* default */],
    order: 1
  },
  price_min: {
    inRangeWith: { max: 'price_max' },
    icon: dollar["a" /* default */],
    label: 'At least',
    format: function format(value) {
      return '$' + value;
    },
    order: 2
  },
  price_max: {
    inRangeWith: { min: 'price_min' },
    icon: dollar["a" /* default */],
    label: 'At most',
    format: function format(value) {
      return '$' + value;
    },
    order: 3
  },
  length_min: {
    inRangeWith: { max: 'length_max' },
    icon: clock["a" /* default */],
    label: 'At least'
  },
  length_max: {
    inRangeWith: { min: 'length_min' },
    icon: clock["a" /* default */],
    label: 'At most'
  },
  sales: {
    isMultiple: true,
    delimiter: ',',
    icon: barChart["a" /* default */],
    labels: {
      'rank-0': 'No sales',
      'rank-1': 'Low',
      'rank-2': 'Medium',
      'rank-3': 'High',
      'rank-4': 'Top Sellers'
    },
    order: 4
  },
  rating_min: {
    isMultiple: false,
    icon: star,
    labels: {
      '': 'Show All',
      '1': '1 star and higher',
      '2': '2 stars and higher',
      '3': '3 stars and higher',
      '4': '4 stars and higher'
    },
    order: 5
  },
  sort_by: {
    isMultiple: false,
    icon: sort["a" /* default */],
    labels: {
      relevance: 'Best match',
      trending: 'Trending items',
      sales: 'Best sellers',
      rating: 'Best rated',
      date: 'Newest items',
      'price-asc': 'Price: low to high',
      'price-desc': 'Price: high to low'
    },
    order: 6
  },
  date: {
    isMultiple: false,
    icon: calendar["a" /* default */],
    labels: {
      '': 'Any date',
      'this-year': 'In the last year',
      'this-month': 'In the last month',
      'this-week': 'In the last week',
      'this-day': 'In the last day'
    },
    order: 7
  },
  hosting_setup: {
    isMultiple: false,
    isBoolean: true,
    icon: host,
    labels: {
      1: 'Hosting & Setup'
    },
    order: 8
  },
  platform: {
    isMultiple: false,
    icon: code["a" /* default */],
    delimiter: ' ',
    order: 9
  },
  compatible_with: {
    isMultiple: true,
    delimiter: ',',
    icon: code["a" /* default */],
    order: 10
  },
  attribute_value: {
    isMultiple: false,
    icon: cog["a" /* default */],
    order: 11
  },
  poly_count: {
    isMultiple: false,
    icon: polygon["a" /* default */],
    order: 12
  },
  file_formats: {
    isMultiple: true,
    isArrayFormat: true,
    delimiter: ',',
    icon: icons_document["a" /* default */],
    order: 13,
    labels: {
      obj: '.obj (multi format)',
      fbx: '.fbx (multi format)',
      max: '.max (3ds Max)',
      c4d: '.c4d (cinema 4d)',
      ma: '.ma (maya)',
      blend: '.blend (blender)',
      '3ds': '.3ds (multi format)',
      mb: '.mb (maya)',
      lwo: '.lwo (lightwave)',
      dxf: '.dxf (multi format)',
      dwg: '.dwg (AutoCAD)',
      lws: '.lws (lightwave)',
      '3b': '.3b (3dcoat)',
      unitypackage: '.unitypackage (Unity3D)',
      vob: '.vob (Vue)',
      vue: '.vue (Vue)',
      ztl: '.ztl (zbrush)',
      xsi: '.xsi (softimage)'
    }
  },
  orientation: {
    isMultiple: false,
    icon: frameRotated,
    labels: {
      '': 'Show All',
      landscape: 'Landscape',
      portrait: 'Portrait',
      square: 'Square'
    },
    order: 14
  },
  colors: {
    isMultiple: true,
    delimiter: ',',
    icon: palette["a" /* default */],
    order: 15
  },
  sizes: {
    isMultiple: true,
    delimiter: ',',
    icon: ruler["a" /* default */],
    labels: {
      m: 'Medium',
      l: 'Large',
      xl: 'Extra large',
      xxl: 'Extra extra large'
    },
    order: 16
  },
  vocals_in_audio: {
    isMultiple: true,
    delimiter: ',',
    icon: vocals["a" /* default */]
  },
  tempo: {
    isMultiple: false,
    icon: tempo["a" /* default */],
    labels: {
      'very-slow': 'Very slow (0 - 60 BPM)',
      slow: 'Slow (60 - 90 BPM)',
      medium: 'Medium (90 - 110 BPM)',
      upbeat: 'Upbeat (110 - 140 BPM)',
      fast: 'Fast (140 - 160 BPM)',
      'very-fast': 'Very fast (160+ BPM)'
    }
  },
  resolution_min: {
    isMultiple: false,
    icon: tv,
    labels: {
      '720p': '720p (HD)',
      '1080p': '1080p (Full HD)',
      '2K': '2K',
      '4K': '4K (UHD)'
    }
  },
  frame_rate: {
    isMultiple: false,
    icon: film,
    format: function format(value) {
      return value + ' fps';
    }
  },
  requires_plugins: {
    isMultiple: false,
    icon: plug,
    labels: {
      F: 'No',
      T: 'Yes'
    }
  },
  alpha: {
    isMultiple: false,
    isBoolean: true,
    icon: alpha,
    labels: {
      1: 'Alpha channel'
    }
  },
  looped: {
    isMultiple: false,
    isBoolean: true,
    icon: looped,
    labels: {
      1: 'Looped'
    }
  }
});

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeModal", function() { return closeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openModal", function() { return openModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showModalMessage", function() { return showModalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dismissModalMessage", function() { return dismissModalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleOffCanvas", function() { return toggleOffCanvas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "togglePanel", function() { return togglePanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectItem", function() { return selectItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectItemAction", function() { return selectItemAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOffsetTop", function() { return setOffsetTop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__searchPage__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__searchPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__searchPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetchSimilarItems__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetchSimilarItems___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fetchSimilarItems__);



var closeModal = function closeModal() {
  return {
    type: 'closeModal'
  };
};

var openModal = function openModal(data) {
  return {
    type: 'openModal',
    payload: data
  };
};

var showModalMessage = function showModalMessage(data) {
  return {
    type: 'showModalMessage',
    payload: data
  };
};

var dismissModalMessage = function dismissModalMessage() {
  return {
    type: 'dismissModalMessage'
  };
};

var toggleOffCanvas = function toggleOffCanvas(direction) {
  return {
    type: 'toggleOffCanvas',
    payload: direction
  };
};

var togglePanel = function togglePanel(panelId) {
  return {
    type: 'togglePanel',
    payload: panelId
  };
};

var toggleSidebar = function toggleSidebar() {
  return {
    type: 'toggleSidebar'
  };
};

var selectItem = function selectItem(itemId) {
  return function (dispatch, getState) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__searchPage__["fetchItemLicenses"])(itemId));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__fetchSimilarItems__["fetchSimilarItems"])(itemId));
    return dispatch(selectItemAction(itemId));
  };
};

var selectItemAction = function selectItemAction(itemId) {
  return {
    type: 'selectItem',
    payload: itemId
  };
};

var setOffsetTop = function setOffsetTop(offsetTop) {
  return {
    type: 'offsetTop',
    payload: { offsetTop: offsetTop }
  };
};

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var querystring = __webpack_require__(22);
var studio_recommendations_1 = __webpack_require__(225);
var common_1 = __webpack_require__(37);
var fetchRecommendedSearchesByCategoryResults_1 = __webpack_require__(240);
var fetchRecommendedSearchesByTermResults_1 = __webpack_require__(248);
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
var getProxyApiUrl_1 = __webpack_require__(70);
var searchQueryHelper_1 = __webpack_require__(249);
var urlHelper_1 = __webpack_require__(5);
var setStudioRecommendations_1 = __webpack_require__(251);
var itemMatrix_1 = __webpack_require__(120);
var TypeKeys;
(function (TypeKeys) {
    TypeKeys["GET_SEARCH_RESULTS_REQUEST"] = "GET_SEARCH_RESULTS_REQUEST";
    TypeKeys["GET_SEARCH_RESULTS_SUCCESS"] = "GET_SEARCH_RESULTS_SUCCESS";
    TypeKeys["GET_SEARCH_RESULTS_FAIL"] = "GET_SEARCH_RESULTS_FAIL";
    TypeKeys["GET_INGESTED_CONTENT_SUCCESS"] = "GET_INGESTED_CONTENT_SUCCESS";
    TypeKeys["SET_SEARCH_HEADINGS"] = "SET_SEARCH_HEADINGS";
    TypeKeys["SET_ACTIVE_AUDIO"] = "SET_ACTIVE_AUDIO";
    TypeKeys["SET_HOSTING_SETUP_SEARCH"] = "SET_HOSTING_SETUP_SEARCH";
    TypeKeys["SET_STUDIO_RECOMMENDATIONS"] = "SET_STUDIO_RECOMMENDATIONS";
    TypeKeys["GET_ITEM_LICENCES_SUCCESS"] = "GET_ITEM_LICENCES_SUCCESS";
    TypeKeys["GET_ITEM_LICENCES_FAIL"] = "GET_ITEM_LICENCES_FAIL";
    TypeKeys["GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_REQUEST"] = "GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_REQUEST";
    TypeKeys["GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_SUCCESS"] = "GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_SUCCESS";
    TypeKeys["GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_FAIL"] = "GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_FAIL";
    TypeKeys["GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_SUCCESS"] = "GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_SUCCESS";
    TypeKeys["GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_FAIL"] = "GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_FAIL";
    TypeKeys["GET_SIMILAR_ITEMS_SUCCESS"] = "GET_SIMILAR_ITEMS_SUCCESS";
    TypeKeys["GET_SIMILAR_ITEMS_FAIL"] = "GET_SIMILAR_ITEMS_FAIL";
})(TypeKeys = exports.TypeKeys || (exports.TypeKeys = {}));
var fetchSearchResults = function (parsedUrl, opts) {
    return function (dispatch, getState) {
        var parsedLocation = urlHelper_1.parseLocation({
            pathname: parsedUrl.pathname,
            query: querystring.parse(parsedUrl.search)
        });
        var currentSite = lodash_1.get(getState(), 'common.currentSite') || 'themeforest';
        var apiUrlPrefix = getProxyApiUrl_1.default(opts);
        var searchStringQuery = searchQueryHelper_1.buildSearchQueryString(parsedLocation, currentSite);
        var hasItemId = parsedLocation.item_id;
        var hasSearchTerm = parsedLocation.term;
        var searchUrl = hasItemId
            ? apiUrlPrefix + "/shopfront_api/search/similar?" + searchStringQuery
            : apiUrlPrefix + "/shopfront_api/search?" + searchStringQuery;
        dispatch(fetchSearchResultsRequest());
        if (hasSearchTerm && !hasItemId) {
            dispatch(fetchRecommendedSearchesByTermResults_1.default(parsedLocation.term, {
                apiUrlPrefix: apiUrlPrefix
            }));
        }
        return axiosVerbose_1.default
            .get(searchUrl)
            .then(function (res) {
            if (res.data && res.data.matches) {
                if (res.data.metadata) {
                    if (typeof document !== 'undefined') {
                        document.title = res.data.metadata.title;
                    }
                    dispatch(setSearchHeadings(res.data.metadata));
                    dispatch(common_1.setSeoMeta(res.data.metadata));
                }
                dispatch(fetchSearchResultsSuccess(res.data));
                dispatch(fetchIngestedContentSuccess(res.data.searchIngestedContent));
                dispatch(setStudioRecommendations_1.default(studio_recommendations_1.default[currentSite] || {}));
                dispatch(exports.setHostingSetupSearch(parsedLocation));
                // process other types of recommendations if term is not present
                if (searchQueryHelper_1.isCategoryOnlySearch(parsedLocation)) {
                    dispatch(fetchRecommendedSearchesByCategoryResults_1.default(parsedLocation, res.data, currentSite));
                }
            }
            else {
                throw errors_1.ResponseDataError({ response: res });
            }
        })
            .catch(function (err) {
            var isSearchOffline = [422, 500, 502, 503].includes(err.statusCode);
            if (isSearchOffline) {
                throw errors_1.SearchOfflineError({
                    statusCode: err.statusCode,
                    message: "HTTP " + err.statusCode + ". " + err.message,
                    responseData: err.responseData
                });
            }
            throw err;
        })
            .catch(function (err) { return Promise.reject(errors_1.logError(err)); })
            .catch(function (err) {
            return Promise.reject(dispatch(fetchSearchResultsFailure(err)));
        });
    };
};
/**
 * Search result actions
 */
var fetchSearchResultsRequest = function () {
    var action = {
        type: TypeKeys.GET_SEARCH_RESULTS_REQUEST
    };
    return action;
};
var fetchSearchResultsSuccess = function (results) {
    var action = {
        type: TypeKeys.GET_SEARCH_RESULTS_SUCCESS,
        payload: { results: results }
    };
    return action;
};
var fetchSearchResultsFailure = function (error) {
    return function (dispatch) {
        var timeout = false;
        dispatch(common_1.noIndex());
        if (error.type === 'search.offline') {
            dispatch(common_1.setErrorPage('SearchOffline'));
        }
        else {
            if (error.type === 'axios.timeout') {
                timeout = true;
            }
            dispatch(common_1.showAlert(error.message, 'failure', false));
        }
        var action = {
            type: TypeKeys.GET_SEARCH_RESULTS_FAIL,
            error: true,
            httpStatus: 500,
            timeout: timeout
        };
        return dispatch(action);
    };
};
/**
 * IngestedContentSuccess
 */
var fetchIngestedContentSuccess = function (content) {
    var action = {
        type: TypeKeys.GET_INGESTED_CONTENT_SUCCESS,
        payload: { content: content }
    };
    return action;
};
/**
 * Search headings
 */
var setSearchHeadings = function (_a) {
    var heading = _a.heading, sub_heading = _a.sub_heading, fine_print = _a.fine_print;
    var action = {
        type: TypeKeys.SET_SEARCH_HEADINGS,
        payload: {
            heading: heading,
            sub_heading: sub_heading,
            fine_print: fine_print
        }
    };
    return action;
};
exports.setActiveAudio = function (activeAudio) {
    var action = {
        type: TypeKeys.SET_ACTIVE_AUDIO,
        payload: { activeAudio: activeAudio }
    };
    return action;
};
exports.setHostingSetupSearch = function (parsedLocation) {
    var action = {
        type: TypeKeys.SET_HOSTING_SETUP_SEARCH,
        payload: { hostingSetupSearch: parsedLocation.hosting_setup === '1' }
    };
    return action;
};
/**
 * Search item licenses
 */
exports.fetchItemLicenses = function (itemID) {
    return function (dispatch, getState) {
        var licenses = lodash_1.get(getState(), 'searchPage.licenses');
        var errorOccured = !!(licenses[itemID] && licenses[itemID].error);
        if (!licenses[itemID] || errorOccured) {
            return itemMatrix_1.getItemMatrix(itemID)
                .then(function (licensesData) {
                return dispatch(fetchItemLicensesSuccess({ itemID: itemID, licenses: licensesData }));
            })
                .catch(function (error) {
                return dispatch(fetchItemLicensesFailure(itemID, error.message));
            });
        }
        else {
            return Promise.resolve(dispatch(fetchItemLicensesSuccess({ itemID: itemID, licenses: licenses[itemID] })));
        }
    };
};
var fetchItemLicensesSuccess = function (_a) {
    var itemID = _a.itemID, licenses = _a.licenses;
    var action = {
        type: TypeKeys.GET_ITEM_LICENCES_SUCCESS,
        payload: { itemID: itemID, licenses: licenses }
    };
    return action;
};
var fetchItemLicensesFailure = function (itemID, error) {
    var action = {
        type: TypeKeys.GET_ITEM_LICENCES_FAIL,
        payload: { itemID: itemID, error: error }
    };
    return action;
};
exports.default = fetchSearchResults;


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentSiteDomain", function() { return getCurrentSiteDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInSitesList", function() { return isInSitesList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__envHelper__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_siteList__ = __webpack_require__(114);



var getCurrentSiteDomain = function getCurrentSiteDomain(currentSite) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__envHelper__["isDevelopment"])()) {
    return currentSite + '.test';
  } else {
    return currentSite + '.net';
  }
};

var isInSitesList = function isInSitesList(host) {
  return __WEBPACK_IMPORTED_MODULE_1__constants_siteList__["a" /* allDomains */].indexOf(host) !== -1;
};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSearchResultMatchesEqual", function() { return isSearchResultMatchesEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterSortByOptions", function() { return filterSortByOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemAttribute", function() { return getItemAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemDecorator", function() { return itemDecorator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sites__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics_resultAnalytics__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics_resultAnalytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__analytics_resultAnalytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__urlHelper__ = __webpack_require__(5);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var isSearchResultMatchesEqual = function isSearchResultMatchesEqual(mainMatches, comparingMatches) {
  var hasSameLength = mainMatches.length === comparingMatches.length;
  if (!hasSameLength) {
    return false;
  }
  var comparisonResults = mainMatches.map(function (item, index) {
    return item && comparingMatches && item.id === comparingMatches[index].id;
  }).every(function (isIdEqual) {
    return isIdEqual;
  });

  return comparisonResults;
};

// https://github.com/envato/foundation-docs/blob/master/docs/shopfront_special_ui_rules.md
var filterSortByOptions = function filterSortByOptions(currentSite, parsedLocation, options) {
  var filteredOptions = [].concat(_toConsumableArray(options));
  // no ratings for photodune
  if (currentSite === 'photodune') {
    filteredOptions = filteredOptions.filter(function (options) {
      return options.value !== 'rating';
    });
  }

  // no `Best Match` if there's no search term
  if (!parsedLocation.term) {
    filteredOptions = filteredOptions.filter(function (options) {
      return options.value !== 'relevance';
    });
  }
  return filteredOptions;
};

var getItemAttribute = function getItemAttribute(item, name) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(item.attributes.find(function (attribute) {
    return attribute.name === name;
  }), 'value');
};

var itemDecorator = function itemDecorator(currentSite, openModal, signedOut, favoriteCollectionID, collections, deleteBookmark, addBookmark, createFavoriteCollection, itemRankOffset, cartItems, location) {
  return function (item, index) {
    var isInFavourites = item.ui.isInFavourites;


    var rank = index + itemRankOffset;
    var topLevelRoute = Object(__WEBPACK_IMPORTED_MODULE_4__urlHelper__["getTopLevelRoute"])(location.pathname);
    var reportProductClickHandler = __WEBPACK_IMPORTED_MODULE_2__analytics_resultAnalytics__["reportProductClick"].bind(null, item, rank, currentSite, topLevelRoute);
    var reportProductAddToCartAttemptHandler = __WEBPACK_IMPORTED_MODULE_2__analytics_resultAnalytics__["reportProductAddToCartAttempt"].bind(null, item, rank, currentSite, topLevelRoute);

    var onAddToFavourites = function onAddToFavourites(event) {
      event.preventDefault();
      if (signedOut) {
        window.location = '//' + Object(__WEBPACK_IMPORTED_MODULE_1__sites__["getCurrentSiteDomain"])(currentSite) + '/sign_in?action_name=favorite&resource_id=' + item.id + '&return_to=' + window.location.pathname + window.location.search;
      } else {
        // check whether user has favorite collection
        if (favoriteCollectionID) {
          if (isInFavourites) {
            var bookmark = collections[favoriteCollectionID].bookmarks[item.id];
            if (bookmark.id && bookmark.optimisticStatus !== 'pending') {
              var isFavouriteCollection = true;
              deleteBookmark(favoriteCollectionID, item.id, bookmark.id, isFavouriteCollection);
            }
          } else {
            var _isFavouriteCollection = true;
            addBookmark(favoriteCollectionID, item.id, _isFavouriteCollection);
          }
        } else {
          createFavoriteCollection().then(function (action) {
            if (action && action.type === 'createCollectionSuccess') {
              var newCollectionId = action.payload.id;
              // this is used for ga tracking so we know it's add to favourite collection
              var _isFavouriteCollection2 = true;
              return addBookmark(newCollectionId, item.id, _isFavouriteCollection2);
            }
          }).catch(__WEBPACK_IMPORTED_MODULE_3__errors__["logError"]);
        }
      }
    };

    var onAddToCollections = function onAddToCollections(event) {
      event.preventDefault();
      if (signedOut) {
        window.location = '//' + Object(__WEBPACK_IMPORTED_MODULE_1__sites__["getCurrentSiteDomain"])(currentSite) + '/sign_in?action_name=collection&resource_id=' + item.id + '&return_to=' + window.location.pathname + window.location.search;
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2__analytics_resultAnalytics__["reportModalPageView"])({
          title: 'Modal: Add item to collection',
          page: window.location.pathname + '/add-item-to-collection' + window.location.search
        });
        openModal({
          type: 'addItemToCollection',
          payload: {
            item: item
          }
        });
      }
    };

    var onAddToCart = function onAddToCart(event) {
      event.preventDefault();
      reportProductAddToCartAttemptHandler();

      Object(__WEBPACK_IMPORTED_MODULE_2__analytics_resultAnalytics__["reportModalPageView"])({
        title: 'Modal: Customize item before adding to cart',
        page: window.location.pathname + '/customize-item-before-adding-to-cart' + window.location.search
      });
      openModal({
        type: 'addItemToCart',
        payload: {
          item: item
        }
      });
    };

    return {
      item: item,
      rank: rank,
      onItemLinkClick: reportProductClickHandler,
      onAddToCart: onAddToCart,
      onAddToFavourites: onAddToFavourites,
      onAddToCollections: onAddToCollections
    };
  };
};

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Right-Open' },
      props.title || 'Right-Open'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M408.3 232.3c6.4 6.3 9.7 13.9 9.7 22.4 0 8.6-3.2 16.2-9.7 22.5l-222.3 222.1c-6.4 6.3-13.8 9.6-22.3 9.6-8.4 0-15.9-3.2-22.3-9.6l-33.1-33.1c-6.4-6.5-9.6-13.9-9.6-22.4 0-8.5 3.2-15.9 9.6-22.3l168.1-168-168.2-166.2c-6.4-6.3-9.6-13.8-9.6-22s3.2-15.5 9.6-22l33.1-33.7c6.4-6.3 13.9-9.6 22.5-9.6s16 3.2 22.1 9.6l222.4 222.7z' })
    )
  );
});

/***/ }),
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["default"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Search' },
      props.title || 'Search'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M507.5 469.3c0 10.5-3.8 19.5-11.5 27.2s-16.7 11.5-27.2 11.5c-10.9 0-20-3.8-27.2-11.5l-103.7-103.4c-36.1 25-76.3 37.5-120.6 37.5-28.8 0-56.4-5.6-82.7-16.8s-49-26.3-68-45.3-34.2-41.7-45.3-68c-11.2-26.3-16.8-53.9-16.8-82.7s5.6-56.4 16.8-82.7 26.3-49 45.3-68 41.7-34.2 68-45.3c26.3-11.2 53.9-16.8 82.7-16.8s56.4 5.6 82.7 16.8c26.3 11.2 49 26.3 68 45.3s34.2 41.7 45.3 68c11.2 26.3 16.8 53.9 16.8 82.7 0 44.3-12.5 84.5-37.5 120.6l103.7 103.7c7.5 7.5 11.2 16.5 11.2 27.2zm-154.8-251.5c0-37.3-13.2-69.2-39.8-95.7-26.5-26.5-58.4-39.8-95.7-39.8s-69.2 13.3-95.7 39.8-39.8 58.4-39.8 95.7 13.2 69.2 39.8 95.7c26.5 26.5 58.4 39.8 95.7 39.8s69.2-13.2 95.7-39.8c26.6-26.5 39.8-58.4 39.8-95.7z' })
    )
  );
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var menus_1 = __webpack_require__(117);
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
var CACHED_STATS = null;
exports.fetchStats = function (_a) {
    var apiUrlPrefix = _a.apiUrlPrefix;
    return function (dispatch, getState) {
        var state = getState();
        if (state.common.stats) {
            return;
        }
        if (CACHED_STATS) {
            return dispatch({
                type: 'receiveStats',
                payload: CACHED_STATS
            });
        }
        return axiosVerbose_1.default
            .get(apiUrlPrefix + "/shopfront_api/stat")
            .then(function (response) {
            CACHED_STATS = response.data;
            return dispatch({
                type: 'receiveStats',
                payload: response.data
            });
        })
            .catch(function (err) { return Promise.reject(errors_1.logError(err)); })
            .catch(function () {
            return dispatch({
                type: 'receiveStatsError',
                error: true
            });
        });
    };
};
exports.setCurrentSite = function (currentSite) {
    return function (dispatch, getState) {
        dispatch({
            type: 'loadSiteConfigs',
            payload: {
                currentSite: currentSite
            }
        });
        return dispatch({
            type: 'setCurrentSite',
            payload: currentSite
        });
    };
};
exports.setBaseUrl = function (baseUrl) {
    return {
        type: 'setBaseUrl',
        payload: baseUrl
    };
};
exports.setMenuConfig = function (currentSite) {
    return {
        type: 'setMenuConfig',
        payload: menus_1.default[currentSite] || []
    };
};
exports.showAlert = function (message, type, canBeDismissed) {
    if (type === void 0) { type = 'warning'; }
    if (canBeDismissed === void 0) { canBeDismissed = true; }
    return {
        type: 'showAlert',
        payload: {
            message: message,
            type: type,
            canBeDismissed: canBeDismissed
        }
    };
};
exports.hideAlert = function (message) {
    return {
        type: 'hideAlert',
        payload: {
            message: message
        }
    };
};
exports.resetAlerts = function () {
    return {
        type: 'resetAlerts'
    };
};
exports.setErrorPage = function (id) {
    return {
        type: 'setErrorPage',
        payload: {
            id: id
        }
    };
};
exports.resetErrorPage = function () {
    return {
        type: 'resetErrorPage'
    };
};
exports.noIndex = function () {
    return {
        type: 'noIndex'
    };
};
exports.setClientVersion = function (_a) {
    var clientVersion = _a.clientVersion;
    return {
        type: 'setClientVersion',
        payload: { clientVersion: clientVersion }
    };
};
exports.clientFinishedLoading = function () {
    return {
        type: 'clientFinishedLoading'
    };
};
exports.setSeoMeta = function (_a) {
    var title = _a.title, meta_description = _a.meta_description, description = _a.description;
    return {
        type: 'setSeoMeta',
        payload: {
            title: title,
            meta_description: meta_description || description
        }
    };
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportItemAddedToFavourite", function() { return reportItemAddedToFavourite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportItemRemovedFromFavourite", function() { return reportItemRemovedFromFavourite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportItemAddedToCollection", function() { return reportItemAddedToCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportItemRemovedFromCollection", function() { return reportItemRemovedFromCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportCollectionCreated", function() { return reportCollectionCreated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGAUserID", function() { return setGAUserID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportModalPageView", function() { return reportModalPageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(13);


var reportItemAddedToFavourite = function reportItemAddedToFavourite(itemID) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Item', 'click', 'favourite: added', itemID);
};

var reportItemRemovedFromFavourite = function reportItemRemovedFromFavourite(itemID) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Item', 'click', 'favourite: removed', itemID);
};

var reportItemAddedToCollection = function reportItemAddedToCollection(itemID) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Item', 'click', 'collection: added', itemID);
};

var reportItemRemovedFromCollection = function reportItemRemovedFromCollection(itemID) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Item', 'click', 'collection: removed', itemID);
};

var reportCollectionCreated = function reportCollectionCreated() {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Item', 'click', 'collection: created');
};

var setGAUserID = function setGAUserID(id) {
  if (!id) return;

  var idString = id;
  if (typeof id === 'number') {
    idString = id.toString();
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('set', 'userId', id);
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('set', 'dimension1', idString);
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'User Authentication', 'signed-in', 'shopfront');
};

var reportModalPageView = function reportModalPageView(_ref) {
  var title = _ref.title,
      page = _ref.page;

  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', {
    hitType: 'pageview',
    page: page,
    title: title
  });
};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["default"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 10 10' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Close' },
      props.title || 'Close'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M9.888641,1.2053571 C9.962881,1.2797623 10,1.3690471 10,1.4732143 C10,1.5773815 9.962881,1.6666663 9.888641,1.7410714 L6.904232,4.7321429 C6.829992,4.806548 6.792873,4.8958328 6.792873,5 C6.792873,5.1041672 6.829992,5.193452 6.904232,5.2678571 L9.86637,8.2589286 C9.955457,8.3333337 10,8.4226185 10,8.5267857 C10,8.6309529 9.955457,8.7202377 9.86637,8.7946429 L8.797327,9.8883929 C8.723088,9.962798 8.63029,10 8.518931,10 C8.407572,10 8.314774,9.962798 8.240535,9.8883929 L5.278396,6.8973214 C5.204157,6.8229163 5.111359,6.7857143 5,6.7857143 C4.888641,6.7857143 4.795843,6.8229163 4.721604,6.8973214 L1.737194,9.8883929 C1.662954,9.962798 1.573868,10 1.469933,10 C1.365998,10 1.276912,9.962798 1.202673,9.8883929 L0.111359,8.7946429 C0.037119,8.7202377 0,8.6309529 0,8.5267857 C0,8.4226185 0.037119,8.3333337 0.111359,8.2589286 L3.095768,5.2678571 C3.170008,5.193452 3.207127,5.1041672 3.207127,5 C3.207127,4.8958328 3.170008,4.806548 3.095768,4.7321429 L0.111359,1.7410714 C0.037119,1.6666663 0,1.5736613 0,1.4620536 C0,1.3504459 0.037119,1.2574408 0.111359,1.1830357 L1.202673,0.1116071 C1.276912,0.037202 1.36971,0 1.481069,0 C1.592428,0 1.685226,0.037202 1.759465,0.1116071 L4.721604,3.1026786 C4.795843,3.1770837 4.888641,3.2142857 5,3.2142857 C5.111359,3.2142857 5.204157,3.1770837 5.278396,3.1026786 L8.262806,0.1116071 C8.337046,0.037202 8.426132,0 8.530067,0 C8.634002,0 8.723088,0.037202 8.797327,0.1116071 L9.888641,1.2053571 Z' })
    )
  );
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["default"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Ok' },
      props.title || 'Ok'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M200.5 447.6c-2.3 1.8-4.7 3-7.6 3-2.9 0-5.3-1.2-7.6-3l-180-179.9c-4.1-4.1-4.1-11.2 0-15.3l74.1-74.1c4.1-4.1 11.2-4.1 15.3 0l98.2 98.8 225.1-225.7c4.1-4.1 11.2-4.1 15.3 0l74.1 74.1c4.1 4.1 4.1 11.2 0 15.3l-306.9 306.8z' })
    )
  );
});

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLocalStorageItem", function() { return setLocalStorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocalStorageItem", function() { return getLocalStorageItem; });
var setLocalStorageItem = function setLocalStorageItem(itemKey, itemValue) {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(itemKey, JSON.stringify(itemValue));
  }
};

var getLocalStorageItem = function getLocalStorageItem(itemKey, defaultValue) {
  if (typeof window !== 'undefined' && window.localStorage) {
    var result = JSON.parse(window.localStorage.getItem(itemKey));
    return result == null ? defaultValue : result;
  } else {
    return defaultValue;
  }
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultViewTypeBySite", function() { return getDefaultViewTypeBySite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initClientUserSearchResultsViewType", function() { return initClientUserSearchResultsViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initServerUserSearchResultsViewType", function() { return initServerUserSearchResultsViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserSearchResultsViewType", function() { return setUserSearchResultsViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setServerUserSearchResultsViewType", function() { return setServerUserSearchResultsViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserVideoPlayerStatus", function() { return getUserVideoPlayerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserVideoPlayerStatus", function() { return setUserVideoPlayerStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_sites__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_ga__ = __webpack_require__(13);





/**
 * check if a site has only one avaiable layout
 * @param {String} siteName
 */
var hasOnlyOneLayout = function hasOnlyOneLayout(siteName) {
  var itemViewsConfig = Object(__WEBPACK_IMPORTED_MODULE_1__config_sites__["getConfigBySite"])(siteName, 'ui.item_list_views') || [];
  return itemViewsConfig.length === 1;
};

/**
 * read the default view type from config
 * @param  {String} currentSite
 * @return {String} the final view type we use
 */
var getDefaultViewTypeBySite = function getDefaultViewTypeBySite(currentSite) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__config_sites__["getConfigBySite"])(currentSite, 'item_results_layout');
};

var initClientUserSearchResultsViewType = function initClientUserSearchResultsViewType(location) {
  return function (dispatch, getState) {
    var currentSite = getState().common.currentSite;
    var defaultSiteViewType = getDefaultViewTypeBySite(currentSite);

    if (hasOnlyOneLayout(currentSite)) {
      dispatch(setUserSearchResultsViewType(defaultSiteViewType));
    } else if (location && location.query.view) {
      // if there is view parameter for initial rendering, save view type to cookie
      dispatch(setUserSearchResultsViewType(location.query.view));
    } else {
      // read from cookie
      var view = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('search-view-mode-preference');
      // override default view type if there's preference in cookie
      if (view) {
        dispatch(setUserSearchResultsViewType(view));
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2__common_utils_ga__["default"])('send', 'event', 'product list', 'display', defaultSiteViewType);
      }
    }
  };
};

var initServerUserSearchResultsViewType = function initServerUserSearchResultsViewType(location) {
  return function (dispatch, getState) {
    var currentSite = getState().common.currentSite;
    var defaultSiteViewType = getDefaultViewTypeBySite(currentSite);

    if (hasOnlyOneLayout(currentSite)) {
      dispatch(setServerUserSearchResultsViewType(defaultSiteViewType));
    } else if (location && location.query.view) {
      // if there is view parameter for initial rendering, set view type to cookie
      dispatch(setServerUserSearchResultsViewType(location.query.view));
    } else {
      // otherwise read from the default config
      dispatch(setServerUserSearchResultsViewType(defaultSiteViewType));
    }
  };
};

var setUserSearchResultsViewType = function setUserSearchResultsViewType(nextView) {
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('search-view-mode-preference', nextView);
  Object(__WEBPACK_IMPORTED_MODULE_2__common_utils_ga__["default"])('send', 'event', 'product list', 'display', nextView);
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } };
};

var setServerUserSearchResultsViewType = function setServerUserSearchResultsViewType(nextView) {
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } };
};

var getUserVideoPlayerStatus = function getUserVideoPlayerStatus() {
  var key = 'search_videos_muted';
  if (window.localStorage && window.localStorage.getItem(key)) {
    return {
      type: 'getUserVideoPlayerStatus',
      payload: {
        type: window.localStorage.getItem(key) === 'true'
      }
    };
  } else {
    return {
      type: 'nullAction'
    };
  }
};

var setUserVideoPlayerStatus = function setUserVideoPlayerStatus(type) {
  if (window.localStorage) {
    var key = 'search_videos_muted';
    window.localStorage.setItem(key, type);
    return { type: 'setUserVideoPlayerStatus', payload: { type: type } };
  } else {
    return {
      type: 'nullAction'
    };
  }
};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 474 474' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Bar-Chart' },
      props.title || 'Bar-Chart'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'title',
        null,
        'bar-chart 2'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M126.76 266.89v93.5h-62.2v-93.5h62.2zm93.39-124.62v218.12h-62.2v-218.12h62.2zm93.45 62.34v155.78h-62.26v-155.78h62.26zm93.4-93.51v249.29h-62.21v-249.29h62.21zm31.07 272.72v-296.09c0-2.13-.73-3.98-2.3-5.44-1.56-1.57-3.41-2.3-5.43-2.3h-389.19c-2.12 0-3.97.73-5.43 2.3-1.45 1.57-2.29 3.42-2.29 5.44v295.98c0 2.13.72 3.98 2.29 5.44 1.57 1.46 3.42 2.3 5.43 2.3h389.08c2.13 0 3.98-.73 5.43-2.3 1.68-1.46 2.41-3.25 2.41-5.33zm31.13-296.09v295.98c0 10.71-3.75 19.9-11.42 27.52-7.62 7.68-16.74 11.44-27.49 11.44h-389.14c-10.69 0-19.87-3.76-27.49-11.44-7.67-7.62-11.42-16.76-11.42-27.52v-295.98c0-10.71 3.75-19.9 11.42-27.52 7.62-7.68 16.74-11.44 27.49-11.44h389.08c10.7 0 19.88 3.76 27.49 11.44 7.73 7.62 11.48 16.81 11.48 27.52z' })
    )
  );
});

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getUserProfileRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getGuestCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addItemToUserCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return editUserCartEntryRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createUserCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createGuestCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addItemToGuestCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return editGuestCartEntryRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getBookmarksForItemsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteBookmarkRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createBookmarkRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createCollectionRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return formatUserResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var getUserProfileRequest = function getUserProfileRequest(token) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].get('/shopfront_api/user', {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var getGuestCartRequest = function getGuestCartRequest() {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].get('/shopfront_api/cart');
};

var addItemToUserCartRequest = function addItemToUserCartRequest(token, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].post('/shopfront_api/user/cart/entry', data, {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var editUserCartEntryRequest = function editUserCartEntryRequest(token, entryID, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].put('/shopfront_api/user/cart/entry/' + entryID, data, {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createUserCartRequest = function createUserCartRequest(token) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].post('/shopfront_api/user/cart/', {}, {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createGuestCartRequest = function createGuestCartRequest() {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].post('/shopfront_api/cart/', {}).then(function (res) {
    return res.data;
  });
};

var addItemToGuestCartRequest = function addItemToGuestCartRequest(data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].post('/shopfront_api/cart/entry', data).then(function (res) {
    return res.data;
  });
};

var editGuestCartEntryRequest = function editGuestCartEntryRequest(entryID, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].put('/shopfront_api/cart/entry/' + entryID, data).then(function (res) {
    return res.data;
  });
};

var getBookmarksForItemsRequest = function getBookmarksForItemsRequest(token, itemIds) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].get('/shopfront_api/user/bookmarks_for_items?item_ids=' + itemIds.join(','), {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var deleteBookmarkRequest = function deleteBookmarkRequest(token, id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].delete('/shopfront_api/user/bookmark/' + id, {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createBookmarkRequest = function createBookmarkRequest(token, collectionId, itemId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].post('/shopfront_api/user/collection/' + collectionId + '/bookmark', {
    item_id: itemId
  }, {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createCollectionRequest = function createCollectionRequest(token, _ref) {
  var name = _ref.name,
      isPublic = _ref.isPublic,
      description = _ref.description,
      specialRole = _ref.specialRole;

  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].post('/shopfront_api/user/collection', {
    name: name,
    public: isPublic,
    description: description,
    specialRole: specialRole
  }, {
    headers: {
      Authorization: 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

/**
 * Converts a User Api Response to a user object,
 * a list of their collections with bookmarks nested,
 * @param  {Object} the api user response
 * @return {Object} a object with the users info, collections/bookmarks and favorites collection ID
 */
var formatUserResponse = function formatUserResponse(userResponse) {
  try {
    var user = _extends({}, userResponse);

    delete user.collections;
    delete user.cart;
    delete user.misc;

    var collections = userResponse.collections;
    var newCollections = {};

    if (collections) {
      newCollections = collections.reduce(function (prev, collection) {
        prev[collection.id] = collection;
        prev[collection.id].bookmarks = {};
        return prev;
      }, {});
    }

    return {
      profile: user,
      collections: newCollections,
      cart: userResponse.cart,
      misc: userResponse.misc
    };
  } catch (e) {
    // eslint-disable-next-line
    console.log('format user response error', e);
  }
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var formatString_1 = __webpack_require__(14);
var ga_1 = __webpack_require__(13);
var sites_1 = __webpack_require__(23);
var getListName = function (pageType) {
    if (pageType === 'category') {
        return 'Search Results: Category';
    }
    return 'Search Results: Search';
};
exports.reportProductClick = function (index, item, currentSite, pageType) {
    var currentSiteDomain = sites_1.getCurrentSiteDomain(currentSite);
    ga_1.default('ec:addProduct', {
        brand: item.author_username,
        category: currentSiteDomain + "/" + item.classification,
        id: item.id,
        list: getListName(pageType),
        name: item.name,
        position: index
    });
    ga_1.default('ec:setAction', 'click', {
        list: getListName(pageType)
    });
    ga_1.default('send', 'event', 'Ecommerce', 'click', 'Product click: product list');
};
exports.reportProductAddToCartAttempt = function (item, index, currentSite, pageType) {
    var currentSiteDomain = sites_1.getCurrentSiteDomain(currentSite);
    ga_1.default('ec:addProduct', {
        brand: item.author_username,
        category: currentSiteDomain + "/" + item.classification,
        id: item.id,
        list: getListName(pageType),
        name: item.name,
        position: index
    });
    ga_1.default('ec:setAction', 'add');
    ga_1.default('send', 'event', 'Ecommerce', 'click', 'Add to cart: product list');
};
exports.reportProductsImpressions = function (_a) {
    var items = _a.items, currentSite = _a.currentSite, itemRankOffset = _a.itemRankOffset, page = _a.page, section = _a.section;
    var currentSiteDomain = sites_1.getCurrentSiteDomain(currentSite);
    items.forEach(function (item, index) {
        ga_1.default('ec:addImpression', {
            brand: item.author_username,
            category: currentSiteDomain + "/" + item.classification,
            id: item.id,
            list: page + ": " + formatString_1.toTitle(section),
            name: item.name,
            position: index + itemRankOffset
        });
    });
    ga_1.default('send', 'event', 'Ecommerce', 'view', 'Product impression', {
        nonInteraction: true
    });
};
exports.reportModalPageView = function (_a) {
    var title = _a.title, page = _a.page;
    ga_1.default('send', {
        hitType: 'pageview',
        page: page,
        title: title
    });
};


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTopCategoryLabel", function() { return getTopCategoryLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3docean_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiojungle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codecanyon_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphicriver_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__photodune_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__themeforest_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__videohive_json__);








var configs = {
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean_json___default.a,
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default.a,
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default.a,
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default.a,
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune_json___default.a,
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default.a,
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive_json___default.a
};

var getTopCategoryLabel = function getTopCategoryLabel(siteKey, key) {
  var result = configs[siteKey].find(function (category) {
    return category.path === key;
  });
  return result && result.name;
};

/* harmony default export */ __webpack_exports__["default"] = (configs);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var react_video_1 = __webpack_require__(197);
var magnifier_1 = __webpack_require__(285);
var MagnifierConfigurator = function (_a) {
    var item = _a.item, videoMuted = _a.videoMuted, muteVideo = _a.muteVideo;
    var previews = item.previews;
    var getMagnifier = function () {
        if (lodash_1.get(previews, 'icon_with_square_preview.square_url')) {
            return (React.createElement(magnifier_1.default, { item: item, width: 300, height: 300 },
                React.createElement("img", { src: previews.icon_with_square_preview.square_url })));
        }
        if (lodash_1.get(previews, 'icon_with_thumbnail_preview.thumbnail_url')) {
            var width = previews.icon_with_thumbnail_preview.thumbnail_width || 300;
            var height = previews.icon_with_thumbnail_preview.thumbnail_height || 300;
            return (React.createElement(magnifier_1.default, { item: item, width: width, height: height },
                React.createElement("img", { src: previews.icon_with_thumbnail_preview.thumbnail_url })));
        }
        if (lodash_1.get(previews, 'icon_with_video_preview.video_url')) {
            return (React.createElement(magnifier_1.default, { item: item, width: 477, height: 264 },
                React.createElement(react_video_1.BaseVideoPlayer, { playState: react_video_1.PlayState.PLAY, muteVideo: muteVideo, loop: true, muted: videoMuted, preload: "none", src: previews.icon_with_video_preview.video_url, poster: previews.icon_with_video_preview.landscape_url })));
        }
        if (lodash_1.get(previews, 'icon_with_landscape_preview.landscape_url')) {
            return (React.createElement(magnifier_1.default, { item: item, width: 477, height: 240 },
                React.createElement("img", { src: previews.icon_with_landscape_preview.landscape_url })));
        }
        return null;
    };
    return React.createElement("div", { className: "fds-u-hide-small-and-below" }, getMagnifier());
};
exports.default = MagnifierConfigurator;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var getOverlaySidePosition = function (_a) {
    var container = _a.container, target = _a.target;
    var top;
    var left;
    var documentWidth = document.body.offsetWidth || document.documentElement.offsetWidth;
    var containerViewportPosition = container.getBoundingClientRect();
    top = target.offsetHeight - container.offsetHeight;
    left = target.offsetWidth;
    // Adjust top if exceeds viewport at the top
    if (Math.abs(top) > containerViewportPosition.top) {
        top = -containerViewportPosition.top;
    }
    // Display container on the left side of the target if it exceeds viewport on the right side
    if (target.offsetWidth + containerViewportPosition.right > documentWidth) {
        left = -container.offsetWidth;
    }
    return {
        left: left,
        top: top
    };
};
var PositionStrategies = {
    side: getOverlaySidePosition
};
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showContent: false
        };
        return _this;
    }
    Overlay.prototype.componentDidUpdate = function () {
        if (this.state.showContent && this.$target && this.$content) {
            var position = this.getOverlayPosition(this.$content, this.$target);
            this.$content.style.left = position.left + "px";
            this.$content.style.top = position.top + "px";
        }
    };
    Overlay.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: { position: 'relative' } },
            this.state.showContent && this.renderContent(),
            React.createElement("div", { ref: function ($target) {
                    _this.$target = $target;
                }, style: { display: 'inline-block' }, onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this) }, this.props.children)));
    };
    Overlay.prototype.onMouseEnter = function () {
        var _this = this;
        this.timeoutId = window.setTimeout(function () {
            _this.setState({
                showContent: true
            });
        }, 500);
    };
    Overlay.prototype.onMouseLeave = function () {
        clearTimeout(this.timeoutId);
        this.setState({ showContent: false });
    };
    Overlay.prototype.renderContent = function () {
        var _this = this;
        return (React.createElement("div", { ref: function ($content) {
                _this.$content = $content;
            }, style: { display: 'inline-block', position: 'absolute' } }, this.props.content));
    };
    Overlay.prototype.getOverlayPosition = function (container, target) {
        if (typeof this.props.position === 'function') {
            return this.props.position({ container: container, target: target });
        }
        return PositionStrategies[this.props.position]({ container: container, target: target });
    };
    Overlay.defaultProps = {
        position: 'side'
    };
    return Overlay;
}(React.Component));
exports.default = Overlay;


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usDollarsNotice__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usDollarsNotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usDollarsNotice__);




var mapStateToProps = function mapStateToProps(state) {
  var usDollarsNotice = state.user.usDollarsNotice;


  return { notice: usDollarsNotice };
};

var UsDollarsNoticeContainer = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, null)(__WEBPACK_IMPORTED_MODULE_1__usDollarsNotice___default.a);

/* harmony default export */ __webpack_exports__["default"] = (UsDollarsNoticeContainer);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_module_css__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_module_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





// https://codepen.io/MHWK/pen/WEXdGB
var LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$strokeColor = _ref.strokeColor,
      strokeColor = _ref$strokeColor === undefined ? 'hsl(86, 47%, 48%)' : _ref$strokeColor,
      props = _objectWithoutProperties(_ref, ['strokeColor']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({
      className: __WEBPACK_IMPORTED_MODULE_1__index_module_css___default.a.spinner,
      width: '65px',
      height: '65px',
      viewBox: '0 0 66 66',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', {
      className: __WEBPACK_IMPORTED_MODULE_1__index_module_css___default.a.path,
      fill: 'none',
      strokeWidth: '6',
      strokeLinecap: 'round',
      stroke: strokeColor,
      cx: '33',
      cy: '33',
      r: '30'
    })
  );
};

/* harmony default export */ __webpack_exports__["default"] = (LoadingSpinner);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Dropdown = function (props) {
    var options = props.options, rest = __rest(props, ["options"]);
    return (React.createElement("select", __assign({}, rest), options.map(function (option) {
        return (React.createElement("option", { key: option.value, value: option.value }, option.label));
    })));
};
exports.default = Dropdown;


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isServer", function() { return isServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isProduction", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDevelopment", function() { return isDevelopment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasWindow", function() { return hasWindow; });
/**
 * A helper function to decide the current env, ie browser/server.
 * @return {Boolean} true/false
 */
var isServer = function isServer() {
  return false === true; // eslint-disable-line
};

/**
 * A helpful funciton to decide the current env, ie production/development
 * @return {Boolean} true/false
 */
var isProduction = function isProduction() {
  return "production" === 'production';
};

var isDevelopment = function isDevelopment() {
  return "production" === 'development';
};

var hasWindow = function hasWindow() {
  return typeof window !== 'undefined';
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (_a) {
    var isServer = _a.isServer, isBoxenUser = _a.isBoxenUser, _b = _a.internalServerUrl, internalServerUrl = _b === void 0 ? '' : _b, baseUrl = _a.baseUrl;
    var apiUrlPrefix = '';
    // on client side there's no need for prefix, browser will append it for us
    if (isServer) {
        apiUrlPrefix = isBoxenUser ? baseUrl : internalServerUrl;
    }
    return apiUrlPrefix;
};


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchCommonParams", function() { return searchCommonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchApiParams", function() { return searchApiParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchFrontendParams", function() { return searchFrontendParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchFrontendParamsSeoTransform", function() { return searchFrontendParamsSeoTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchApiNonFilterParams", function() { return searchApiNonFilterParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchApiFilterParams", function() { return searchApiFilterParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validSortByOptions", function() { return validSortByOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validSortDirectionOptions", function() { return validSortDirectionOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validDateOptions", function() { return validDateOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validSizesOptions", function() { return validSizesOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validOrientationOptions", function() { return validOrientationOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_difference__);


var searchCommonParams = ['term', 'tags', 'category', 'platform', 'hosting_setup', 'compatible_with', 'colors', 'sizes', 'sales', 'rating_min', 'price_min', 'price_max', 'poly_count', 'file_formats', 'item_type', 'date', 'length_min', 'length_max', 'tempo', 'alpha', 'vocals_in_audio', 'looped', 'orientation', 'requires_plugins', 'resolution_min', 'frame_rate', 'page', 'attribute_key', 'attribute_value', 'username', 'item_id', 'include_pro_affiliated'];

var searchApiParams = searchCommonParams.concat(['site', 'sort_by', 'sort_direction', 'page_size', 'suggest', 'metadata']);

var searchFrontendParams = searchCommonParams.concat(['view', 'sort']);

var searchFrontendParamsSeoTransform = __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(searchFrontendParams, ['term']);

var searchApiNonFilterParams = ['page', 'page_size', 'sort_by', 'sort_direction', 'metadata', 'site'];

var searchApiFilterParams = __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(searchApiParams, searchApiNonFilterParams);

var validSortByOptions = ['relevance', 'rating', 'sales', 'price', 'date', 'updated', 'category', 'name', 'trending'];

var validSortDirectionOptions = ['asc', 'desc'];

var validDateOptions = ['this-year', 'this-month', 'this-week', 'this-day'];

var validSizesOptions = ['m', 'l', 'xl', 'xxl'];

var validOrientationOptions = ['landscape', 'portrait', 'square'];

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_errors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__session__ = __webpack_require__(73);




/**
 * Handle auth error middleware
 */
/* harmony default export */ __webpack_exports__["a"] = (function (next) {
  return function (dispatch) {
    // token expired, let's try get session again.
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__session__["getSessionRequestAction"])());
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* getSession */])().then(function (res) {
      return res.data.token;
    }).then(function (jwtToken) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__session__["getSessionSuccessAction"])(jwtToken));
      dispatch(next);
    }).catch(__WEBPACK_IMPORTED_MODULE_1__utils_errors__["logError"]);
  };
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSessionRequestAction", function() { return getSessionRequestAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSessionSuccessAction", function() { return getSessionSuccessAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSessionFailureAction", function() { return getSessionFailureAction; });
/**
 * Get user session actions
 */
var getSessionRequestAction = function getSessionRequestAction() {
  return { type: 'getSessionRequest' };
};
var getSessionSuccessAction = function getSessionSuccessAction(jwtToken) {
  return {
    type: 'getSessionSuccess',
    payload: { token: jwtToken }
  };
};
var getSessionFailureAction = function getSessionFailureAction() {
  return { type: 'getSessionFailure' };
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteBookmark", function() { return deleteBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBookmark", function() { return addBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookmarksForItems", function() { return getBookmarksForItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authMiddleware__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_user__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__ = __webpack_require__(38);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var deleteBookmarkRequestAction = function deleteBookmarkRequestAction(collectionID, itemID) {
  return {
    type: 'deleteBookmarkRequest',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};
var deleteBookmarkSuccessAction = function deleteBookmarkSuccessAction(collectionID, itemID, isFavouriteCollection) {
  if (isFavouriteCollection) {
    Object(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["reportItemRemovedFromFavourite"])(itemID);
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["reportItemRemovedFromCollection"])(itemID);
  }

  return {
    type: 'deleteBookmarkSuccess',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};
var deleteBookmarkFailureAction = function deleteBookmarkFailureAction(collectionID, itemID) {
  return {
    type: 'deleteBookmarkFailure',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};

var deleteBookmark = function deleteBookmark(collectionID, itemID, bookmarkID, isFavouriteCollection) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, token, message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), token = _getState.user.token;

              if (token) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', dispatch(deleteBookmarkFailureAction(collectionID, itemID)));

            case 3:

              dispatch(deleteBookmarkRequestAction(collectionID, itemID));

              _context.prev = 4;
              _context.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_1__utils_user__["g" /* deleteBookmarkRequest */])(token, bookmarkID);

            case 7:
              return _context.abrupt('return', dispatch(deleteBookmarkSuccessAction(collectionID, itemID, isFavouriteCollection)));

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](4);

              if (!(_context.t0.statusCode === 401)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(deleteBookmark(collectionID, itemID, bookmarkID))));

            case 16:
              Object(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["logError"])(_context.t0);
              message = "Unfortunately we couldn't delete the bookmark. Please try again.";

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common__["showAlert"])(message, 'failure', false));
              return _context.abrupt('return', dispatch(deleteBookmarkFailureAction(collectionID, itemID)));

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 10]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var addBookmarkRequestAction = function addBookmarkRequestAction(collectionID, itemID) {
  return {
    type: 'addBookmarkRequest',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};
var addBookmarkSuccessAction = function addBookmarkSuccessAction(bookmarkID, collectionID, itemID, isFavouriteCollection) {
  if (isFavouriteCollection) {
    Object(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["reportItemAddedToFavourite"])(itemID);
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["reportItemAddedToCollection"])(itemID);
  }

  return {
    type: 'addBookmarkSuccess',
    payload: { bookmarkID: bookmarkID, collectionID: collectionID, itemID: itemID }
  };
};
var addBookmarkFailureAction = function addBookmarkFailureAction(collectionID, itemID) {
  return {
    type: 'addBookmarkFailure',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};

var addBookmark = function addBookmark(collectionID, itemID, isFavouriteCollection) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState2, token, _ref3, bookmark_id, message;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getState2 = getState(), token = _getState2.user.token;

              if (token) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', dispatch(addBookmarkFailureAction(collectionID, itemID)));

            case 3:

              dispatch(addBookmarkRequestAction(collectionID, itemID));

              _context2.prev = 4;
              _context2.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_1__utils_user__["c" /* createBookmarkRequest */])(token, collectionID, itemID);

            case 7:
              _ref3 = _context2.sent;
              bookmark_id = _ref3.bookmark_id;
              return _context2.abrupt('return', dispatch(addBookmarkSuccessAction(bookmark_id, collectionID, itemID, isFavouriteCollection)));

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](4);

              if (!(_context2.t0.statusCode === 401)) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(addBookmark(collectionID, itemID))));

            case 18:
              Object(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["logError"])(_context2.t0);
              message = "Unfortunately your bookmark hasn't been added. Please try again.";

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__common__["showAlert"])(message, 'failure', false));
              return _context2.abrupt('return', dispatch(addBookmarkFailureAction(collectionID, itemID)));

            case 22:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[4, 12]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var getBookmarksForItemsRequestAction = function getBookmarksForItemsRequestAction(itemIds) {
  return {
    type: 'getBookmarksForItemsRequest',
    payload: { itemIds: itemIds }
  };
};
var getBookmarksForItemsSuccessAction = function getBookmarksForItemsSuccessAction(bookmarks) {
  return {
    type: 'getBookmarksForItemsSuccess',
    payload: { bookmarks: bookmarks }
  };
};
var getBookmarksForItemsFailureAction = function getBookmarksForItemsFailureAction(itemIds) {
  return {
    type: 'getBookmarksForItemsFailure',
    payload: { itemIds: itemIds }
  };
};

var getBookmarksForItems = function getBookmarksForItems(itemIds) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _getState3, token, _ref5, bookmarks;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState3 = getState(), token = _getState3.user.token;

              if (token) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt('return', { type: 'nullAction' });

            case 3:

              dispatch(getBookmarksForItemsRequestAction(itemIds));

              _context3.prev = 4;
              _context3.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_1__utils_user__["k" /* getBookmarksForItemsRequest */])(token, itemIds);

            case 7:
              _ref5 = _context3.sent;
              bookmarks = _ref5.bookmarks;
              return _context3.abrupt('return', dispatch(getBookmarksForItemsSuccessAction(bookmarks)));

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3['catch'](4);

              if (!(_context3.t0.statusCode === 401)) {
                _context3.next = 18;
                break;
              }

              return _context3.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(getBookmarksForItems(itemIds))));

            case 18:
              Object(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["logError"])(_context3.t0);
              return _context3.abrupt('return', dispatch(getBookmarksForItemsFailureAction(itemIds)));

            case 20:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[4, 12]]);
    }));

    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserCollections", function() { return getUserCollections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserCartItems", function() { return getUserCartItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserFavoriteCollectionID", function() { return getUserFavoriteCollectionID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var getUserCollections = function getUserCollections(state) {
  return state.user.collections;
};

var getUserCartItems = function getUserCartItems(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(state, 'user.cart.entries') || [];
};

var getUserFavoriteCollectionID = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getUserCollections], function (collections) {
  return Object.keys(collections).filter(function (collectionID) {
    return collections[collectionID].special_role === 'favorite';
  })[0];
});

/***/ }),
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(3);
var react_router_dom_1 = __webpack_require__(6);
var urlHelper_1 = __webpack_require__(5);
var SearchBarFormPure = function (props) {
    var location = props.location, history = props.history, children = props.children;
    var passProps = lodash_1.omit(props, [
        'location',
        'router',
        'onSubmit',
        'role',
        'method',
        'action',
        'match',
        'history',
        'staticContext'
    ]);
    var onSubmit = function (event) {
        event.preventDefault();
        // get query from form
        var form = event.currentTarget;
        var query = {};
        Array.prototype.slice
            .call(form.elements)
            .filter(function (el) { return el.getAttribute('name') && el.value; })
            .forEach(function (el) {
            query[el.getAttribute('name')] = el.value;
        });
        // only update query inside the from and keep the existing one
        var nextQuery = __assign({}, urlHelper_1.parseLocation(location), query);
        // remove page param when do search
        delete nextQuery.page;
        history.push(urlHelper_1.makeLink(nextQuery));
    };
    return (React.createElement("form", __assign({ role: "search", method: "get", action: "/search", onSubmit: onSubmit }, passProps), children));
};
exports.default = react_router_dom_1.withRouter(SearchBarFormPure);


/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var createMarkup = function (markup) {
    if (markup === void 0) { markup = ''; }
    // TODO: REMOVE THIS ONCE ALL TYPESCRIPT
    if (typeof markup !== 'string') {
        throw new Error('must have a single html string as a child.');
    }
    return { __html: "" + markup };
};
var DangerouslySetInnerHtml = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: className, dangerouslySetInnerHTML: createMarkup(children) }));
};
exports.default = DangerouslySetInnerHtml;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sectionDescription_1 = __webpack_require__(459);
exports.default = sectionDescription_1.default;


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 28 28' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Clock' },
      props.title || 'Clock'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M0 14c0-2.2.5-4.2 1.6-6s2.5-3.3 4.4-4.4 3.8-1.6 6-1.6 4.2.5 6 1.6 3.3 2.5 4.4 4.4 1.6 3.8 1.6 6-.5 4.2-1.6 6c-1.1 1.8-2.5 3.3-4.4 4.4s-3.8 1.6-6 1.6-4.2-.5-6-1.6-3.3-2.5-4.4-4.4-1.6-3.8-1.6-6zm3.5 0c0 1.5.4 3 1.1 4.3s1.8 2.3 3.1 3.1c1.3.8 2.7 1.1 4.3 1.1s3-.4 4.3-1.1 2.3-1.8 3.1-3.1c.8-1.3 1.1-2.7 1.1-4.3s-.4-3-1.1-4.3c-.8-1.3-1.8-2.3-3.1-3.1s-2.8-1.1-4.3-1.1-3 .4-4.3 1.1-2.3 1.8-3.1 3.1-1.1 2.8-1.1 4.3zm4.5 1.5v-1c0-.1 0-.3.1-.4.1-.1.3-.1.4-.1h3.5v-5.5c0-.1 0-.3.1-.4.1-.1.3-.1.4-.1h1c.1 0 .3 0 .4.1.1.1.1.3.1.4v7c0 .1 0 .3-.1.4-.1.1-.3.1-.4.1h-5c-.1 0-.3 0-.4-.1-.1-.1-.1-.3-.1-.4z' })
    )
  );
});

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGuestUserCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addItemToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return editCartEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authMiddleware__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_user__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics_userAnalytics__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors__ = __webpack_require__(8);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var addItemToCartRequestAction = function addItemToCartRequestAction() {
  return { type: 'addItemToCartRequest' };
};
var addItemToCartSuccessAction = function addItemToCartSuccessAction(response) {
  Object(__WEBPACK_IMPORTED_MODULE_3__analytics_userAnalytics__["reportModalPageView"])({
    title: 'Modal: Item added to cart',
    page: window.location.pathname + '/item-added-to-cart' + window.location.search
  });
  return {
    type: 'addItemToCartSuccess',
    payload: response
  };
};

var getGuestUserCartRequestAction = function getGuestUserCartRequestAction() {
  return {
    type: 'getGuestUserCartRequest'
  };
};
var getGuestUserCartFailureAction = function getGuestUserCartFailureAction() {
  return {
    type: 'getGuestUserCartFailure'
  };
};

var getGuestUserCart = function getGuestUserCart() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var response, cartData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch(getGuestUserCartRequestAction());
              _context.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["l" /* getGuestCartRequest */])();

            case 4:
              response = _context.sent;
              cartData = response.data === '' ? null : response.data;
              return _context.abrupt('return', dispatch(getGuestUserCartSuccessAction(cartData)));

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["logError"])(_context.t0);
              dispatch(getGuestUserCartFailureAction());

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getGuestUserCartSuccessAction = function getGuestUserCartSuccessAction(cart) {
  return {
    type: 'getGuestUserCartSuccess',
    payload: cart
  };
};

var createUserCartRequestAction = function createUserCartRequestAction() {
  return {
    type: 'createUserCartRequest'
  };
};
var createUserCartSuccessAction = function createUserCartSuccessAction(cart) {
  return {
    type: 'createUserCartSuccess',
    payload: cart
  };
};
var createUserCartFailureAction = function createUserCartFailureAction() {
  return {
    type: 'createUserCartFailure'
  };
};

var addItemToCart = function addItemToCart(data) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState, _getState$user, token, cart, newCart, response, _newCart, _response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getState = getState(), _getState$user = _getState.user, token = _getState$user.token, cart = _getState$user.cart;
              // add to signed in user cart

              if (!token) {
                _context2.next = 38;
                break;
              }

              if (cart) {
                _context2.next = 20;
                break;
              }

              _context2.prev = 3;

              dispatch(createUserCartRequestAction());
              _context2.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["f" /* createUserCartRequest */])(token);

            case 7:
              newCart = _context2.sent;

              dispatch(createUserCartSuccessAction(newCart));
              _context2.next = 20;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](3);

              if (!(_context2.t0.statusCode === 401)) {
                _context2.next = 17;
                break;
              }

              return _context2.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(addItemToCart(data))));

            case 17:
              Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["logError"])(_context2.t0);
              dispatch(createUserCartFailureAction());
              return _context2.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__layout__["showModalMessage"])({ message: 'Creating user cart failed' })));

            case 20:

              dispatch(addItemToCartRequestAction());
              _context2.prev = 21;
              _context2.next = 24;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["b" /* addItemToUserCartRequest */])(token, data);

            case 24:
              response = _context2.sent;
              return _context2.abrupt('return', dispatch(addItemToCartSuccessAction(response)));

            case 28:
              _context2.prev = 28;
              _context2.t1 = _context2['catch'](21);

              if (!(_context2.t1.statusCode === 401)) {
                _context2.next = 34;
                break;
              }

              return _context2.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(addItemToCart(data))));

            case 34:
              Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["logError"])(_context2.t1);
              return _context2.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__layout__["showModalMessage"])({ message: 'Adding item to cart failed' })));

            case 36:
              _context2.next = 56;
              break;

            case 38:
              dispatch(addItemToCartRequestAction());

              if (cart) {
                _context2.next = 45;
                break;
              }

              _context2.next = 42;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["e" /* createGuestCartRequest */])();

            case 42:
              _newCart = _context2.sent;
              _context2.next = 45;
              return dispatch(getGuestUserCartSuccessAction(_newCart));

            case 45:
              _context2.prev = 45;
              _context2.next = 48;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["a" /* addItemToGuestCartRequest */])(data);

            case 48:
              _response = _context2.sent;
              return _context2.abrupt('return', dispatch(addItemToCartSuccessAction(_response)));

            case 52:
              _context2.prev = 52;
              _context2.t2 = _context2['catch'](45);

              Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["logError"])(_context2.t2);
              return _context2.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__layout__["showModalMessage"])({ message: 'Adding item to cart failed' })));

            case 56:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[3, 11], [21, 28], [45, 52]]);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var editCartEntryRequestAction = function editCartEntryRequestAction() {
  return { type: 'editCartEntryRequest' };
};
var editCartEntrySuccessAction = function editCartEntrySuccessAction(response) {
  return {
    type: 'editCartEntrySuccess',
    payload: response
  };
};

var editCartEntry = function editCartEntry(entryID, data) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _getState2, token, response, _response2;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState2 = getState(), token = _getState2.user.token;
              // edit to signed in user cart

              if (!token) {
                _context3.next = 20;
                break;
              }

              dispatch(editCartEntryRequestAction());
              _context3.prev = 3;
              _context3.next = 6;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["i" /* editUserCartEntryRequest */])(token, entryID, data);

            case 6:
              response = _context3.sent;
              return _context3.abrupt('return', dispatch(editCartEntrySuccessAction(response)));

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](3);

              if (!(_context3.t0.statusCode === 401)) {
                _context3.next = 16;
                break;
              }

              return _context3.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(editCartEntry(entryID, data))));

            case 16:
              Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["logError"])(_context3.t0);
              return _context3.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__layout__["showModalMessage"])({
                message: 'Cart update failed. Please try again.'
              })));

            case 18:
              _context3.next = 32;
              break;

            case 20:
              dispatch(editCartEntryRequestAction());
              _context3.prev = 21;
              _context3.next = 24;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["h" /* editGuestCartEntryRequest */])(entryID, data);

            case 24:
              _response2 = _context3.sent;
              return _context3.abrupt('return', dispatch(editCartEntrySuccessAction(_response2)));

            case 28:
              _context3.prev = 28;
              _context3.t1 = _context3['catch'](21);

              Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["logError"])(_context3.t1);
              return _context3.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__layout__["showModalMessage"])({ message: 'Cart update failed. Please try again.' })));

            case 32:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[3, 10], [21, 28]]);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldTrackSearchCount", function() { return shouldTrackSearchCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchesCount", function() { return searchesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countSearchFor", function() { return countSearchFor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__localStorageHelpers__ = __webpack_require__(43);


var itemKey = function itemKey(site) {
  return site + '-search-page-views';
};

var shouldTrackSearchCount = function shouldTrackSearchCount(site) {
  return site === 'themeforest';
};

var searchesCount = function searchesCount(site) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__localStorageHelpers__["getLocalStorageItem"])(itemKey(site), 0);
};

var countSearchFor = function countSearchFor(site) {
  var newCount = Object(__WEBPACK_IMPORTED_MODULE_0__localStorageHelpers__["getLocalStorageItem"])(itemKey(site), 0) + 1;
  Object(__WEBPACK_IMPORTED_MODULE_0__localStorageHelpers__["setLocalStorageItem"])(itemKey(site), newCount);
};

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  analytics: {
    google_conversion_id: '943617023',
    google_analytics_sandbox_id: 'UA-11834194-31'
  },
  ui: {
    default_user_image_path: '/images/default-user.jpg',
    item_list_views: [{
      value: 'list',
      label: 'List'
    }, {
      value: 'grid',
      label: 'Grid'
    }],
    item_small_preview_paths: ['icon_with_landscape_preview.icon_url', 'icon_with_square_preview.icon_url', 'icon_with_video_preview.icon_url', 'icon_with_audio_preview.icon_url', 'thumbnail_preview.small_url', 'icon_preview.icon_url']
  },
  common: {
    search_page_size: 30,
    max_pages_count: 60
  },
  assets_domains: {
    main: 'd2mdw063ttlqtq.cloudfront.net',
    main_alias: '0.s3.envato.com',
    user_profile: 'user-profile.s3.envato.com'
  },
  asset_type: 'item',
  search_query: {
    defalut_sort_by: 'date',
    defalut_sort_by_options: [{
      label: 'Best match',
      value: 'relevance'
    }, {
      label: 'Trending items',
      value: 'trending'
    }, {
      label: 'Best sellers',
      value: 'sales'
    }, {
      label: 'Best rated',
      value: 'rating'
    }, {
      label: 'Newest items',
      value: 'date'
    }, {
      label: 'Price: low to high',
      value: 'price-asc'
    }, {
      label: 'Price: high to low',
      value: 'price-desc'
    }]
  },
  recommendations_limit: 8
});

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 30 28' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Code' },
      props.title || 'Code'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M.7 15c0-.1.1-.3.2-.4l7.3-7.3c.1-.1.2-.2.4-.2.1 0 .3.1.4.2l.8.8c.1.1.2.2.2.4l-.4.4-6.1 6.1 6.1 6.1c.1.1.2.2.2.4 0 .1-.1.3-.2.4l-.8.8c-.1.1-.2.2-.4.2s-.3-.1-.4-.2l-7.3-7.3c.1-.1 0-.3 0-.4zm10.4 9.8l5.9-20.2c0-.1.1-.2.2-.3s.2-.1.4 0l1 .3c.1 0 .2.1.3.2s.1.2 0 .4l-5.9 20.2c0 .1-.1.2-.2.3s-.2.1-.4 0l-1-.3c-.1 0-.2-.1-.3-.2v-.4zm9.1-3.3c0-.1.1-.3.2-.4l6.1-6.1-6.1-6.1c-.1-.1-.2-.2-.2-.4 0-.1.1-.3.2-.4l.8-.8c.1-.1.2-.2.4-.2s.3.1.4.2l7.3 7.3c.1.1.2.2.2.4 0 .1-.1.3-.2.4l-7.3 7.3c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.2l-.8-.8c-.1-.1-.2-.3-.2-.4z' })
    )
  );
});

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(9);
var mapStateToProps = function (state) {
    var currentSite = state.common.currentSite;
    return {
        currentSite: currentSite
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
var createNotFoundContainer = function (component) {
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(component);
};
exports.default = createNotFoundContainer;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = __webpack_require__(457);
exports.default = button_1.default;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var sites_1 = __webpack_require__(10);
var formatString_1 = __webpack_require__(14);
var user_1 = __webpack_require__(75);
/**
 * Check if an item is favourite
 * @param  {Object} state
 * @param  {Object} item
 * @return {Boolean}
 */
exports.isInFavourites = function (state, item) {
    var collections = user_1.getUserCollections(state);
    var favoriteCollectionID = user_1.getUserFavoriteCollectionID(state);
    return ((collections[favoriteCollectionID] &&
        collections[favoriteCollectionID].bookmarks[item.id] &&
        collections[favoriteCollectionID].bookmarks[item.id].optimisticStatus !==
            'deleted') ||
        false);
};
/**
 * Check if an item is in bookmark
 * @param  {Object} state
 * @param  {Object} item
 * @return {Boolean}
 */
exports.isInBookmarks = function (state, item) {
    var collections = user_1.getUserCollections(state);
    var nonFavoriteCollections = Object.keys(collections)
        .map(function (collectionID) { return collections[collectionID]; })
        .filter(function (collection) { return collection.special_role !== 'favorite'; });
    return (nonFavoriteCollections.some(function (collection) { return collection.bookmarks[item.id]; }) ||
        false);
};
/**
 * Check if an item is in cart
 * @param  {Object} state
 * @param  {Object} item
 * @return {Boolean}
 */
exports.isInCart = function (state, item) {
    var cartItems = user_1.getUserCartItems(state);
    return (cartItems.some(function (cartItemId) { return cartItemId.item_id === item.id; }) || false);
};
var getFooterLink = function (state, item) {
    var currentSite = state.common.currentSite;
    var footerLink = sites_1.getConfigBySite(currentSite, 'item_view.footer_link');
    return (footerLink && {
        href: footerLink.href.replace(/\{(.*)\}/g, function (match, field) {
            return item[field];
        }),
        label: footerLink.label
    });
};
var getItemSmallPreviewUrlPath = function (item) {
    var previewPaths = sites_1.getConfigBySite('defaults', 'ui.item_small_preview_paths');
    return (previewPaths
        .map(function (path) { return lodash_1.get(item.previews, path); })
        .reduce(function (prevPath, currPath) {
        if (prevPath) {
            return prevPath;
        }
        return currPath;
    }));
};
var getPDItemImageAspectRatio = function (item) {
    if (!item.image_urls || item.image_urls.length <= 0) {
        return null;
    }
    var imgUrls = item.image_urls;
    var firstImage = imgUrls[0];
    return firstImage.width / firstImage.height;
};
var price = function (state, match) {
    if (isHostingSetupFilterSelected(state)) {
        return '16';
    }
    return match.price_cents ? match.price_cents.toString().slice(0, -2) : '';
};
var pricePeriod = function (state, match) {
    return isHostingSetupFilterSelected(state) ? 'month' : null;
};
// When 'Hosting & Setup' filter is selected we need to override search result
// prices with a fixed $16/month price
var isHostingSetupFilterSelected = function (state) {
    return state.searchPage.hostingSetupSearch;
};
exports.decorateSearchResult = function (state, match) {
    var formattedClassification = match.classification && typeof match.classification === 'string'
        ? match.classification
            .split('/')
            .map(function (category) { return formatString_1.toTitle(category); })
            .join(' / ')
        : '';
    var newMatch = __assign({}, match, { ui: {
            aspectRatio: getPDItemImageAspectRatio(match),
            footerLink: getFooterLink(state, match),
            formattedClassification: formattedClassification,
            isInBookmarks: exports.isInBookmarks(state, match),
            isInCart: exports.isInCart(state, match),
            isInFavourites: exports.isInFavourites(state, match),
            price: price(state, match),
            pricePeriod: pricePeriod(state, match),
            smallPreviewUrl: getItemSmallPreviewUrlPath(match)
        } });
    return newMatch;
};
/**
 * Compute additional property for ease of use in the UI
 * It does not modify any existing props from the API
 * @param  {Object} global redux state
 * @return {Object} the formatted result selected from state
 */
exports.searchResults = function (state) {
    return __assign({}, state.searchPage.results, { matches: state.searchPage.results.matches.map(function (match) {
            return exports.decorateSearchResult(state, match);
        }) });
};


/***/ }),
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(141);
var common_1 = __webpack_require__(217);
var experiments_1 = __webpack_require__(218);
var homePage_1 = __webpack_require__(219);
var landingPage_1 = __webpack_require__(220);
var layout_1 = __webpack_require__(221);
var marketing_1 = __webpack_require__(222);
var searchPage_1 = __webpack_require__(224);
var user_1 = __webpack_require__(252);
exports.rootReducer = redux_1.combineReducers({
    common: common_1.default,
    experiments: experiments_1.default,
    homePage: homePage_1.reducer,
    landingPage: landingPage_1.default,
    layout: layout_1.default,
    marketing: marketing_1.reducer,
    searchPage: searchPage_1.reducer,
    user: user_1.default
});


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeoutRetryRejectionInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return betterErrorsRejectionInterceptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors__ = __webpack_require__(8);





var timeoutRetryRejectionInterceptor = function timeoutRetryRejectionInterceptor(err) {
  if (err && err.code === 'ECONNABORTED' && err.config && !err.config.__isRetryRequest) {
    err.config.__isRetryRequest = true;
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(err.config);
  }
  throw err;
};

var betterErrorsRejectionInterceptor = function betterErrorsRejectionInterceptor(err) {
  if (!err) {
    return null;
  }

  var url = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, 'config.url');
  var statusCode = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, 'response.status');
  var endpoint = url && url.split('?')[0];

  if (err.message === 'Network Error') {
    throw Object(__WEBPACK_IMPORTED_MODULE_2__errors__["AxiosNetworkError"])({
      url: url,
      message: err.message
    });
  }

  if (err.code === 'ECONNABORTED' || [408, 504].includes(statusCode)) {
    throw Object(__WEBPACK_IMPORTED_MODULE_2__errors__["AxiosTimeoutError"])({
      endpoint: endpoint,
      url: url,
      statusCode: statusCode,
      code: err.code
    });
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_2__errors__["AxiosError"])({
    endpoint: endpoint,
    url: url,
    statusCode: statusCode,
    statusText: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, 'response.statusText'),
    httpMethod: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, 'config.method'),
    responseData: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, 'response.data'),
    responseHeaders: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(err, 'response.headers')
  });
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allDomains; });
/* unused harmony export siteNames */
var allDomains = ['activeden.net', 'audiojungle.net', 'themeforest.net', 'videohive.net', 'graphicriver.net', '3docean.net', 'codecanyon.net', 'photodune.net', 'market.envato.com', 'market.styleguide.envato.com', 'elements.envato.com', 'build.envatohostedservices.com', 'author.envato.com'];

// The order of exported sites determines the order of logotypes
// in the header.
var siteNames = ['themeforest', 'codecanyon', 'videohive', 'audiojungle', 'graphicriver', 'photodune', '3docean'];

/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var activeFeatures = function activeFeatures(query) {
  return query && query.features && query.features.split(',') || [];
};

/* harmony default export */ __webpack_exports__["default"] = (activeFeatures);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3docean_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiojungle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codecanyon_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphicriver_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__photodune_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__themeforest_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__videohive_json__);








/* harmony default export */ __webpack_exports__["default"] = ({
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean_json___default.a,
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default.a,
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default.a,
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default.a,
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune_json___default.a,
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default.a,
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive_json___default.a
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 100 100' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Tempo' },
      props.title || 'Tempo'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M95 23.4l-3.7-3.6-7.4 7.5-4.3-4.3-5.7 9.9 2.2 2.2-8.9 9-5.3-32.6c-.4-2.7-3-4.9-5.7-4.9h-32.5c-2.7 0-5.3 2.2-5.8 4.9l-12.9 77.1c-.5 2.7 1.4 4.9 4.1 4.9h61.3c2.7 0 4.6-2.2 4.1-4.9l-6.2-38.2 11.5-11.7 2.2 2.2 9.8-5.8-4.3-4.3 7.5-7.4zm-72.9 46.4c-2.7 0-4.6-2.2-4.2-4.9l7.2-45.2c.4-2.7 3-4.9 5.7-4.9h18.3c2.7 0 5.3 2.2 5.7 4.9l4.9 32.1-14.2 14.4v-.2h-7.8v-4.3h7.8v-6.8h-7.8v-4.3h7.8v-6.8h-7.8v-4.3h7.8v-6.8h-7.8v-4.3h7.8v-.4c0-2.7-2.2-4.9-4.9-4.9h-1.5c-2.7 0-4.9 2.2-4.9 4.9v41.8h-12.1zm39.6-4.9c.4 2.7-1.5 4.9-4.2 4.9h-8.3l11.5-11.6 1 6.7z' })
    )
  );
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Cog' },
      props.title || 'Cog'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M421.9 162c7 11.6 12.4 24.5 16.1 38.8 10.3 2.1 21.3 3.5 32.7 4.1 11.5.6 22.2 2.7 32 6.3 3.4.8 5.1 2.7 5.1 5.7v74.4c0 2.6-3.2 4.8-9.3 6.8-6.3 2.1-13.5 3.6-21.6 4.9-8.2 1.3-16.2 2.2-24 2.8-7.7.6-12.9 1.2-15.5 1.5-3 12-7.9 24.4-14.8 37 11.6 17.3 24.4 33.8 38.2 49.6l1.9 4.8c0 1.7-2.8 5.7-8.6 12.1-5.8 6.4-12.4 13.3-19.7 20.7-7.4 7.3-14.4 13.9-21 19.7-6.7 5.8-11 8.6-12.8 8.6-.5 0-3.2-1.9-8.4-5.8s-10.9-8.2-17.1-13c-6.2-4.6-12.1-9.3-17.7-13.5-5.6-4.4-9.1-7-10.6-7.7-6.2 3.4-12.3 6.2-18.6 8.6-6.2 2.4-12.4 4.5-18.7 6.2-.4 2.6-1 7.7-1.7 15.6-.8 8-1.7 16-3 24.1-1.3 8.1-2.8 15.3-4.5 21.9-1.7 6.6-3.9 9.8-6.6 9.8h-74.9c-3 0-5-1.8-6-5.4-3-10.3-5-21.1-6-32.5-1.1-11.3-2.2-22.2-3.5-32.6-12.9-3.7-25.2-9-36.9-15.7-8.7 6.6-17.2 12.9-25.6 19.1-8.4 6.2-16.7 12.8-24.9 19.7l-3.8 1.3c-1.3 0-5.2-2.8-11.7-8.6-6.5-5.8-13.3-12.4-20.4-19.7-7.1-7.5-13.5-14.3-19.3-20.7-5.8-6.4-8.7-10.4-8.7-12.1 0-.5 1.7-3.2 5.1-8.4 3.4-5.2 7.3-10.8 11.9-16.9 4.5-6.2 9-12 13.3-17.5 4.3-5.7 7.1-9.3 8.4-10.9-7-11.6-12.3-24.5-16.1-38.9-10.8-2.1-21.7-3.4-33-4-11.3-.6-21.8-2.8-31.7-6.3-3.4-.9-5.1-2.8-5.1-5.8v-74.4c0-2.6 3.2-4.8 9.6-6.8 6.4-2 13.6-3.7 21.6-4.9 8-1.2 15.8-2.3 23.4-2.8 7.6-.6 12.6-1.2 15.2-1.6 3.8-12.8 8.9-25.1 15.5-36.9-11.6-17.3-24.2-33.8-37.9-49.6l-2.2-4.7c0-1.7 2.9-5.8 8.8-12.2 5.9-6.4 12.5-13.3 19.7-20.7 7.3-7.3 14.3-13.9 21-19.7 6.7-5.8 10.9-8.8 12.6-8.8.4 0 3.2 2 8.4 5.9 5.2 3.9 10.9 8.2 17.2 12.9 6.3 4.8 12.3 9.3 17.8 13.6 5.6 4.3 9 6.9 10.3 7.7 6.1-3.3 12.3-6.1 18.5-8.4 6.2-2.2 12.6-4.3 19.1-6.4 0-2.5.3-7.7.9-15.5.6-7.7 1.6-15.7 2.8-23.6 1.3-8 2.9-15.3 4.9-21.8 2-6.4 4.3-9.7 6.8-9.7h74.9c2.9 0 5 1.5 6 4.7 2.5 10.3 4.4 21.1 5.4 32.5 1 11.4 2.6 22.5 4.4 33.5 6.5 1.7 12.8 3.7 18.8 6 6.1 2.3 12 5.3 17.9 8.8 1.7-1.2 5.2-4.1 10.7-8.4 5.5-4.3 11.3-8.8 17.5-13.6 6.2-4.7 11.9-8.9 16.8-12.6 5-3.7 8.1-5.5 9.3-5.5 1.2 0 5.2 3 11.7 8.8 6.6 5.8 13.4 12.4 20.5 19.7 7.2 7.3 13.6 14.3 19.4 20.7 5.8 6.4 8.7 10.5 8.7 12.2 0 .8-1.9 3.9-5.5 9-3.7 5.2-7.9 10.8-12.4 16.9-4.5 6.1-9 11.9-13.3 17.5-4.2 5.4-6.8 8.9-7.7 10.1zm-165.5 167.7c10.3 0 20.1-2.1 29.3-6.2 9.3-4.1 17.3-9.7 24-16.6 6.6-7 12-14.9 16.1-24.2 4.1-9.3 6.1-19.1 6.1-29.3 0-10.3-2.1-20-6.1-29.1-4.1-9-9.5-17-16.1-24-6.7-7-14.7-12.4-24-16.2-9.3-3.9-19-5.9-29.3-5.9s-20.2 2-29.5 5.9c-9.4 3.9-17.5 9.3-24.3 16.2-6.8 7-12.2 15-16.1 24-3.9 9.1-5.8 18.8-5.8 29.1s1.9 20.1 5.8 29.3c3.9 9.3 9.3 17.3 16.1 24.2 6.8 7 14.9 12.5 24.3 16.6 9.3 4.2 19.2 6.2 29.5 6.2z' })
    )
  );
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemMatrix", function() { return getItemMatrix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors__ = __webpack_require__(8);



var getItemMatrix = function getItemMatrix(itemId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].get('/shopfront_api/item/' + itemId + '/price_matrix').then(function (res) {
    return res.data;
  }).catch(function (err) {
    return Promise.reject(Object(__WEBPACK_IMPORTED_MODULE_1__errors__["logError"])(err));
  });
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCollection", function() { return createCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFavoriteCollection", function() { return createFavoriteCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authMiddleware__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_user__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__ = __webpack_require__(38);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var createCollectionRequestAction = { type: 'createCollectionRequest' };
var createCollectionSuccessAction = function createCollectionSuccessAction(response) {
  Object(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["reportCollectionCreated"])();
  return {
    type: 'createCollectionSuccess',
    payload: response
  };
};
var createCollectionFailureAction = function createCollectionFailureAction(name, isPublic) {
  return {
    type: 'createCollectionFailure',
    payload: { name: name, isPublic: isPublic }
  };
};

var createCollection = function createCollection(_ref) {
  var name = _ref.name,
      _ref$isPublic = _ref.isPublic,
      isPublic = _ref$isPublic === undefined ? false : _ref$isPublic,
      description = _ref.description,
      specialRole = _ref.specialRole;

  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, token, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), token = _getState.user.token;

              if (token) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', dispatch(createCollectionFailureAction(name, isPublic)));

            case 3:

              dispatch(createCollectionRequestAction);

              _context.prev = 4;
              _context.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_2__utils_user__["d" /* createCollectionRequest */])(token, {
                name: name,
                isPublic: isPublic,
                description: description,
                specialRole: specialRole
              });

            case 7:
              response = _context.sent;
              return _context.abrupt('return', dispatch(createCollectionSuccessAction(response)));

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](4);

              if (!(_context.t0.statusCode === 401)) {
                _context.next = 17;
                break;
              }

              return _context.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(createCollection({
                name: name,
                isPublic: isPublic,
                description: description,
                specialRole: specialRole
              }))));

            case 17:
              Object(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["logError"])(_context.t0);
              return _context.abrupt('return', dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__layout__["showModalMessage"])({ message: 'Create collection failed' })));

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 11]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var createFavoriteCollection = function createFavoriteCollection() {
  return createCollection({
    name: 'My Favorites',
    isPublic: 'false',
    description: 'Items you marked as your favorites.',
    specialRole: 'favorite'
  });
};

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(11);


/**
 * Get shopfront jwt token with given sso token
 * @return {String} jwt token
 */
var getSession = function getSession() {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["default"].get('/jwt_session');
};



/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(3);
var SearchBarInput = /** @class */ (function (_super) {
    __extends(SearchBarInput, _super);
    function SearchBarInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value || ''
        };
        return _this;
    }
    SearchBarInput.prototype.componentWillReceiveProps = function (nextProps) {
        var value = nextProps.value;
        if (value !== this.state.value) {
            this.setState({ value: value });
        }
    };
    SearchBarInput.prototype.render = function () {
        var passProps = lodash_1.omit(this.props, [
            'type',
            'value',
            'onChange',
            'aria-label'
        ]);
        return (React.createElement("input", __assign({ type: "search", value: this.state.value, onChange: this.onChange.bind(this), "aria-label": "search" }, passProps)));
    };
    SearchBarInput.prototype.onChange = function (event) {
        var _this = this;
        this.setState({ value: event.target.value }, function () {
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        });
    };
    return SearchBarInput;
}(React.Component));
exports.default = SearchBarInput;


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/phoenix-socket/dist/socket.js
var socket = __webpack_require__(451);
var socket_default = /*#__PURE__*/__webpack_require__.n(socket);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./common/utils/ga.js
var ga = __webpack_require__(13);

// CONCATENATED MODULE: ./common/analytics/searchBarAnalytics.js


var searchBarAnalytics_reportAutoSuggest = function reportAutoSuggest(payload) {
  Object(ga["default"])('set', {
    metric2: payload.suggestedTerm.length,
    metric3: payload.label.length,
    dimension16: payload.suggestedTerm.join(',')
  });
  Object(ga["default"])('send', 'event', 'autosuggestion', payload.action || 'click', payload.label);
};
// CONCATENATED MODULE: ./common/constants/autoSuggestEndpoints.js
/* harmony default export */ var autoSuggestEndpoints = ({
  endpoint: 'wss://suggest.market.envato.com/socket',
  channel: 'autocomplete:standard'
});
// EXTERNAL MODULE: ./common/utils/urlHelper.js
var urlHelper = __webpack_require__(5);

// EXTERNAL MODULE: ./common/utils/errors.js + 4 modules
var errors = __webpack_require__(8);

// EXTERNAL MODULE: ./client/components/searchBar/searchBarForm.tsx
var searchBarForm = __webpack_require__(77);
var searchBarForm_default = /*#__PURE__*/__webpack_require__.n(searchBarForm);

// EXTERNAL MODULE: ./config/sites/categories/index.js
var categories = __webpack_require__(53);

// EXTERNAL MODULE: ./client/components/autosuggest/recentSearch.ts
var recentSearch = __webpack_require__(282);
var recentSearch_default = /*#__PURE__*/__webpack_require__.n(recentSearch);

// CONCATENATED MODULE: ./client/components/autosuggest/autoSuggestDataContainer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















/* harmony default export */ var autoSuggestDataContainer = __webpack_exports__["default"] = (function (AutoSuggest) {
  var AutoSuggestDataContainer = function (_React$Component) {
    _inherits(AutoSuggestDataContainer, _React$Component);

    function AutoSuggestDataContainer(props) {
      _classCallCheck(this, AutoSuggestDataContainer);

      var _this = _possibleConstructorReturn(this, (AutoSuggestDataContainer.__proto__ || Object.getPrototypeOf(AutoSuggestDataContainer)).call(this, props));

      _this.state = {
        suggestions: [],
        inputValue: props.value || ''
      };

      _this.socketConnection = null;
      _this.socketChannel = null;

      _this.setSuggestions = _this.setSuggestions.bind(_this);
      _this.onInputChange = _this.onInputChange.bind(_this);
      _this.onSelectOption = _this.onSelectOption.bind(_this);
      _this.onInputFocus = _this.onInputFocus.bind(_this);
      return _this;
    }

    _createClass(AutoSuggestDataContainer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.initSocket();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.closeSocket();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
          this.setState({
            inputValue: nextProps.value
          });
        }
      }
    }, {
      key: 'initSocket',
      value: function initSocket() {
        var _this2 = this;

        var endpoint = autoSuggestEndpoints.endpoint,
            channel = autoSuggestEndpoints.channel;


        this.socketConnection = new socket["Socket"](endpoint);
        this.socketChannel = this.socketConnection.channel(channel, {});

        this.socketConnection.connect();

        this.socketChannel.on('new_msg', function (message) {
          _this2.setSuggestions(message.body);
        });

        this.socketChannel.join().receive('ok', function () {
          if (_this2.state.inputValue) {
            _this2.sendMessage(_this2.state.inputValue);
          }
        }).receive('error', function (reason) {
          Object(errors["logError"])(Object(errors["WebSocketError"])({ message: reason }));
        });
      }
    }, {
      key: 'closeSocket',
      value: function closeSocket() {
        if (this.socketConnection) {
          this.socketConnection.disconnect();
        }
      }
    }, {
      key: 'sendMessage',
      value: function sendMessage() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var currentSite = this.props.currentSite;


        var message = {
          body: value.trim().toLowerCase(),
          category: null,
          site: currentSite || 'themeforest'
        };

        if (this.socketConnection && this.socketChannel && this.socketConnection.isConnected() && this.socketChannel.isJoined()) {
          this.socketChannel.push('new_msg', message).receive('error', function (reason) {
            Object(errors["logError"])(Object(errors["WebSocketError"])({ message: reason }));
          });
        }
      }
    }, {
      key: 'setSuggestions',
      value: function setSuggestions(suggestions) {
        this.setState({
          suggestions: suggestions
        });
      }
    }, {
      key: 'onInputChange',
      value: function onInputChange() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        this.setState({
          inputValue: value
        });
        if (value === '') {
          this.setSuggestions(recentSearch_default.a.getRecentSearch());
        } else {
          this.sendMessage(value);
        }
      }
    }, {
      key: 'getLink',
      value: function getLink(term) {
        var location = this.props.location;


        var nextQueries = Object.assign({}, Object(urlHelper["parseLocation"])(location), {
          term: term
        });
        // reset page number
        delete nextQueries.page;
        return Object(urlHelper["makeLink"])(nextQueries);
      }
    }, {
      key: 'onSelectOption',
      value: function onSelectOption(option, event) {
        var history = this.props.history;
        var suggestions = this.state.suggestions;


        var nextOption = void 0;

        // if the selection option is a string, we need to build the link
        if (typeof option === 'string') {
          nextOption = {
            text: option,
            link: this.getLink(option)
            // if the selection option is an object, it means it's triggered by auto-suggest
            // we need to report this to ga
          };
        } else if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
          nextOption = Object.assign({}, option);
          searchBarAnalytics_reportAutoSuggest({
            action: event && event.type === 'mousedown' ? 'click' : 'keyboard',
            label: option.text,
            suggestedTerm: suggestions.map(function (suggestion) {
              return suggestion.text;
            })
          });

          if (nextOption.type === 'p') {
            nextOption.link = this.getLink(option.text);
          }
        }

        if (nextOption && nextOption.text) {
          recentSearch_default.a.addItem(nextOption.text);
          this.setState({
            inputValue: nextOption.text
          }, function () {
            history.push(nextOption.link);
          });
        }
      }
    }, {
      key: 'onInputFocus',
      value: function onInputFocus() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (value === '') {
          this.setState({ suggestions: recentSearch_default.a.getRecentSearch() });
        }
      }
    }, {
      key: 'getCategorySuggestions',
      value: function getCategorySuggestions() {
        var suggestions = this.state.suggestions;
        var currentSite = this.props.currentSite;


        var categorySuggestions = suggestions.filter(function (suggestion) {
          return suggestion.type === 'c';
        }).map(function (suggestion) {
          return suggestion.categories.map(function (categoryKey) {
            return {
              link: suggestion.link + categoryKey,
              type: suggestion.type,
              text: suggestion.text,
              category: Object(categories["getTopCategoryLabel"])(currentSite, categoryKey) || categoryKey
            };
          });
        });

        return Object(lodash["flatten"])(categorySuggestions);
      }
    }, {
      key: 'getSuggestions',
      value: function getSuggestions() {
        var showCategories = this.props.showCategories;
        var suggestions = this.state.suggestions;


        var nonCategorySuggestions = suggestions.filter(function (suggestion) {
          return suggestion.type !== 'c';
        });

        if (showCategories) {
          return this.getCategorySuggestions().concat(nonCategorySuggestions);
        }

        return nonCategorySuggestions;
      }
    }, {
      key: 'render',
      value: function render() {
        var inputValue = this.state.inputValue;
        var location = this.props.location;


        var autosuggestProps = _extends({}, this.props, {
          suggestions: this.getSuggestions(),
          onInputChange: this.onInputChange,
          onSelectOption: this.onSelectOption,
          inputValue: inputValue,
          type: 'search',
          onInputFocus: this.onInputFocus
        });
        return react_default.a.createElement(
          searchBarForm_default.a,
          { location: location },
          react_default.a.createElement(AutoSuggest, autosuggestProps)
        );
      }
    }]);

    return AutoSuggestDataContainer;
  }(react_default.a.Component);

  AutoSuggestDataContainer.propTypes = {
    inputName: prop_types_default.a.string.isRequired,
    placeholder: prop_types_default.a.string,
    location: prop_types_default.a.object.isRequired
  };
  AutoSuggestDataContainer.defaultProps = {
    placeholder: ''
  };


  return Object(es["withRouter"])(AutoSuggestDataContainer);
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keycode__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keycode__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/* harmony default export */ __webpack_exports__["default"] = (function (AutoSuggest) {
  var AutoSuggestLogicContainer = function (_React$Component) {
    _inherits(AutoSuggestLogicContainer, _React$Component);

    function AutoSuggestLogicContainer(props) {
      _classCallCheck(this, AutoSuggestLogicContainer);

      var _this = _possibleConstructorReturn(this, (AutoSuggestLogicContainer.__proto__ || Object.getPrototypeOf(AutoSuggestLogicContainer)).call(this, props));

      _this.state = {
        inputValue: props.inputValue,
        isOpen: false,
        focusedIndex: -1
      };

      _this.handleInputFocus = _this.handleInputFocus.bind(_this);
      _this.handleInputChange = _this.handleInputChange.bind(_this);
      _this.handleKeyDown = _this.handleKeyDown.bind(_this);
      _this.handleKeyUp = _this.handleKeyUp.bind(_this);
      _this.setWrapperRef = _this.setWrapperRef.bind(_this);
      _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
      _this.handleMenuMouseEnter = _this.handleMenuMouseEnter.bind(_this);
      _this.handleMenuMouseLeave = _this.handleMenuMouseLeave.bind(_this);
      return _this;
    }

    _createClass(AutoSuggestLogicContainer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick, true);
        document.addEventListener('touchend', this.handleDocumentClick, true);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick, true);
        document.removeEventListener('touchend', this.handleDocumentClick, true);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.inputValue !== this.props.inputValue) {
          this.setState({
            inputValue: nextProps.inputValue
          });
        }
      }
    }, {
      key: 'setWrapperRef',
      value: function setWrapperRef(ref) {
        if (ref !== null) {
          this.wrapper = ref;
        }
      }
    }, {
      key: 'setTextInputRef',
      value: function setTextInputRef(ref) {
        if (ref !== null) {
          this.textInput = ref;
        }
      }
    }, {
      key: 'setMenuRef',
      value: function setMenuRef(ref) {
        if (ref !== null) {
          this.menu = ref;
        }
      }
    }, {
      key: 'handleDocumentClick',
      value: function handleDocumentClick(event) {
        if (!this.wrapper.contains(event.target)) {
          this.setState({ isOpen: false });
        }
      }
    }, {
      key: 'handleInputChange',
      value: function handleInputChange(event) {
        if (this.props.onInputChange) {
          this.props.onInputChange(event.target.value);
        }

        // if auto suggest menu is not open, we should open it on input change
        if (!this.state.isOpen) {
          this.setState({
            isOpen: true
          });
        }
      }
    }, {
      key: 'handleInputFocus',
      value: function handleInputFocus(event) {
        this.setState({
          isOpen: true
        });

        if (this.props.onInputFocus) {
          this.props.onInputFocus(event.target.value);
        }
      }
    }, {
      key: 'onMenuClick',
      value: function onMenuClick(option, event) {
        event.preventDefault();

        if (this.props.onSelectOption) {
          this.props.onSelectOption(option, event);
        }

        this.setState({
          isOpen: false
        });
      }
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(event) {
        var keyCode = event.which;

        switch (keyCode) {
          // Block up/down arrow from moving the cursor in the search input
          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('up'):
          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('down'):
            event.preventDefault();
            break;

          // 1. Because Enter triggers form submission before we get the chance to run
          //    `_updateAnalyticsParamInput`, we disable the submission on keydown and
          //    manually trigger it on keyup. Ideally we'd have the form and the input
          //    as custom React components and then this wouldn't be necessary.
          // 2. Block Esc from emptying the search input
          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('enter'):
          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('esc'):
            event.preventDefault();
            break;
        }
      }
    }, {
      key: 'handleKeyUp',
      value: function handleKeyUp(event) {
        var _state = this.state,
            focusedIndex = _state.focusedIndex,
            inputValue = _state.inputValue;
        var suggestions = this.props.suggestions;


        var keyCode = event.which;

        switch (keyCode) {
          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('enter'):
            if (this.props.onSelectOption) {
              // when the user hit `enter` without selecting any option, we simply pass the inputValue to onSelection option
              this.props.onSelectOption(focusedIndex === -1 ? inputValue : suggestions[focusedIndex], event);
            }

            this.setState({
              isOpen: false
            });
            break;

          // Esc hides autosuggest and deselects the current suggestion
          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('esc'):
            this.setState({
              isOpen: false,
              focusedIndex: -1
            });
            break;

          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('up'):
            this.setFocusedIndex('prev');
            break;

          case __WEBPACK_IMPORTED_MODULE_1_keycode___default()('down'):
            this.setFocusedIndex('next');
            break;

          default:
            this.setState({
              focusedIndex: -1
            });
            event.preventDefault();
        }
      }
    }, {
      key: 'setFocusedIndex',
      value: function setFocusedIndex(dir) {
        var _state2 = this.state,
            focusedIndex = _state2.focusedIndex,
            inputValue = _state2.inputValue;
        var suggestions = this.props.suggestions;

        var optionLength = suggestions.length;

        var isNoneSelected = focusedIndex === -1;
        var isFirstSelected = focusedIndex === 0;
        var isLastSelected = focusedIndex === optionLength - 1;

        if (dir === 'prev') {
          if (isFirstSelected || isNoneSelected) {
            this.setState({
              focusedIndex: optionLength - 1,
              inputValue: suggestions[optionLength - 1] ? suggestions[optionLength - 1].text : inputValue
            });
          } else {
            this.setState({
              focusedIndex: focusedIndex - 1,
              inputValue: suggestions[focusedIndex - 1] ? suggestions[focusedIndex - 1].text : inputValue
            });
          }
        } else if (dir === 'next') {
          if (isLastSelected || isNoneSelected) {
            this.setState({
              focusedIndex: 0,
              inputValue: suggestions[0] ? suggestions[0].text : inputValue
            });
          } else {
            this.setState({
              focusedIndex: focusedIndex + 1,
              inputValue: suggestions[focusedIndex + 1] ? suggestions[focusedIndex + 1].text : inputValue
            });
          }
        }
      }
    }, {
      key: 'handleMenuMouseEnter',
      value: function handleMenuMouseEnter(index) {
        this.setState({
          focusedIndex: index
        });
      }
    }, {
      key: 'handleMenuMouseLeave',
      value: function handleMenuMouseLeave() {
        this.setState({
          focusedIndex: -1
        });
      }
    }, {
      key: 'onSearchDismiss',
      value: function onSearchDismiss() {
        this.setState({
          inputValue: ''
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state3 = this.state,
            focusedIndex = _state3.focusedIndex,
            isOpen = _state3.isOpen,
            inputValue = _state3.inputValue;

        var props = _extends({}, this.props, {
          focusedIndex: focusedIndex,
          inputValue: inputValue,
          isOpen: isOpen,
          wrapperRef: this.wrapper,
          textInputRef: this.textInput,
          setWrapperRef: this.setWrapperRef.bind(this),
          setMenuRef: this.setMenuRef.bind(this),
          setTextInputRef: this.setTextInputRef.bind(this),
          onMenuClick: this.onMenuClick.bind(this),
          handleMenuMouseEnter: this.handleMenuMouseEnter.bind(this),
          handleMenuMouseLeave: this.handleMenuMouseLeave.bind(this),
          handleInputChange: this.handleInputChange.bind(this),
          handleInputFocus: this.handleInputFocus.bind(this),
          handleKeyDown: this.handleKeyDown.bind(this),
          handleKeyUp: this.handleKeyUp.bind(this),
          onSearchDismiss: this.onSearchDismiss.bind(this)
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoSuggest, props);
      }
    }]);

    return AutoSuggestLogicContainer;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  return AutoSuggestLogicContainer;
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportPageView", function() { return reportPageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportExperiment", function() { return reportExperiment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ga__ = __webpack_require__(13);


var reportPageView = function reportPageView() {
  if (typeof document === 'undefined') {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__ga__["default"])('send', {
    hitType: 'pageview'
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__ga__["default"])('set', {
    referrer: null
  });
};

var reportExperiment = function reportExperiment(experimentId, variantId) {
  Object(__WEBPACK_IMPORTED_MODULE_0__ga__["default"])('set', 'expId', experimentId);
  Object(__WEBPACK_IMPORTED_MODULE_0__ga__["default"])('set', 'expVar', variantId);
  Object(__WEBPACK_IMPORTED_MODULE_0__ga__["default"])('send', {
    hitType: 'event',
    eventCategory: 'experiment',
    eventAction: 'view',
    eventLabel: experimentId,
    eventValue: variantId,
    nonInteraction: true
  });
};



/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var querystring = __webpack_require__(22);
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
var TypeKeys;
(function (TypeKeys) {
    TypeKeys["GET_NEWEST_ITEMS_BY_CATEGORY_PENDING"] = "GET_NEWEST_ITEMS_BY_CATEGORY_PENDING";
    TypeKeys["GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS"] = "GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS";
    TypeKeys["GET_NEWEST_ITEMS_BY_CATEGORY_FAIL"] = "GET_NEWEST_ITEMS_BY_CATEGORY_FAIL";
})(TypeKeys = exports.TypeKeys || (exports.TypeKeys = {}));
exports.fetchNewestItemsByCategory = function (category) {
    return function (dispatch, getState) {
        var currentSite = getState().common.currentSite;
        var query;
        if (category === 'all') {
            query = { site: currentSite + ".net", page_size: 40, sort_by: 'date' };
        }
        else {
            query = {
                category: category,
                page_size: 40,
                site: currentSite + ".net",
                sort_by: 'date'
            };
        }
        dispatch({
            payload: { category: category },
            type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
        });
        return axiosVerbose_1.default
            .get("/shopfront_api/search?" + querystring.stringify(query))
            .then(function (response) {
            var successAction = {
                payload: { searchResults: response.data, category: category },
                type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
            };
            return dispatch(successAction);
        })
            .catch(function (err) { return Promise.reject(errors_1.logError(err)); })
            .catch(function () {
            var failAction = {
                type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
            };
            return dispatch(failAction);
        });
    };
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
var getProxyApiUrl_1 = __webpack_require__(70);
var TypeKeys;
(function (TypeKeys) {
    TypeKeys["GET_HOME_PAGE_API_SUCCESS"] = "GET_HOME_PAGE_API_SUCCESS";
    TypeKeys["GET_HOME_PAGE_API_FAIL"] = "GET_HOME_PAGE_API_FAIL";
})(TypeKeys = exports.TypeKeys || (exports.TypeKeys = {}));
exports.fetchHomePageDataBySite = function (parsedUrl, opts) {
    return function (dispatch, getState) {
        var currentSite = getState().common.currentSite;
        var apiUrlPrefix = getProxyApiUrl_1.default(opts);
        return axiosVerbose_1.default
            .get(apiUrlPrefix + "/shopfront_api/homepage/" + currentSite)
            .then(function (response) {
            var action = {
                payload: response.data,
                type: TypeKeys.GET_HOME_PAGE_API_SUCCESS
            };
            return dispatch(action);
        })
            .catch(function (err) { return Promise.reject(errors_1.logError(err)); })
            .catch(function () {
            var action = {
                type: TypeKeys.GET_HOME_PAGE_API_FAIL
            };
            return dispatch(action);
        });
    };
};


/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Folder' },
      props.title || 'Folder'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M507.5 177v213.7c0 18.6-6.7 34.6-20 48-13.4 13.4-29.3 20-48 20h-369.1c-18.6 0-34.6-6.7-48-20-13.4-13.4-20-29.3-20-48v-291.4c0-18.6 6.7-34.6 20-48 13.4-13.4 29.3-20 48-20h97.1c18.6 0 34.6 6.7 48 20 13.4 13.4 20 29.3 20 48v9.7h204c18.6 0 34.6 6.7 48 20 13.4 13.4 20 29.4 20 48z' })
    )
  );
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Tag' },
      props.title || 'Tag'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M152 108.5c0-11.8-4.2-21.9-12.5-30.3-8.4-8.4-18.5-12.5-30.3-12.5s-21.9 4.2-30.3 12.5-12.5 18.5-12.5 30.3 4.2 21.9 12.5 30.3 18.5 12.5 30.3 12.5 21.9-4.2 30.3-12.5 12.5-18.5 12.5-30.3zm356.9 192.6c0 11.8-4.1 21.9-12.4 30.1l-164.2 164.6c-8.7 8.2-18.8 12.4-30.5 12.4-11.8 0-21.9-4.1-30.1-12.4l-239.1-239.5c-8.5-8.2-15.7-19.5-21.6-33.8s-8.8-27.3-8.8-39.1v-139.2c0-11.6 4.2-21.6 12.7-30.1s18.5-12.7 30.1-12.7h139.2c11.8 0 24.8 3 39.1 8.8 14.3 5.9 25.6 13.1 34.1 21.6l239.1 238.8c8.2 8.8 12.4 18.9 12.4 30.5z' })
    )
  );
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Dollar' },
      props.title || 'Dollar'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M255.3-.7c-141.5 0-256.2 114.7-256.2 256.2s114.7 256.2 256.2 256.2 256.2-114.7 256.2-256.2c.1-141.5-114.7-256.2-256.2-256.2zm0 478.3c-122.5 0-222.1-99.6-222.1-222.1s99.7-222.1 222.1-222.1 222.1 99.6 222.1 222.1-99.6 222.1-222.1 222.1zM323.6 170.1c9.4 0 17.1-7.7 17.1-17.1 0-9.4-7.7-17.1-17.1-17.1h-51.3v-17.1c0-9.4-7.7-17.1-17.1-17.1-9.4 0-17.1 7.7-17.1 17.1v17.1h-17.1c-20.6 0-51.3 13.6-51.3 51.3v34.2c0 37.6 30.6 51.3 51.3 51.3h17.1v68.3h-51.1c-9.4 0-17.1 7.7-17.1 17.1 0 9.4 7.7 17.1 17.1 17.1h51.3v17.1c0 9.4 7.7 17.1 17.1 17.1 9.4 0 17.1-7.7 17.1-17.1v-17.1h17.1c20.6 0 51.3-13.6 51.3-51.3v-34.2c0-37.6-30.6-51.3-51.3-51.3h-17.1v-68.3h51.1zm-85.4 68.3h-17.1c-7.7-.2-17.1-3.3-17.1-17.1v-34.2c0-13.7 9.4-16.9 17.1-17.1h17.1v68.4zm51.3 34.2c7.7.2 17.1 3.3 17.1 17.1v34.2c0 13.7-9.4 16.9-17.1 17.1h-17.1v-68.3l17.1-.1z' })
      )
    )
  );
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Sort' },
      props.title || 'Sort'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { stroke: '#449FDB', d: 'M10.4 10.4' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M19.8 401.8c1.5-3.7 4.2-5.5 8.2-5.5h52.6v-377.1c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h52.6c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v377.1h52.6c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3 0 2.2-.9 4.4-2.7 6.6l-87.5 87.4c-1.8 1.6-3.9 2.5-6.3 2.5-2.2 0-4.3-.8-6.3-2.5l-87.7-87.7c-2.7-2.9-3.4-6.1-1.9-9.6zm236.2 38.4c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h70.2c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3-1.6 1.6-3.7 2.5-6.3 2.5h-70.2c-2.6 0-4.7-.8-6.3-2.5-1.6-1.6-2.5-3.7-2.5-6.3v-52.6zm0-87.7v-52.6c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h122.8c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3s-3.7 2.5-6.3 2.5h-122.8c-2.6 0-4.7-.8-6.3-2.5-1.7-1.7-2.5-3.8-2.5-6.3zm0-140.3v-52.6c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h175.4c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3-1.6 1.6-3.7 2.5-6.3 2.5h-175.4c-2.6 0-4.7-.8-6.3-2.5-1.7-1.7-2.5-3.8-2.5-6.3zm0-140.4v-52.6c0-2.6.8-4.7 2.5-6.3 1.6-1.6 3.7-2.5 6.3-2.5h228c2.6 0 4.7.8 6.3 2.5 1.6 1.6 2.5 3.7 2.5 6.3v52.6c0 2.6-.8 4.7-2.5 6.3s-3.7 2.5-6.3 2.5h-228c-2.6 0-4.7-.8-6.3-2.5s-2.5-3.7-2.5-6.3z' })
    )
  );
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Calendar' },
      props.title || 'Calendar'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M57.5 473.5h81.5v-81.5h-81.5v81.5zm99.6 0h90.6v-81.5h-90.6v81.5zm-99.6-99.7h81.5v-90.6h-81.5v90.6zm99.6 0h90.6v-90.6h-90.6v90.6zm-99.6-108.8h81.5v-81.5h-81.5v81.5zm208.4 208.5h90.6v-81.5h-90.6v81.5zm-108.8-208.5h90.6v-81.5h-90.6v81.5zm217.6 208.5h81.5v-81.5h-81.5v81.5zm-108.8-99.7h90.6v-90.6h-90.6v90.6zm-99.7-244.7v-81.6c0-2.4-.9-4.6-2.7-6.4-1.8-1.8-3.9-2.7-6.4-2.7h-18.1c-2.4 0-4.6.9-6.4 2.7-1.8 1.8-2.7 3.9-2.7 6.4v81.5c0 2.4.9 4.6 2.7 6.4 1.8 1.8 3.9 2.7 6.4 2.7h18.1c2.4 0 4.6-.9 6.4-2.7 1.8-1.7 2.7-3.8 2.7-6.3zm208.5 244.7h81.5v-90.6h-81.5v90.6zm-108.8-108.8h90.6v-81.5h-90.6v81.5zm108.8 0h81.5v-81.5h-81.5v81.5zm9-135.9v-81.6c0-2.4-.9-4.6-2.7-6.4-1.8-1.8-3.9-2.7-6.4-2.7h-18.1c-2.4 0-4.6.9-6.4 2.7-1.8 1.8-2.7 3.9-2.7 6.4v81.5c0 2.4.9 4.6 2.7 6.4 1.8 1.8 3.9 2.7 6.4 2.7h18.1c2.4 0 4.6-.9 6.4-2.7 1.8-1.7 2.7-3.8 2.7-6.3zm108.7-18.1v362.5c0 9.8-3.6 18.3-10.8 25.5-7.2 7.1-15.7 10.8-25.5 10.8h-398.7c-9.8 0-18.3-3.6-25.5-10.8-7.1-7.2-10.8-15.7-10.8-25.5v-362.5c0-9.8 3.6-18.3 10.8-25.5 7.2-7.1 15.7-10.8 25.5-10.8h36.2v-27.2c0-12.5 4.4-23.1 13.3-32 8.8-8.8 19.6-13.3 32-13.3h18.1c12.5 0 23.1 4.4 32 13.3s13.3 19.6 13.3 32v27.2h108.7v-27.2c0-12.5 4.4-23.1 13.3-32 8.8-8.8 19.6-13.3 32-13.3h18.1c12.5 0 23.1 4.4 32 13.3 8.8 8.9 13.3 19.6 13.3 32v27.2h36.3c9.8 0 18.3 3.6 25.5 10.8s10.9 15.7 10.9 25.5z' })
    )
  );
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 90.9 100' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Polygon' },
      props.title || 'Polygon'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M90.6 42.7v-26.5h-26.5v9.2l-26.7-7.3v-16.8h-26.4v26.5h11.3l-6.7 44.5h-15.3v26.5h26.5v-13.9l30.7-1.3v12.3h26.5v-26.5h-11.4l3.3-26.7h14.7zm-70.5 49.3h-13.1v-13.1h13.1v13.1zm10.7-70.9h-13.1v-13.1h13.1v13.1zm46.5 55v13.1h-13.1v-13.1h13.1zm-6.3-40.1v-13.1h13.1v13.1h-13.1z' })
    )
  );
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 100 100' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Palette' },
      props.title || 'Palette'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M84.7 81.6c-.2-4-6.2-15.9-6-20.5.2-5.2 3.3-11.7 9.9.9 4 7.6 10 2.9 10.8-.8 2.2-11.1-1.1-24.5-11.6-37.5-18.2-22.6-50.2-28.8-71.4-13.9-21.2 15-21.7 48.6-2.3 68.1 17.6 17.7 41.8 25.4 62 16.9 2.1-.8 9-3.5 8.6-13.2zm-56.8-65.5c3.8-2.7 9.1-1.8 11.8 2.1 2.7 3.8 1.8 9.1-2.1 11.8-3.8 2.7-9.1 1.8-11.8-2.1s-1.8-9.1 2.1-11.8zm-16.6 34.5c-2.7-3.8-1.8-9.1 2.1-11.8 3.8-2.7 9.1-1.8 11.8 2 2.7 3.8 1.8 9.1-2.1 11.8-3.8 2.7-9.1 1.8-11.8-2zm41.2-22.1c-2.7-3.8-1.8-9.1 2.1-11.8 3.8-2.7 9.1-1.8 11.8 2.1 2.7 3.8 1.8 9.1-2.1 11.8-3.8 2.6-9.1 1.7-11.8-2.1zm-28.7 43.7c-2.7-3.8-1.8-9.1 2-11.8 3.8-2.7 9.1-1.8 11.8 2.1 2.7 3.8 1.8 9.1-2.1 11.8-3.7 2.7-9 1.7-11.7-2.1z' })
    )
  );
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Ruler' },
      props.title || 'Ruler'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M267.4 414h-161.3c-4.5 0-8.1-3.6-8.1-8.1v-161.2c0-3.3 2-6.2 5-7.5 3-1.3 6.5-.6 8.8 1.8l160.6 160.6c1.9 1.5 3.1 3.8 3.1 6.4 0 4.4-3.6 8-8.1 8zm-153.2-16.2h133.6l-133.6-133.6v133.6zM508.9 497.5l-495.1-495.1c-2.3-2.3-5.8-3-8.8-1.8-3 1.3-5 4.3-5 7.5v495.7c0 4.4 3.6 8.1 8.1 8.1h495.8c4.5 0 8.1-3.6 8.1-8.1 0-2.5-1.2-4.8-3.1-6.3zm-492.7-1.7v-468.1l33.9 33.9-9.7 9.7c-3.2 3.2-3.2 8.3 0 11.4 1.6 1.6 3.7 2.4 5.7 2.4 2.1 0 4.1-.8 5.7-2.4l9.7-9.7 26.5 26.5-22.9 22.9c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.6 2.3 5.7 2.3s4.2-.8 5.7-2.3l22.9-22.9 28.4 28.4-9.7 9.7c-3.2 3.2-3.2 8.3 0 11.4 1.6 1.6 3.7 2.4 5.7 2.4s4.1-.8 5.7-2.3l9.7-9.7 26.5 26.5-22.9 22.9c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l22.9-22.9 28.4 28.4-9.7 9.7c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l9.7-9.7 26.4 26.4-22.7 22.8c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l22.9-22.9 28.4 28.4-9.7 9.7c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l9.7-9.7 26.4 26.4-22.9 22.9c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.7 2.3 5.7 2.3 2.1 0 4.1-.8 5.7-2.3l22.9-22.9 28.4 28.4-9.7 9.7c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.6 2.3 5.7 2.3s4.2-.8 5.7-2.3l9.7-9.7 26.4 26.4-22.9 22.9c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.7 2.4 5.7 2.4 2.1 0 4.1-.8 5.7-2.4l22.9-22.9 28.4 28.4-9.7 9.7c-3.2 3.2-3.2 8.3 0 11.5 1.6 1.6 3.6 2.4 5.7 2.4s4.2-.8 5.7-2.4l9.7-9.7 33.9 33.9-467.6-.2z' })
    )
  );
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 451 487' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Vocals' },
      props.title || 'Vocals'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M264.4 75.4c47.5 10.9 85.8 47.3 98.6 96.5 12.8 49.2-3.6 100.2-38.3 133 10.9-32.8 10.9-76.5-1.8-122.1-9.2-45.5-32.9-83.7-58.5-107.4zm34.7-74.7c67.6 21.9 124.2 76.5 144.2 149.3 20.1 74.7-1.8 149.4-49.2 202.2 23.7-52.8 29.2-122 10.9-191.2-20.1-69.2-60.2-127.5-105.9-160.3z' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M217.7 358.1c29.9-16.3 54.4-58.4 54.4-100.5 0-67.8 0-122.1-81.6-122.1-81.7 0-81.7 54.3-81.7 122.1 0 42.1 24.5 84.2 54.4 100.5v21.7c-92.5 8.1-163.2 52.9-163.2 107.2h380.9c0-54.3-70.7-100.4-163.2-107.2v-21.7z' })
      )
    )
  );
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Document' },
      props.title || 'Document'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M307.8 2.7h-248.1v506.8h390.4v-359.2l-142.3-147.6zm6.7 66.1l67 69.5h-67v-69.5zm-213.7 399.6v-424.6h182.9v125.4h125.3v299.2h-308.2z' })
    )
  );
});

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Plus' },
      props.title || 'Plus'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M478.4 200.1c8.6 0 15.9 3 22 9.1s9.1 13.4 9.1 22v47.7c0 8.6-3 15.9-9.1 22s-13.4 9.1-22 9.1h-168.1v167.6c0 9.1-3 16.6-9.1 22.6-6.1 6.1-13.4 9.1-22 9.1h-47.7c-8.6 0-15.9-3-22-9.1-6.1-6-9.1-13.4-9.1-22v-168.2h-167.6c-9 0-16.6-2.9-22.7-8.8-6-5.8-9.1-13.3-9.1-22.3v-47.7c0-8.6 3-15.9 9.1-22 6.1-6 13.4-9.1 22-9.1h168.2v-167.5c0-9.1 3-16.6 8.8-22.7 5.9-6 13.3-9.1 22.4-9.1h47.7c8.6 0 15.9 3.1 22 9.1 6.1 6.1 9.1 13.4 9.1 22v168.2h168.1z' })
    )
  );
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./common/utils/async.js
/**
 * Executes the first callback, if it not resolve within timeout the fallback
 * function will be called.
 * @param {Function} mainExecutor
 * @param {Function} fallbackExecutor
 * @param {Number} timeout
 * @returns {Promise}
 */
var setTimeoutFallback = function setTimeoutFallback(mainExecutor, fallbackExecutor, timeout) {
  var mainPromise = new Promise(mainExecutor);
  var fallbackPromise = new Promise(function (resolve, reject) {
    setTimeout(function () {
      fallbackExecutor(resolve, reject);
    }, timeout);
  });

  return Promise.race([mainPromise, fallbackPromise]);
};
// EXTERNAL MODULE: ./common/utils/ga.js
var ga = __webpack_require__(13);

// CONCATENATED MODULE: ./common/utils/setGATracker.js



var setGATracker_setGATracker = function setGATracker() {
  return setTimeoutFallback(function (resolve) {
    Object(ga["default"])(function (tracker) {
      resolve(tracker.get('clientId'));
    });
  }, function (resolve) {
    resolve(null);
  }, 1000);
};

/* harmony default export */ var utils_setGATracker = __webpack_exports__["a"] = (setGATracker_setGATracker);

/***/ }),
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_helmet_1 = __webpack_require__(78);
var react_router_dom_1 = __webpack_require__(6);
var ga_1 = __webpack_require__(13);
var sites_1 = __webpack_require__(23);
var amGrid_1 = __webpack_require__(278);
var search_1 = __webpack_require__(36);
var searchBarForm_1 = __webpack_require__(77);
var searchBarInput_1 = __webpack_require__(126);
var NotFoundPage = function (_a) {
    var location = _a.location, currentSite = _a.currentSite;
    ga_1.default('send', 'event', {
        eventCategory: '404',
        eventAction: "https://" + sites_1.getCurrentSiteDomain(currentSite) + "/404"
    });
    var pageTitle = "Page Not Found | " + currentSite;
    return (React.createElement("section", { className: "page-section" },
        React.createElement("div", { className: "grid-container" },
            React.createElement(react_helmet_1.default, { title: pageTitle }),
            React.createElement("header", { className: "fds-u-text-align-center" },
                React.createElement("h1", { className: "fds-c-text-heading -size-xxl" }, "404 - Nothing to see here"),
                React.createElement("h2", { className: "fds-c-text-body -size-xl" },
                    "Just kidding. There's plenty to see on ",
                    currentSite,
                    ". Why not",
                    React.createElement("br", { className: "fds-u-hide-medium-and-below" }),
                    ' ',
                    "try a search, or take a look at our",
                    ' ',
                    React.createElement(react_router_dom_1.Link, { className: "fds-c-text-link -decoration-reversed", to: "/page/top_sellers" }, "Popular files"),
                    "?")),
            React.createElement(amGrid_1.default, { "am-grid": true, className: "fds-u-my2" },
                React.createElement(amGrid_1.default, { "am-grid-col": "l:8 l:pre2 m:6 m:pre1", "am-grid-row": "m:start m:end l:start l:end" },
                    React.createElement(searchBarForm_1.default, { className: "search-field -size-xl" },
                        React.createElement("div", { style: { margin: 0, padding: 0, display: 'inline' } },
                            React.createElement("input", { name: "utf8", type: "hidden", value: "✓" })),
                        React.createElement("div", { className: "search-field__input" },
                            React.createElement(searchBarInput_1.default, { value: location.query.term, className: "search-field__input-field", name: "term", placeholder: "e.g. responsive wordpress" })),
                        React.createElement("button", { className: "fds-c-button search-field__button", type: "submit" },
                            React.createElement(search_1.default, null))))))));
};
exports.default = NotFoundPage;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var dangerouslySetInnerHtml_1 = __webpack_require__(79);
var safeInnerHtml_1 = __webpack_require__(163);
var SeoHeadings = function (_a) {
    var _b = _a.TagName, TagName = _b === void 0 ? 'p' : _b, heading = _a.heading, subHeading = _a.subHeading, finePrint = _a.finePrint, _c = _a.styles, styles = _c === void 0 ? {} : _c;
    return (React.createElement("div", { "data-test-selector": "SeoHeadings" },
        React.createElement(TagName, { className: styles.seoHeading, dangerouslySetInnerHTML: { __html: heading } }),
        subHeading && (React.createElement("h2", { className: styles.seoSubHeading },
            React.createElement(dangerouslySetInnerHtml_1.default, null, subHeading))),
        finePrint && (React.createElement("small", { className: styles.seoFinePrint },
            React.createElement(safeInnerHtml_1.default, { html: finePrint })))));
};
exports.default = SeoHeadings;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var safeInnerHtml_1 = __webpack_require__(284);
exports.default = safeInnerHtml_1.default;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var configurator_1 = __webpack_require__(54);
var overlay_1 = __webpack_require__(55);
var styles = __webpack_require__(464);
var ItemPreviewer = function (_a) {
    var item = _a.item, annotation = _a.annotation, videoMuted = _a.videoMuted, muteVideo = _a.muteVideo;
    var overlayContent = (React.createElement("div", { className: styles.magnifier },
        React.createElement(configurator_1.default, { item: item, videoMuted: videoMuted, muteVideo: muteVideo })));
    return (React.createElement("div", null,
        React.createElement(overlay_1.default, { position: "side", content: overlayContent },
            React.createElement("a", { href: item.url },
                React.createElement("img", { alt: item.name, className: styles.img, src: item.ui.smallPreviewUrl, title: item.name }))),
        annotation && React.createElement("small", { className: styles.annotation }, annotation)));
};
exports.default = ItemPreviewer;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var itemThumbnailCarousel_1 = __webpack_require__(465);
exports.default = itemThumbnailCarousel_1.default;


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 24 24' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Cancel' },
      props.title || 'Cancel'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M22.245 4.015c.313.313.313.826 0 1.139l-6.276 6.27c-.313.312-.313.826 0 1.14l6.273 6.272c.313.313.313.826 0 1.14l-2.285 2.277c-.314.312-.828.312-1.142 0l-6.271-6.271c-.313-.313-.828-.313-1.141 0l-6.276 6.267c-.313.313-.828.313-1.141 0l-2.282-2.28c-.313-.313-.313-.826 0-1.14l6.278-6.269c.313-.312.313-.826 0-1.14l-6.273-6.273c-.314-.313-.314-.827 0-1.14l2.284-2.278c.315-.312.828-.312 1.142.001l6.27 6.27c.314.314.828.314 1.141.001l6.276-6.267c.312-.312.826-.312 1.141 0l2.282 2.281z' })
    )
  );
});

/***/ }),
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMinutesSecondsTime; });
/* unused harmony export toSeconds */
/**
 * Convert time to proper MM:SS format:
 *  12 -> '00:12'
 *  74 -> '1:14'
 *  ':12' -> '0:12'
 *  '1:12' -> '1:12'
 *  '1:74' -> '2:14'
 *  'ab:' -> ''
 * @param {Number|String} input
 * @returns {*}
 */
var getMinutesSecondsTime = function getMinutesSecondsTime(input) {
  var matchedSeconds = void 0;
  var matchedMinutes = void 0;

  if (Number(input)) {
    matchedMinutes = 0;
    matchedSeconds = Number(input);
  } else {
    var inputString = String(input);
    var format = /^(\d*):?(\d+)$/;
    var match = inputString.match(format);

    if (!match) {
      return '';
    }

    matchedMinutes = match[1] ? Number(match[1]) : 0;
    matchedSeconds = match[2] ? Number(match[2]) : 0;
  }

  var additionalMinutes = Math.floor(matchedSeconds / 60);
  var seconds = matchedSeconds - additionalMinutes * 60;
  var minutes = matchedMinutes + additionalMinutes;
  var secondsFormatted = seconds < 10 ? '0' + seconds.toFixed(0) : String(seconds.toFixed(0));
  var minutesFormatted = String(minutes);
  return minutesFormatted + ':' + secondsFormatted;
};

/**
 * Convert user input MM:SS to seconds
 * 12 -> 12
 * '0:12' -> 12
 * '1:12' -> 72
 * 'ab' -> ''
 * @param  {String|Number} input
 * @return {Number} time in seconds
 */
var toSeconds = function toSeconds(input) {
  var timeReg = /^([0-9]?[0-9]):([0-5][0-9])(:[0-5][0-9])?$/;
  if (Number(input)) {
    if (parseInt(input) < 0) {
      return 0;
    } else {
      return parseInt(input);
    }
  } else if (timeReg.test(input)) {
    var parts = input.split(':');
    var sec = 0;
    var min = 1;

    while (parts.length > 0) {
      sec += min * parseInt(parts.pop(), 10);
      min *= 60;
    }

    return sec;
  } else {
    return null;
  }
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(9);
var layout_1 = __webpack_require__(18);
var bookmark_1 = __webpack_require__(74);
var collection_1 = __webpack_require__(121);
var preference_1 = __webpack_require__(44);
var user_1 = __webpack_require__(75);
var mapStateToProps = function (state) {
    var _a = state.common, currentSite = _a.currentSite, clientFinishedLoading = _a.clientFinishedLoading, clientVersion = _a.clientVersion, _b = state.user, token = _b.token, preferences = _b.preferences;
    return {
        currentSite: currentSite,
        collections: user_1.getUserCollections(state),
        cartItems: user_1.getUserCartItems(state),
        favoriteCollectionID: user_1.getUserFavoriteCollectionID(state),
        token: token,
        preferences: preferences,
        clientFinishedLoading: clientFinishedLoading,
        clientVersion: clientVersion
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        deleteBookmark: function (collectionID, itemID, id, isFavouriteCollection) {
            return dispatch(bookmark_1.deleteBookmark(collectionID, itemID, id, isFavouriteCollection));
        },
        addBookmark: function (collectionId, itemId, isFavouriteCollection) {
            return dispatch(bookmark_1.addBookmark(collectionId, itemId, isFavouriteCollection));
        },
        openModal: function (data) { return dispatch(layout_1.openModal(data)); },
        createFavoriteCollection: function () { return dispatch(collection_1.createFavoriteCollection()); },
        muteVideo: function () { return dispatch(preference_1.setUserVideoPlayerStatus(true)); }
    };
};
var createSearchResultBodyContainer = function (component) {
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(component);
};
exports.default = createSearchResultBodyContainer;


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Favorite' },
      props.title || 'Favorite'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M256 475.8c-4.9 0-9.1-1.7-12.5-5.1l-176.7-170.5c-1.9-1.5-4.5-4-7.8-7.4-3.3-3.4-8.5-9.6-15.7-18.6-7.2-9-13.6-18.2-19.3-27.6-5.7-9.4-10.7-20.9-15.2-34.3-4.3-13.3-6.5-26.3-6.5-38.9 0-41.5 12-74 36-97.4 24-23.4 57.1-35.1 99.4-35.1 11.7 0 23.6 2 35.8 6.1 12.2 4.1 23.5 9.5 34 16.4 10.5 6.9 19.5 13.4 27 19.4 7.5 6 14.7 12.5 21.5 19.3 6.8-6.8 14-13.2 21.5-19.3 7.5-6 16.6-12.5 27-19.4 10.5-6.9 21.8-12.4 34-16.4 12.2-4.1 24.1-6.1 35.8-6.1 42.3 0 75.4 11.7 99.4 35.1 24 23.4 36 55.9 36 97.4 0 41.7-21.6 84.2-64.9 127.4l-176.3 169.9c-3.4 3.4-7.6 5.1-12.5 5.1z' })
    )
  );
});

/***/ }),
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var styles = __webpack_require__(299);
var Experiment = /** @class */ (function (_super) {
    __extends(Experiment, _super);
    function Experiment(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: true,
            variantId: null
        };
        return _this;
    }
    Experiment.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.forcedVariantId || this.props.forcedVariantId === 0) {
            this.forceVariantId(this.props.forcedVariantId);
        }
        this.getVariantId().then(function (variantId) {
            var _a = _this.props, id = _a.id, onExperimentView = _a.onExperimentView;
            if (onExperimentView && (variantId === 0 || variantId)) {
                onExperimentView(id, variantId);
            }
            _this.setState({ loading: false, variantId: variantId });
        });
    };
    Experiment.prototype.componentWillReceiveProps = function (nextProps) {
        var variantId = this.state.variantId;
        var _a = this.props, id = _a.id, onExperimentView = _a.onExperimentView;
        var navigated = !lodash_1.isEqual(nextProps.location, this.props.location);
        if (navigated && onExperimentView && (variantId === 0 || variantId)) {
            onExperimentView(id, variantId);
        }
    };
    Experiment.prototype.render = function () {
        var _a = this.state, loading = _a.loading, variantId = _a.variantId;
        var _b = this.props, preloader = _b.preloader, defaultVariantId = _b.defaultVariantId;
        var showPreloader = loading && preloader;
        return (React.createElement("div", { className: styles.experimentContainer },
            showPreloader && this.seoFriendlyPreloader(),
            this.findVariantById(variantId || defaultVariantId)));
    };
    Experiment.prototype.seoFriendlyPreloader = function () {
        return React.createElement("div", { className: styles.preloaderOverlay }, this.props.preloader);
    };
    Experiment.prototype.nullCache = function () {
        return {
            get: function () { return null; },
            set: function () { return null; }
        };
    };
    Experiment.prototype.cache = function () {
        if (this.props.cache == null) {
            return this.nullCache();
        }
        else {
            return this.props.cache;
        }
    };
    Experiment.prototype.fetchVariantId = function () {
        return this.props.fetchVariantId && this.props.fetchVariantId(this.props.id);
    };
    Experiment.prototype.experimentKey = function () {
        return "experiment_" + this.props.id;
    };
    Experiment.prototype.getCachedVariantId = function () {
        return this.cache().get(this.experimentKey());
    };
    Experiment.prototype.setCachedVariantId = function (variantId) {
        return this.cache().set(this.experimentKey(), variantId);
    };
    Experiment.prototype.forceVariantId = function (forcedVariantId) {
        var availableVariants = this.props.children.map(function (child) { return child.props.variantId; });
        if (availableVariants.includes(forcedVariantId)) {
            this.setCachedVariantId(forcedVariantId);
        }
    };
    Experiment.prototype.chooseRandomVariantId = function () {
        var randomIndex = Math.floor(Math.random() * this.props.children.length);
        var choosenVariantComponent = this.props.children[randomIndex];
        return Promise.resolve(choosenVariantComponent.props.variantId);
    };
    Experiment.prototype.getVariantId = function () {
        var _this = this;
        var cachedVariantId = this.getCachedVariantId();
        if (cachedVariantId || cachedVariantId === 0) {
            return Promise.resolve(cachedVariantId);
        }
        else {
            return (this.fetchVariantId() || this.chooseRandomVariantId())
                .then(function (variantId) {
                _this.setCachedVariantId(variantId);
                return variantId;
            })
                .catch(function (err) {
                var originalVariant = _this.props.children[0];
                return originalVariant.props.variantId;
            });
        }
    };
    Experiment.prototype.findVariantById = function (variantId) {
        return this.props.children.find(function (v) { return v.props.variantId === variantId; });
    };
    return Experiment;
}(React.Component));
exports.default = Experiment;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var Variant = /** @class */ (function (_super) {
    __extends(Variant, _super);
    function Variant(props) {
        return _super.call(this, props) || this;
    }
    Variant.prototype.render = function () {
        return this.props.children;
    };
    return Variant;
}(React.Component));
exports.default = Variant;


/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(3);
var queryString = __webpack_require__(22);
var react_router_config_1 = __webpack_require__(89);
var market_shared_header_1 = __webpack_require__(424);
var headBanner_1 = __webpack_require__(256);
var categoriesMenu_1 = __webpack_require__(258);
var crossSellLinksFooter_1 = __webpack_require__(261);
var siteFooter_1 = __webpack_require__(262);
var loadingSpinner_1 = __webpack_require__(64);
var _1 = __webpack_require__(268);
var pageOffLeftMenu_1 = __webpack_require__(273);
var pageOffLeftSearchBar_1 = __webpack_require__(275);
var siteMeta_1 = __webpack_require__(276);
var userAnalytics_1 = __webpack_require__(38);
var config_1 = __webpack_require__(12);
var sites_1 = __webpack_require__(23);
var sites_2 = __webpack_require__(10);
var oldIE_1 = __webpack_require__(277);
var notFoundContainer_1 = __webpack_require__(107);
var notFoundPage_1 = __webpack_require__(161);
var searchOfflinePage_1 = __webpack_require__(279);
var styles = __webpack_require__(280);
var ssoServerHost = config_1.config.sso.SERVER_HOST;
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.componentDidMount = function () {
        var fastclick = __webpack_require__(449);
        var initUser = this.props.initUser;
        fastclick.attach(document.body);
        // init user and load user preference
        initUser();
    };
    App.prototype.render = function () {
        var _a = this.props, user = _a.user, stats = _a.stats, currentSite = _a.currentSite, seoMeta = _a.seoMeta, location = _a.location, baseUrl = _a.baseUrl, menuConfig = _a.menuConfig, noIndex = _a.noIndex, isModalOpen = _a.isModalOpen, closeModal = _a.closeModal, openModalType = _a.openModalType, openModalData = _a.openModalData, banners = _a.banners, openModal = _a.openModal, handleSignInSuccess = _a.handleSignInSuccess, clientFinishedLoading = _a.clientFinishedLoading, clientVersion = _a.clientVersion;
        // add query back to location object
        // TODO: fetch from redux store instead of `withRouter`
        location.query = queryString.parse(location.search);
        var pageOffLeftMenu = React.createElement(pageOffLeftMenu_1.default, { items: menuConfig });
        var pageOffLeftSearchBar = React.createElement(pageOffLeftSearchBar_1.default, { location: location });
        var onClickSignIn = function (event) {
            event.preventDefault();
            userAnalytics_1.reportModalPageView({
                title: 'Modal: direct sign in',
                page: '//direct-sign-in'
            });
            openModal({
                type: 'signIn',
                payload: {
                    currentSite: currentSite,
                    onSignInSuccess: handleSignInSuccess,
                    welcomeMsg: 'Great to have you back!'
                }
            });
        };
        var headerConfigs = {
            ssoServerHost: ssoServerHost,
            rootDomain: "//" + sites_1.getCurrentSiteDomain(currentSite)
        };
        return (React.createElement("div", { className: "page" },
            React.createElement(oldIE_1.default, { siteName: currentSite }),
            React.createElement(siteMeta_1.default, { seoMeta: seoMeta, location: location, currentSite: currentSite, noIndex: noIndex, baseUrl: baseUrl }),
            React.createElement(_1.default, { closeModal: closeModal, isModalOpen: isModalOpen, openModalType: openModalType, openModalData: openModalData }),
            React.createElement("div", { className: "page__canvas" },
                React.createElement("div", { className: "canvas" },
                    React.createElement("div", { className: styles.headerWrapper, "data-test-selector": "global-header-wrapper" },
                        React.createElement(headBanner_1.default, { banners: banners }),
                        React.createElement(market_shared_header_1.default, { user: user, currentSite: currentSite, mobileCategoriesMenu: pageOffLeftMenu, mobileCategoriesSearchBar: pageOffLeftSearchBar, onClickSignIn: onClickSignIn, configs: headerConfigs }),
                        React.createElement("div", { className: styles.headerCategoriesWrapper },
                            React.createElement("div", { className: styles.headerCategories },
                                React.createElement("div", { className: styles.gridWide },
                                    React.createElement(categoriesMenu_1.default, { items: menuConfig }))))),
                    React.createElement("div", { className: styles.contentSection },
                        clientVersion === 2 &&
                            !clientFinishedLoading &&
                            this.renderLoadingCover(),
                        this.renderContent()),
                    React.createElement(crossSellLinksFooter_1.default, { currentSite: currentSite }),
                    React.createElement(siteFooter_1.default, { stats: stats, usDollarsNotice: user.usDollarsNotice })))));
    };
    App.prototype.renderLoadingCover = function () {
        return [
            React.createElement("style", { key: "style" }, "\n          .js .loadingContainer {\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            z-index: 10000;\n            background: rgba(255, 255, 255, 1);\n            text-align: center;\n            padding-top: 44px;\n          }\n      "),
            React.createElement("div", { key: "loadingContainer", className: "loadingContainer" },
                React.createElement(loadingSpinner_1.default, null))
        ];
    };
    App.prototype.renderContent = function () {
        var _a = this.props, errorPage = _a.errorPage, location = _a.location, currentSite = _a.currentSite, route = _a.route;
        // add query back to location object
        location.query = queryString.parse(location.search);
        var popularFilesUrl = "//" + sites_1.getCurrentSiteDomain(currentSite) + "/page/top_sellers";
        var siteDisplayName = lodash_1.get(sites_2.default, currentSite + ".name") || currentSite;
        var NotFoundContainer = notFoundContainer_1.default(notFoundPage_1.default);
        if (route) {
            switch (errorPage) {
                case 'NotFoundContainer':
                    return React.createElement(NotFoundContainer, { location: location });
                case 'SearchOffline':
                    return (React.createElement(searchOfflinePage_1.default, { popularFilesUrl: popularFilesUrl, siteDisplayName: siteDisplayName }));
                default:
                    return react_router_config_1.renderRoutes(route.routes);
            }
        }
        else {
            return React.createElement(NotFoundContainer, { location: location });
        }
    };
    return App;
}(React.Component));
exports.default = App;


/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var dangerouslySetInnerHtml_1 = __webpack_require__(79);
var LandingPage = function (_a) {
    var html = _a.html, css = _a.css;
    return (React.createElement("div", { className: "landing-page-content" },
        css && React.createElement("style", null, css),
        React.createElement(dangerouslySetInnerHtml_1.default, { className: "landing-page-body" }, html)));
};
exports.default = LandingPage;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var resultsInfo_1 = __webpack_require__(287);
var suggestions_1 = __webpack_require__(288);
var SearchResultHeaders = function (props) {
    var _a = props.totalHits, totalHits = _a === void 0 ? 0 : _a, _b = props.didYouMeanByTerms, didYouMeanByTerms = _b === void 0 ? [] : _b, authorSuggestion = props.authorSuggestion, seoMeta = props.seoMeta, styles = props.styles;
    var shouldShowSeo = seoMeta && seoMeta.heading && totalHits > 0;
    return (React.createElement("div", { className: styles.mainContainer },
        shouldShowSeo && React.createElement(resultsInfo_1.default, __assign({}, props)),
        didYouMeanByTerms.length || authorSuggestion ? (React.createElement(suggestions_1.default, __assign({}, props))) : null));
};
exports.default = SearchResultHeaders;


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dangerouslySetInnerHtml__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dangerouslySetInnerHtml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dangerouslySetInnerHtml__);




var SearchPageArticle = function SearchPageArticle(_ref) {
  var html = _ref.html;

  if (!html) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: 'page-section -color-grey-light -border-top -border-bottom' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'search-page-content-article__text-section' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'grid-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'sidebar-s -size-fixed-tablet is-hidden-phone' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'search-page-content__sidebar-spacer' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content-l -size-scale-tablet content-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fds-c-text-preformatted' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__components_dangerouslySetInnerHtml___default.a,
              null,
              html
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (SearchPageArticle);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/date-fns/format/index.js
var format = __webpack_require__(494);
var format_default = /*#__PURE__*/__webpack_require__.n(format);

// CONCATENATED MODULE: ./client/pages/search/content/searchPageRelatedPost.js



var searchPageRelatedPost_SearchPageRelatedPost = function SearchPageRelatedPost(_ref) {
  var post = _ref.post;

  var publishDate = format_default()(post.date, 'DD MMM YYYY');

  return react_default.a.createElement(
    'li',
    { className: 'search-related-posts__post' },
    react_default.a.createElement(
      'article',
      { className: 'search-related-posts__post-container' },
      react_default.a.createElement(
        'header',
        { className: 'search-related-posts__post-header' },
        react_default.a.createElement(
          'a',
          {
            className: 'search-related-posts__post-preview-link is-hidden-phone',
            href: post.url
          },
          react_default.a.createElement('img', {
            alt: post.title,
            className: 'search-related-posts__post-image',
            src: post.image
          })
        ),
        react_default.a.createElement(
          'a',
          {
            className: 'search-related-posts__post-preview-title-link',
            href: post.url
          },
          react_default.a.createElement(
            'h2',
            { className: 'fds-c-text-heading -size-xs -color-mid' },
            post.title
          )
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'search-related-posts__post-teaser' },
        react_default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-s -color-mid' },
          post.summary
        )
      ),
      react_default.a.createElement(
        'footer',
        { className: 'search-related-posts__post-footer' },
        react_default.a.createElement(
          'div',
          { className: 'fds-c-text-body -size-s -color-mid' },
          react_default.a.createElement(
            'div',
            { className: 'search-related-posts__post-publication-meta' },
            post.author && react_default.a.createElement('img', {
              className: 'search-related-posts__post-author_photo',
              alt: post.author,
              src: post.author_avatar
            }),
            react_default.a.createElement(
              'div',
              { className: 'search-related-posts__post-details' },
              react_default.a.createElement(
                'address',
                { className: 'search-related-posts__post-author' },
                react_default.a.createElement(
                  'p',
                  { className: 'search-related-posts__post-author-link' },
                  post.author && react_default.a.createElement(
                    'a',
                    {
                      className: 'fds-c-text-link -decoration-reversed -color-inherit',
                      href: post.author_url
                    },
                    post.author
                  )
                )
              ),
              react_default.a.createElement(
                'time',
                { dateTime: post.date, title: publishDate },
                publishDate
              )
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'search-related-posts__post-primary-category' },
            react_default.a.createElement(
              'a',
              {
                className: 'fds-c-text-link -decoration-reversed -color-inherit -weight-bold',
                href: post.category_url
              },
              post.category
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ var searchPageRelatedPost = (searchPageRelatedPost_SearchPageRelatedPost);
// CONCATENATED MODULE: ./client/pages/search/content/searchPageRelatedPosts.js



var searchPageRelatedPosts_SearchPageRelatedPosts = function SearchPageRelatedPosts(_ref) {
  var posts = _ref.posts;

  return react_default.a.createElement(
    'section',
    { className: 'page-section' },
    react_default.a.createElement(
      'div',
      { className: 'grid-container' },
      react_default.a.createElement(
        'div',
        { className: 'search-related-posts__posts-section' },
        react_default.a.createElement(
          'div',
          { className: 'sidebar-s -size-fixed-tablet is-hidden-phone' },
          react_default.a.createElement('div', { className: 'search-page-content__sidebar-spacer' })
        ),
        react_default.a.createElement(
          'div',
          { className: 'content-l -size-scale-tablet content-right' },
          react_default.a.createElement(
            'ol',
            { className: 'search-related-posts__post_list' },
            posts.map(function (post, index) {
              return react_default.a.createElement(searchPageRelatedPost, { key: index, post: post });
            })
          )
        )
      )
    )
  );
};

/* harmony default export */ var searchPageRelatedPosts = __webpack_exports__["default"] = (searchPageRelatedPosts_SearchPageRelatedPosts);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_formatString__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__ = __webpack_require__(16);








var createLabelMapping = function createLabelMapping() {
  var prepend = function prepend(labels, prefix) {
    var prefixedLabels = {};
    Object.keys(labels).forEach(function (key) {
      prefixedLabels[key] = prefix + ' ' + labels[key];
    });
    return prefixedLabels;
  };

  var sizeLabels = prepend(__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"].sizes.labels, 'Size');
  var salesLabels = prepend(__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"].sales.labels, 'Sale');
  return Object.assign(sizeLabels, salesLabels);
};

var FilterList = function FilterList(_ref) {
  var FilterItem = _ref.FilterItem,
      parsedLocation = _ref.parsedLocation,
      param = _ref.param;

  // if the fitler is not in the config, simply return null
  if (!__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param] || !parsedLocation[param]) return null;

  if (__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].isMultiple) {
    var labelMapping = createLabelMapping();
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'ul',
      null,
      parsedLocation[param].split(__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].delimiter).map(function (option, index) {
        var link = void 0,
            newQuery = void 0;
        var displayName = labelMapping[option] || Object(__WEBPACK_IMPORTED_MODULE_3__common_utils_formatString__["toTitle"])(option);

        // category is separate by '/' eg. 'category/wordpress/clean'
        if (__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].delimiter === '/') {
          newQuery = Object(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["getQueryWithoutCategory"])(parsedLocation, param, option);
          // tags
        } else if (__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].delimiter === ',') {
          newQuery = Object(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["getQueryWithoutOption"])(parsedLocation, param, option);
        }
        // reset page param
        delete newQuery.page;
        link = Object(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["makeLink"])(newQuery);
        if (displayName) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FilterItem, {
            paramType: param,
            displayName: displayName,
            link: link,
            key: index,
            index: index
          });
        } else {
          return null;
        }
      })
    );
  } else {
    if (__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].inRangeWith) {
      var minRangeParam = __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].inRangeWith.min || param;
      var maxRangeParam = __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].inRangeWith.max || param;
      var minParamValue = parsedLocation[minRangeParam];
      var maxParamValue = parsedLocation[maxRangeParam];

      // combine price_min and price_max if both exist
      if (minParamValue && maxParamValue) {
        var minParamFormatValue = __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format ? __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format(minParamValue) : minParamValue;
        var maxParamFormatValue = __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format ? __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format(maxParamValue) : maxParamValue;
        var priceDisplayName = minParamFormatValue + ' - ' + maxParamFormatValue;
        var link = Object(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["makeLink"])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [minRangeParam, maxRangeParam, 'page']));
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FilterItem, {
            paramType: param,
            displayName: priceDisplayName,
            link: link,
            index: 0
          })
        );
      } else {
        var paramFormatValue = __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format ? __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format(parsedLocation[param]) : parsedLocation[param];
        var _priceDisplayName = __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].label + ' ' + paramFormatValue;
        var _link = Object(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["makeLink"])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [param, 'page']));
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FilterItem, {
            paramType: param,
            displayName: _priceDisplayName,
            link: _link,
            index: 0
          })
        );
      }
    } else {
      var label = parsedLocation[param];
      var _link2 = Object(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["makeLink"])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [param, 'page']));
      if (param === 'sort_by' && parsedLocation['sort_direction']) {
        // parse label for sort_by filter
        label = parsedLocation['sort_by'] + '-' + parsedLocation['sort_direction'];
        // when it's a sort by filter, we remove the `sort_direction`
        // as well when clear
        _link2 = Object(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["makeLink"])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [param, 'page', 'sort_direction']));
      }
      var displayName = !__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].labels ? parsedLocation[param] : __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].labels[label];

      if (__WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format) {
        displayName = __WEBPACK_IMPORTED_MODULE_5__common_constants_filterParamsConfig__["default"][param].format(displayName);
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FilterItem, {
          paramType: param,
          displayName: displayName,
          link: _link2,
          index: 0
        })
      );
    }
  }
};

FilterList.propTypes = {
  parsedLocation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  param: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FilterList);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(7);
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(6);
var urlHelper_1 = __webpack_require__(5);
var sites_1 = __webpack_require__(10);
var grid_1 = __webpack_require__(289);
var list_1 = __webpack_require__(290);
var LayoutSwitcher = function (_a) {
    var currentSite = _a.currentSite, location = _a.location, currentView = _a.currentView;
    var itemViews = sites_1.getConfigBySite(currentSite, 'ui.item_list_views') || [];
    var parsedLocation = urlHelper_1.parseLocation(location);
    if (itemViews.length <= 1) {
        return null;
    }
    return (React.createElement("div", { className: "search-facet-layout-switcher" },
        React.createElement("div", { className: "btn-group" }, itemViews.map(function (availableView, index) {
            var nextQuery = __assign({}, parsedLocation, { view: availableView.value });
            var className = classNames('btn-search-switch', {
                'is-active': currentView === availableView.value
            });
            var Icon = availableView.value === 'grid' ? (React.createElement(grid_1.default, { title: "Grid" })) : (React.createElement(list_1.default, { title: "List" }));
            return (React.createElement(react_router_dom_1.Link, { to: urlHelper_1.makeLink(nextQuery), className: className, key: index }, Icon));
        }))));
};
exports.default = LayoutSwitcher;


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./client/containers/searchResultBodyContainer.ts
var searchResultBodyContainer = __webpack_require__(169);
var searchResultBodyContainer_default = /*#__PURE__*/__webpack_require__.n(searchResultBodyContainer);

// EXTERNAL MODULE: ./config/sites/index.js + 7 modules
var sites = __webpack_require__(10);

// EXTERNAL MODULE: ./common/analytics/resultAnalytics.tsx
var resultAnalytics = __webpack_require__(48);
var resultAnalytics_default = /*#__PURE__*/__webpack_require__.n(resultAnalytics);

// EXTERNAL MODULE: ./node_modules/react-icon-base/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./client/components/icons/starFull.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var starFull = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Star-Full' },
      props.title || 'Star-Full'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M511.522 201.165c0 4.502-2.666 9.43-7.997 14.739l-111.506 108.752 26.409 153.596c.202 1.434.314 3.494.314 6.16 0 4.301-1.075 7.93-3.226 10.886-2.15 2.979-5.286 4.458-9.363 4.458-3.898 0-7.997-1.232-12.298-3.674l-137.939-72.508-137.916 72.508c-4.525 2.442-8.602 3.674-12.298 3.674-4.301 0-7.526-1.478-9.677-4.458-2.15-2.957-3.226-6.586-3.226-10.886 0-1.232.202-3.293.605-6.16l26.432-153.596-111.819-108.752c-5.13-5.533-7.683-10.438-7.683-14.739 0-7.571 5.734-12.298 17.203-14.134l154.223-22.422 69.104-139.775c3.898-8.4 8.915-12.589 15.053-12.589 6.16 0 11.155 4.189 15.053 12.589l69.126 139.775 154.223 22.422c11.447 1.836 17.203 6.563 17.203 14.134z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/starHalfEmpty.js
var starHalfEmpty__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var starHalfEmpty = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    starHalfEmpty__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Star-Half-Empty' },
      props.title || 'Star-Half-Empty'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M365.2 295.3l79.3-77.2-130.3-19.1-9.3-18.5-49.1-99.4v297.3l18.2 9.6 98.2 51.9-18.5-109.6-3.7-20.4 15.2-14.6zm139.5-80.8l-112.1 109.2 26.6 154.4c1 6.8.4 12.1-1.9 15.9-2.3 3.8-5.8 5.7-10.5 5.7-3.5 0-7.6-1.2-12.3-3.7l-138.6-72.9-138.7 72.9c-4.7 2.5-8.9 3.7-12.3 3.7-4.7 0-8.2-1.9-10.5-5.7-2.3-3.8-2.9-9.1-1.9-15.9l26.6-154.4-112.4-109.2c-6.6-6.6-9-12.7-7.1-18.4 1.8-5.7 7.4-9.2 16.7-10.7l155-22.5 69.5-140.5c4.1-8.4 9.2-12.7 15.1-12.7 5.8 0 10.8 4.2 15.1 12.7l69.5 140.5 155 22.5c9.3 1.4 14.8 5 16.7 10.7 1.8 5.6-.7 11.8-7.5 18.4z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/starEmpty.js
var starEmpty__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var starEmpty = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    starEmpty__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Star-Empty' },
      props.title || 'Star-Empty'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M349.7 311.7l94.2-91.4-129.9-19.1-58.2-117.5-58.2 117.5-129.8 19.1 94.2 91.4-22.5 129.6 116.3-61.3 116 61.2-22.1-129.5zm162.2-109.9c0 4.5-2.7 9.4-8 14.8l-111.7 108.9 26.5 153.9c.2 1.4.3 3.5.3 6.2 0 10.3-4.2 15.4-12.6 15.4-3.9 0-8-1.2-12.3-3.7l-138.2-72.6-138.2 72.6c-4.5 2.5-8.6 3.7-12.3 3.7-4.3 0-7.5-1.5-9.7-4.5-2.2-3-3.2-6.6-3.2-10.9 0-1.2.2-3.3.6-6.2l26.5-153.9-112.1-108.9c-5.1-5.5-7.7-10.5-7.7-14.8 0-7.6 5.7-12.3 17.2-14.1l154.5-22.5 69.2-140c3.9-8.4 8.9-12.6 15.1-12.6s11.2 4.2 15.1 12.6l69.2 140 154.5 22.5c11.5 1.8 17.3 6.5 17.3 14.1z' })
    )
  );
});
// CONCATENATED MODULE: ./client/pages/search/result/starRating.js







var starRating_StarRating = function StarRating(_ref) {
  var rating = _ref.rating,
      className = _ref.className,
      _ref$fullStarClass = _ref.fullStarClass,
      fullStarClass = _ref$fullStarClass === undefined ? 'star-rating__star--full' : _ref$fullStarClass,
      _ref$halfStarClass = _ref.halfStarClass,
      halfStarClass = _ref$halfStarClass === undefined ? 'star-rating__star--half' : _ref$halfStarClass,
      _ref$emptyStarClass = _ref.emptyStarClass,
      emptyStarClass = _ref$emptyStarClass === undefined ? 'star-rating__star--empty' : _ref$emptyStarClass,
      _ref$maxStars = _ref.maxStars,
      maxStars = _ref$maxStars === undefined ? 5 : _ref$maxStars;

  var stars = [];
  var roundedRating = Math.round(rating * 2) / 2.0;
  for (var i = 0; i < Math.floor(roundedRating); i++) {
    stars.push(starFull);
  }

  if (roundedRating % 1) {
    stars.push(starHalfEmpty);
  }

  while (stars.length < maxStars) {
    stars.push(starEmpty);
  }

  var IconStyles = {
    color: '#fec42d'
  };

  return react_default.a.createElement(
    'div',
    { className: className },
    stars.map(function (Icon, index) {
      return react_default.a.createElement(Icon, { style: IconStyles, key: index });
    })
  );
};

starRating_StarRating.propTypes = {
  rating: prop_types_default.a.number.isRequired,
  className: prop_types_default.a.string,
  fullStarClass: prop_types_default.a.string,
  halfStarClass: prop_types_default.a.string,
  emptyStarClass: prop_types_default.a.string,
  maxStars: prop_types_default.a.number
};

/* harmony default export */ var starRating = (starRating_StarRating);
// EXTERNAL MODULE: ./common/utils/formatString.js
var formatString = __webpack_require__(14);

// CONCATENATED MODULE: ./client/pages/search/result/metaCategories.js





var metaCategories_MetaCategories = function MetaCategories(_ref) {
  var className = _ref.className,
      classification = _ref.classification;

  var categories = classification.split('/');
  return react_default.a.createElement(
    'span',
    { className: className },
    'in',
    ' ',
    categories.map(function (category, index) {
      var slash = index === categories.length - 1 ? null : ' / ';
      return react_default.a.createElement(
        'span',
        { key: index },
        react_default.a.createElement(
          'b',
          null,
          Object(formatString["toTitle"])(category)
        ),
        slash
      );
    })
  );
};

metaCategories_MetaCategories.propTypes = {
  className: prop_types_default.a.string,
  classification: prop_types_default.a.string.isRequired
};

/* harmony default export */ var metaCategories = (metaCategories_MetaCategories);
// EXTERNAL MODULE: ./client/components/itemCard/common/trendingSash.module.css
var trendingSash_module = __webpack_require__(291);
var trendingSash_module_default = /*#__PURE__*/__webpack_require__.n(trendingSash_module);

// CONCATENATED MODULE: ./client/components/itemCard/common/trendingSash.js




var trendingSash_TrendingItem = function TrendingItem() {
  return react_default.a.createElement(
    'span',
    { className: trendingSash_module_default.a.trending },
    'Trending'
  );
};

/* harmony default export */ var trendingSash = (trendingSash_TrendingItem);
// EXTERNAL MODULE: ./client/components/magnifier/configurator.tsx
var configurator = __webpack_require__(54);
var configurator_default = /*#__PURE__*/__webpack_require__.n(configurator);

// EXTERNAL MODULE: ./client/components/overlay.tsx
var overlay = __webpack_require__(55);
var overlay_default = /*#__PURE__*/__webpack_require__.n(overlay);

// EXTERNAL MODULE: ./client/components/icons/barChart.js
var barChart = __webpack_require__(45);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./client/components/icons/favorite.js
var favorite = __webpack_require__(170);

// CONCATENATED MODULE: ./client/components/icons/cart.js
var cart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var cart = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    cart__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Cart' },
      props.title || 'Cart'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M440.2 328.3c-3.5 13.9-15.7 23.8-30.2 23.8h-250.2c-14.5 0-27.3-9.9-30.2-23.8l-63.9-258.4h-31.3c-17.5 0-31.4-14-31.4-31.4s13.9-31.3 31.4-31.3h55.7c14.5 0 27.3 9.9 30.8 23.8l17.4 70.3h355.9c2.9 0 6.4 1.7 8.1 4.1 2.3 2.3 2.9 5.8 1.8 8.7l-63.9 214.2zm-238.6 76c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3zm167.2 0c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/folderOpen.js
var folderOpen__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var folderOpen = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    folderOpen__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Folder-Open' },
      props.title || 'Folder-Open'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M415.8 188.5v43.1h-223.9c-16.9 0-34.5 4.3-53 12.8s-33.2 19.2-44.1 32.2l-90.7 106.4-1.3 1.6c0-.7 0-1.8-.1-3.4-.1-1.5-.1-2.6-.1-3.4v-258.2c0-16.5 5.9-30.7 17.8-42.5 11.8-11.8 26-17.8 42.5-17.8h86.1c16.5 0 30.7 5.9 42.5 17.8 11.8 11.8 17.8 26 17.8 42.5v8.6h146.4c16.5 0 30.7 5.9 42.5 17.8 11.7 11.8 17.6 26 17.6 42.5zm92.3 92.5c0 5.6-2.8 11.5-8.3 17.8l-90.4 106.6c-7.7 9.2-18.5 16.9-32.4 23.3-13.9 6.4-26.8 9.6-38.6 9.6h-292.9c-6.1 0-11.5-1.2-16.3-3.5-4.8-2.3-7.1-6.2-7.1-11.6 0-5.6 2.8-11.5 8.3-17.8l90.4-106.6c7.7-9.1 18.5-16.9 32.4-23.3 13.9-6.4 26.8-9.6 38.6-9.6h292.8c6.1 0 11.5 1.2 16.3 3.5 4.8 2.4 7.2 6.3 7.2 11.6z' })
    )
  );
});
// EXTERNAL MODULE: ./client/components/itemCard/common/itemActions.module.css
var itemActions_module = __webpack_require__(292);
var itemActions_module_default = /*#__PURE__*/__webpack_require__.n(itemActions_module);

// CONCATENATED MODULE: ./client/components/itemCard/common/itemActions.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var itemActions_ItemActions = function ItemActions(_ref) {
  var _classNames4;

  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      onAddToCollections = _ref.onAddToCollections,
      onAddToCart = _ref.onAddToCart,
      _ref$defaultTheme = _ref.defaultTheme,
      defaultTheme = _ref$defaultTheme === undefined ? true : _ref$defaultTheme,
      _ref$nonAudioTheme = _ref.nonAudioTheme,
      nonAudioTheme = _ref$nonAudioTheme === undefined ? false : _ref$nonAudioTheme,
      _ref$transparentTheme = _ref.transparentTheme,
      transparentTheme = _ref$transparentTheme === undefined ? false : _ref$transparentTheme;

  var favoriteClassNames = classnames_default()(itemActions_module_default.a.action, _defineProperty({}, itemActions_module_default.a.active, item.ui.isInFavourites));

  var bookmarkClassNames = classnames_default()(itemActions_module_default.a.action, _defineProperty({}, itemActions_module_default.a.active, item.ui.isInBookmarks));

  var cartClassNames = classnames_default()(itemActions_module_default.a.action, _defineProperty({}, itemActions_module_default.a.active, item.ui.isInCart));

  var rootClassName = classnames_default()((_classNames4 = {}, _defineProperty(_classNames4, itemActions_module_default.a.defaultTheme, defaultTheme), _defineProperty(_classNames4, itemActions_module_default.a.nonAudioTheme, nonAudioTheme), _defineProperty(_classNames4, itemActions_module_default.a.transparentTheme, transparentTheme), _classNames4));

  return react_default.a.createElement(
    'div',
    { className: rootClassName },
    react_default.a.createElement(
      'div',
      { className: itemActions_module_default.a.actionsContainer },
      react_default.a.createElement(
        'a',
        {
          href: '/favorites?item_id=' + item.id,
          onClick: onAddToFavourites,
          title: 'Add to Favorites',
          rel: 'nofollow',
          className: favoriteClassNames
        },
        react_default.a.createElement(favorite["a" /* default */], {
          className: itemActions_module_default.a.icon,
          style: { verticalAlign: '' },
          title: 'Add to Favorites'
        })
      ),
      react_default.a.createElement(
        'a',
        {
          href: '/bookmarks/widget?item_id=' + item.id,
          onClick: function onClick(event) {
            return onAddToCollections(event);
          },
          title: 'Add to Collection',
          rel: 'nofollow',
          className: bookmarkClassNames
        },
        react_default.a.createElement(folderOpen, {
          className: itemActions_module_default.a.icon,
          style: { verticalAlign: '' },
          title: 'Add to Collection'
        })
      ),
      react_default.a.createElement(
        'a',
        {
          className: cartClassNames,
          onClick: onAddToCart,
          href: '/cart/configure_before_adding/' + item.id,
          rel: 'nofollow',
          title: 'Add to Cart'
        },
        react_default.a.createElement(cart, {
          className: itemActions_module_default.a.icon,
          style: { verticalAlign: '' },
          title: 'Add to Cart'
        })
      )
    )
  );
};

/* harmony default export */ var itemActions = (itemActions_ItemActions);
// CONCATENATED MODULE: ./client/components/itemCard/listDefault.js











var listDefault_ItemCardListDefault = function ItemCardListDefault(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      rank = _ref.rank,
      onAddToCollections = _ref.onAddToCollections,
      _ref$onItemLinkClick = _ref.onItemLinkClick,
      onItemLinkClick = _ref$onItemLinkClick === undefined ? function () {} : _ref$onItemLinkClick,
      _ref$onAddToCart = _ref.onAddToCart,
      onAddToCart = _ref$onAddToCart === undefined ? function () {} : _ref$onAddToCart,
      muted = _ref.muted,
      muteVideo = _ref.muteVideo;

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      { className: 'product-list__columns-container' },
      react_default.a.createElement(
        'div',
        { className: 'product-list__column-detail' },
        react_default.a.createElement(
          'div',
          { className: 'product-list__item-thumbnail' },
          react_default.a.createElement(
            'div',
            { className: 'item-thumbnail' },
            react_default.a.createElement(
              overlay_default.a,
              {
                position: 'side',
                content: react_default.a.createElement(configurator_default.a, {
                  item: item,
                  videoMuted: muted,
                  muteVideo: muteVideo
                })
              },
              react_default.a.createElement(
                'div',
                {
                  className: 'item-thumbnail__image',
                  'data-test-selector': 'item-thumbnail-default'
                },
                react_default.a.createElement(
                  'a',
                  {
                    href: item.url + '?s_rank=' + rank,
                    onClick: onItemLinkClick,
                    className: 'item-thumbnail__link'
                  },
                  react_default.a.createElement('img', {
                    alt: item.name,
                    className: 'preload no_preview landscape-image-magnifier',
                    height: '80',
                    src: item.ui.smallPreviewUrl,
                    title: item.name,
                    width: '80'
                  })
                ),
                item.previews.live_site ? react_default.a.createElement(
                  'div',
                  { className: 'item-thumbnail__preview' },
                  react_default.a.createElement(
                    'a',
                    {
                      href: item.previews.live_site.url,
                      target: '_blank',
                      className: 'item-thumbnail__preview-link'
                    },
                    'Live preview'
                  )
                ) : null
              )
            )
          )
        ),
        react_default.a.createElement(
          'div',
          { className: 'product-list__adjacent-thumbnail' },
          react_default.a.createElement(
            'h3',
            { className: 'product-list__heading' },
            react_default.a.createElement(
              'a',
              {
                className: 'fds-c-text-link -color-inherit -decoration-reversed',
                href: item.url + '?s_rank=' + rank,
                onClick: onItemLinkClick
              },
              item.name
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'product-list__price' },
            react_default.a.createElement(
              'p',
              { className: 'fds-c-text-body -size-m -color-inherit -weight-bold fds-u-m0' },
              '$',
              item.ui.price,
              ' ',
              item.ui.pricePeriod && react_default.a.createElement(
                'span',
                { className: 'fds-c-text-body -size-xs fds-u-m0' },
                '/',
                item.ui.pricePeriod,
                '*'
              )
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'product-list__info' },
            react_default.a.createElement(
              'div',
              { className: 'product-list__info-author' },
              react_default.a.createElement(
                'a',
                {
                  className: 'fds-c-text-link -color-default -decoration-reversed',
                  href: item.author_url
                },
                item.author_username
              )
            ),
            react_default.a.createElement(
              'div',
              { className: 'product-list__info-rating' },
              item.rating.rating ? react_default.a.createElement(starRating, {
                rating: item.rating.rating,
                className: 'star-rating--search'
              }) : null,
              item.rating.rating && item.rating.count ? item.rating.count + ' ratings' : null
            ),
            item.number_of_sales ? react_default.a.createElement(
              'div',
              { className: 'product-list__info-sale' },
              react_default.a.createElement(
                'span',
                { className: 'product-list__info-sale-glyph' },
                react_default.a.createElement(barChart["a" /* default */], null)
              ),
              item.number_of_sales,
              ' Sales'
            ) : null
          )
        ),
        react_default.a.createElement(
          'div',
          { className: 'fds-u-clear' },
          react_default.a.createElement(
            'div',
            { className: 'product-list__item-thumbnail-actions' },
            react_default.a.createElement(
              'div',
              { className: 'item-thumbnail-actions -width-full' },
              react_default.a.createElement(itemActions, {
                item: item,
                onAddToFavourites: onAddToFavourites,
                onAddToCollections: onAddToCollections,
                onAddToCart: onAddToCart,
                nonAudioTheme: true
              })
            )
          )
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'product-list__column-category' },
        react_default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-xs fds-u-m0' },
          react_default.a.createElement(metaCategories, {
            classification: item.classification,
            className: 'meta-categories -no-slash'
          }),
          react_default.a.createElement('br', null),
          ' ',
          item.summary
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'product-list__column-price' },
        react_default.a.createElement(
          'p',
          { className: 'product-list__price-desktop' },
          '$',
          item.ui.price
        ),
        item.ui.pricePeriod && react_default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-xs fds-u-m0' },
          '/',
          item.ui.pricePeriod,
          '*'
        ),
        react_default.a.createElement(
          'div',
          { className: 'product-list__info-desktop' },
          item.rating.rating ? react_default.a.createElement(starRating, {
            rating: item.rating.rating,
            className: 'star-rating--search'
          }) : null,
          item.rating.rating ? react_default.a.createElement('br', null) : null,
          item.rating.rating && item.rating.count ? item.rating.count + ' ratings' : null,
          item.number_of_sales ? react_default.a.createElement(
            'div',
            { className: 'product-list__sales-desktop' },
            react_default.a.createElement(barChart["a" /* default */], { width: '20', height: '30' }),
            react_default.a.createElement('br', null),
            item.number_of_sales ? item.number_of_sales + ' Sales' : null
          ) : null
        )
      )
    ),
    item.trending && react_default.a.createElement(trendingSash, null)
  );
};

listDefault_ItemCardListDefault.propTypes = {
  item: prop_types_default.a.object.isRequired,
  onAddToFavourites: prop_types_default.a.func.isRequired,
  rank: prop_types_default.a.number.isRequired,
  onItemLinkClick: prop_types_default.a.func,
  onAddToCart: prop_types_default.a.func
};

/* harmony default export */ var listDefault = (listDefault_ItemCardListDefault);
// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(6);

// CONCATENATED MODULE: ./client/components/itemCard/gridDefault.js










var gridDefault_ItemCardGridDefault = function ItemCardGridDefault(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      rank = _ref.rank,
      onAddToCollections = _ref.onAddToCollections,
      _ref$onItemLinkClick = _ref.onItemLinkClick,
      onItemLinkClick = _ref$onItemLinkClick === undefined ? function () {} : _ref$onItemLinkClick,
      _ref$onAddToCart = _ref.onAddToCart,
      onAddToCart = _ref$onAddToCart === undefined ? function () {} : _ref$onAddToCart;

  var salesLabel = item.number_of_sales === 1 ? 'Sale' : 'Sales';
  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      { className: 'product-grid__inside' },
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'div',
          { className: 'item-thumbnail' },
          react_default.a.createElement(
            overlay_default.a,
            { position: 'side', content: configurator_default()({ item: item }) },
            react_default.a.createElement(
              'div',
              { className: 'item-thumbnail__image' },
              item.trending && react_default.a.createElement(trendingSash, null),
              react_default.a.createElement(
                'a',
                {
                  href: item.url + '?s_rank=' + rank,
                  onClick: onItemLinkClick,
                  className: 'item-thumbnail__link'
                },
                react_default.a.createElement('img', {
                  alt: item.name,
                  className: 'preload no_preview landscape-image-magnifier',
                  src: item.ui.smallPreviewUrl,
                  title: item.name
                })
              ),
              item.previews.live_site ? react_default.a.createElement(
                'div',
                { className: 'item-thumbnail__preview' },
                react_default.a.createElement(
                  'a',
                  {
                    href: item.previews.live_site.url,
                    target: '_blank',
                    className: 'item-thumbnail__preview-link'
                  },
                  'Live preview'
                )
              ) : null
            )
          )
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'product-grid__item-thumbnail-actions' },
        react_default.a.createElement(
          'div',
          { className: 'item-thumbnail-actions -width-full' },
          react_default.a.createElement(
            'ul',
            { className: 'item-thumbnail-actions__list' },
            react_default.a.createElement(itemActions, {
              item: item,
              onAddToFavourites: onAddToFavourites,
              onAddToCollections: onAddToCollections,
              onAddToCart: onAddToCart
            })
          )
        )
      ),
      react_default.a.createElement(
        'h3',
        { className: 'product-grid__heading fds-u-text-truncate' },
        react_default.a.createElement(
          'a',
          {
            className: 'fds-c-text-link -color-inherit -decoration-reversed',
            href: item.url + '?s_rank=' + rank,
            onClick: onItemLinkClick
          },
          item.name
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'product-grid__rating' },
        item.rating.rating ? react_default.a.createElement(starRating, {
          rating: item.rating.rating,
          className: 'star-rating--search'
        }) : null
      ),
      react_default.a.createElement(
        'footer',
        { className: 'product-grid__footer' },
        react_default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-xs fds-u-m0' },
          item.number_of_sales,
          ' ',
          salesLabel,
          ' ',
          react_default.a.createElement(
            'span',
            { className: 'product-grid__price' },
            '$',
            item.ui.price,
            item.ui.pricePeriod && '/' + item.ui.pricePeriod + '*'
          )
        ),
        item.ui.footerLink && react_default.a.createElement(
          es["Link"],
          { to: item.ui.footerLink.href },
          item.ui.footerLink.label
        )
      )
    )
  );
};

gridDefault_ItemCardGridDefault.propTypes = {
  item: prop_types_default.a.object.isRequired,
  onAddToFavourites: prop_types_default.a.func.isRequired,
  rank: prop_types_default.a.number.isRequired,
  onItemLinkClick: prop_types_default.a.func,
  onAddToCart: prop_types_default.a.func
};

/* harmony default export */ var gridDefault = (gridDefault_ItemCardGridDefault);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(9);

// EXTERNAL MODULE: ./common/actions/searchPage.ts
var searchPage = __webpack_require__(20);
var searchPage_default = /*#__PURE__*/__webpack_require__.n(searchPage);

// EXTERNAL MODULE: ./node_modules/raf/index.js
var raf = __webpack_require__(171);
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(498);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);

// EXTERNAL MODULE: ./common/utils/axios/axiosVerbose.js
var axiosVerbose = __webpack_require__(11);

// EXTERNAL MODULE: ./common/utils/errors.js + 4 modules
var errors = __webpack_require__(8);

// EXTERNAL MODULE: ./common/utils/time.js
var time = __webpack_require__(168);

// CONCATENATED MODULE: ./client/components/audio/waveform.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var waveform_Waveform = function (_React$Component) {
  _inherits(Waveform, _React$Component);

  function Waveform(props) {
    _classCallCheck(this, Waveform);

    var _this = _possibleConstructorReturn(this, (Waveform.__proto__ || Object.getPrototypeOf(Waveform)).call(this, props));

    _this.state = {
      waveformData: _this.sampleData(props.data)
    };

    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.setCanvasContainerRef = _this.setCanvasContainerRef.bind(_this);
    _this.setCanvasRef = _this.setCanvasRef.bind(_this);
    return _this;
  }

  _createClass(Waveform, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateWaveform();
      window.addEventListener('resize', this.handleWindowResize, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize, true);
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      if (this.canvasElement) {
        this.canvasElement.style.width = this.canvasContainerElement.parentNode.clientWidth + 'px';
      }
    }
  }, {
    key: 'sampleData',
    value: function sampleData(response) {
      var form = { max: 1, samples: [] };
      for (var i = 0; i < response.length; i++) {
        var sample = response.data[i * 2 + 1] - response.data[i * 2];
        form.samples.push(sample);
        if (sample > form.max) {
          form.max = sample;
        }
      }
      return form;
    }
  }, {
    key: 'updateWaveform',
    value: function updateWaveform() {
      var colour = this.props.colour;
      var waveformData = this.state.waveformData;

      var canvasContainer = this.canvasContainerElement;
      var canvas = this.canvasElement;

      var context = canvas.getContext('2d');
      canvas.style.width = canvasContainer.parentNode.clientWidth + 'px';
      canvas.width = this.state.waveformData.samples.length;

      // Clear the canvas
      context.clearRect(0, 0, canvas.width, canvas.height);

      // Pre-calculate some values
      var yBaseline = canvas.height / 2;
      var yMultiplier = yBaseline / waveformData.max;

      // Draw the dividing middle line
      context.lineWidth = 0.1;
      context.beginPath();
      context.moveTo(0, yBaseline);
      context.lineTo(canvas.width, yBaseline);
      context.stroke();

      // Draw the top part of the waveform
      context.fillStyle = colour;
      context.beginPath();
      context.moveTo(0, yBaseline);
      for (var i = 0; i < waveformData.samples.length; i++) {
        context.lineTo(i, yBaseline - waveformData.samples[i] * yMultiplier);
      }
      context.lineTo(canvas.width, yBaseline);
      context.closePath();
      context.fill();

      // Draw the bottom part
      context.beginPath();
      context.moveTo(0, yBaseline);
      for (var _i = 0; _i < waveformData.samples.length; _i++) {
        context.lineTo(_i, yBaseline + waveformData.samples[_i] * yMultiplier);
      }
      context.lineTo(canvas.width, yBaseline);
      context.closePath();
      context.fill();
    }
  }, {
    key: 'setCanvasContainerRef',
    value: function setCanvasContainerRef(canvasContainerElement) {
      this.canvasContainerElement = canvasContainerElement;
    }
  }, {
    key: 'setCanvasRef',
    value: function setCanvasRef(canvasElement) {
      this.canvasElement = canvasElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var progress = this.props.progress;

      var canvasContainerStyles = {
        width: progress * 100 + '%',
        height: '100%',
        position: 'absolute',
        overflow: 'hidden'
      };
      var canvasStyles = {
        height: '100%',
        position: 'absolute'
      };
      return react_default.a.createElement(
        'div',
        { ref: this.setCanvasContainerRef, style: canvasContainerStyles },
        react_default.a.createElement('canvas', { ref: this.setCanvasRef, style: canvasStyles })
      );
    }
  }]);

  return Waveform;
}(react_default.a.Component);

/* harmony default export */ var waveform = (waveform_Waveform);
// CONCATENATED MODULE: ./client/components/icons/play.js
var play__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var play = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    play__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Play' },
      props.title || 'Play'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M255.5,5C116.6,5,4,117.6,4,256.5C4,395.41,116.6,508,255.5,508C394.4,508,507,395.4,507,256.5 C507,117.6,394.4,5,255.5,5 M374.8,269.99l-172.98,98.6c-13.03,7.44-23.69,1.36-23.69-13.48V157.9c0-14.84,10.66-20.91,23.69-13.49 L374.8,243C387.8,250.43,387.8,262.57,374.8,269.99' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/pause.js
var pause__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var pause = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    pause__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Pause' },
      props.title || 'Pause'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M224 435.8v-359.7c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8 0-12.2 5.4-12.2 12.1v359.7c0 6.7 5.4 12.2 12.2 12.2h71.6c6.8 0 12.2-5.4 12.2-12.2zM371.8 64h-71.6c-6.7 0-12.2 5.4-12.2 12.1v359.7c0 6.7 5.4 12.2 12.2 12.2h71.6c6.7 0 12.2-5.4 12.2-12.2v-359.7c0-6.7-5.4-12.1-12.2-12.1z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/spinner.js
var spinner__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var spinner = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    spinner__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Spinner' },
      props.title || 'Spinner'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M169.9 408c0 12.7-4.5 23.4-13.5 32.3s-19.7 13.3-32.1 13.3c-12.7 0-23.4-4.4-32.3-13.3s-13.3-19.7-13.3-32.3 4.4-23.4 13.3-32.3c8.9-8.9 19.6-13.3 32.3-13.3 12.5 0 23.2 4.4 32.1 13.3 9 8.8 13.5 19.6 13.5 32.3zm136.7 60.7c0 11.2-4 20.7-11.9 28.6-7.9 7.9-17.5 11.9-28.6 11.9-11.2 0-20.7-4-28.6-11.9-7.9-7.9-11.9-17.5-11.9-28.6 0-11.2 4-20.7 11.9-28.6 7.9-7.9 17.5-11.9 28.6-11.9 11.2 0 20.7 4 28.6 11.9 8 7.9 11.9 17.5 11.9 28.6zm-192.4-202.6c0 13.9-5 25.9-14.9 35.8s-21.8 14.9-35.8 14.9c-13.9 0-25.9-5-35.8-14.9s-14.9-21.8-14.9-35.8 5-25.9 14.9-35.8c9.9-9.9 21.8-14.9 35.8-14.9 13.9 0 25.9 5 35.8 14.9s14.9 21.9 14.9 35.8zm329.2 141.9c0 9.7-3.5 18-10.4 25-7 7-15.3 10.5-25 10.4-9.7 0-18.1-3.5-25-10.4s-10.4-15.3-10.4-25 3.5-18.1 10.4-25c7-6.9 15.3-10.4 25-10.4s18.1 3.5 25 10.4c6.9 6.9 10.4 15.3 10.4 25zm-263.4-283.7c0 15.4-5.4 28.5-16.3 39.4-10.9 10.9-24 16.3-39.4 16.3-15.4 0-28.5-5.4-39.4-16.3-10.9-10.9-16.3-24-16.3-39.4s5.4-28.5 16.3-39.4 24-16.3 39.4-16.3 28.5 5.4 39.4 16.3c10.9 10.9 16.3 24 16.3 39.4zm146.9-60.8c0 16.9-5.9 31.2-17.7 43.1s-26.2 17.7-43.1 17.7-31.2-5.9-43.1-17.7c-11.8-11.8-17.7-26.2-17.7-43.1 0-16.9 5.9-31.2 17.7-43.1 11.8-11.8 26.2-17.7 43.1-17.7s31.2 5.9 43.1 17.7 17.7 26.2 17.7 43.1zm172.2 202.6c0 8.4-3 15.6-8.9 21.5s-13.1 8.9-21.5 8.9-15.6-3-21.5-8.9-8.9-13.1-8.9-21.5 3-15.6 8.9-21.5 13.1-8.9 21.5-8.9 15.6 3 21.5 8.9c6 5.9 8.9 13.1 8.9 21.5zm-65.8-141.8c0 7-2.5 12.9-7.4 17.9-5 5-10.9 7.4-17.9 7.4-7 0-12.9-2.5-17.9-7.4-5-5-7.4-10.9-7.4-17.9s2.5-12.9 7.4-17.9c5-5 10.9-7.4 17.9-7.4 7 0 12.9 2.5 17.9 7.4 4.9 5 7.4 10.9 7.4 17.9z' })
    )
  );
});
// EXTERNAL MODULE: ./client/components/audio/audioPlayerLarge.module.css
var audioPlayerLarge_module = __webpack_require__(293);
var audioPlayerLarge_module_default = /*#__PURE__*/__webpack_require__.n(audioPlayerLarge_module);

// CONCATENATED MODULE: ./client/components/audio/audioPlayerLarge.js
var audioPlayerLarge__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function audioPlayerLarge__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function audioPlayerLarge__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function audioPlayerLarge__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var audioPlayerLarge_AudioPlayerLarge = function (_React$Component) {
  audioPlayerLarge__inherits(AudioPlayerLarge, _React$Component);

  function AudioPlayerLarge(props) {
    audioPlayerLarge__classCallCheck(this, AudioPlayerLarge);

    var _this = audioPlayerLarge__possibleConstructorReturn(this, (AudioPlayerLarge.__proto__ || Object.getPrototypeOf(AudioPlayerLarge)).call(this, props));

    _this.state = {
      playing: false,
      bufferProgress: 0,
      playBarProgress: 0,
      expectedPlayBarProgress: null,
      dragging: false,
      loading: false,
      seen: false,
      waveformData: null,
      playPromise: null
    };

    _this.togglePlay = _this.togglePlay.bind(_this);
    _this.onAudioBuffer = _this.onAudioBuffer.bind(_this);
    _this.onAudioProgress = _this.onAudioProgress.bind(_this);
    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.onMouseMove = _this.onMouseMove.bind(_this);
    _this.onSeeked = _this.onSeeked.bind(_this);
    _this.onDurationChange = _this.onDurationChange.bind(_this);
    _this.onPlay = _this.onPlay.bind(_this);
    _this.onPause = _this.onPause.bind(_this);
    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
    _this.onElementVisible = _this.onElementVisible.bind(_this);
    _this.setAudioElementRef = _this.setAudioElementRef.bind(_this);
    _this.setWaveformContainerElementRef = _this.setWaveformContainerElementRef.bind(_this);
    return _this;
  }

  audioPlayerLarge__createClass(AudioPlayerLarge, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.audioElement) {
        if (prevProps.isActive && !this.props.isActive) {
          this.tryPause();
        }
      }
    }
  }, {
    key: 'onElementVisible',
    value: function onElementVisible(isVisible) {
      var _this2 = this;

      var item = this.props.item;
      var seen = this.state.seen;

      if (!seen && isVisible) {
        this.setState({ seen: true });
        // We get a url that looks like the following: https://0.s3.envato.com/files/88545/preview.mp3?foo=bar
        // This regex will extract the 88545/preview.mp3 part from it and send that to tsunami
        var mp3UrlRegex = /^.*files\/(.*\.mp3)/g;
        var mp3Url = Object(lodash["get"])(item, 'previews.icon_with_audio_preview.mp3_url');
        var mp3PathGroup = mp3UrlRegex.exec(mp3Url);
        var mp3Path = void 0;
        if (mp3PathGroup && mp3PathGroup.length >= 1) {
          mp3Path = mp3PathGroup[1];
        }

        axiosVerbose["default"].get('https://waveform-discovery.envato.com/tsunami/' + mp3Path).then(function (response) {
          _this2.setState({ waveformData: response.data });
        }).catch(errors["logError"]);
      }
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this.setState({ playing: false });
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this.props.onPlay();
      this.setState({ playing: true });
      raf_default()(this.onAudioProgress);
    }
  }, {
    key: 'tryPause',
    value: function tryPause() {
      var _this3 = this;

      if (this.state.playPromise) {
        this.state.playPromise.then(function () {
          if (_this3.audioElement) {
            _this3.audioElement.pause();
          }
        });
      }
    }
  }, {
    key: 'tryPlay',
    value: function tryPlay() {
      var _this4 = this;

      if (this.audioElement) {
        /*
          For some old browsers (Safari 9) play() does not return promise but undefined.
          Let's handle that case by returning resolved promise instead.
         */
        return (this.audioElement.play() || Promise.resolve()).catch(function (error) {
          // Throw error only if HTMLMediaElement still exists, if it's unmounted let's ignored it.
          // HTMLMediaElement internally call pause when removed from DOM. If media is still loading when unmounted
          // it caused an error "play() interrupted by pause()". There is no way to wait for media to play in the process of
          // unmounting
          if (_this4.audioElement) {
            throw error;
          }
        });
      }
    }
  }, {
    key: 'onDurationChange',
    value: function onDurationChange() {
      if (this.state.expectedPlayBarProgress) {
        this.audioElement.currentTime = this.state.expectedPlayBarProgress * this.audioElement.duration;
      }
    }
  }, {
    key: 'onSeeked',
    value: function onSeeked() {
      this.showLoading();
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown(event) {
      var progress = event.nativeEvent.offsetX / this.waveformContainerElement.clientWidth;
      this.setState({ dragging: true, playBarProgress: progress });
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp() {
      var _this5 = this;

      var playBarProgress = this.state.playBarProgress;


      this.setState({ dragging: false });

      if (this.audioElement.duration) {
        this.audioElement.currentTime = playBarProgress * this.audioElement.duration;
        this.setState({
          playPromise: this.tryPlay()
        });

        this.showLoading();
      } else {
        this.setState({
          expectedPlayBarProgress: playBarProgress
        }, function () {
          _this5.setState({
            playPromise: _this5.tryPlay()
          });
          _this5.showLoading();
        });
      }
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      var dragging = this.state.dragging;

      if (dragging) {
        this.setState({
          playBarProgress: event.nativeEvent.offsetX / this.waveformContainerElement.clientWidth
        });
      }
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      this.setState({
        dragging: false
      });
    }
  }, {
    key: 'onAudioBuffer',
    value: function onAudioBuffer() {
      if (this.audioElement.buffered.length > 0 && this.audioElement.duration) {
        var percentLoaded = this.audioElement.buffered.end(this.audioElement.buffered.length - 1) / this.audioElement.duration;
        if (percentLoaded > 1) {
          percentLoaded = 1;
        }
        this.setState({ bufferProgress: percentLoaded });
      }
    }
  }, {
    key: 'onAudioProgress',
    value: function onAudioProgress() {
      if (this.state.playing) {
        if (!this.state.dragging && this.audioElement) {
          this.setState({
            playBarProgress: this.audioElement.currentTime / this.audioElement.duration
          });
        }
        raf_default()(this.onAudioProgress);
      }
    }
  }, {
    key: 'showLoading',
    value: function showLoading() {
      if (this.audioElement.seeking || this.audioElement.readyState < 3) {
        this.setState({ loading: true });
      } else {
        this.setState({ loading: false });
      }
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      var playing = this.state.playing;

      if (this.audioElement) {
        var isTrulyPlaying = this.audioElement.currentTime > 0 && !this.audioElement.paused && !this.audioElement.ended && this.audioElement.readyState > 2;
        if (playing && isTrulyPlaying) {
          this.tryPause();
        } else if (!isTrulyPlaying) {
          this.setState({
            playPromise: this.tryPlay()
          });
          this.showLoading();
        }
      }
    }
  }, {
    key: 'setAudioElementRef',
    value: function setAudioElementRef(audioElement) {
      this.audioElement = audioElement;
    }
  }, {
    key: 'setWaveformContainerElementRef',
    value: function setWaveformContainerElementRef(waveformElement) {
      this.waveformContainerElement = waveformElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          playing = _state.playing,
          loading = _state.loading,
          seen = _state.seen,
          waveformData = _state.waveformData,
          bufferProgress = _state.bufferProgress,
          playBarProgress = _state.playBarProgress;
      var item = this.props.item;

      var playBarProgressStyles = {
        width: playBarProgress * 100 + '%',
        height: '100%',
        position: 'absolute',
        boxShadow: '2px 0px 0px #000',
        display: playBarProgress > 0 ? null : 'none'
      };
      var buttonIcon = null;
      if (loading) {
        buttonIcon = react_default.a.createElement(spinner, { className: audioPlayerLarge_module_default.a.spinningIcon });
      } else {
        if (playing) {
          buttonIcon = react_default.a.createElement(pause, { className: audioPlayerLarge_module_default.a.icon });
        } else {
          buttonIcon = react_default.a.createElement(play, { className: audioPlayerLarge_module_default.a.icon });
        }
      }

      var mp3Url = Object(lodash["get"])(item, 'previews.icon_with_audio_preview.mp3_url');

      return react_default.a.createElement(
        'div',
        { className: audioPlayerLarge_module_default.a.spaceBetween },
        react_default.a.createElement(visibility_sensor_default.a, { onChange: this.onElementVisible, active: !seen }),
        react_default.a.createElement(
          'audio',
          {
            ref: this.setAudioElementRef,
            preload: 'none',
            onPlay: this.onPlay,
            onPause: this.onPause,
            onDurationChange: this.onDurationChange,
            onProgress: this.onAudioBuffer,
            onSeeked: this.onSeeked,
            onCanPlay: this.onSeeked
          },
          react_default.a.createElement('source', { src: mp3Url, type: 'audio/mpeg' })
        ),
        react_default.a.createElement(
          'button',
          {
            onClick: this.togglePlay,
            className: 'fds-c-button -color-transparent'
          },
          buttonIcon
        ),
        waveformData && react_default.a.createElement(
          'div',
          {
            ref: this.setWaveformContainerElementRef,
            className: audioPlayerLarge_module_default.a.waveformContainer,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseMove: this.onMouseMove,
            onMouseLeave: this.onMouseLeave
          },
          react_default.a.createElement(waveform, { data: waveformData, colour: '#aaa', progress: 1 }),
          react_default.a.createElement(waveform, {
            data: waveformData,
            colour: '#7e7e7e',
            progress: bufferProgress
          }),
          react_default.a.createElement(waveform, {
            data: waveformData,
            colour: '#7aa93c',
            progress: playBarProgress
          }),
          react_default.a.createElement(
            'div',
            { style: playBarProgressStyles },
            react_default.a.createElement(
              'div',
              { className: audioPlayerLarge_module_default.a.timeContainer },
              this.audioElement ? Object(time["a" /* getMinutesSecondsTime */])(this.audioElement.currentTime) : ''
            )
          )
        )
      );
    }
  }]);

  return AudioPlayerLarge;
}(react_default.a.Component);

audioPlayerLarge_AudioPlayerLarge.propTypes = {
  item: prop_types_default.a.object.isRequired,
  onPlay: prop_types_default.a.func,
  isActive: prop_types_default.a.bool
};
audioPlayerLarge_AudioPlayerLarge.defaultProps = {
  onPlay: function onPlay() {}
};
/* harmony default export */ var audioPlayerLarge = (audioPlayerLarge_AudioPlayerLarge);
// CONCATENATED MODULE: ./client/components/audio/audioPlayerLargeContainer.js






var audioPlayerLargeContainer_mapStateToProps = function mapStateToProps(state, ownProps) {
  var itemAudioSrc = Object(lodash["get"])(ownProps, 'item.previews.icon_with_audio_preview.mp3_url');
  var activeAudio = state.searchPage.activeAudio;


  return {
    isActive: itemAudioSrc && itemAudioSrc === activeAudio
  };
};

var audioPlayerLargeContainer_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var itemAudioSrc = Object(lodash["get"])(ownProps, 'item.previews.icon_with_audio_preview.mp3_url');
  return {
    onPlay: function onPlay() {
      return dispatch(Object(searchPage["setActiveAudio"])(itemAudioSrc));
    }
  };
};

var AudioPlayerLargeContainer = Object(react_redux_es["connect"])(audioPlayerLargeContainer_mapStateToProps, audioPlayerLargeContainer_mapDispatchToProps)(audioPlayerLarge);

/* harmony default export */ var audioPlayerLargeContainer = (AudioPlayerLargeContainer);
// CONCATENATED MODULE: ./common/utils/pad.js
var pad = function pad(num, size) {
  var s = '0' + num;
  return s.substr(s.length - size);
};

/* harmony default export */ var utils_pad = (pad);
// EXTERNAL MODULE: ./common/utils/item.js
var utils_item = __webpack_require__(28);

// EXTERNAL MODULE: ./client/components/icons/clock.js
var clock = __webpack_require__(88);

// EXTERNAL MODULE: ./client/components/icons/tempo.js
var tempo = __webpack_require__(118);

// EXTERNAL MODULE: ./client/components/itemCard/listAudio.module.css
var listAudio_module = __webpack_require__(294);
var listAudio_module_default = /*#__PURE__*/__webpack_require__.n(listAudio_module);

// CONCATENATED MODULE: ./client/components/itemCard/listAudio.js
















var listAudio_ItemCardListAudio = function ItemCardListAudio(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      rank = _ref.rank,
      onAddToCollections = _ref.onAddToCollections,
      onItemLinkClick = _ref.onItemLinkClick,
      onAddToCart = _ref.onAddToCart;

  var trackTempo = Object(utils_item["getItemAttribute"])(item, 'bpm');
  var length = Object(lodash["get"])(item, 'previews.icon_with_audio_preview.length');
  var trackLengthHours = length && length.hours ? length.hours + ':' : '';
  var trackLength = length ? '' + trackLengthHours + utils_pad(length.minutes, 2) + ':' + utils_pad(length.seconds, 2) : null;

  return react_default.a.createElement(
    'div',
    { className: listAudio_module_default.a.container },
    react_default.a.createElement(
      'div',
      { className: listAudio_module_default.a.itemSummary },
      react_default.a.createElement(
        'a',
        {
          className: listAudio_module_default.a.thumbnail,
          href: item.url + '?s_rank=' + rank,
          onClick: onItemLinkClick
        },
        react_default.a.createElement('img', {
          alt: item.name,
          width: '80',
          height: '80',
          src: item.ui.smallPreviewUrl,
          title: item.name
        })
      ),
      react_default.a.createElement(itemActions, {
        item: item,
        onAddToFavourites: onAddToFavourites,
        onAddToCollections: onAddToCollections,
        onAddToCart: onAddToCart
      })
    ),
    react_default.a.createElement(
      'div',
      { className: listAudio_module_default.a.itemDescription },
      react_default.a.createElement(
        'div',
        { className: listAudio_module_default.a.flexColumn },
        react_default.a.createElement(
          'div',
          { className: listAudio_module_default.a.spaceBetween },
          react_default.a.createElement(
            'h3',
            { className: 'fds-u-m0 fds-c-text-heading -size-xs' },
            react_default.a.createElement(
              'a',
              {
                className: 'fds-c-text-link -color-inherit -decoration-reversed',
                href: item.url + '?s_rank=' + rank,
                onClick: onItemLinkClick
              },
              item.name
            )
          ),
          react_default.a.createElement(
            'span',
            null,
            'by',
            ' ',
            react_default.a.createElement(
              'a',
              {
                className: 'fds-c-text-link -color-dark -decoration-reversed',
                href: item.author_url
              },
              item.author_username
            )
          )
        ),
        react_default.a.createElement(audioPlayerLargeContainer, { item: item }),
        react_default.a.createElement(
          'div',
          { className: listAudio_module_default.a.meta },
          react_default.a.createElement(
            'p',
            { className: 'fds-c-text-body -size-xs fds-u-m0' },
            react_default.a.createElement(metaCategories, {
              classification: item.classification,
              className: 'meta-categories -no-slash'
            })
          ),
          react_default.a.createElement(
            'div',
            null,
            trackLength ? react_default.a.createElement(
              'span',
              { className: 'fds-u-pr2' },
              react_default.a.createElement(clock["a" /* default */], null),
              react_default.a.createElement(
                'span',
                {
                  className: 'fds-c-text-body -size-xs -weight-bold fds-u-m0  fds-u-pl1',
                  'data-test-selector': 'duration'
                },
                trackLength
              )
            ) : null,
            trackTempo ? react_default.a.createElement(
              'span',
              { className: 'fds-u-pr2' },
              react_default.a.createElement(tempo["a" /* default */], null),
              react_default.a.createElement(
                'span',
                { className: 'fds-c-text-body -size-xs -weight-bold fds-u-m0 fds-u-pl1' },
                trackTempo
              )
            ) : null,
            item.number_of_sales ? react_default.a.createElement(
              'span',
              { className: 'fds-u-pr4' },
              react_default.a.createElement(barChart["a" /* default */], null),
              react_default.a.createElement(
                'span',
                { className: 'fds-c-text-body -size-xs -weight-bold fds-u-m0 fds-u-pl1' },
                item.number_of_sales
              )
            ) : null,
            react_default.a.createElement(
              'span',
              { className: 'fds-c-text-heading -size-xs' },
              react_default.a.createElement(
                'b',
                { className: 'fds-c-text-currency' },
                '$',
                item.ui.price
              )
            )
          )
        )
      )
    ),
    item.trending && react_default.a.createElement(trendingSash, null)
  );
};

listAudio_ItemCardListAudio.propTypes = {
  item: prop_types_default.a.object.isRequired,
  onAddToFavourites: prop_types_default.a.func.isRequired,
  rank: prop_types_default.a.number.isRequired,
  onItemLinkClick: prop_types_default.a.func,
  onAddToCart: prop_types_default.a.func
};

/* harmony default export */ var listAudio = (listAudio_ItemCardListAudio);
// EXTERNAL MODULE: ./client/components/audio/audioPlayerSmall.module.css
var audioPlayerSmall_module = __webpack_require__(295);
var audioPlayerSmall_module_default = /*#__PURE__*/__webpack_require__.n(audioPlayerSmall_module);

// CONCATENATED MODULE: ./client/components/audio/audioPlayerSmall.js
var audioPlayerSmall__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function audioPlayerSmall__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function audioPlayerSmall__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function audioPlayerSmall__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var audioPlayerSmall_AudioPlayerSmall = function (_React$Component) {
  audioPlayerSmall__inherits(AudioPlayerSmall, _React$Component);

  function AudioPlayerSmall(props) {
    audioPlayerSmall__classCallCheck(this, AudioPlayerSmall);

    var _this = audioPlayerSmall__possibleConstructorReturn(this, (AudioPlayerSmall.__proto__ || Object.getPrototypeOf(AudioPlayerSmall)).call(this, props));

    _this.state = {
      playing: false,
      loading: false,
      playBarProgress: 0,
      playPromise: null
    };

    _this.togglePlay = _this.togglePlay.bind(_this);
    _this.onPlay = _this.onPlay.bind(_this);
    _this.onPause = _this.onPause.bind(_this);
    _this.audioCanPlay = _this.audioCanPlay.bind(_this);
    _this.onAudioProgress = _this.onAudioProgress.bind(_this);
    _this.setAudioElementRef = _this.setAudioElementRef.bind(_this);
    return _this;
  }

  audioPlayerSmall__createClass(AudioPlayerSmall, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.audioElement) {
        if (prevProps.isActive && !this.props.isActive) {
          this.tryPause();
        }
      }
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this.setState({ playing: false });
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this.props.onPlay();
      this.setState({ playing: true });
      raf_default()(this.onAudioProgress);
    }
  }, {
    key: 'tryPause',
    value: function tryPause() {
      var _this2 = this;

      if (this.state.playPromise) {
        this.state.playPromise.then(function () {
          if (_this2.audioElement) {
            _this2.audioElement.pause();
          }
        });
      }
    }
  }, {
    key: 'tryPlay',
    value: function tryPlay() {
      var _this3 = this;

      if (this.audioElement) {
        /*
         For some old browsers (Safari 9) play() does not return promise but undefined.
         Let's handle that case by returning resolved promise instead.
         */
        return (this.audioElement.play() || Promise.resolve()).catch(function (error) {
          // Throw error only if HTMLMediaElement still exists, if it's unmounted let's ignored it.
          // HTMLMediaElement internally call pause when removed from DOM. If media is still loading when unmounted
          // it caused an error "play() interrupted by pause()". There is no way to wait for media to play in the process of
          // unmounting
          if (_this3.audioElement) {
            throw error;
          }
        });
      }
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      var playing = this.state.playing;

      if (this.audioElement) {
        var isTrulyPlaying = this.audioElement.currentTime > 0 && !this.audioElement.paused && !this.audioElement.ended && this.audioElement.readyState > 2;
        if (playing && isTrulyPlaying) {
          this.tryPause();
        } else if (!isTrulyPlaying) {
          this.setState({
            playPromise: this.tryPlay()
          });
          this.showLoading();
        }
      }
    }
  }, {
    key: 'onAudioProgress',
    value: function onAudioProgress() {
      if (this.state.playing) {
        if (this.audioElement) {
          this.setState({
            playBarProgress: this.audioElement.currentTime / this.audioElement.duration
          });
        }
        raf_default()(this.onAudioProgress);
      }
    }
  }, {
    key: 'showLoading',
    value: function showLoading() {
      if (this.audioElement.seeking || this.audioElement.readyState < 3) {
        this.setState({ loading: true });
      } else {
        this.setState({ loading: false });
      }
    }
  }, {
    key: 'audioCanPlay',
    value: function audioCanPlay() {
      this.showLoading();
    }
  }, {
    key: 'setAudioElementRef',
    value: function setAudioElementRef(audioElement) {
      this.audioElement = audioElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var src = this.props.src;
      var _state = this.state,
          playing = _state.playing,
          loading = _state.loading,
          playBarProgress = _state.playBarProgress;


      var buttonIcon = null;
      if (loading) {
        buttonIcon = react_default.a.createElement(spinner, { className: audioPlayerSmall_module_default.a.spinningIcon });
      } else {
        if (playing) {
          buttonIcon = react_default.a.createElement(pause, { className: audioPlayerSmall_module_default.a.whiteIcon });
        } else {
          buttonIcon = react_default.a.createElement(play, { className: audioPlayerSmall_module_default.a.icon });
        }
      }

      return react_default.a.createElement(
        'div',
        { className: audioPlayerSmall_module_default.a.container },
        react_default.a.createElement(
          'audio',
          {
            ref: this.setAudioElementRef,
            preload: 'none',
            onPlay: this.onPlay,
            onPause: this.onPause,
            onCanPlay: this.audioCanPlay
          },
          react_default.a.createElement('source', { src: src, type: 'audio/mpeg' })
        ),
        react_default.a.createElement(
          'button',
          { onClick: this.togglePlay, className: audioPlayerSmall_module_default.a.playButton },
          buttonIcon
        ),
        react_default.a.createElement(
          'div',
          { className: audioPlayerSmall_module_default.a.progressBarContainer },
          react_default.a.createElement('div', {
            className: audioPlayerSmall_module_default.a.progressBar,
            style: {
              width: playBarProgress * 100 + '%'
            }
          })
        )
      );
    }
  }]);

  return AudioPlayerSmall;
}(react_default.a.Component);

audioPlayerSmall_AudioPlayerSmall.propTypes = {
  src: prop_types_default.a.string.isRequired,
  onPlay: prop_types_default.a.func,
  isActive: prop_types_default.a.bool
};
audioPlayerSmall_AudioPlayerSmall.defaultProps = {
  onPlay: function onPlay() {}
};
/* harmony default export */ var audioPlayerSmall = (audioPlayerSmall_AudioPlayerSmall);
// CONCATENATED MODULE: ./client/components/audio/audioPlayerSmallContainer.js





var audioPlayerSmallContainer_mapStateToProps = function mapStateToProps(state, ownProps) {
  var activeAudio = state.searchPage.activeAudio;


  return {
    isActive: ownProps.src && ownProps.src === activeAudio
  };
};

var audioPlayerSmallContainer_mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onPlay: function onPlay() {
      return dispatch(Object(searchPage["setActiveAudio"])(ownProps.src));
    }
  };
};

var AudioPlayerSmallContainer = Object(react_redux_es["connect"])(audioPlayerSmallContainer_mapStateToProps, audioPlayerSmallContainer_mapDispatchToProps)(audioPlayerSmall);

/* harmony default export */ var audioPlayerSmallContainer = (AudioPlayerSmallContainer);
// EXTERNAL MODULE: ./client/components/itemCard/gridAudio.module.css
var gridAudio_module = __webpack_require__(296);
var gridAudio_module_default = /*#__PURE__*/__webpack_require__.n(gridAudio_module);

// CONCATENATED MODULE: ./client/components/itemCard/gridAudio.js












var gridAudio_ItemCardGridAudio = function ItemCardGridAudio(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      rank = _ref.rank,
      onAddToCollections = _ref.onAddToCollections,
      _ref$onItemLinkClick = _ref.onItemLinkClick,
      onItemLinkClick = _ref$onItemLinkClick === undefined ? function () {} : _ref$onItemLinkClick,
      _ref$onAddToCart = _ref.onAddToCart,
      onAddToCart = _ref$onAddToCart === undefined ? function () {} : _ref$onAddToCart;

  var salesLabel = item.number_of_sales === 1 ? 'Sale' : 'Sales';

  var mp3Url = Object(lodash["get"])(item, 'previews.icon_with_audio_preview.mp3_url');

  return react_default.a.createElement(
    'div',
    { className: gridAudio_module_default.a.itemView },
    react_default.a.createElement(
      'div',
      { className: gridAudio_module_default.a.actionContainer },
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'div',
          { className: gridAudio_module_default.a.miniAudioPlayerContainer },
          react_default.a.createElement(audioPlayerSmallContainer, { src: mp3Url })
        ),
        react_default.a.createElement(
          'a',
          {
            className: gridAudio_module_default.a.thumbnail,
            href: item.url + '?s_rank=' + rank,
            onClick: onItemLinkClick
          },
          item.trending && react_default.a.createElement(trendingSash, null),
          react_default.a.createElement('img', {
            alt: item.name,
            src: item.ui.smallPreviewUrl,
            title: item.name,
            width: '80',
            height: '80',
            className: gridAudio_module_default.a.thumbnailImage
          })
        )
      ),
      react_default.a.createElement(itemActions, {
        item: item,
        onAddToFavourites: onAddToFavourites,
        onAddToCollections: onAddToCollections,
        onAddToCart: onAddToCart
      })
    ),
    react_default.a.createElement(
      'h3',
      { className: gridAudio_module_default.a.itemName },
      react_default.a.createElement(
        'a',
        {
          className: 'fds-c-text-link -color-inherit -decoration-reversed',
          href: item.url + '?s_rank=' + rank,
          onClick: onItemLinkClick
        },
        item.name
      )
    ),
    react_default.a.createElement(
      'div',
      null,
      !!item.rating.rating && react_default.a.createElement(starRating, {
        rating: item.rating.rating,
        className: 'star-rating--search'
      })
    ),
    react_default.a.createElement(
      'footer',
      { className: gridAudio_module_default.a.footer },
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-xs fds-u-m0' },
        item.number_of_sales,
        ' ',
        salesLabel,
        ' ',
        react_default.a.createElement(
          'span',
          { className: 'product-grid__price' },
          '$',
          item.ui.price
        )
      ),
      item.ui.footerLink && react_default.a.createElement(
        es["Link"],
        { to: item.ui.footerLink.href },
        item.ui.footerLink.label
      )
    )
  );
};

gridAudio_ItemCardGridAudio.propTypes = {
  item: prop_types_default.a.object.isRequired,
  onAddToFavourites: prop_types_default.a.func.isRequired,
  rank: prop_types_default.a.number.isRequired,
  onItemLinkClick: prop_types_default.a.func,
  onAddToCart: prop_types_default.a.func
};

/* harmony default export */ var gridAudio = (gridAudio_ItemCardGridAudio);
// EXTERNAL MODULE: ./node_modules/@envato/react-video/dist/index.js
var dist = __webpack_require__(197);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./client/components/itemCard/gridVideo.module.css
var gridVideo_module = __webpack_require__(297);
var gridVideo_module_default = /*#__PURE__*/__webpack_require__.n(gridVideo_module);

// CONCATENATED MODULE: ./client/components/itemCard/gridVideo.js
var gridVideo__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function gridVideo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function gridVideo__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function gridVideo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var gridVideo_ItemCardGridVideo = function (_React$Component) {
  gridVideo__inherits(ItemCardGridVideo, _React$Component);

  function ItemCardGridVideo(props) {
    gridVideo__classCallCheck(this, ItemCardGridVideo);

    var _this = gridVideo__possibleConstructorReturn(this, (ItemCardGridVideo.__proto__ || Object.getPrototypeOf(ItemCardGridVideo)).call(this, props));

    _this.state = {
      playState: 'PAUSE',
      hideCursor: false,
      videoPlayPromise: null,
      videoLooped: false,
      reportedEvents: []
    };

    _this.onMouseOver = _this.onMouseOver.bind(_this);
    _this.onMouseOut = _this.onMouseOut.bind(_this);
    _this.onMouseMove = _this.onMouseMove.bind(_this);

    _this.handleVideoReportEvent = _this.handleVideoReportEvent.bind(_this);
    return _this;
  }

  gridVideo__createClass(ItemCardGridVideo, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.discardVideoReset();
    }
  }, {
    key: 'handleVideoReportEvent',
    value: function handleVideoReportEvent(playProgress) {
      if (this.playProgress === 0) {
        this.reportEvent('video_start');
      }

      if (playProgress >= 25 && playProgress < 50) {
        this.reportEvent('25_percent');
      }

      if (playProgress >= 50 && playProgress < 75) {
        this.reportEvent('50_percent');
      }

      if (playProgress >= 75) {
        this.reportEvent('75_percent');
      }

      if (playProgress + 1 >= 100) {
        this.reportEvent('video_complete');
        this.setState({
          videoLooped: true
        });
      }
    }
  }, {
    key: 'hasEventReported',
    value: function hasEventReported(eventName) {
      return this.state.reportedEvents.indexOf(eventName) >= 0;
    }
  }, {
    key: 'reportEvent',
    value: function reportEvent(eventName) {
      if (!this.state.videoLooped && !this.hasEventReported(eventName)) {
        var item = this.props.item;

        var videoSrc = Object(lodash["get"])(item, 'previews.icon_with_video_preview.video_url');

        if (this.props.reportVideoProgress) {
          this.props.reportVideoProgress(eventName, videoSrc);
          this.setState({
            reportedEvents: [eventName].concat(_toConsumableArray(this.state.reportedEvents))
          });
        }
      }
    }
  }, {
    key: 'scheduleVideoReset',
    value: function scheduleVideoReset() {
      var _this2 = this;

      this.videoResetTimeout = setTimeout(function () {
        _this2.setState({ playState: 'RESET' });
      }, 5000);
    }
  }, {
    key: 'discardVideoReset',
    value: function discardVideoReset() {
      if (this.videoResetTimeout) {
        clearTimeout(this.videoResetTimeout);
        this.videoResetTimeout = null;
      }
    }
  }, {
    key: 'pauseVideo',
    value: function pauseVideo() {
      this.setState({ playState: 'PAUSE' });
    }
  }, {
    key: 'scheduleVideoPlay',
    value: function scheduleVideoPlay() {
      var _this3 = this;

      this.discardScheduledVideoPlay();
      this.videoPlayTimeout = setTimeout(function () {
        _this3.setState({ playState: 'PLAY' });
      }, 500);
    }
  }, {
    key: 'discardScheduledVideoPlay',
    value: function discardScheduledVideoPlay() {
      if (this.videoPlayTimeout) {
        clearTimeout(this.videoPlayTimeout);
        this.videoPlayTimeout = null;
      }
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      var _this4 = this;

      this.timeout = setTimeout(function () {
        _this4.setState({ hideCursor: true });
      }, 3000);

      this.discardVideoReset();
      this.scheduleVideoPlay();
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.setState({ hideCursor: false });

      this.discardScheduledVideoPlay();
      this.pauseVideo();
      this.scheduleVideoReset();
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove() {
      if (this.state.hideCursor) {
        this.setState({ hideCursor: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          onAddToFavourites = _props.onAddToFavourites,
          rank = _props.rank,
          onAddToCollections = _props.onAddToCollections,
          onItemLinkClick = _props.onItemLinkClick,
          onAddToCart = _props.onAddToCart,
          muted = _props.muted,
          muteVideo = _props.muteVideo;
      var playState = this.state.playState;


      var videoLinkStyle = void 0;
      var overlayStyle = void 0;

      if (this.state.hideCursor) {
        videoLinkStyle = { cursor: 'none' };
        overlayStyle = { opacity: 0 };
      }

      var videoLength = Object(utils_item["getItemAttribute"])(item, 'length-video') || Object(utils_item["getItemAttribute"])(item, 'after-effects-project-file-length');
      var videoUrl = Object(lodash["get"])(item, 'previews.icon_with_video_preview.video_url');
      var posterUrl = Object(lodash["get"])(item, 'previews.icon_with_video_preview.landscape_url');

      return react_default.a.createElement(
        'div',
        { className: gridVideo_module_default.a.container },
        react_default.a.createElement(
          'div',
          {
            className: gridVideo_module_default.a.videoContainer,
            onMouseOver: this.onMouseOver,
            onMouseOut: this.onMouseOut,
            onMouseMove: this.onMouseMove
          },
          react_default.a.createElement(
            'a',
            {
              className: gridVideo_module_default.a.videoLink,
              href: item.url + '?s_rank=' + rank,
              onClick: onItemLinkClick,
              style: videoLinkStyle
            },
            react_default.a.createElement(dist["BaseVideoPlayer"], {
              playState: playState,
              muteVideo: muteVideo,
              onVideoProgress: this.handleVideoReportEvent,
              muted: muted,
              preload: 'none',
              className: gridVideo_module_default.a.video,
              loop: true,
              src: videoUrl,
              poster: posterUrl
            })
          ),
          react_default.a.createElement(
            'div',
            { className: gridVideo_module_default.a.overlay, style: overlayStyle },
            react_default.a.createElement(
              'div',
              { className: gridVideo_module_default.a.itemActions },
              react_default.a.createElement(itemActions, {
                item: item,
                defaultTheme: false,
                onAddToFavourites: onAddToFavourites,
                onAddToCollections: onAddToCollections,
                onAddToCart: onAddToCart
              })
            ),
            react_default.a.createElement(
              'div',
              { className: gridVideo_module_default.a.price },
              '$',
              item.ui.price
            )
          )
        ),
        item.trending && react_default.a.createElement(trendingSash, null),
        react_default.a.createElement(
          'div',
          { className: gridVideo_module_default.a.meta },
          react_default.a.createElement(
            'div',
            { className: gridVideo_module_default.a.titleContainer },
            react_default.a.createElement(
              'a',
              {
                className: gridVideo_module_default.a.title,
                href: item.url + '?s_rank=' + rank,
                onClick: onItemLinkClick
              },
              item.name
            )
          ),
          react_default.a.createElement(
            'div',
            { className: gridVideo_module_default.a.duration },
            videoLength
          )
        )
      );
    }
  }]);

  return ItemCardGridVideo;
}(react_default.a.Component);

/* harmony default export */ var gridVideo = (gridVideo_ItemCardGridVideo);
// EXTERNAL MODULE: ./common/utils/ga.js
var ga = __webpack_require__(13);

// CONCATENATED MODULE: ./common/analytics/videoHiveAnalytics.js


var videoHiveAnalytics_reportVideoProgress = function reportVideoProgress(eventName, videoSrc) {
  Object(ga["default"])('send', 'event', 'video player - search', eventName, videoSrc);
};
// CONCATENATED MODULE: ./client/components/itemCard/index.js
var itemCard__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var itemCard_ItemCard = function ItemCard(_ref) {
  var viewType = _ref.viewType,
      videoMuted = _ref.videoMuted,
      itemProps = _ref.itemProps,
      currentSite = _ref.currentSite,
      muteVideo = _ref.muteVideo;

  if (viewType === 'grid') {
    if (currentSite === 'audiojungle') {
      return react_default.a.createElement(gridAudio, itemProps);
    } else if (currentSite === 'videohive') {
      return react_default.a.createElement(gridVideo, itemCard__extends({
        reportVideoProgress: videoHiveAnalytics_reportVideoProgress,
        muted: videoMuted,
        muteVideo: muteVideo
      }, itemProps));
    }

    return react_default.a.createElement(gridDefault, itemProps);
  }

  if (currentSite === 'audiojungle') {
    return react_default.a.createElement(listAudio, itemProps);
  }
  return react_default.a.createElement(listDefault, itemCard__extends({}, itemProps, {
    muted: videoMuted,
    muteVideo: muteVideo
  }));
};

/* harmony default export */ var itemCard = (itemCard_ItemCard);
// CONCATENATED MODULE: ./client/components/productList/gridDefault.js




var gridDefault_GridDefault = function GridDefault(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator;

  return react_default.a.createElement(
    'ul',
    { 'data-test-selector': 'grid-layout', className: 'product-grid' },
    items.map(function (item, index) {
      return react_default.a.createElement(
        'li',
        { key: item.id },
        react_default.a.createElement(itemCard, {
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index)
        })
      );
    })
  );
};

/* harmony default export */ var productList_gridDefault = (gridDefault_GridDefault);
// CONCATENATED MODULE: ./client/components/productList/listDefault.js




var listDefault_ListDefault = function ListDefault(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator,
      videoMuted = _ref.videoMuted,
      muteVideo = _ref.muteVideo;

  return react_default.a.createElement(
    'ul',
    { 'data-test-selector': 'list-layout', className: 'product-list' },
    items.map(function (item, index) {
      return react_default.a.createElement(
        'li',
        { key: item.id },
        react_default.a.createElement(itemCard, {
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index),
          videoMuted: videoMuted,
          muteVideo: muteVideo
        })
      );
    })
  );
};

/* harmony default export */ var productList_listDefault = (listDefault_ListDefault);
// CONCATENATED MODULE: ./client/components/itemCard/listDefault.v1.js











var screenshotSrc = function screenshotSrc(item) {
  return 'https://envato-screenshots.imgix.net/' + item.id + '/screenshot.jpeg?w=300&h=280&fit=crop&crop=top';
};

var marketingSrc = function marketingSrc(item) {
  return item.previews.landscape_preview && item.previews.landscape_preview.landscape_url || item.previews.icon_with_video_preview && item.previews.icon_with_video_preview.landscape_url;
};

var listDefault_v1_ItemListViewImage = function ItemListViewImage(_ref) {
  var item = _ref.item,
      src = _ref.src;

  return react_default.a.createElement('img', {
    alt: item.name,
    className: 'preload no_preview landscape-image-magnifier',
    src: src,
    title: item.name,
    onError: function onError(e) {
      e.target.src = marketingSrc(item);
    }
  });
};

var listDefault_v1_ItemListViewScreenshotImage = function ItemListViewScreenshotImage(_ref2) {
  var item = _ref2.item;
  return react_default.a.createElement(listDefault_v1_ItemListViewImage, { item: item, src: screenshotSrc(item) });
};

var listDefault_v1_ItemListViewMarketingImage = function ItemListViewMarketingImage(_ref3) {
  var item = _ref3.item;
  return react_default.a.createElement(listDefault_v1_ItemListViewImage, { item: item, src: marketingSrc(item) });
};

var listDefault_v1_ItemCardListDefault = function ItemCardListDefault(_ref4) {
  var item = _ref4.item,
      onAddToFavourites = _ref4.onAddToFavourites,
      rank = _ref4.rank,
      onAddToCollections = _ref4.onAddToCollections,
      _ref4$onItemLinkClick = _ref4.onItemLinkClick,
      onItemLinkClick = _ref4$onItemLinkClick === undefined ? function () {} : _ref4$onItemLinkClick,
      _ref4$onAddToCart = _ref4.onAddToCart,
      onAddToCart = _ref4$onAddToCart === undefined ? function () {} : _ref4$onAddToCart,
      muted = _ref4.muted,
      muteVideo = _ref4.muteVideo,
      imageType = _ref4.imageType;

  var thumbnailClass = 'item-thumbnail__image item-thumbnail__' + (imageType || 'screenshot');

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement(
      'div',
      { className: 'product-list__columns-container' },
      react_default.a.createElement(
        'div',
        { className: 'product-list__column-detail' },
        react_default.a.createElement(
          'div',
          { className: 'product-list__item-thumbnail' },
          react_default.a.createElement(
            'div',
            { className: 'item-thumbnail' },
            react_default.a.createElement(
              overlay_default.a,
              {
                position: 'side',
                content: react_default.a.createElement(configurator_default.a, {
                  item: item,
                  videoMuted: muted,
                  muteVideo: muteVideo
                })
              },
              react_default.a.createElement(
                'div',
                { className: thumbnailClass },
                react_default.a.createElement(
                  'a',
                  {
                    href: item.url + '?s_rank=' + rank,
                    onClick: onItemLinkClick,
                    className: 'item-thumbnail__link'
                  },
                  imageType === 'marketing' ? react_default.a.createElement(listDefault_v1_ItemListViewMarketingImage, { item: item }) : react_default.a.createElement(listDefault_v1_ItemListViewScreenshotImage, { item: item })
                ),
                item.previews.live_site ? react_default.a.createElement(
                  'div',
                  { className: 'item-thumbnail__preview' },
                  react_default.a.createElement(
                    'a',
                    {
                      href: item.previews.live_site.url,
                      target: '_blank',
                      className: 'item-thumbnail__preview-link'
                    },
                    'Live preview'
                  )
                ) : null
              )
            )
          )
        ),
        react_default.a.createElement(
          'div',
          { className: 'product-list__adjacent-thumbnail' },
          react_default.a.createElement(
            'h3',
            { className: 'product-list__heading' },
            react_default.a.createElement(
              'a',
              {
                className: 'fds-c-text-link -color-inherit -decoration-reversed',
                href: item.url + '?s_rank=' + rank,
                onClick: onItemLinkClick
              },
              item.name
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'product-list__price' },
            react_default.a.createElement(
              'p',
              { className: 'fds-c-text-body -size-m -color-inherit -weight-bold fds-u-m0' },
              '$',
              item.ui.price
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'product-list__info' },
            react_default.a.createElement(
              'div',
              { className: 'product-list__info-author' },
              react_default.a.createElement(
                'a',
                {
                  className: 'fds-c-text-link -color-default -decoration-reversed',
                  href: item.author_url
                },
                item.author_username
              )
            ),
            react_default.a.createElement(
              'div',
              { className: 'product-list__column-category' },
              react_default.a.createElement(
                'p',
                { className: 'fds-c-text-body -size-xs fds-u-m0' },
                react_default.a.createElement(metaCategories, {
                  classification: item.classification,
                  className: 'meta-categories -no-slash'
                })
              )
            ),
            react_default.a.createElement(
              'div',
              { className: 'product-list__info-rating' },
              item.rating.rating ? react_default.a.createElement(starRating, {
                rating: item.rating.rating,
                className: 'star-rating--search'
              }) : null,
              item.rating.rating && item.rating.count ? item.rating.count + ' ratings' : null
            ),
            item.number_of_sales ? react_default.a.createElement(
              'div',
              { className: 'product-list__info-sale' },
              react_default.a.createElement(
                'span',
                { className: 'product-list__info-sale-glyph' },
                react_default.a.createElement(barChart["a" /* default */], null)
              ),
              item.number_of_sales,
              ' Sales'
            ) : null,
            react_default.a.createElement(
              'div',
              { className: 'product-list__item-thumbnail-actions' },
              react_default.a.createElement(
                'div',
                { className: 'item-thumbnail-actions -width-full' },
                react_default.a.createElement(itemActions, {
                  item: item,
                  onAddToFavourites: onAddToFavourites,
                  onAddToCollections: onAddToCollections,
                  onAddToCart: onAddToCart,
                  nonAudioTheme: true,
                  transparentTheme: true
                })
              )
            )
          )
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'product-list__column-price' },
        react_default.a.createElement(
          'p',
          { className: 'product-list__price-desktop' },
          '$',
          item.ui.price
        ),
        react_default.a.createElement(
          'div',
          { className: 'product-list__info-desktop' },
          item.rating.rating ? react_default.a.createElement(starRating, {
            rating: item.rating.rating,
            className: 'star-rating--search'
          }) : null,
          item.rating.rating ? react_default.a.createElement('br', null) : null,
          item.rating.rating && item.rating.count ? item.rating.count + ' ratings' : null,
          item.number_of_sales ? react_default.a.createElement(
            'div',
            { className: 'product-list__sales-desktop' },
            react_default.a.createElement(barChart["a" /* default */], { width: '20', height: '30' }),
            react_default.a.createElement('br', null),
            item.number_of_sales ? item.number_of_sales + ' Sales' : null
          ) : null
        )
      )
    ),
    item.trending && react_default.a.createElement(trendingSash, null)
  );
};

listDefault_v1_ItemCardListDefault.propTypes = {
  item: prop_types_default.a.object.isRequired,
  onAddToFavourites: prop_types_default.a.func.isRequired,
  rank: prop_types_default.a.number.isRequired,
  onItemLinkClick: prop_types_default.a.func,
  onAddToCart: prop_types_default.a.func,
  imageType: prop_types_default.a.string
};

/* harmony default export */ var listDefault_v1 = (listDefault_v1_ItemCardListDefault);
// CONCATENATED MODULE: ./client/components/itemCard/ItemCardExperimental.js
var ItemCardExperimental__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var ItemCardExperimental_ItemCard = function ItemCard(_ref) {
  var viewType = _ref.viewType,
      videoMuted = _ref.videoMuted,
      itemProps = _ref.itemProps,
      currentSite = _ref.currentSite,
      muteVideo = _ref.muteVideo,
      imageType = _ref.imageType;

  if (viewType === 'grid') {
    return react_default.a.createElement(gridDefault, itemProps);
  }

  return react_default.a.createElement(listDefault_v1, ItemCardExperimental__extends({}, itemProps, {
    muted: videoMuted,
    muteVideo: muteVideo,
    imageType: imageType
  }));
};

/* harmony default export */ var ItemCardExperimental = (ItemCardExperimental_ItemCard);
// CONCATENATED MODULE: ./client/components/productList/listThemePreviews.js




var listThemePreviews_ListThemePreviews = function ListThemePreviews(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator,
      videoMuted = _ref.videoMuted,
      muteVideo = _ref.muteVideo;

  return react_default.a.createElement(
    'ul',
    { 'data-test-selector': 'list-layout', className: 'product-list' },
    items.map(function (item, index) {
      return react_default.a.createElement(
        'li',
        { key: item.id },
        react_default.a.createElement(ItemCardExperimental, {
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index),
          videoMuted: videoMuted,
          muteVideo: muteVideo
        })
      );
    })
  );
};

/* harmony default export */ var listThemePreviews = (listThemePreviews_ListThemePreviews);
// CONCATENATED MODULE: ./client/components/productList/listMarketingImages.js




var listMarketingImages_ListMarketingImages = function ListMarketingImages(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator,
      videoMuted = _ref.videoMuted,
      muteVideo = _ref.muteVideo;

  return react_default.a.createElement(
    'ul',
    { 'data-test-selector': 'list-layout', className: 'product-list' },
    items.map(function (item, index) {
      return react_default.a.createElement(
        'li',
        { key: item.id },
        react_default.a.createElement(ItemCardExperimental, {
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index),
          videoMuted: videoMuted,
          muteVideo: muteVideo,
          imageType: 'marketing'
        })
      );
    })
  );
};

/* harmony default export */ var listMarketingImages = (listMarketingImages_ListMarketingImages);
// EXTERNAL MODULE: ./client/components/productList/gridVideo.module.css
var productList_gridVideo_module = __webpack_require__(298);
var productList_gridVideo_module_default = /*#__PURE__*/__webpack_require__.n(productList_gridVideo_module);

// CONCATENATED MODULE: ./client/components/productList/gridVideo.js






var gridVideo_GridVideo = function GridVideo(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      videoMuted = _ref.videoMuted,
      muteVideo = _ref.muteVideo,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator;

  return react_default.a.createElement(
    'ul',
    { 'data-test-selector': 'grid-layout', className: productList_gridVideo_module_default.a.grid },
    items.map(function (item, index) {
      return react_default.a.createElement(
        'li',
        { className: productList_gridVideo_module_default.a.result, key: item.id },
        react_default.a.createElement(itemCard, {
          videoMuted: videoMuted,
          muteVideo: muteVideo,
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index)
        })
      );
    })
  );
};

/* harmony default export */ var productList_gridVideo = (gridVideo_GridVideo);
// EXTERNAL MODULE: ./common/utils/analytics.js
var analytics = __webpack_require__(129);

// EXTERNAL MODULE: ./common/utils/localStorageHelpers.js
var localStorageHelpers = __webpack_require__(43);

// EXTERNAL MODULE: ./client/components/experiment/index.tsx
var experiment = __webpack_require__(172);
var experiment_default = /*#__PURE__*/__webpack_require__.n(experiment);

// EXTERNAL MODULE: ./client/components/experiment/variant.tsx
var variant = __webpack_require__(173);
var variant_default = /*#__PURE__*/__webpack_require__.n(variant);

// EXTERNAL MODULE: ./client/components/productList/preloader/index.tsx
var preloader = __webpack_require__(300);
var preloader_default = /*#__PURE__*/__webpack_require__.n(preloader);

// CONCATENATED MODULE: ./client/components/productList/index.js















var productList_ProductList = function ProductList(_ref) {
  var items = _ref.items,
      currentSite = _ref.currentSite,
      preferences = _ref.preferences,
      itemDecorator = _ref.itemDecorator,
      muteVideo = _ref.muteVideo,
      location = _ref.location;

  var viewType = preferences.searchResultsViewType;
  var videoMuted = preferences.searchVideoMuted;

  var cache = {
    get: function get(key) {
      return Object(localStorageHelpers["getLocalStorageItem"])(key);
    },
    set: function set(key, value) {
      return Object(localStorageHelpers["setLocalStorageItem"])(key, value);
    }
  };

  if (viewType === 'grid') {
    if (currentSite === 'videohive') {
      return react_default.a.createElement(productList_gridVideo, {
        items: items,
        viewType: viewType,
        videoMuted: videoMuted,
        muteVideo: muteVideo,
        currentSite: currentSite,
        itemDecorator: itemDecorator
      });
    } else {
      return react_default.a.createElement(productList_gridDefault, {
        items: items,
        viewType: viewType,
        currentSite: currentSite,
        itemDecorator: itemDecorator,
        location: location
      });
    }
  } else {
    if (currentSite === 'themeforest') {
      return react_default.a.createElement(
        experiment_default.a,
        {
          id: 'XHbr8E-VSVeHER8HvTH5gQ',
          onExperimentView: analytics["reportExperiment"],
          location: location,
          cache: cache,
          defaultVariantId: 0,
          forcedVariantId: location.query.variant && parseInt(location.query.variant),
          preloader: react_default.a.createElement(preloader_default.a, null)
        },
        react_default.a.createElement(
          variant_default.a,
          { variantId: 0 },
          react_default.a.createElement(productList_listDefault, {
            items: items,
            viewType: viewType,
            currentSite: currentSite,
            itemDecorator: itemDecorator,
            videoMuted: videoMuted,
            muteVideo: muteVideo
          })
        ),
        react_default.a.createElement(
          variant_default.a,
          { variantId: 1 },
          react_default.a.createElement(productList_listDefault, {
            items: items,
            viewType: viewType,
            currentSite: currentSite,
            itemDecorator: itemDecorator,
            videoMuted: videoMuted,
            muteVideo: muteVideo
          })
        ),
        react_default.a.createElement(
          variant_default.a,
          { variantId: 2 },
          react_default.a.createElement(
            'div',
            { className: 'xp' },
            react_default.a.createElement(listThemePreviews, {
              items: items,
              viewType: viewType,
              currentSite: currentSite,
              itemDecorator: itemDecorator,
              videoMuted: videoMuted,
              muteVideo: muteVideo
            })
          )
        ),
        react_default.a.createElement(
          variant_default.a,
          { variantId: 3 },
          react_default.a.createElement(
            'div',
            { className: 'xp' },
            react_default.a.createElement(listThemePreviews, {
              items: items,
              viewType: viewType,
              currentSite: currentSite,
              itemDecorator: itemDecorator,
              videoMuted: videoMuted,
              muteVideo: muteVideo
            })
          )
        ),
        react_default.a.createElement(
          variant_default.a,
          { variantId: 4 },
          react_default.a.createElement(
            'div',
            { className: 'xp' },
            react_default.a.createElement(listMarketingImages, {
              items: items,
              viewType: viewType,
              currentSite: currentSite,
              itemDecorator: itemDecorator,
              videoMuted: videoMuted,
              muteVideo: muteVideo
            })
          )
        ),
        react_default.a.createElement(
          variant_default.a,
          { variantId: 5 },
          react_default.a.createElement(
            'div',
            { className: 'xp' },
            react_default.a.createElement(listMarketingImages, {
              items: items,
              viewType: viewType,
              currentSite: currentSite,
              itemDecorator: itemDecorator,
              videoMuted: videoMuted,
              muteVideo: muteVideo
            })
          )
        )
      );
    } else {
      return react_default.a.createElement(productList_listDefault, {
        items: items,
        viewType: viewType,
        currentSite: currentSite,
        itemDecorator: itemDecorator,
        videoMuted: videoMuted,
        muteVideo: muteVideo
      });
    }
  }
};

/* harmony default export */ var productList = (productList_ProductList);
// EXTERNAL MODULE: ./common/utils/urlHelper.js
var urlHelper = __webpack_require__(5);

// CONCATENATED MODULE: ./client/pages/search/result/searchResultBody.js
var searchResultBody__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function searchResultBody__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function searchResultBody__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function searchResultBody__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var searchResultBody_SearchResultBody = function (_React$Component) {
  searchResultBody__inherits(SearchResultBody, _React$Component);

  function SearchResultBody() {
    searchResultBody__classCallCheck(this, SearchResultBody);

    return searchResultBody__possibleConstructorReturn(this, (SearchResultBody.__proto__ || Object.getPrototypeOf(SearchResultBody)).apply(this, arguments));
  }

  searchResultBody__createClass(SearchResultBody, [{
    key: 'itemRankOffset',
    value: function itemRankOffset() {
      var _props = this.props,
          currentSite = _props.currentSite,
          location = _props.location;


      var pageSize = Object(sites["getConfigBySite"])(currentSite, 'common.search_page_size');

      return ((Number(location.query.page) || 1) - 1) * pageSize + 1;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          matches = _props2.matches,
          currentSite = _props2.currentSite,
          location = _props2.location,
          clientVersion = _props2.clientVersion;

      // only report product impressions at page initial rendering for client that is not 2

      if (clientVersion !== 2) {
        Object(resultAnalytics["reportProductsImpressions"])({
          items: matches,
          currentSite: currentSite,
          itemRankOffset: this.itemRankOffset(),
          page: 'Search Results',
          section: Object(urlHelper["getTopLevelRoute"])(location.pathname)
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevMatches = prevProps.matches;
      var _props3 = this.props,
          matches = _props3.matches,
          currentSite = _props3.currentSite,
          location = _props3.location,
          clientFinishedLoading = _props3.clientFinishedLoading,
          clientVersion = _props3.clientVersion;

      // only report again when search result change or client finished loading

      if (!Object(utils_item["isSearchResultMatchesEqual"])(prevMatches, matches) || clientVersion === 2 && prevProps.clientFinishedLoading !== clientFinishedLoading) {
        Object(resultAnalytics["reportProductsImpressions"])({
          items: matches,
          currentSite: currentSite,
          itemRankOffset: this.itemRankOffset(),
          page: 'Search Results',
          section: Object(urlHelper["getTopLevelRoute"])(location.pathname)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          matches = _props4.matches,
          createFavoriteCollection = _props4.createFavoriteCollection,
          currentSite = _props4.currentSite,
          collections = _props4.collections,
          cartItems = _props4.cartItems,
          token = _props4.token,
          deleteBookmark = _props4.deleteBookmark,
          addBookmark = _props4.addBookmark,
          favoriteCollectionID = _props4.favoriteCollectionID,
          openModal = _props4.openModal,
          location = _props4.location,
          preferences = _props4.preferences,
          muteVideo = _props4.muteVideo;


      return react_default.a.createElement(
        'div',
        { 'data-test-selector': 'search-results-default' },
        react_default.a.createElement(productList, {
          items: matches,
          currentSite: currentSite,
          preferences: preferences,
          muteVideo: muteVideo,
          location: location,
          itemDecorator: Object(utils_item["itemDecorator"])(currentSite, openModal, !token, favoriteCollectionID, collections, deleteBookmark, addBookmark, createFavoriteCollection, this.itemRankOffset(), cartItems, location)
        })
      );
    }
  }]);

  return SearchResultBody;
}(react_default.a.Component);

searchResultBody_SearchResultBody.propTypes = {
  matches: prop_types_default.a.array.isRequired,
  view: prop_types_default.a.string
};

/* harmony default export */ var searchResultBody = __webpack_exports__["default"] = (searchResultBodyContainer_default()(searchResultBody_SearchResultBody));

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(6);
var urlHelper_1 = __webpack_require__(5);
var styles = __webpack_require__(303);
var RelatedSearchItem = function (_a) {
    var term = _a.term, type = _a.type;
    var nextQuery = {};
    nextQuery[type] = term;
    return (React.createElement("li", { className: styles.listItem },
        React.createElement(react_router_dom_1.Link, { className: styles.link, to: urlHelper_1.makeLink(nextQuery) }, term)));
};
var RelatedSearches = function (_a) {
    var recommendations = _a.recommendations, type = _a.type, hint = _a.hint;
    return (React.createElement("div", { className: styles.root },
        React.createElement("p", { className: styles.title },
            "Searches related to",
            React.createElement("span", { className: styles.bold },
                " ",
                hint)),
        type && (React.createElement("ul", { className: styles.list }, recommendations.map(function (term, index) {
            return React.createElement(RelatedSearchItem, { key: index, term: term, type: type });
        })))));
};
exports.default = RelatedSearches;


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(304);
var range_default = /*#__PURE__*/__webpack_require__.n(range);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__(78);
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./common/utils/urlHelper.js
var urlHelper = __webpack_require__(5);

// EXTERNAL MODULE: ./client/components/icons/rightOpen.js
var rightOpen = __webpack_require__(34);

// EXTERNAL MODULE: ./node_modules/react-icon-base/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./client/components/icons/leftOpen.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var leftOpen = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Left-Open' },
      props.title || 'Left-Open'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M106.9 275.1c-6.4-6.3-9.6-13.7-9.6-22s3.2-15.6 9.6-21.8l221.1-222.2c6.4-6.3 13.8-9.5 22.5-9.5 8.5 0 16 3.2 22.4 9.5l32.9 32.9c6.4 6.5 9.6 13.8 9.6 22.5 0 8.6-3.2 15.9-9.6 22l-167.5 168.1 167.4 164.8c6.4 6.3 9.6 13.6 9.6 21.9 0 8.2-3.2 15.5-9.6 21.9l-32.9 33.6c-6.4 6.3-13.9 9.5-22.4 9.5-8.6 0-16.1-3.2-22.5-9.5l-221-221.7z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/pagination/pagination.js
var pagination__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











/**
 * Return array of pages by given params with gap elements if needed. For pagination purpose. Examples:
 *  getPagesRange(1, 20, 10) -> [1, 2, 3, 4, 5, 6, 7, 8, 9, '...', 20]
 *  getPagesRange(11, 20, 10) -> [1, '...', 7, 8, 9, 10, 11, 12, 13, 14, '...', 20]
 * @param {Number} currentPage
 * @param {Number} pagesCount
 * @param {Number} maxDisplayedPages
 * @returns {Array}
 */
var pagination_getPagesRange = function getPagesRange(currentPage, pagesCount, maxDisplayedPages) {
  if (pagesCount <= maxDisplayedPages) {
    return range_default()(1, pagesCount + 1);
  }

  var pagesRange = [currentPage];
  var minPage = currentPage - 1;
  var maxPage = currentPage + 1;
  var direction = 1;

  while (pagesRange.length < maxDisplayedPages) {
    if (direction < 0 && minPage > 0) {
      pagesRange.unshift(minPage);
      minPage--;
    }

    if (direction > 0 && maxPage <= pagesCount) {
      pagesRange.push(maxPage);
      maxPage++;
    }

    direction *= -1;
  }

  if (pagesRange[0] !== 1) {
    pagesRange.splice(0, 1, 1, '...');
  }

  if (pagesRange[pagesRange.length - 1] !== pagesCount) {
    pagesRange.pop();
    pagesRange.push('...', pagesCount);
  }

  return pagesRange;
};

var scrollToTop = function scrollToTop() {
  window.scrollTo(0, 0);
};

var pagination_PaginationItem = function PaginationItem(_ref) {
  var value = _ref.value,
      link = _ref.link,
      isCurrentPage = _ref.isCurrentPage;

  var content = void 0;

  if (value === '...') {
    content = react_default.a.createElement(
      'span',
      { className: 'pagination__gap' },
      value
    );
  } else if (isCurrentPage) {
    content = react_default.a.createElement(
      'span',
      { className: 'pagination__page--current' },
      value
    );
  } else {
    content = react_default.a.createElement(
      es["Link"],
      { to: link, className: 'pagination__page', onClick: scrollToTop },
      value
    );
  }
  return react_default.a.createElement(
    'li',
    null,
    content
  );
};

var pagination_Pagination = function Pagination(_ref2) {
  var _ref2$currentPage = _ref2.currentPage,
      currentPage = _ref2$currentPage === undefined ? 1 : _ref2$currentPage,
      currentSite = _ref2.currentSite,
      totalItemsCount = _ref2.totalItemsCount,
      pageSize = _ref2.pageSize,
      location = _ref2.location,
      _ref2$maxDisplayedPag = _ref2.maxDisplayedPages,
      maxDisplayedPages = _ref2$maxDisplayedPag === undefined ? 10 : _ref2$maxDisplayedPag,
      baseUrl = _ref2.baseUrl,
      maxPagesCount = _ref2.maxPagesCount;

  var calculatedPagesCount = Math.ceil(totalItemsCount / pageSize);
  var pagesCount = maxPagesCount && calculatedPagesCount > maxPagesCount ? maxPagesCount : calculatedPagesCount;
  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  var previousPageLink = currentPage > 1 ? Object(urlHelper["makeLink"])(pagination__extends({}, parsedLocation, { page: currentPage - 1 }), currentSite) : null;
  var nextPageLink = currentPage < pagesCount ? Object(urlHelper["makeLink"])(pagination__extends({}, parsedLocation, { page: currentPage + 1 }), currentSite) : null;
  var shouldShowPagination = pagesCount > 1;

  var link = [];
  if (previousPageLink) {
    link.push({
      rel: 'prev',
      href: baseUrl + previousPageLink
    });
  }
  if (nextPageLink) {
    link.push({
      rel: 'next',
      href: baseUrl + nextPageLink
    });
  }

  return react_default.a.createElement(
    'div',
    null,
    shouldShowPagination && react_default.a.createElement(
      'nav',
      { className: 'pagination' },
      react_default.a.createElement(Helmet_default.a, { link: link }),
      react_default.a.createElement(
        'ul',
        { className: 'pagination__list' },
        previousPageLink ? react_default.a.createElement(
          'li',
          null,
          react_default.a.createElement(
            es["Link"],
            {
              to: previousPageLink,
              className: 'pagination__previous',
              onClick: scrollToTop
            },
            react_default.a.createElement(leftOpen, null)
          )
        ) : null,
        pagination_getPagesRange(currentPage, pagesCount, maxDisplayedPages).map(function (pageNumber, index) {
          var pageLink = Object(urlHelper["makeLink"])(pagination__extends({}, parsedLocation, { page: pageNumber }), currentSite);
          return react_default.a.createElement(pagination_PaginationItem, {
            key: index,
            value: pageNumber,
            link: pageLink,
            isCurrentPage: currentPage === pageNumber
          });
        }),
        nextPageLink ? react_default.a.createElement(
          'li',
          null,
          react_default.a.createElement(
            es["Link"],
            {
              to: nextPageLink,
              className: 'pagination__next',
              onClick: scrollToTop
            },
            react_default.a.createElement(rightOpen["a" /* default */], null)
          )
        ) : null
      )
    )
  );
};

pagination_Pagination.propTypes = {
  currentPage: prop_types_default.a.number,
  currentSite: prop_types_default.a.string,
  totalItemsCount: prop_types_default.a.number.isRequired,
  pageSize: prop_types_default.a.number.isRequired,
  location: prop_types_default.a.object.isRequired,
  maxDisplayedPages: prop_types_default.a.number,
  maxPagesCount: prop_types_default.a.number
};

/* harmony default export */ var pagination = __webpack_exports__["default"] = (pagination_Pagination);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./config/sites/ads/3docean.json
var _docean = __webpack_require__(305);
var _docean_default = /*#__PURE__*/__webpack_require__.n(_docean);

// EXTERNAL MODULE: ./config/sites/ads/audiojungle.json
var audiojungle = __webpack_require__(306);
var audiojungle_default = /*#__PURE__*/__webpack_require__.n(audiojungle);

// EXTERNAL MODULE: ./config/sites/ads/codecanyon.json
var codecanyon = __webpack_require__(307);
var codecanyon_default = /*#__PURE__*/__webpack_require__.n(codecanyon);

// EXTERNAL MODULE: ./config/sites/ads/graphicriver.json
var graphicriver = __webpack_require__(308);
var graphicriver_default = /*#__PURE__*/__webpack_require__.n(graphicriver);

// EXTERNAL MODULE: ./config/sites/ads/photodune.json
var photodune = __webpack_require__(309);
var photodune_default = /*#__PURE__*/__webpack_require__.n(photodune);

// EXTERNAL MODULE: ./config/sites/ads/themeforest.json
var themeforest = __webpack_require__(310);
var themeforest_default = /*#__PURE__*/__webpack_require__.n(themeforest);

// EXTERNAL MODULE: ./config/sites/ads/videohive.json
var videohive = __webpack_require__(311);
var videohive_default = /*#__PURE__*/__webpack_require__.n(videohive);

// CONCATENATED MODULE: ./config/sites/ads/index.js








/* harmony default export */ var ads = ({
  '3docean': _docean_default.a,
  audiojungle: audiojungle_default.a,
  codecanyon: codecanyon_default.a,
  graphicriver: graphicriver_default.a,
  photodune: photodune_default.a,
  themeforest: themeforest_default.a,
  videohive: videohive_default.a
});
// EXTERNAL MODULE: ./common/config.ts
var config = __webpack_require__(12);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./client/components/banners/crossPromoBanner.js





var crossPromoBanner_CrossPromoBanner = function CrossPromoBanner(_ref) {
  var currentSite = _ref.currentSite,
      currentCategory = _ref.currentCategory;

  var currentSiteConfig = ads[currentSite];

  var matchedAdsFromConfig = function matchedAdsFromConfig(config) {
    return config.reduce(function (incr, ad) {
      if (Array.isArray(ad.match)) {
        ad.match.forEach(function (match) {
          if (match === currentCategory) {
            incr.push(ad);
          }
        });
      } else {
        if (ad.match === currentCategory) {
          incr.push(ad);
        }
      }
      return incr;
    }, []);
  };

  var matchedAds = matchedAdsFromConfig(currentSiteConfig);

  if (matchedAds.length === 0) return null;

  return react_default.a.createElement(
    'div',
    null,
    react_default.a.createElement('hr', { className: 'search-facet-divider' }),
    matchedAds.map(function (ad) {
      return react_default.a.createElement(
        'div',
        { key: ad.title, className: 'cross-promos__box' },
        react_default.a.createElement(
          'div',
          { className: 'cross-promos' },
          ad.icon_source && react_default.a.createElement('img', {
            className: 'fds-u-mb2',
            title: ad.title,
            src: config["config"].assets.PUBLIC_PATH + '/images/cross-promos/' + ad.icon_source,
            alt: ad.title
          }),
          react_default.a.createElement(
            'div',
            { className: 'cross-promos__header fds-u-m0' },
            ad.title
          ),
          react_default.a.createElement('p', {
            dangerouslySetInnerHTML: {
              __html: ad.content
            },
            className: 'fds-c-text-body -size-s'
          }),
          react_default.a.createElement(
            'a',
            {
              title: ad.button_label,
              className: 'fds-c-button--outline -color-primary -width-full',
              href: ad.link
            },
            ad.button_label
          )
        )
      );
    })
  );
};

/* harmony default export */ var crossPromoBanner = __webpack_exports__["default"] = (crossPromoBanner_CrossPromoBanner);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(9);
var layout_1 = __webpack_require__(18);
var _1 = __webpack_require__(312);
var preference_1 = __webpack_require__(44);
var session_1 = __webpack_require__(73);
var mapStateToProps = function (state) {
    var layout = state.layout, common = state.common, searchPage = state.searchPage, user = state.user, marketing = state.marketing, experiments = state.experiments;
    var isModalOpen = layout.isModalOpen, openModalType = layout.openModalType, openModalData = layout.openModalData;
    var ingestedContent = searchPage.ingestedContent;
    var banners = marketing.banners;
    return {
        banners: banners,
        baseUrl: common.baseUrl,
        currentSite: common.currentSite,
        errorPage: common.errorPage,
        experiments: experiments,
        ingestedContent: ingestedContent,
        isModalOpen: isModalOpen,
        menuConfig: common.menuConfig,
        noIndex: common.noIndex,
        openModalData: openModalData,
        openModalType: openModalType,
        seoMeta: common.seoMeta,
        stats: common.stats,
        clientFinishedLoading: common.clientFinishedLoading,
        clientVersion: common.clientVersion,
        user: user
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        closeModal: function () { return dispatch(layout_1.closeModal()); },
        handleSignInSuccess: function (token) {
            dispatch(session_1.getSessionSuccessAction(token));
            return dispatch(_1.getUserProfile(token));
        },
        initUser: function () {
            dispatch(preference_1.initClientUserSearchResultsViewType(ownProps.location));
            dispatch(preference_1.getUserVideoPlayerStatus());
            dispatch(_1.getUser());
        },
        openModal: function (data) { return dispatch(layout_1.openModal(data)); }
    };
};
var createAppContainer = function (component) {
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(component);
};
exports.default = createAppContainer;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(9);
var fetchLandingPageContent_1 = __webpack_require__(313);
var mapStateToProps = function (state) {
    var _a = state.landingPage, html = _a.html, css = _a.css;
    return {
        html: html,
        css: css
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
var createLandingPageContainer = function (component) {
    var pageComponent = component;
    pageComponent.loadData = function (store, parsedUrl, opts) {
        return store.dispatch(fetchLandingPageContent_1.default(parsedUrl, opts));
    };
    var container = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(component);
    return container;
};
exports.default = createLandingPageContainer;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(9);
var onSearchPageDidUpdate_1 = __webpack_require__(314);
var searchPage_1 = __webpack_require__(20);
var searchResults_1 = __webpack_require__(109);
var mapStateToProps = function (state) {
    var _a = state.searchPage, loading = _a.loading, ingestedContent = _a.ingestedContent, relatedSearches = _a.relatedSearches, timeout = _a.timeout, studioRecommendations = _a.studioRecommendations, searchHeadings = _a.searchHeadings;
    var _b = state.common, currentSite = _b.currentSite, baseUrl = _b.baseUrl;
    var user = state.user;
    var selectedItemId = state.layout.selectedItemId;
    return {
        results: searchResults_1.searchResults(state),
        loading: loading,
        searchHeadings: searchHeadings,
        studioRecommendations: studioRecommendations,
        ingestedContent: ingestedContent,
        currentSite: currentSite,
        relatedSearches: relatedSearches,
        user: user,
        baseUrl: baseUrl,
        timeout: timeout,
        itemDetailsOpen: !!selectedItemId
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        onSearchPageDidUpdate: function (location, prevUser, prevResults) {
            dispatch(onSearchPageDidUpdate_1.default(location, prevUser, prevResults));
        }
    };
};
var createSearchPageContainer = function (component) {
    var pageComponent = component;
    pageComponent.loadData = function (store, parsedUrl, opts) {
        return store.dispatch(searchPage_1.default(parsedUrl, opts));
    };
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(component);
};
exports.default = createSearchPageContainer;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(3);
var querystring = __webpack_require__(22);
var react_router_dom_1 = __webpack_require__(6);
var url = __webpack_require__(511);
var common_1 = __webpack_require__(37);
var preference_1 = __webpack_require__(44);
var searchQueryWhitelist_1 = __webpack_require__(71);
var analytics_1 = __webpack_require__(129);
var fetchAllRequest_1 = __webpack_require__(315);
var ga_1 = __webpack_require__(13);
var objectDiff_1 = __webpack_require__(316);
var trackSearchCount_1 = __webpack_require__(94);
var urlHelper_1 = __webpack_require__(5);
var shouldFetchData = function (previousLocation, newLoaction) {
    var previousParsedLocationQuery = urlHelper_1.parseLocation({
        pathname: previousLocation.pathname,
        query: querystring.parse(previousLocation.search)
    });
    var newParsedLocationQuery = urlHelper_1.parseLocation({
        pathname: newLoaction.pathname,
        query: querystring.parse(newLoaction.search)
    });
    return objectDiff_1.default(previousParsedLocationQuery, newParsedLocationQuery).some(function (key) { return searchQueryWhitelist_1.searchApiParams.includes(key); });
};
var PendingNavDataLoader = /** @class */ (function (_super) {
    __extends(PendingNavDataLoader, _super);
    function PendingNavDataLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PendingNavDataLoader.prototype.componentWillReceiveProps = function (nextProps) {
        // check whether url has changed
        var navigated = !lodash_1.isEqual(nextProps.location, this.props.location);
        var _a = this.props, store = _a.store, routes = _a.routes;
        var newLocationQuery = querystring.parse(nextProps.location.search);
        if (navigated) {
            // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages#overriding
            ga_1.default('set', 'location', window.location.href);
            // Reset / hide alerts when changing the route after first rendering
            if (store.getState().common.alerts.length) {
                store.dispatch(common_1.resetAlerts());
            }
            // Reset (remove) error page if present
            if (store.getState().common.errorPage) {
                store.dispatch(common_1.resetErrorPage());
            }
            if (typeof window !== 'undefined' && newLocationQuery.view) {
                store.dispatch(preference_1.setUserSearchResultsViewType(newLocationQuery.view));
            }
            if (shouldFetchData(this.props.location, nextProps.location)) {
                // we have to ge the full location because `matchRoutes` does not return the search query part
                var opts = {
                    baseUrl: '',
                    isServer: false
                };
                var parsedUrl = url.parse(window.location.href);
                var promiseRequests = fetchAllRequest_1.default(store, parsedUrl, routes, opts);
                var currentSite_1 = this.props.store.getState().common.currentSite;
                Promise.all(promiseRequests)
                    .then(function (results) {
                    analytics_1.reportPageView();
                    if (currentSite_1 === 'photodune') {
                        trackSearchCount_1.countSearchFor(currentSite_1);
                    }
                })
                    .catch(function () {
                    analytics_1.reportPageView();
                });
            }
        }
    };
    PendingNavDataLoader.prototype.render = function () {
        var _a = this.props, children = _a.children, location = _a.location;
        return React.createElement(react_router_dom_1.Route, { location: location, render: function () { return children; } });
    };
    return PendingNavDataLoader;
}(React.Component));
exports.default = react_router_dom_1.withRouter(PendingNavDataLoader);


/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = __webpack_require__(141);
var redux_thunk_1 = __webpack_require__(394);
var reducers_1 = __webpack_require__(112);
var envHelper_1 = __webpack_require__(69);
function configureStore(preloadedState) {
    var devToolsExtension = !envHelper_1.isServer() &&
        !envHelper_1.isProduction() &&
        envHelper_1.hasWindow() &&
        window.devToolsExtension
        ? window.devToolsExtension()
        : function (f) { return f; };
    var enhancer = redux_1.compose(redux_1.applyMiddleware(redux_thunk_1.default), devToolsExtension);
    var store = preloadedState
        ? redux_1.createStore(reducers_1.rootReducer, preloadedState, enhancer)
        : redux_1.createStore(reducers_1.rootReducer, enhancer);
    var moduleHot = module.hot;
    if (moduleHot) {
        // Enable Webpack hot module replacement for reducers
        moduleHot.accept('../reducers', function () {
            var nextRootReducer = __webpack_require__(112).default;
            store.replaceReducer(nextRootReducer);
        });
    }
    return store;
}
exports.default = configureStore;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)(module)))

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = common;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  // default to v0
  clientVersion: 0,
  clientFinishedLoading: false,
  currentSite: null,
  stats: null,
  baseUrl: null,
  menuConfig: [],
  alerts: [],
  errorPage: null,
  noIndex: false,
  seoMeta: {
    title: 'Envato Market',
    meta_description: 'Over 3 million digital products created by a global community of designers, developers, photographers, illustrators &amp; producers.'
  }

  /**
   * UI state store action handler
   * @param  {Object} action Object
   * @param  {Object} state  Object
   * @return {Object} new State
   */
};function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var alerts = void 0;

  switch (action.type) {
    case 'setClientVersion':
      {
        return _extends({}, state, {
          clientVersion: action.payload.clientVersion
        });
      }
    case 'clientFinishedLoading':
      return _extends({}, state, {
        clientFinishedLoading: true
      });

    case 'receiveStats':
      return _extends({}, state, {
        stats: action.payload
      });

    case 'setCurrentSite':
      return _extends({}, state, {
        currentSite: action.payload
      });

    case 'setBaseUrl':
      return _extends({}, state, {
        baseUrl: action.payload
      });

    case 'setMenuConfig':
      return _extends({}, state, {
        menuConfig: action.payload
      });

    case 'showAlert':
      alerts = state.alerts.slice();
      alerts.push(action.payload);
      return _extends({}, state, {
        alerts: alerts
      });

    case 'hideAlert':
      alerts = state.alerts.slice().filter(function (alert) {
        return alert.message !== action.payload.message;
      });

      return _extends({}, state, {
        alerts: alerts
      });

    case 'resetAlerts':
      return _extends({}, state, {
        alerts: []
      });

    case 'setErrorPage':
      return _extends({}, state, {
        errorPage: action.payload.id
      });

    case 'resetErrorPage':
      return _extends({}, state, {
        errorPage: null
      });

    case 'noIndex':
      return _extends({}, state, {
        noIndex: true
      });

    case 'setSeoMeta':
      return _extends({}, state, {
        seoMeta: {
          title: action.payload.title || initialState.seoMeta.title,
          meta_description: action.payload.meta_description || initialState.seoMeta.meta_description
        }
      });

    default:
      return state;
  }
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["default"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'experimentDataReceived':
      return _extends({}, state, _defineProperty({}, action.payload.experiment_id, {
        isLoadingVariant: false,
        variant: action.payload.variant
      }));
    case 'fetchExperimentDataError':
      return _extends({}, state, _defineProperty({}, action.payload.experiment_id, {
        isLoadingVariant: false
      }));
    default:
      return state;
  }
});

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchNewestItemsByCategory_1 = __webpack_require__(142);
var homePage_1 = __webpack_require__(143);
var initialState = {
    newestItems: { all: undefined },
    newestItemsCategory: 'all',
    featuredItems: undefined
};
exports.reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case homePage_1.TypeKeys.GET_HOME_PAGE_API_SUCCESS:
            var newestItemsCategory = 'all';
            var newestItems = action.payload.newest_items
                ? (_a = {}, _a[newestItemsCategory] = action.payload.newest_items, _a) : { all: undefined };
            var featuredItems = action.payload.featured_items;
            return {
                metadata: action.payload.metadata,
                newestItems: newestItems,
                newestItemsCategory: newestItemsCategory,
                featuredItems: featuredItems
            };
        case fetchNewestItemsByCategory_1.TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING:
            return __assign({}, state, { newestItemsPendingCategory: action.payload.category });
        case fetchNewestItemsByCategory_1.TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS:
            return __assign({}, state, { newestItems: __assign({}, state.newestItems, (_b = {}, _b[action.payload.category] = action.payload.searchResults, _b)), newestItemsCategory: action.payload.category, newestItemsPendingCategory: undefined });
        case fetchNewestItemsByCategory_1.TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL:
            return __assign({}, state, { newestItemsPendingCategory: undefined });
        default:
            return state;
    }
    var _a, _b;
};


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = landingPage;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  html: '',
  css: null
};

function landingPage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'fetchLandingPageContentSuccess':
      return _extends({}, state, {
        html: action.payload.html,
        css: action.payload.css
      });

    default:
      return state;
  }
}

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_sites__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  pageIsOffCanvas: false,
  pageCanvasDirection: null,
  isModalOpen: false,
  openModalType: null,
  openModalData: null,
  modalMessages: null,
  toggledPanelIds: [],
  selectedItemId: null,
  offsetTop: null,
  isSidebarOpen: true

  /**
   * UI state store action handler
   * @param  {Object} action Object
   * @param  {Object} state  Object
   * @return {Object} new State
   */
};/* harmony default export */ __webpack_exports__["default"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'toggleOffCanvas':
      {
        var direction = action.payload;
        return _extends({}, state, {
          pageIsOffCanvas: !state['pageIsOffCanvas'],
          pageCanvasDirection: direction
        });
      }

    case 'closeModal':
      return _extends({}, state, {
        isModalOpen: false,
        openModalType: null,
        openModalData: null,
        modalMessages: null
      });

    case 'openModal':
      {
        var _action$payload = action.payload,
            type = _action$payload.type,
            payload = _action$payload.payload;

        return _extends({}, state, {
          isModalOpen: true,
          openModalType: type,
          openModalData: payload
        });
      }

    case 'showModalMessage':
      return _extends({}, state, {
        modalMessages: action.payload
      });

    case 'dismissModalMessage':
      return _extends({}, state, {
        modalMessages: null
      });

    case 'togglePanel':
      {
        var toggledPanelIds = state.toggledPanelIds;

        var panelId = action.payload;
        var panelToggled = toggledPanelIds.indexOf(panelId) >= 0;

        var ids = panelToggled ? toggledPanelIds.filter(function (id) {
          return id !== panelId;
        }) : [].concat(_toConsumableArray(toggledPanelIds), [panelId]);

        return _extends({}, state, { toggledPanelIds: ids });
      }

    case 'loadSiteConfigs':
      {
        var currentSite = action.payload.currentSite;


        var currentSiteConfig = __WEBPACK_IMPORTED_MODULE_0__config_sites__["default"][currentSite];
        var isCurrentSiteSidebarOpen = !currentSiteConfig.hide_sidebar_by_default;
        return _extends({}, state, { isSidebarOpen: isCurrentSiteSidebarOpen });
      }

    case 'toggleSidebar':
      {
        var isSidebarOpen = state.isSidebarOpen;


        return _extends({}, state, { isSidebarOpen: !isSidebarOpen });
      }

    case 'selectItem':
      {
        var selectedItemId = state.selectedItemId;

        var itemId = action.payload;

        var id = selectedItemId === itemId ? null : itemId;

        return _extends({}, state, { selectedItemId: id });
      }

    case 'offsetTop':
      {
        var offsetTop = action.payload.offsetTop;


        return _extends({}, state, { offsetTop: offsetTop });
      }

    default:
      return state;
  }
});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var banner_1 = __webpack_require__(223);
var initialState = {
    banners: []
};
exports.reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case banner_1.TypeKeys.GET_BANNER_SUCCESS:
            var banners = action.payload;
            return __assign({}, state, { banners: banners });
        default:
            return state;
    }
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var activeFeatures_1 = __webpack_require__(116);
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
var TypeKeys;
(function (TypeKeys) {
    TypeKeys["GET_BANNER_SUCCESS"] = "GET_BANNER_SUCCESS";
    TypeKeys["GET_BANNER_FAIL"] = "GET_BANNER_FAIL";
})(TypeKeys = exports.TypeKeys || (exports.TypeKeys = {}));
exports.fetchBannerDataBySite = function (_a) {
    var apiUrlPrefix = _a.apiUrlPrefix, query = _a.query;
    return function (dispatch, getState) {
        var currentSite = getState().common.currentSite;
        var apiUrl = apiUrlPrefix + "/shopfront_api/banner/" + currentSite;
        if (activeFeatures_1.default(query).includes('banners:v2')) {
            apiUrl = apiUrlPrefix + "/shopfront_api/banner/v2/" + currentSite;
        }
        return axiosVerbose_1.default
            .get(apiUrl)
            .then(function (response) {
            var successAction = {
                payload: response.data,
                type: TypeKeys.GET_BANNER_SUCCESS
            };
            return dispatch(successAction);
        })
            .catch(function (err) { return Promise.reject(errors_1.logError(err)); })
            .catch(function () {
            // if banner data fetch error, we simply report to rollbar
            // and don't do anything
            return dispatch({
                type: TypeKeys.GET_BANNER_FAIL
            });
        });
    };
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var searchPage_1 = __webpack_require__(20);
var initialState = {
    activeAudio: '',
    ingestedContent: null,
    licenses: {},
    loading: false,
    relatedSearches: {
        recommendations: []
    },
    results: {
        aggregations: {},
        matches: [],
        total_hits: 0,
        author_exists: null,
        links: {},
        timed_out: false,
        suggestions: [],
        took: 0,
        metadata: {
            description: '',
            heading: '',
            sub_heading: '',
            title: ''
        }
    },
    searchHeadings: {
        heading: ''
    },
    showModal: false,
    showSidebar: false,
    similarItems: {},
    studioRecommendations: {
        generation: 0,
        items: []
    },
    timeout: false,
    hostingSetupSearch: false
};
exports.reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case searchPage_1.TypeKeys.SET_ACTIVE_AUDIO:
            return __assign({}, state, { activeAudio: action.payload.activeAudio });
        case searchPage_1.TypeKeys.SET_HOSTING_SETUP_SEARCH:
            return __assign({}, state, { hostingSetupSearch: action.payload.hostingSetupSearch });
        case searchPage_1.TypeKeys.GET_SEARCH_RESULTS_REQUEST:
            return __assign({}, state, { loading: true, relatedSearches: {
                    recommendations: []
                }, timeout: false });
        case searchPage_1.TypeKeys.GET_SEARCH_RESULTS_SUCCESS:
            return __assign({}, state, { loading: false, results: action.payload.results });
        case searchPage_1.TypeKeys.GET_SEARCH_RESULTS_FAIL:
            return __assign({}, state, { loading: false, timeout: action.timeout });
        case searchPage_1.TypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_SUCCESS:
            return __assign({}, state, { relatedSearches: {
                    hint: action.payload.hint,
                    recommendations: action.payload.recommendations,
                    type: action.payload.type
                } });
        case searchPage_1.TypeKeys.GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_SUCCESS:
            return __assign({}, state, { relatedSearches: {
                    hint: action.payload.hint,
                    recommendations: action.payload.recommendations,
                    type: action.payload.type
                } });
        case searchPage_1.TypeKeys.SET_SEARCH_HEADINGS:
            return __assign({}, state, { searchHeadings: {
                    heading: action.payload.heading || initialState.searchHeadings.heading,
                    sub_heading: action.payload.sub_heading ||
                        initialState.searchHeadings.sub_heading,
                    fine_print: action.payload.fine_print || initialState.searchHeadings.fine_print
                } });
        case searchPage_1.TypeKeys.SET_STUDIO_RECOMMENDATIONS:
            return __assign({}, state, { studioRecommendations: action.payload });
        case searchPage_1.TypeKeys.GET_INGESTED_CONTENT_SUCCESS:
            return __assign({}, state, { ingestedContent: action.payload.content || initialState.ingestedContent });
        case searchPage_1.TypeKeys.GET_ITEM_LICENCES_SUCCESS: {
            var _a = action.payload, itemID = _a.itemID, licenses = _a.licenses;
            return __assign({}, state, { licenses: __assign({}, state.licenses, (_b = {}, _b[itemID] = licenses, _b)) });
        }
        case searchPage_1.TypeKeys.GET_ITEM_LICENCES_FAIL: {
            var _c = action.payload, itemID = _c.itemID, error = _c.error;
            return __assign({}, state, { licenses: __assign({}, state.licenses, (_d = {}, _d[itemID] = { error: error }, _d)) });
        }
        case searchPage_1.TypeKeys.GET_SIMILAR_ITEMS_SUCCESS: {
            var _e = action.payload, itemID = _e.itemID, similarItems = _e.similarItems;
            return __assign({}, state, { similarItems: __assign({}, state.similarItems, (_f = {}, _f[itemID] = similarItems, _f)) });
        }
        case searchPage_1.TypeKeys.GET_SIMILAR_ITEMS_FAIL: {
            var _g = action.payload, itemID = _g.itemID, error = _g.error;
            return __assign({}, state, { similarItems: __assign({}, state.similarItems, (_h = {}, _h[itemID] = { error: error }, _h)) });
        }
        default:
            return state;
    }
    var _b, _d, _f, _h;
};


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3docean_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiojungle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codecanyon_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphicriver_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__photodune_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__themeforest_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__videohive_json__);








/* harmony default export */ __webpack_exports__["default"] = ({
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean_json___default.a,
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default.a,
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default.a,
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default.a,
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune_json___default.a,
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default.a,
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive_json___default.a
});

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = {"generation":12,"links_in_ad":3,"items":[{"id":17340,"name":"Game Development and Design","url":"https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin","price_from":150},{"id":9740,"name":"Mobile-Friendly Redesign for a WordPress Site","url":"https://studio.envato.com/explore/mobile-design-development/9740-make-wordpress-existing-site-mobile-responsive","price_from":150},{"id":9320,"name":"Android UI/UX App Design","url":"https://studio.envato.com/explore/app-design/9320-android-ui-ux-app-design-or-android-xml-layout","price_from":200},{"id":14553,"name":"Slider (Carousel) Banners","url":"https://studio.envato.com/explore/web-banner-design/14553-slider-carousel-banners","price_from":55},{"id":8155,"name":"3D Rendering Service","url":"https://studio.envato.com/explore/3d-design-modeling/8155-3d-rendering","price_from":120},{"id":8374,"name":"Professional High-Quality Infographics Design","url":"https://studio.envato.com/explore/infographic-design/8374-professional-high-quality-infographics-design","price_from":250},{"id":1453,"name":"Effective Web Banner Design","url":"https://studio.envato.com/explore/web-banner-design/1453-effective-web-banner-design","price_from":55},{"id":2017,"name":"3D Logo Design","url":"https://studio.envato.com/explore/3d-design-modeling/2017-3d-logo-design","price_from":200}]}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = {"generation":12,"links_in_ad":3,"items":[{"id":44820,"name":"Audio Mastering","url":"https://studio.envato.com/explore/mixing-mastering/44820-audio-mastering","price_from":90},{"id":9314,"name":"1 Minute Explainer Animation plus Voice Over and Music","url":"https://studio.envato.com/explore/explainer-videos/9314-explainer-animation-1-minute-voice-over-and-music","price_from":1500},{"id":44881,"name":"Professional Female Voice Over Talent","url":"https://studio.envato.com/explore/voice-overs/44881-professional-female-voice-over-talent","price_from":100},{"id":44937,"name":"Profesional Guitar and Bass Tracking","url":"https://studio.envato.com/explore/session-musicians/44937-profesional-guitar-and-bass-tracking","price_from":125},{"id":38271,"name":"Up to 30 Second Voice Over","url":"https://studio.envato.com/explore/voice-overs/38271-up-to-30-second-voice-over-male-american-english","price_from":50},{"id":44912,"name":"Audio Editing For Any Type Of Project","url":"https://studio.envato.com/explore/audio-editing/44912-audio-editing-for-any-type-of-project","price_from":40},{"id":45370,"name":"In-Vision Explainer HD Videos shot in a Virtual Newsroom Studio","url":"https://studio.envato.com/explore/explainer-videos/45370-in-vision-explainer-hd-videos-shot-in-a-virtual-newsroom-studio","price_from":275},{"id":3335,"name":"Speed up WordPress PageSpeed","url":"https://studio.envato.com/explore/wordpress-speed-optimization/3335-speed-up-wordpress-pagespeed","price_from":100},{"id":44805,"name":"Soundtrack Production for Movies, Games and more","url":"https://studio.envato.com/explore/music-production/44805-soundtrack-production-movies-games-more","price_from":320}]}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = {"generation":12,"links_in_ad":4,"items":[{"id":45370,"name":"In-Vision Explainer HD Videos shot in a Virtual Newsroom Studio","url":"https://studio.envato.com/explore/explainer-videos/45370-in-vision-explainer-hd-videos-shot-in-a-virtual-newsroom-studio","price_from":275},{"id":12830,"name":"Parallels Plesk Panel Instalation & Configuration","url":"https://studio.envato.com/explore/server-admin/12830-parallels-plesk-panel-instalation-configuration","price_from":100},{"id":38913,"name":"1 Hour Remote Support Session","url":"https://studio.envato.com/explore/wordpress-support/38913-remote-support-session-1-hour-max","price_from":50},{"id":7150,"name":"Wordpress Website SEO Optimization","url":"https://studio.envato.com/explore/wordpress-seo/7150-wordpress-website-seo-optimization","price_from":150},{"id":939,"name":"Professional Logo Design","url":"https://studio.envato.com/explore/logo-design/939-professional-logo-design","price_from":100},{"id":5108,"name":"Adaptive Logo Design","url":"https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design","price_from":60},{"id":3891,"name":"UX/UI Design for Mobile and Web Apps","url":"https://studio.envato.com/explore/app-design/3891-ux-ui-design-for-mobile-and-web-apps","price_from":300},{"id":16089,"name":"PSD to Responsive Email template for MailChimp","url":"https://studio.envato.com/explore/email-design-development/16089-psd-to-responsive-email-template-for-mailchimp-or-any-email-marketing-platform","price_from":100},{"id":9333,"name":"Shopify Store Setup/Creation","url":"https://studio.envato.com/explore/shopify-development/9333-shopify-store-setup-creation","price_from":1200},{"id":39161,"name":"Website to IOS / IPad App","url":"https://studio.envato.com/explore/app-development/39161-website-to-ios-ipad-app","price_from":100}]}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = {"generation":12,"links_in_ad":4,"items":[{"id":399,"name":"Professional Express Logo Design","url":"https://studio.envato.com/explore/logo-design/399-professional-express-logo-design","price_from":50},{"id":3099,"name":"Corporate Business Card Design","url":"https://studio.envato.com/explore/business-card-design/3099-corporate-business-card","price_from":40},{"id":6136,"name":"Professional WordPress OnSite SEO","url":"https://studio.envato.com/explore/wordpress-seo/6136-professional-wordpress-onsite-seo","price_from":100},{"id":3746,"name":"Logo Vectorization, Customization & Improvements","url":"https://studio.envato.com/explore/logo-customization/3746-logo-vectorization-customization-improvements","price_from":20},{"id":1250,"name":"Professional Icon Set Design","url":"https://studio.envato.com/explore/icon-set-design/1250-professional-icon-set-design","price_from":100},{"id":38271,"name":"Up to 30 Second Voice Over Male American English","url":"https://studio.envato.com/explore/voice-overs/38271-up-to-30-second-voice-over-male-american-english","price_from":50},{"id":11264,"name":"Express Design & Template Customization","url":"https://studio.envato.com/explore/customize-graphics/11264-express-design-customization-templates-graphic-files","price_from":20},{"id":478,"name":"Hand-Drawn Lettering & Type Service","url":"https://studio.envato.com/explore/lettering-calligraphy/478-hand-drawn-lettering-type","price_from":50},{"id":9320,"name":"Android UI/UX App Design","url":"https://studio.envato.com/explore/app-design/9320-android-ui-ux-app-design-or-android-xml-layout","price_from":200},{"id":3292,"name":"Professional Company Brochure Design","url":"https://studio.envato.com/explore/brochure-design/3292-professional-company-brochure-design","price_from":150}]}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = {"generation":12,"links_in_ad":3,"items":[{"id":399,"name":"Professional Express Logo Design","url":"https://studio.envato.com/explore/logo-design/399-professional-express-logo-design","price_from":50},{"id":939,"name":"Professional Logo Design","url":"https://studio.envato.com/explore/logo-design/939-professional-logo-design","price_from":100},{"id":6513,"name":"Logo Vectorization","url":"https://studio.envato.com/explore/photo-editing/6513-vector-redraw-your-logo","price_from":20},{"id":17340,"name":"Game Development and Design","url":"https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin","price_from":150},{"id":9740,"name":"Mobile-Friendly Redesign for Existing WordPress Site","url":"https://studio.envato.com/explore/mobile-design-development/9740-make-wordpress-existing-site-mobile-responsive","price_from":150},{"id":2759,"name":"Product Background Removal","url":"https://studio.envato.com/explore/photo-editing/2759-product-background-removal-for-10-photos","price_from":20},{"id":5108,"name":"Adaptive Logo Design","url":"https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design","price_from":60}]}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = {"generation":12,"links_in_ad":4,"items":[{"id":6296,"name":"Fix Small WordPress Issues","url":"https://studio.envato.com/explore/wordpress-customization/6296-fix-small-wordpress-issues","price_from":50},{"id":5108,"name":"Adaptive Logo Design","url":"https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design","price_from":60},{"id":39424,"name":"Professional Flat Style Homepage Design","url":"https://studio.envato.com/explore/new-website/39424-premium-professional-flat-style-homepage-design-psd","price_from":190},{"id":2349,"name":"Premium Flyer Design","url":"https://studio.envato.com/explore/poster-flyer-design/2349-premium-flyer-design","price_from":50},{"id":7825,"name":"Professional WordPress Theme Customization","url":"https://studio.envato.com/explore/wordpress-customization/7825-professional-wordpress-theme-customization","price_from":100},{"id":6500,"name":"Customisation of Keynote or Powerpoint Presentations","url":"https://studio.envato.com/explore/presentation-design/6500-customisation-of-keynote-or-powerpoint-presentations","price_from":225},{"id":14872,"name":"WordPress Theme Setup & Design Customization","url":"https://studio.envato.com/explore/wordpress-installation/14872-wordpress-theme-setup-design-customization","price_from":250},{"id":1453,"name":"Effective Web Banner Design","url":"https://studio.envato.com/explore/web-banner-design/1453-effective-web-banner-design","price_from":55},{"id":23385,"name":"High Quality Website Content","url":"https://studio.envato.com/explore/website-content/23385-high-quality-website-content-one-page","price_from":90},{"id":9390,"name":"Professional Custom HD Logo Reveal","url":"https://studio.envato.com/explore/logo-animation/9390-professional-custom-hd-logo-reveal","price_from":140},{"id":7368,"name":"WordPress Theme Customization","url":"https://studio.envato.com/explore/wordpress-customization/7368-wordpress-theme-customization-with-a-smile","price_from":175},{"id":24158,"name":"Blog/Article Writing","url":"https://studio.envato.com/explore/blog-article-writing/24158-blog-article-writing-up-to-1000-words","price_from":80},{"id":7205,"name":"Mobile Application UI Designing","url":"https://studio.envato.com/explore/app-design/7205-mobile-application-ui-designing","price_from":280},{"id":6084,"name":"Convert HTML to WordPress","url":"https://studio.envato.com/explore/website-to-wordpress/6084-convert-html-to-wordpress","price_from":250}]}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = {"generation":12,"links_in_ad":3,"items":[{"id":12317,"name":"Express Basic After Effects Customization","url":"https://studio.envato.com/explore/after-effects-customization/12317-express-basic-after-effects-customization","price_from":150},{"id":11537,"name":"Professional Corporate Stationery Design","url":"https://studio.envato.com/explore/stationery-design/11537-corporate-professional-stationery-design","price_from":70},{"id":2616,"name":"Professional and Fun Infographics","url":"https://studio.envato.com/explore/infographic-design/2616-professional-and-fun-infographics","price_from":300},{"id":44936,"name":"Logo Sound Design","url":"https://studio.envato.com/explore/jingles-drops/44936-logo-sound-design-10-seconds","price_from":50},{"id":13313,"name":"Explainer, Sales, Startup, Promotional Videos","url":"https://studio.envato.com/explore/explainer-videos/13313-explainer-video-sales-video-startup-video-promotional-videos","price_from":950},{"id":17340,"name":"Redesign Mobile or Browser Game","url":"https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin","price_from":150},{"id":9314,"name":"1 Minute Explainer Animation plus Voice Over and Music","url":"https://studio.envato.com/explore/explainer-videos/9314-explainer-animation-1-minute-voice-over-and-music","price_from":1500},{"id":3336,"name":"Fun Professional Avatar","url":"https://studio.envato.com/explore/social-media-design/3336-fun-professional-avatar","price_from":50},{"id":44863,"name":"Original Music Composition","url":"https://studio.envato.com/explore/music-production/44863-original-music-composition","price_from":300},{"id":10073,"name":"Professional Web Banner Design","url":"https://studio.envato.com/explore/web-banner-design/10073-professional-web-banner-design","price_from":50},{"id":17634,"name":"Professional Unique Logo Intro Opener","url":"https://studio.envato.com/explore/logo-animation/17634-professional-unique-logo-intro-opener","price_from":100}]}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = [{"name":"All Items","url":"/category/all","children":[{"name":"Popular Files","url":"/page/top_sellers"},{"name":"Featured Files","url":"/feature"},{"name":"Top New Files","url":"/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"},{"name":"Follow Feed","url":"/follow_feed"},{"name":"Top Authors","url":"/authors/top"},{"name":"Top New Authors","url":"/page/top_new_sellers"},{"name":"Public Collections","url":"/collections"},{"name":"View All Categories","url":"/category"}]},{"name":"3D Models","url":"/category/3d-models","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=3d-models","isTop":true},{"name":"Anatomy","url":"/category/3d-models/anatomy"},{"name":"Animals","url":"/category/3d-models/animals"},{"name":"Base Meshes","url":"/category/3d-models/base-meshes"},{"name":"Buildings and Architecture","url":"/category/3d-models/buildings-and-architecture"},{"name":"Clothes & Accessories","url":"/category/3d-models/clothes-accessories"},{"name":"Deco Objects","url":"/category/3d-models/deco-objects"},{"name":"Design Elements","url":"/category/3d-models/design-elements"},{"name":"Electronics","url":"/category/3d-models/electronics"},{"name":"Engines and Parts","url":"/category/3d-models/engines-and-parts"},{"name":"Fantasy and Fiction","url":"/category/3d-models/fantasy-and-fiction"},{"name":"Food and Drinks","url":"/category/3d-models/food-and-drinks"},{"name":"Furnishings","url":"/category/3d-models/furnishings"},{"name":"Humans","url":"/category/3d-models/humans"},{"name":"Music","url":"/category/3d-models/music"},{"name":"Nature","url":"/category/3d-models/nature"},{"name":"Products","url":"/category/3d-models/products"},{"name":"Science","url":"/category/3d-models/science"},{"name":"Sports","url":"/category/3d-models/sports"},{"name":"Theme Packages","url":"/category/3d-models/theme-packages"},{"name":"Tools","url":"/category/3d-models/tools"},{"name":"Toys and Games","url":"/category/3d-models/toys-and-games"},{"name":"Vehicles","url":"/category/3d-models/vehicles"},{"name":"Weapons and Armor","url":"/category/3d-models/weapons-and-armor"},{"name":"Miscellaneous","url":"/category/3d-models/miscellaneous"}]},{"name":"Cars","url":"/category/3d-models/vehicles/land/cars","children":[]},{"name":"HDRI Images","url":"/category/cg-textures/hdri-images","children":[{"name":"Exterior","url":"/category/cg-textures/hdri-images/exterior"},{"name":"Interior","url":"/category/cg-textures/hdri-images/interior"},{"name":"Sky","url":"/category/cg-textures/hdri-images/exterior/sky"}]},{"name":"CG Textures","url":"/category/cg-textures","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=cg-textures","isTop":true},{"name":"Bones","url":"/category/cg-textures/bones"},{"name":"Buildings","url":"/category/cg-textures/buildings"},{"name":"Concrete","url":"/category/cg-textures/concrete"},{"name":"Doors","url":"/category/cg-textures/doors"},{"name":"Fabric","url":"/category/cg-textures/fabric"},{"name":"Fauna","url":"/category/cg-textures/fauna"},{"name":"Flora","url":"/category/cg-textures/flora"},{"name":"Ground","url":"/category/cg-textures/ground"},{"name":"HDRI Images","url":"/category/cg-textures/hdri-images"},{"name":"Humans","url":"/category/cg-textures/humans"},{"name":"Ice","url":"/category/cg-textures/ice"},{"name":"Metal","url":"/category/cg-textures/metal"},{"name":"Ornaments","url":"/category/cg-textures/ornaments"},{"name":"Paper","url":"/category/cg-textures/paper"},{"name":"Plaster","url":"/category/cg-textures/plaster"},{"name":"Plastic","url":"/category/cg-textures/plastic"},{"name":"Roads","url":"/category/cg-textures/roads"},{"name":"Roofing","url":"/category/cg-textures/roofing"},{"name":"Skies","url":"/category/cg-textures/skies"},{"name":"Splatter","url":"/category/cg-textures/splatter"},{"name":"Stone","url":"/category/cg-textures/stone"},{"name":"Tiles","url":"/category/cg-textures/tiles"},{"name":"Walls","url":"/category/cg-textures/walls"},{"name":"Water","url":"/category/cg-textures/water"},{"name":"Windows","url":"/category/cg-textures/windows"},{"name":"Wood","url":"/category/cg-textures/wood"},{"name":"Miscellaneous","url":"/category/cg-textures/miscellaneous"}]},{"name":"Materials & Shaders","url":"/category/materials-and-shaders","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=materials-and-shaders","isTop":true},{"name":"Ceramic","url":"/category/materials-and-shaders/ceramic"},{"name":"Fabric","url":"/category/materials-and-shaders/fabric"},{"name":"Glass","url":"/category/materials-and-shaders/glass"},{"name":"Glow","url":"/category/materials-and-shaders/glow"},{"name":"Marble","url":"/category/materials-and-shaders/marble"},{"name":"Metal","url":"/category/materials-and-shaders/metal"},{"name":"Organic","url":"/category/materials-and-shaders/organic"},{"name":"Plastic","url":"/category/materials-and-shaders/plastic"},{"name":"Sci-fi","url":"/category/materials-and-shaders/sci-fi"},{"name":"Stone","url":"/category/materials-and-shaders/stone"},{"name":"Water","url":"/category/materials-and-shaders/water"},{"name":"Wood","url":"/category/materials-and-shaders/wood"},{"name":"Miscellaneous","url":"/category/materials-and-shaders/miscellaneous"}]},{"name":"Base Meshes","url":"/category/3d-models/base-meshes","children":[]},{"name":"Scripts & Plugins","url":"/category/scripts-and-plugins","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=scripts-and-plugins","isTop":true},{"name":"Plugins","url":"/category/scripts-and-plugins/plugins"},{"name":"Scripts","url":"/category/scripts-and-plugins/scripts"}]},{"name":"More","url":"/category","children":[{"name":"2D Concepts","url":"/category/2d-concepts"},{"name":"Animation Data","url":"/category/animation-data"},{"name":"Render Setups","url":"/category/render-setups"}]}]

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = [{"name":"All Items","url":"/category/all","children":[{"name":"Popular Files","url":"/page/top_sellers"},{"name":"Featured Files","url":"/feature"},{"name":"Top New Files","url":"/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"},{"name":"Follow Feed","url":"/follow_feed"},{"name":"Top Authors","url":"/authors/top"},{"name":"Top New Authors","url":"/page/top_new_sellers"},{"name":"Public Collections","url":"/collections"},{"name":"View All Categories","url":"/category"}]},{"name":"Music","url":"/category/music","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=music","isTop":true},{"name":"Ambient","url":"/category/music/ambient"},{"name":"Children's","url":"/category/music/children-s"},{"name":"Cinematic","url":"/category/music/cinematic"},{"name":"Classical","url":"/category/music/classical"},{"name":"Corporate","url":"/category/music/corporate"},{"name":"Country, Western","url":"/category/music/country-western"},{"name":"Drum & Bass, Breakbeat","url":"/category/music/drum-bass-breakbeat"},{"name":"Electronica","url":"/category/music/electronica"},{"name":"Experimental, Abstract","url":"/category/music/experimental-abstract"},{"name":"Folk, Acoustic","url":"/category/music/folk-acoustic"},{"name":"Funk, Groove","url":"/category/music/funk-groove"},{"name":"Hip-Hop","url":"/category/music/hip-hop"},{"name":"Holiday & Seasonal","url":"/category/music/holiday-seasonal"},{"name":"House","url":"/category/music/house"},{"name":"Jazz","url":"/category/music/jazz"},{"name":"Percussion","url":"/category/music/percussion"},{"name":"Pop","url":"/category/music/pop"},{"name":"Rock","url":"/category/music/rock"},{"name":"Soul, R&B","url":"/category/music/soul-r-b"},{"name":"Vocals, Voice","url":"/category/music/vocals-voice"},{"name":"World Beat","url":"/category/music/world-beat"},{"name":"Miscellaneous","url":"/category/music/miscellaneous"}]},{"name":"Music Packs","url":"/category/music-packs","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=music-packs","isTop":true},{"name":"Ambient","url":"/category/music-packs/ambient"},{"name":"Children's","url":"/category/music-packs/children-s"},{"name":"Cinematic","url":"/category/music-packs/cinematic"},{"name":"Classical","url":"/category/music-packs/classical"},{"name":"Corporate","url":"/category/music-packs/corporate"},{"name":"Country, Western","url":"/category/music-packs/country-western"},{"name":"Drum & Bass, Breakbeat","url":"/category/music-packs/drum-bass-breakbeat"},{"name":"Electronica","url":"/category/music-packs/electronica"},{"name":"Experimental, Abstract","url":"/category/music-packs/experimental-abstract"},{"name":"Folk, Acoustic","url":"/category/music-packs/folk-acoustic"},{"name":"Funk, Groove","url":"/category/music-packs/funk-groove"},{"name":"Hip-Hop","url":"/category/music-packs/hip-hop"},{"name":"Holiday & Seasonal","url":"/category/music-packs/holiday-seasonal"},{"name":"House","url":"/category/music-packs/house"},{"name":"Jazz","url":"/category/music-packs/jazz"},{"name":"Percussion","url":"/category/music-packs/percussion"},{"name":"Pop","url":"/category/music-packs/pop"},{"name":"Rock","url":"/category/music-packs/rock"},{"name":"Soul, R&B","url":"/category/music-packs/soul-r-b"},{"name":"Vocals, Voice","url":"/category/music-packs/vocals-voice"},{"name":"World Beat","url":"/category/music-packs/world-beat"},{"name":"Miscellaneous","url":"/category/music-packs/miscellaneous"}]},{"name":"Music Kits","url":"/category/music-kits","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=music-kits","isTop":true},{"name":"Ambient","url":"/category/music-kits/ambient"},{"name":"Children's","url":"/category/music-kits/children-s"},{"name":"Cinematic","url":"/category/music-kits/cinematic"},{"name":"Classical","url":"/category/music-kits/classical"},{"name":"Corporate","url":"/category/music-kits/corporate"},{"name":"Country, Western","url":"/category/music-kits/country-western"},{"name":"Drum & Bass, Breakbeat","url":"/category/music-kits/drum-bass-breakbeat"},{"name":"Electronica","url":"/category/music-kits/electronica"},{"name":"Experimental, Abstract","url":"/category/music-kits/experimental-abstract"},{"name":"Folk, Acoustic","url":"/category/music-kits/folk-acoustic"},{"name":"Funk, Groove","url":"/category/music-kits/funk-groove"},{"name":"Hip-Hop","url":"/category/music-kits/hip-hop"},{"name":"Holiday & Seasonal","url":"/category/music-kits/holiday-seasonal"},{"name":"House","url":"/category/music-kits/house"},{"name":"Jazz","url":"/category/music-kits/jazz"},{"name":"Percussion","url":"/category/music-kits/percussion"},{"name":"Pop","url":"/category/music-kits/pop"},{"name":"Rock","url":"/category/music-kits/rock"},{"name":"Soul, R&B","url":"/category/music-kits/soul-r-b"},{"name":"Vocals, Voice","url":"/category/music-kits/vocals-voice"},{"name":"World Beat","url":"/category/music-kits/world-beat"},{"name":"Miscellaneous","url":"/category/music-kits/miscellaneous"}],"isNew":true},{"name":"Logos & Idents","url":"/category/logos-idents","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=logos-idents","isTop":true},{"name":"Individual","url":"/category/logos-idents/individual"},{"name":"Packs","url":"/category/logos-idents/packs"}]},{"name":"Sound Effects","url":"/category/sound","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=sound","isTop":true},{"name":"Buttons & Menus","url":"/category/sound/buttons-menus"},{"name":"Cartoon Sounds","url":"/category/sound/cartoon-sounds"},{"name":"Domestic Sounds","url":"/category/sound/domestic-sounds"},{"name":"Futuristic Sounds","url":"/category/sound/futuristic-sounds"},{"name":"Game Sounds","url":"/category/sound/game-sounds"},{"name":"Human Sounds","url":"/category/sound/human-sounds"},{"name":"Industrial Sounds","url":"/category/sound/industrial-sounds"},{"name":"Interface Sounds","url":"/category/sound/interface-sounds"},{"name":"Nature Sounds","url":"/category/sound/nature-sounds"},{"name":"Sound","url":"/category/sound/sound"},{"name":"Sound Packs","url":"/category/sound/sound-packs"},{"name":"Transitions & Movement","url":"/category/sound/transitions-movement"},{"name":"Urban Sounds","url":"/category/sound/urban-sounds"},{"name":"Miscellaneous","url":"/category/sound/miscellaneous"}]},{"name":"Source Files","url":"/category/source-files","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=source-files","isTop":true},{"name":"Cubase","url":"/category/source-files/cubase"},{"name":"FL Studio","url":"/category/source-files/fl-studio"},{"name":"Logic Pro","url":"/category/source-files/logic-pro"},{"name":"Reason","url":"/category/source-files/reason"},{"name":"Miscellaneous","url":"/category/source-files/miscellaneous"}]}]

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = [{"name":"All Items","url":"/category/all","children":[{"name":"Popular Files","url":"/page/top_sellers"},{"name":"Featured Files","url":"/feature"},{"name":"Top New Files","url":"/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"},{"name":"Follow Feed","url":"/follow_feed"},{"name":"Top Authors","url":"/authors/top"},{"name":"Top New Authors","url":"/page/top_new_sellers"},{"name":"Public Collections","url":"/collections"},{"name":"View All Categories","url":"/category"}]},{"name":"PHP Scripts","url":"/category/php-scripts","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=php-scripts","isTop":true},{"name":"Add-ons","url":"/category/php-scripts/add-ons"},{"name":"Calendars","url":"/category/php-scripts/calendars"},{"name":"Countdowns","url":"/category/php-scripts/countdowns"},{"name":"Database Abstractions","url":"/category/php-scripts/database-abstractions"},{"name":"Forms","url":"/category/php-scripts/forms"},{"name":"Help and Support Tools","url":"/category/php-scripts/help-and-support-tools"},{"name":"Images and Media","url":"/category/php-scripts/images-and-media"},{"name":"Loaders and Uploaders","url":"/category/php-scripts/loaders-and-uploaders"},{"name":"Navigation","url":"/category/php-scripts/navigation"},{"name":"News Tickers","url":"/category/php-scripts/news-tickers"},{"name":"Polls","url":"/category/php-scripts/polls"},{"name":"Project Management Tools","url":"/category/php-scripts/project-management-tools"},{"name":"Ratings and Charts","url":"/category/php-scripts/ratings-and-charts"},{"name":"Search","url":"/category/php-scripts/search"},{"name":"Shopping Carts","url":"/category/php-scripts/shopping-carts"},{"name":"Social Networking","url":"/category/php-scripts/social-networking"},{"name":"Miscellaneous","url":"/category/php-scripts/miscellaneous"}]},{"name":"WordPress","url":"/category/wordpress","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=wordpress","isTop":true},{"name":"Add-ons","url":"/category/wordpress/add-ons"},{"name":"Advertising","url":"/category/wordpress/advertising"},{"name":"Auctions","url":"/category/wordpress/auctions"},{"name":"Calendars","url":"/category/wordpress/calendars"},{"name":"eCommerce","url":"/category/wordpress/ecommerce"},{"name":"Forms","url":"/category/wordpress/forms"},{"name":"Forums","url":"/category/wordpress/forums"},{"name":"Galleries","url":"/category/wordpress/galleries"},{"name":"Interface Elements","url":"/category/wordpress/interface-elements"},{"name":"Layers WP","url":"/attributes/compatible-with/layers%20wp"},{"name":"Media","url":"/category/wordpress/media"},{"name":"Membership","url":"/category/wordpress/membership"},{"name":"Newsletters","url":"/category/wordpress/newsletters"},{"name":"SEO","url":"/category/wordpress/seo"},{"name":"Social Networking","url":"/category/wordpress/social-networking"},{"name":"Utilities","url":"/category/wordpress/utilities"},{"name":"Widgets","url":"/category/wordpress/widgets"},{"name":"Miscellaneous","url":"/category/wordpress/miscellaneous"},{"name":"WordPress Themes on ThemeForest","url":"http://themeforest.net/category/wordpress","isBottom":true}]},{"name":"eCommerce","url":"/tags/ecommerce","children":[{"name":"Easy Digital Downloads","url":"/search?compatible_with=Easy+Digital+Downloads"},{"name":"Jigoshop","url":"/category/wordpress/ecommerce/jigoshop"},{"name":"Magento Extensions","url":"/category/plugins/magento-extensions"},{"name":"OpenCart","url":"/category/plugins/opencart"},{"name":"osCommerce","url":"/category/plugins/oscommerce"},{"name":"Prestashop","url":"/category/plugins/prestashop"},{"name":"UberCart","url":"/category/plugins/ubercart"},{"name":"VirtueMart","url":"/category/plugins/virtuemart"},{"name":"WooCommerce","url":"/category/wordpress/ecommerce/woocommerce"},{"name":"WP e-Commerce","url":"/category/wordpress/ecommerce/wp-e-commerce"},{"name":"WP Standalone","url":"/category/wordpress/ecommerce/standalone"},{"name":"Zen Cart","url":"/category/plugins/zen-cart"},{"name":"Miscellaneous","url":"/category/wordpress/ecommerce/miscellaneous"}]},{"name":"JavaScript","url":"/category/javascript","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=javascript","isTop":true},{"name":"Animated SVGs","url":"/category/javascript/animated-svgs"},{"name":"Calendars","url":"/category/javascript/calendars"},{"name":"Countdowns","url":"/category/javascript/countdowns"},{"name":"Database Abstractions","url":"/category/javascript/database-abstractions"},{"name":"Forms","url":"/category/javascript/forms"},{"name":"Images and Media","url":"/category/javascript/images-and-media"},{"name":"Loaders and Uploaders","url":"/category/javascript/loaders-and-uploaders"},{"name":"Media","url":"/category/javascript/media"},{"name":"Navigation","url":"/category/javascript/navigation"},{"name":"News Tickers","url":"/category/javascript/news-tickers"},{"name":"Project Management Tools","url":"/category/javascript/project-management-tools"},{"name":"Ratings and Charts","url":"/category/javascript/ratings-and-charts"},{"name":"Shopping Carts","url":"/category/javascript/shopping-carts"},{"name":"Sliders","url":"/category/javascript/sliders"},{"name":"Social Networks","url":"/category/javascript/social-networks"},{"name":"Miscellaneous","url":"/category/javascript/miscellaneous"}]},{"name":"CSS","url":"/category/css","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=css","isTop":true},{"name":"Animations and Effects","url":"/category/css/animations-and-effects"},{"name":"Buttons","url":"/category/css/buttons"},{"name":"Charts and Graphs","url":"/category/css/charts-and-graphs"},{"name":"Forms","url":"/category/css/forms"},{"name":"Layouts","url":"/category/css/layouts"},{"name":"Navigation and Menus","url":"/category/css/navigation-and-menus"},{"name":"Pricing Tables","url":"/category/css/pricing-tables"},{"name":"Tabs and Sliders","url":"/category/css/tabs-and-sliders"},{"name":"Miscellaneous","url":"/category/css/miscellaneous"}]},{"name":"Mobile","url":"/category/mobile","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=mobile","isTop":true},{"name":"Android","url":"/category/mobile/android"},{"name":"iOS","url":"/category/mobile/ios"},{"name":"Native Web","url":"/category/mobile/native-web"},{"name":"Titanium","url":"/category/mobile/titanium"}]},{"name":"HTML5","url":"/category/html5","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=html5","isTop":true},{"name":"3D","url":"/category/html5/3d"},{"name":"Ad Templates","url":"/category/html5/ad-templates"},{"name":"Canvas","url":"/category/html5/canvas"},{"name":"Charts and Graphs","url":"/category/html5/charts-and-graphs"},{"name":"Forms","url":"/category/html5/forms"},{"name":"Games","url":"/category/html5/games"},{"name":"Libraries","url":"/category/html5/libraries"},{"name":"Media","url":"/category/html5/media"},{"name":"Presentations","url":"/category/html5/presentations"},{"name":"Sliders","url":"/category/html5/sliders"},{"name":"Storage","url":"/category/html5/storage"},{"name":"Templates","url":"/category/html5/templates"},{"name":"Miscellaneous","url":"/category/html5/miscellaneous"}]},{"name":"Skins","url":"/category/skins","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=skins","isTop":true},{"name":"Bootstrap","url":"/category/skins/bootstrap"},{"name":"Layers WP Style Kits","url":"/category/skins/layers-wp-style-kits"},{"name":"Miscellaneous","url":"/category/skins/miscellaneous"}]},{"name":"WP Themes","url":"http://themeforest.net/category/wordpress","children":[]},{"name":"Plugins","url":"/category/plugins","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=plugins","isTop":true},{"name":"Concrete5","url":"/category/plugins/concrete5"},{"name":"Drupal","url":"/category/plugins/drupal"},{"name":"ExpressionEngine","url":"/category/plugins/expressionengine"},{"name":"Joomla","url":"/category/plugins/joomla"},{"name":"Magento Extensions","url":"/category/plugins/magento-extensions"},{"name":"Muse Widgets","url":"/category/plugins/muse-widgets"},{"name":"OpenCart","url":"/category/plugins/opencart"},{"name":"osCommerce","url":"/category/plugins/oscommerce"},{"name":"Prestashop","url":"/category/plugins/prestashop"},{"name":"Ubercart","url":"/category/plugins/ubercart"},{"name":"VirtueMart","url":"/category/plugins/virtuemart"},{"name":"Zen Cart","url":"/category/plugins/zen-cart"},{"name":"Miscellaneous","url":"/category/plugins/miscellaneous"}]},{"name":"More","url":"/category","children":[{"name":".NET","url":"/category/net"},{"name":"Apps","url":"/category/apps"},{"name":"Edge Animate Templates","url":"/category/edge-animate-templates"},{"name":"Facebook","url":"/search?term=facebook&type=files"}]}]

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = [{"name":"All Items","url":"/category/all","children":[{"name":"Popular Files","url":"/page/top_sellers"},{"name":"Featured Files","url":"/feature"},{"name":"Top New Files","url":"/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"},{"name":"Follow Feed","url":"/follow_feed"},{"name":"Top Authors","url":"/authors/top"},{"name":"Top New Authors","url":"/page/top_new_sellers"},{"name":"Public Collections","url":"/collections"},{"name":"View All Categories","url":"/category"}]},{"name":"Graphics","url":"/category/graphics","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=graphics","isTop":true},{"name":"3D Renders","url":"/category/graphics/3d-renders"},{"name":"Backgrounds","url":"/category/graphics/backgrounds"},{"name":"Decorative","url":"/category/graphics/decorative"},{"name":"Hero Images","url":"/category/graphics/hero-images"},{"name":"Illustrations","url":"/category/graphics/illustrations"},{"name":"Photo Templates","url":"/category/graphics/photo-templates"},{"name":"Product Mock-Ups","url":"/category/graphics/product-mock-ups"},{"name":"Miscellaneous","url":"/category/graphics/miscellaneous"}]},{"name":"Print","url":"/category/print-templates","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=print-templates","isTop":true},{"name":"Brochures","url":"/category/print-templates/brochures"},{"name":"Business Cards","url":"/category/print-templates/business-cards"},{"name":"Cards & Invites","url":"/category/print-templates/cards-invites"},{"name":"CD & DVD Artwork","url":"/category/print-templates/cd-dvd-artwork"},{"name":"ePublishing","url":"/category/epublishing"},{"name":"Flyers","url":"/category/print-templates/flyers"},{"name":"Food Menus","url":"/category/print-templates/food-menus"},{"name":"Magazines","url":"/category/print-templates/magazines"},{"name":"Newsletters","url":"/category/print-templates/newsletters"},{"name":"Packaging","url":"/category/print-templates/packaging"},{"name":"Photo Albums","url":"/category/print-templates/photo-albums"},{"name":"Signage","url":"/category/print-templates/signage"},{"name":"Stationery","url":"/category/print-templates/stationery"},{"name":"Miscellaneous","url":"/category/print-templates/miscellaneous"}]},{"name":"Web Elements","url":"/category/web-elements","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=web-elements","isTop":true},{"name":"404 Pages","url":"/category/web-elements/4-4-pages"},{"name":"Badges & Stickers","url":"/category/web-elements/badges-stickers"},{"name":"Banners & Ads","url":"/category/web-elements/banners-ads"},{"name":"Buttons","url":"/category/web-elements/buttons"},{"name":"E-newsletters","url":"/category/web-elements/e-newsletters"},{"name":"Forms","url":"/category/web-elements/forms"},{"name":"Navigation Bars","url":"/category/web-elements/navigation-bars"},{"name":"Sliders & Features","url":"/category/web-elements/sliders-features"},{"name":"Social Media","url":"/category/web-elements/social-media"},{"name":"Tables","url":"/category/web-elements/tables"},{"name":"User Interfaces","url":"/category/web-elements/user-interfaces"},{"name":"Miscellaneous","url":"/category/web-elements/miscellaneous"}]},{"name":"Add-ons","url":"/category/add-ons","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=add-ons","isTop":true},{"name":"Aperture Presets","url":"/category/add-ons/aperture-presets"},{"name":"Illustrator","url":"/category/add-ons/illustrator"},{"name":"Lightroom Presets","url":"/category/add-ons/lightroom-presets"},{"name":"Photoshop","url":"/category/add-ons/photoshop"},{"name":"Sketch Plugins","url":"/category/add-ons/sketch-plugins"}]},{"name":"Vectors","url":"/category/vectors","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=vectors","isTop":true},{"name":"Characters","url":"/category/vectors/characters"},{"name":"Conceptual","url":"/category/vectors/conceptual"},{"name":"Decorative","url":"/category/vectors/decorative"},{"name":"Objects","url":"/category/vectors/objects"},{"name":"Tattoos","url":"/category/vectors/tattoos"},{"name":"Web Elements","url":"/category/vectors/web-elements"},{"name":"Miscellaneous","url":"/category/vectors/miscellaneous"}]},{"name":"Presentations","url":"/category/presentation-templates","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=presentation-templates","isTop":true},{"name":"Google Slides","url":"/category/presentation-templates/google-slides"},{"name":"Keynote Templates","url":"/category/presentation-templates/keynote-templates"},{"name":"PowerPoint Templates","url":"/category/presentation-templates/powerpoint-templates"}]},{"name":"Infographics","url":"/category/infographics","children":[]},{"name":"Icons","url":"/category/icons","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=icons","isTop":true},{"name":"Abstract","url":"/category/icons/abstract"},{"name":"Business","url":"/category/icons/business"},{"name":"Characters","url":"/category/icons/characters"},{"name":"Media","url":"/category/icons/media"},{"name":"Objects","url":"/category/icons/objects"},{"name":"Seasonal","url":"/category/icons/seasonal"},{"name":"Software","url":"/category/icons/software"},{"name":"Technology","url":"/category/icons/technology"},{"name":"Web","url":"/category/icons/web"},{"name":"Miscellaneous","url":"/category/icons/miscellaneous"}]},{"name":"Fonts","url":"/category/fonts","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=fonts","isTop":true},{"name":"Cool","url":"/category/fonts/cool"},{"name":"Decorative","url":"/category/fonts/decorative"},{"name":"Ding-bats","url":"/category/fonts/ding-bats"},{"name":"Fancy","url":"/category/fonts/fancy"},{"name":"Graffiti","url":"/category/fonts/graffiti"},{"name":"Handwriting","url":"/category/fonts/handwriting"},{"name":"Sans-Serif","url":"/category/fonts/sans-serif"},{"name":"Script","url":"/category/fonts/script"},{"name":"Serif","url":"/category/fonts/serif"}]},{"name":"Logos","url":"/category/logo-templates","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=logo-templates","isTop":true},{"name":"Abstract","url":"/category/logo-templates/abstract"},{"name":"Animals","url":"/category/logo-templates/animals"},{"name":"Buildings","url":"/category/logo-templates/buildings"},{"name":"College","url":"/category/logo-templates/college"},{"name":"Company","url":"/category/logo-templates/company"},{"name":"Crests","url":"/category/logo-templates/crests"},{"name":"Food","url":"/category/logo-templates/food"},{"name":"Humans","url":"/category/logo-templates/humans"},{"name":"Letters","url":"/category/logo-templates/letters"},{"name":"Nature","url":"/category/logo-templates/nature"},{"name":"Numbers","url":"/category/logo-templates/numbers"},{"name":"Objects","url":"/category/logo-templates/objects"},{"name":"Restaurant","url":"/category/logo-templates/restaurant"},{"name":"Sports","url":"/category/logo-templates/sports"},{"name":"Symbols","url":"/category/logo-templates/symbols"}]},{"name":"More","url":"/category","children":[{"name":"Game Assets","url":"/category/game-assets"},{"name":"Isolated Objects","url":"/category/isolated-objects"},{"name":"T-Shirts","url":"/category/t-shirts"},{"name":"Textures","url":"/category/textures"}]}]

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = [{"name":"All Items","url":"/category/all","children":[{"name":"Popular Files","url":"/page/top_sellers"},{"name":"Featured Files","url":"/feature"},{"name":"Top New Files","url":"/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"},{"name":"Follow Feed","url":"/follow_feed"},{"name":"Top Authors","url":"/authors/top"},{"name":"Top New Authors","url":"/page/top_new_sellers"},{"name":"Public Collections","url":"/collections"}]},{"name":"Animals","url":"/tags/animals","children":[]},{"name":"Architecture","url":"/tags/architecture","children":[]},{"name":"Business","url":"/tags/business","children":[]},{"name":"Food","url":"/tags/food","children":[]},{"name":"Health","url":"/tags/health","children":[]},{"name":"Sports","url":"/tags/sports","children":[]},{"name":"People","url":"/tags/people","children":[]},{"name":"Technology","url":"/tags/technology","children":[]},{"name":"Travel","url":"/tags/travel","children":[]},{"name":"Video Footage","url":"http://videohive.net/category/stock-footage","children":[]}]

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = [{"name":"All Items","url":"/category/all","children":[{"name":"Popular Files","url":"/page/top_sellers"},{"name":"Featured Files","url":"/feature"},{"name":"Top New Files","url":"/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"},{"name":"Follow Feed","url":"/follow_feed"},{"name":"Top Authors","url":"/authors/top"},{"name":"Top New Authors","url":"/page/top_new_sellers"},{"name":"Public Collections","url":"/collections"},{"name":"View All Categories","url":"/category"}]},{"name":"WordPress","url":"/category/wordpress","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=wordpress","isTop":true},{"name":"Blog / Magazine","url":"/category/wordpress/blog-magazine"},{"name":"BuddyPress","url":"/category/wordpress/buddypress"},{"name":"Corporate","url":"/category/wordpress/corporate"},{"name":"Creative","url":"/category/wordpress/creative"},{"name":"Directory & Listings","url":"/category/wordpress/corporate/directory-listings"},{"name":"eCommerce","url":"/category/wordpress/ecommerce"},{"name":"Education","url":"/category/wordpress/education"},{"name":"Entertainment","url":"/category/wordpress/entertainment"},{"name":"Layers WP","url":"/attributes/compatible-with/layers%20wp"},{"name":"Mobile","url":"/category/wordpress/mobile"},{"name":"Nonprofit","url":"/category/wordpress/nonprofit"},{"name":"Real Estate","url":"/category/wordpress/real-estate"},{"name":"Retail","url":"/category/wordpress/retail"},{"name":"Technology","url":"/category/wordpress/technology"},{"name":"Wedding","url":"/category/wordpress/wedding"},{"name":"Miscellaneous","url":"/category/wordpress/miscellaneous"},{"name":"WordPress Plugins on CodeCanyon","url":"https://codecanyon.net/category/wordpress","isBottom":true}]},{"name":"Hosted Websites","url":"/category/wordpress?hosting_setup=1&sort=sales","children":[{"name":"Hosted WordPress","url":"/category/wordpress?hosting_setup=1&sort=sales"},{"name":"Simple Site Builder","url":"https://sites.envato.com/"}]},{"name":"HTML","url":"/category/site-templates","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=site-templates","isTop":true},{"name":"Admin Templates","url":"/category/site-templates/admin-templates"},{"name":"Corporate","url":"/category/site-templates/corporate"},{"name":"Creative","url":"/category/site-templates/creative"},{"name":"Entertainment","url":"/category/site-templates/entertainment"},{"name":"Mobile","url":"/category/site-templates/mobile"},{"name":"Nonprofit","url":"/category/site-templates/nonprofit"},{"name":"Personal","url":"/category/site-templates/personal"},{"name":"Retail","url":"/category/site-templates/retail"},{"name":"Specialty Pages","url":"/category/site-templates/specialty-pages"},{"name":"Technology","url":"/category/site-templates/technology"},{"name":"Wedding","url":"/category/site-templates/wedding"},{"name":"Miscellaneous","url":"/category/site-templates/miscellaneous"}]},{"name":"Marketing","url":"/category/marketing","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=marketing","isTop":true},{"name":"Email Templates","url":"/category/marketing/email-templates"},{"name":"Instapage","url":"/category/marketing/instapage"},{"name":"Landing Pages","url":"/category/marketing/landing-pages"},{"name":"Pagewiz","url":"/category/marketing/pagewiz"},{"name":"Unbounce Landing Pages","url":"/category/marketing/unbounce-landing-pages"},{"name":"Google Web Designer Ads on CodeCanyon","url":"http://codecanyon.net/category/html5/ad-templates?platform=Google%2BWeb%2BDesigner","isBottom":true}]},{"name":"CMS","url":"/category/cms-themes","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=cms-themes","isTop":true},{"name":"Concrete5","url":"/category/cms-themes/concrete5"},{"name":"Drupal","url":"/category/cms-themes/drupal"},{"name":"Joomla","url":"/category/cms-themes/joomla"},{"name":"MODX Themes","url":"/category/cms-themes/modx-themes"},{"name":"Moodle","url":"/category/cms-themes/moodle"},{"name":"Mura","url":"/category/cms-themes/mura"},{"name":"Webflow","url":"/category/cms-themes/webflow"},{"name":"Weebly","url":"/category/cms-themes/weebly"},{"name":"Miscellaneous","url":"/category/cms-themes/miscellaneous"}]},{"name":"eCommerce","url":"/category/ecommerce","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=ecommerce","isTop":true},{"name":"WooCommerce","url":"/category/wordpress/ecommerce/woocommerce"},{"name":"3dcart","url":"/category/ecommerce/3dcart"},{"name":"BigCommerce","url":"/category/ecommerce/bigcommerce"},{"name":"Cart66","url":"/category/wordpress/ecommerce/cart66"},{"name":"CS-Cart","url":"/category/ecommerce/cs-cart"},{"name":"Drupal Commerce","url":"/attributes/compatible-with/Drupal Commerce?sort=date"},{"name":"Easy Digital Downloads","url":"/search?compatible_with=Easy+Digital+Downloads"},{"name":"Ecwid","url":"/attributes/themeforest-files-included/ecwid%20css%20files"},{"name":"Jigoshop","url":"/category/wordpress/ecommerce/jigoshop"},{"name":"Magento","url":"/category/ecommerce/magento"},{"name":"OpenCart","url":"/category/ecommerce/opencart"},{"name":"osCommerce","url":"/category/ecommerce/oscommerce"},{"name":"PrestaShop","url":"/category/ecommerce/prestashop"},{"name":"Shopify","url":"/category/ecommerce/shopify"},{"name":"Ubercart","url":"/attributes/compatible-with/Ubercart?sort=date"},{"name":"VirtueMart","url":"/category/cms-themes/joomla/virtuemart"},{"name":"WP e-Commerce","url":"/category/wordpress/ecommerce/wp-e-commerce"},{"name":"Zen Cart","url":"/category/ecommerce/zen-cart"},{"name":"Miscellaneous","url":"/category/ecommerce/miscellaneous"}]},{"name":"Muse","url":"/category/muse-templates","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=muse-templates","isTop":true},{"name":"Corporate","url":"/category/muse-templates/corporate"},{"name":"Creative","url":"/category/muse-templates/creative"},{"name":"eCommerce","url":"/category/muse-templates/ecommerce"},{"name":"Landing","url":"/category/muse-templates/landing"},{"name":"Personal","url":"/category/muse-templates/personal"},{"name":"Miscellaneous","url":"/category/muse-templates/miscellaneous"},{"name":"Muse Widgets on CodeCanyon","url":"http://codecanyon.net/category/plugins/muse-widgets","isBottom":true}]},{"name":"UI Design","url":"/category/sketch-templates","children":[{"name":"PSD Templates","url":"/category/psd-templates"},{"name":"Popular PSD Templates","url":"/popular_item/by_category?category=psd-templates\n        "},{"name":"Sketch Templates","url":"/category/sketch-templates"},{"name":"Popular Sketch Templates","url":"/popular_item/by_category?category=sketch-templates"}]},{"name":"Plugins","url":"https://codecanyon.net/category/wordpress","children":[]},{"name":"More","url":"/category","children":[{"name":"Blogging","url":"/category/blogging"},{"name":"Courses","url":"/category/courses"},{"name":"Facebook Templates","url":"/attributes/compatible-with/facebook"},{"name":"Forums","url":"/category/forums"},{"name":"Ghost Themes","url":"/category/blogging/ghost-themes"},{"name":"Hosting","url":"/get_hosting"},{"name":"Jekyll","url":"/category/static-site-generators/jekyll"},{"name":"Tumblr","url":"/category/blogging/tumblr"},{"name":"TypeEngine Themes","url":"/category/typeengine-themes"}]}]

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = [{"name":"All Items","url":"/category/all","children":[{"name":"Popular Files","url":"/page/top_sellers"},{"name":"Featured Files","url":"/feature"},{"name":"Top New Files","url":"/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"},{"name":"Follow Feed","url":"/follow_feed"},{"name":"Top Authors","url":"/authors/top"},{"name":"Top New Authors","url":"/page/top_new_sellers"},{"name":"Public Collections","url":"/collections"},{"name":"View All Categories","url":"/category"}]},{"name":"After Effects Project Files","url":"/category/after-effects-project-files","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=after-effects-project-files","isTop":true},{"name":"Broadcast Packages","url":"/category/after-effects-project-files/broadcast-packages"},{"name":"Element 3D","url":"/attributes/video-project-requires/Element 3D?sort=date"},{"name":"Elements","url":"/category/after-effects-project-files/elements"},{"name":"Infographics","url":"/category/after-effects-project-files/infographics"},{"name":"Logo Stings","url":"/category/after-effects-project-files/logo-stings"},{"name":"Openers","url":"/category/after-effects-project-files/openers"},{"name":"Product Promo","url":"/category/after-effects-project-files/product-promo"},{"name":"Titles","url":"/category/after-effects-project-files/titles"},{"name":"Video Displays","url":"/category/after-effects-project-files/video-displays"}]},{"name":"Apple Motion","url":"/category/apple-motion-templates","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=apple-motion-templates","isTop":true},{"name":"Elements","url":"/category/apple-motion-templates/elements"},{"name":"Logo Stings","url":"/category/apple-motion-templates/logo-stings"},{"name":"Openers","url":"/category/apple-motion-templates/openers"},{"name":"Titles","url":"/category/apple-motion-templates/titles"},{"name":"Video Displays","url":"/category/apple-motion-templates/video-displays"}]},{"name":"Motion Graphics","url":"/category/motion-graphics","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=motion-graphics","isTop":true},{"name":"Backgrounds","url":"/category/motion-graphics/backgrounds"},{"name":"Bugs","url":"/category/motion-graphics/bugs"},{"name":"Elements","url":"/category/motion-graphics/elements"},{"name":"Infographics","url":"/category/motion-graphics/infographics"},{"name":"Interface Effects","url":"/category/motion-graphics/interface-effects"},{"name":"Lower Thirds","url":"/category/motion-graphics/lower-thirds"},{"name":"Overlays","url":"/category/motion-graphics/overlays"},{"name":"Revealer","url":"/category/motion-graphics/revealer"},{"name":"Transitions","url":"/category/motion-graphics/transitions"},{"name":"Miscellaneous","url":"/category/motion-graphics/miscellaneous"}]},{"name":"Stock Footage","url":"/category/stock-footage","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=stock-footage","isTop":true},{"name":"Buildings","url":"/category/stock-footage/buildings"},{"name":"Business, Corporate","url":"/category/stock-footage/business-corporate"},{"name":"Cartoons","url":"/category/stock-footage/cartoons"},{"name":"City","url":"/category/stock-footage/city"},{"name":"Construction","url":"/category/stock-footage/construction"},{"name":"Education","url":"/category/stock-footage/education"},{"name":"Food","url":"/category/stock-footage/food"},{"name":"Holidays","url":"/category/stock-footage/holidays"},{"name":"Industrial","url":"/category/stock-footage/industrial"},{"name":"Kids","url":"/category/stock-footage/kids"},{"name":"Lifestyle","url":"/category/stock-footage/lifestyle"},{"name":"Medical","url":"/category/stock-footage/medical"},{"name":"Military","url":"/category/stock-footage/military"},{"name":"Nature","url":"/category/stock-footage/nature"},{"name":"Overhead","url":"/category/stock-footage/overhead"},{"name":"People","url":"/category/stock-footage/people"},{"name":"Religious","url":"/category/stock-footage/religious"},{"name":"Science","url":"/category/stock-footage/science"},{"name":"Slow Motion","url":"/category/stock-footage/slow-motion"},{"name":"Special Events","url":"/category/stock-footage/special-events"},{"name":"Sports","url":"/category/stock-footage/sports"},{"name":"Stop Motion","url":"/category/stock-footage/stop-motion"},{"name":"Technology","url":"/category/stock-footage/technology"},{"name":"Time Lapse","url":"/category/stock-footage/time-lapse"},{"name":"Vehicles","url":"/category/stock-footage/vehicles"},{"name":"Weather","url":"/category/stock-footage/weather"}]},{"name":"Cinema 4D Templates","url":"/category/cinema-4d-templates","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=cinema-4d-templates","isTop":true},{"name":"Elements","url":"/category/cinema-4d-templates/elements"},{"name":"Logo Stings","url":"/category/cinema-4d-templates/logo-stings"},{"name":"Openers","url":"/category/cinema-4d-templates/openers"},{"name":"Titles","url":"/category/cinema-4d-templates/titles"},{"name":"Video Displays","url":"/category/cinema-4d-templates/video-displays"}]},{"name":"Add Ons","url":"/category/add-ons","children":[{"name":"Popular Items","url":"/popular_item/by_category?category=add-ons","isTop":true},{"name":"After Effects Presets","url":"/category/add-ons/after-effects-presets"},{"name":"After Effects Scripts","url":"/category/add-ons/after-effects-scripts"}]},{"name":"More","url":"/category","children":[{"name":"Logo Files","url":"/search?term=logo"},{"name":"News Files","url":"/search?term=news"},{"name":"Wedding Files","url":"/search?term=wedding"}]}]

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var _2 = __webpack_require__(53);
var searchPage_1 = __webpack_require__(20);
var recommendationsLimit = _1.default.defaults.recommendations_limit;
var rootCategoryRecommendations = function (results, rootCategoryPaths) {
    var tagAggregations = lodash_1.get(results, 'aggregations.tags');
    if (lodash_1.isEmpty(tagAggregations)) {
        return [];
    }
    else {
        var lowercasedRootCategories = rootCategoryPaths.map(function (category) {
            return category.toLowerCase();
        });
        var recommendations = [];
        var index = 0;
        while (recommendations.length < recommendationsLimit) {
            var tag = tagAggregations[index];
            if (!tag) {
                break;
            }
            if (!lowercasedRootCategories.includes(tag.key)) {
                recommendations.push(tag.key);
            }
            index++;
        }
        return recommendations;
    }
};
var fetchRecommendedSearchesByCategoryResults = function (query, results, currentSite) {
    var siteRootCategories = _2.default[currentSite];
    var siteRootCategoryPaths = siteRootCategories.reduce(function (paths, category) {
        paths.push(category.path);
        return paths;
    }, []);
    if (siteRootCategoryPaths.includes(query.category)) {
        var rootCategory = lodash_1.find(siteRootCategories, {
            path: query.category
        });
        var action = {
            type: searchPage_1.TypeKeys.GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_SUCCESS,
            payload: {
                type: 'tags',
                recommendations: rootCategoryRecommendations(results, siteRootCategoryPaths),
                hint: rootCategory.name
            }
        };
        return action;
    }
    else {
        var action = {
            type: searchPage_1.TypeKeys.GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_FAIL
        };
        return action;
    }
};
exports.default = fetchRecommendedSearchesByCategoryResults;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = [{"path":"3d-models","name":"3D Models"},{"path":"cg-textures","name":"CG Textures"},{"path":"materials-and-shaders","name":"Materials & Shaders"},{"path":"scripts-and-plugins","name":"Scripts & Plugins"},{"path":"2d-concepts","name":"2D Concepts"},{"path":"animation-data","name":"Animation Data"},{"path":"render-setups","name":"Render Setups"}]

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = [{"path":"music","name":"Music"},{"path":"music-packs","name":"Music Packs"},{"path":"music-kits","name":"Music Kits"},{"path":"logos-idents","name":"Logos & Idents"},{"path":"sound","name":"Sound Effects"},{"path":"source-files","name":"Source Files"}]

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = [{"path":"php-scripts","name":"PHP Scripts"},{"path":"wordpress","name":"WordPress"},{"path":"javascript","name":"JavaScript"},{"path":"css","name":"CSS"},{"path":"mobile","name":"Mobile"},{"path":"html5","name":"HTML5"},{"path":"skins","name":"Skins"},{"path":"plugins","name":"Plugins"},{"path":"net","name":".NET"},{"path":"apps","name":"Apps"},{"path":"edge-animate-templates","name":"Edge Animate Templates"}]

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = [{"path":"graphics","name":"Graphics"},{"path":"print-templates","name":"Print"},{"path":"epublishing","name":"ePublishing"},{"path":"web-elements","name":"Web Elements"},{"path":"add-ons","name":"Add-ons"},{"path":"vectors","name":"Vectors"},{"path":"presentation-templates","name":"Presentations"},{"path":"infographics","name":"Infographics"},{"path":"icons","name":"Icons"},{"path":"fonts","name":"Fonts"},{"path":"logo-templates","name":"Logos"},{"path":"game-assets","name":"Game Assets"},{"path":"isolated-objects","name":"Isolated Objects"},{"path":"t-shirts","name":"T-Shirts"},{"path":"textures","name":"Textures"}]

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = []

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = [{"path":"wordpress","name":"WordPress"},{"path":"site-templates","name":"HTML"},{"path":"marketing","name":"Marketing"},{"path":"cms-themes","name":"CMS"},{"path":"ecommerce","name":"eCommerce"},{"path":"muse-templates","name":"Muse"},{"path":"sketch-templates","name":"UI Design"},{"path":"psd-templates","name":"PSD Templates"},{"path":"blogging","name":"Blogging"},{"path":"courses","name":"Courses"},{"path":"forums","name":"Forums"},{"path":"typeengine-themes","name":"TypeEngine Themes"}]

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = [{"path":"after-effects-project-files","name":"After Effects Project Files"},{"path":"apple-motion-templates","name":"Apple Motion"},{"path":"motion-graphics","name":"Motion Graphics"},{"path":"stock-footage","name":"Stock Footage"},{"path":"cinema-4d-templates","name":"Cinema 4D Templates"},{"path":"add-ons","name":"Add Ons"}]

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
var searchPage_1 = __webpack_require__(20);
var fetchRecommendedSearchesByTermResults = function (term, _a) {
    var apiUrlPrefix = _a.apiUrlPrefix;
    return function (dispatch) {
        var url = apiUrlPrefix + "/shopfront_api/recommendation/" + encodeURIComponent(term);
        var requestAction = {
            type: searchPage_1.TypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_REQUEST
        };
        dispatch(requestAction);
        return axiosVerbose_1.default
            .get(url, { timeout: 5000 })
            .then(function (res) {
            if (res.data && res.data.relatedSearches) {
                var successAction = {
                    type: searchPage_1.TypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_SUCCESS,
                    payload: {
                        recommendations: res.data.relatedSearches,
                        hint: term,
                        type: 'term'
                    }
                };
                return dispatch(successAction);
            }
            else {
                throw errors_1.ResponseDataError({ response: res });
            }
        })
            .catch(function (err) { return Promise.reject(errors_1.logError(err)); })
            .catch(function (err) {
            return dispatch(fetchRecommendedSearchesByTermResultsFailure());
        });
    };
};
var fetchRecommendedSearchesByTermResultsFailure = function () {
    return function (dispatch) {
        var action = {
            type: searchPage_1.TypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_FAIL,
            error: true
        };
        return dispatch(action);
    };
};
exports.default = fetchRecommendedSearchesByTermResults;


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCategoryOnlySearch", function() { return isCategoryOnlySearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHostingSetupSearch", function() { return isHostingSetupSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFirstPage", function() { return isFirstPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includesExactlyTheseFacetingParams", function() { return includesExactlyTheseFacetingParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildSearchQueryString", function() { return buildSearchQueryString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_searchQueryWhitelist__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_filterParamsConfig__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_sites__ = __webpack_require__(10);












var isCategoryOnlySearch = function isCategoryOnlySearch(query) {
  return includesExactlyTheseFacetingParams(query, ['category']);
};

var isHostingSetupSearch = function isHostingSetupSearch(query) {
  var queryFacetingParams = __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default()(query, __WEBPACK_IMPORTED_MODULE_7__constants_searchQueryWhitelist__["searchApiFilterParams"]);
  var queryFacetingParamsWithValues = __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default()(queryFacetingParams, __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default.a);
  var facetingParamKeys = Object.keys(queryFacetingParamsWithValues);
  return __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(facetingParamKeys, 'hosting_setup');
};

var isFirstPage = function isFirstPage(query) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(query.page) || [0, 1].includes(parseInt(query.page));
};

var includesExactlyTheseFacetingParams = function includesExactlyTheseFacetingParams(query, expectedParamKeys) {
  var queryFacetingParams = __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default()(query, __WEBPACK_IMPORTED_MODULE_7__constants_searchQueryWhitelist__["searchApiFilterParams"]);
  var queryFacetingParamsWithValues = __WEBPACK_IMPORTED_MODULE_4_lodash_omitBy___default()(queryFacetingParams, __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default.a);
  var facetingParamKeys = Object.keys(queryFacetingParamsWithValues);

  return __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(facetingParamKeys.sort(), expectedParamKeys.sort());
};

/**
 * Build the search query string
 * @param  {Object} query
 * @return {String} the search query string pass to public-search
 */
var buildSearchQueryString = function buildSearchQueryString(parsedLocation, currentSite) {
  var filteredQueryObject = Object.keys(parsedLocation).filter(function (param) {
    // only keep the queries in the public-search query whitelist
    return __WEBPACK_IMPORTED_MODULE_7__constants_searchQueryWhitelist__["searchApiParams"].indexOf(param) >= 0;
  }).filter(function (param) {
    // filter empty params
    return !!parsedLocation[param];
  }).reduce(function (prev, curr) {
    if (Array.isArray(parsedLocation[curr])) {
      var arrayLength = parsedLocation[curr].length;
      prev[curr] = parsedLocation[curr][arrayLength - 1];
    } else if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["get"])(__WEBPACK_IMPORTED_MODULE_8__constants_filterParamsConfig__["default"], curr + '.isArrayFormat')) {
      prev[curr] = parsedLocation[curr].split(',');
    } else {
      prev[curr] = parsedLocation[curr];
    }
    return prev;
  }, {});

  var pageSize = Object(__WEBPACK_IMPORTED_MODULE_9__config_sites__["getConfigBySite"])(currentSite, 'common.search_page_size');
  var site = currentSite + '.net';
  var sortBy = filteredQueryObject.sort_by || filteredQueryObject.term && 'relevance' || (currentSite === 'photodune' ? 'trending' : 'date');

  // we have a few default value here
  var newQueryObject = Object.assign({}, filteredQueryObject, {
    site: site,
    page: filteredQueryObject.page || 1,
    page_size: filteredQueryObject.page_size || pageSize,
    sort_by: sortBy
  });

  return __WEBPACK_IMPORTED_MODULE_5_query_string___default.a.stringify(newQueryObject, { arrayFormat: 'bracket' });
};

/***/ }),
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var searchPage_1 = __webpack_require__(20);
var setStudioRecommendations = function (config) {
    if (config === void 0) { config = {}; }
    var maxItems = config.links_in_ad || 4;
    var generation = config.generation;
    var items = config.items || [];
    var randomKeys = new Set();
    var randomItems;
    // if there is less items in config than max number of items which should be randomly selected,
    // pick all of them
    if (items.length <= maxItems) {
        randomItems = items;
    }
    else {
        // select random items from given config, by maxItems number
        while (randomKeys.size < maxItems) {
            randomKeys.add(lodash_1.random(0, items.length - 1));
        }
        randomItems = Array.from(randomKeys).map(function (key) { return items[key]; });
    }
    var action = {
        type: searchPage_1.TypeKeys.SET_STUDIO_RECOMMENDATIONS,
        payload: {
            generation: generation,
            items: randomItems
        }
    };
    return action;
};
exports.default = setStudioRecommendations;


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = user;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  hasLoadAttempt: false,
  isPending: false,
  isSignedIn: false,
  token: null,
  profile: null,
  collections: {},
  cart: null,
  usDollarsNotice: null,
  preferences: {
    searchResultsViewType: 'list',
    searchVideoMuted: false
  }
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'getBookmarksForItemsSuccess':
      {
        var bookmarks = action.payload.bookmarks;


        var newCollections = Object.assign({}, state.collections);
        bookmarks.forEach(function (bookmark) {
          if (!newCollections[bookmark.collection.id]) {
            newCollections[bookmark.collection.id] = bookmark.collection;
            newCollections[bookmark.collection.id].bookmarks = {};
          }
          newCollections[bookmark.collection.id].bookmarks[bookmark.item_id] = {
            id: bookmark.id
          };
        });
        return _extends({}, state, {
          collections: newCollections
        });
      }
    case 'addBookmarkRequest':
      {
        var _action$payload = action.payload,
            collectionID = _action$payload.collectionID,
            itemID = _action$payload.itemID;


        return _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, collectionID, _extends({}, state.collections[collectionID], {
            bookmarks: _extends({}, state.collections[collectionID].bookmarks, _defineProperty({}, itemID, { optimisticStatus: 'pending' }))
          })))
        });
      }
    case 'addBookmarkSuccess':
      {
        var _action$payload2 = action.payload,
            _collectionID = _action$payload2.collectionID,
            _itemID = _action$payload2.itemID,
            bookmarkID = _action$payload2.bookmarkID;


        return _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID, _extends({}, state.collections[_collectionID], {
            bookmarks: _extends({}, state.collections[_collectionID].bookmarks, _defineProperty({}, _itemID, { id: bookmarkID, optimisticStatus: 'successful' }))
          })))
        });
      }
    case 'deleteBookmarkRequest':
      {
        var _action$payload3 = action.payload,
            _collectionID2 = _action$payload3.collectionID,
            _itemID2 = _action$payload3.itemID;


        return _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID2, _extends({}, state.collections[_collectionID2], {
            bookmarks: _extends({}, state.collections[_collectionID2].bookmarks, _defineProperty({}, _itemID2, _extends({}, state.collections[_collectionID2].bookmarks[_itemID2], {
              optimisticStatus: 'deleted'
            })))
          })))
        });
      }
    case 'deleteBookmarkFailure':
      {
        var _action$payload4 = action.payload,
            _collectionID3 = _action$payload4.collectionID,
            _itemID3 = _action$payload4.itemID;


        var newState = _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID3, _extends({}, state.collections[_collectionID3], {
            bookmarks: _extends({}, state.collections[_collectionID3].bookmarks, _defineProperty({}, _itemID3, _extends({}, state.collections[_collectionID3].bookmarks[_itemID3])))
          })))
        });

        delete newState.collections[_collectionID3].bookmarks[_itemID3].optimisticStatus;

        return newState;
      }
    case 'deleteBookmarkSuccess':
    case 'addBookmarkFailure':
      {
        var _action$payload5 = action.payload,
            _collectionID4 = _action$payload5.collectionID,
            _itemID4 = _action$payload5.itemID;


        var _newState = _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID4, _extends({}, state.collections[_collectionID4], {
            bookmarks: _extends({}, state.collections[_collectionID4].bookmarks)
          })))
        });

        delete _newState.collections[_collectionID4].bookmarks[_itemID4];

        return _newState;
      }
    case 'createCollectionRequest':
      return state;
    case 'createCollectionSuccess':
      {
        var collection = action.payload;
        return _extends({}, state, {
          collections: _extends(_defineProperty({}, collection.id, _extends({}, collection, { bookmarks: {} })), state.collections)
        });
      }

    case 'createCollectionFailure':
      return state;

    /**
     * User profile
     */
    case 'getUserRequest':
      return _extends({}, state, {
        isPending: true
      });
    case 'getUserSuccess':
      {
        var _action$payload6 = action.payload,
            profile = _action$payload6.profile,
            collections = _action$payload6.collections,
            cart = _action$payload6.cart;


        return _extends({}, state, {
          profile: profile,
          collections: collections || state.collections,
          cart: cart,
          hasLoadAttempt: true,
          isPending: false,
          isSignedIn: !!(state.token && profile)
        });
      }

    case 'getUserFailure':
      return _extends({}, state, {
        profile: null,
        collections: {},
        cart: null,
        hasLoadAttempt: true,
        isPending: false,
        isSignedIn: false

        /**
         * Token
         */
      });case 'getSessionRequest':
      return state;
    case 'getSessionSuccess':
      {
        var token = action.payload.token;

        return _extends({}, state, { token: token });
      }

    case 'getSessionFailure':
      return _extends({}, state, {
        token: null,
        hasLoadAttempt: true,
        isPending: false,
        isSignedIn: false

        /**
         * Guest user
         */
      });case 'getGuestUser':
      return _extends({}, state, {
        hasLoadAttempt: true,
        isPending: false
      });
    case 'getGuestUserCartRequest':
      return state;
    case 'getGuestUserCartSuccess':
      return _extends({}, state, { cart: action.payload });
    case 'getGuestUserCartFailure':
      return state;

    /**
     * User cart action
     */
    case 'createUserCartRequest':
      return state;
    case 'createUserCartSuccess':
      return _extends({}, state, { cart: action.payload });
    case 'createUserCartFailure':
      return state;

    case 'addItemToCartRequest':
      return state;
    case 'addItemToCartSuccess':
      return _extends({}, state, {
        cart: _extends({}, state.cart, {
          entries_count: state.cart.entries_count + 1,
          entries: [].concat(_toConsumableArray(state.cart.entries), [action.payload])
        })
      });
    case 'addItemToCartFailure':
      return state;

    case 'setUserSearchResultsViewType':
    case 'getUserSearchResultsViewType':
      return _extends({}, state, {
        preferences: _extends({}, state.preferences, {
          searchResultsViewType: action.payload.view
        })
      });

    case 'setUserVideoPlayerStatus':
    case 'getUserVideoPlayerStatus':
      return _extends({}, state, {
        preferences: _extends({}, state.preferences, {
          searchVideoMuted: action.payload.type
        })
      });
    case 'getUSDollarsNotice':
      {
        var usDollarsNotice = action.payload.usDollarsNotice;

        return _extends({}, state, { usDollarsNotice: usDollarsNotice });
      }

    default:
      return state;
  }
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
var legacyAffiliates = function (location) {
    axiosVerbose_1.default
        .get("/shopfront_api/affiliate/legacy?location=" + window.escape(
    // TODO: escape is not recommended to be used, should look into changing to encodeURIComponent
    location.href))
        .then(function (res) {
        if (res.data && res.data.redirect) {
            window.location.href = res.data.redirect_url;
        }
    })
        .catch(errors_1.logError);
};
exports.default = legacyAffiliates;


/***/ }),
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(7);
var lodash_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var bannerAnalytics_1 = __webpack_require__(257);
var HeadBanner = /** @class */ (function (_super) {
    __extends(HeadBanner, _super);
    function HeadBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.$dom = null;
        // we should not rendering any thing from server side for two reasons:
        // 1. content will be cached through CDN, and we don't want it to be cached
        // 2. we will get react invalid checksum warning because server and client
        // render differnt content
        _this.state = {
            bannerConfig: null,
            hasBindedClickEvent: false,
            hasBindedDismissEvent: false,
            hideBanner: false
        };
        return _this;
    }
    HeadBanner.prototype.componentDidMount = function () {
        var banners = this.props.banners;
        var bannerId = banners && banners[0] ? banners[0].id : null;
        if (bannerId) {
            var bannerCacheKey = "banner_" + bannerId + "_cache";
            var localStorageSupported = !!window.localStorage;
            // should not show the banner if it's already dismissed
            var hasDimissed = localStorageSupported
                ? window.localStorage.getItem(bannerCacheKey) === 'hidden'
                : false;
            if (localStorageSupported && !hasDimissed) {
                // if it's not dismissed
                // we load random banner config after page is loaded
                var bannerIndex = lodash_1.random(banners.length - 1);
                var bannerConfig = banners[bannerIndex];
                this.setState({
                    bannerConfig: bannerConfig
                });
            }
        }
    };
    HeadBanner.prototype.componentDidUpdate = function () {
        var _a = this.state, bannerConfig = _a.bannerConfig, hasBindedDismissEvent = _a.hasBindedDismissEvent, hasBindedClickEvent = _a.hasBindedClickEvent;
        var dismissButton = this.querySelector('.js-banner__dismiss');
        var bannerLinkButton = this.querySelector('.js-banner__link');
        // only bind the dismiss event when the banner is loaded
        if (bannerConfig) {
            if (dismissButton && !hasBindedDismissEvent) {
                this.bindDismissEvent(bannerConfig);
            }
            if (bannerLinkButton && !hasBindedClickEvent) {
                this.bindBannerClickEvent(bannerConfig);
            }
        }
    };
    HeadBanner.prototype.render = function () {
        var _this = this;
        var _a = this.state, bannerConfig = _a.bannerConfig, hideBanner = _a.hideBanner;
        if (!bannerConfig) {
            return null;
        }
        var bannerContainerClassName = classNames('banner-root', {
            'banner-slide-up': hideBanner
        });
        return (React.createElement("div", { className: bannerContainerClassName, ref: function ($dom) {
                _this.$dom = $dom;
            } },
            React.createElement("style", null, bannerConfig.css),
            React.createElement("div", { className: "banner-container", dangerouslySetInnerHTML: { __html: bannerConfig.html } })));
    };
    HeadBanner.prototype.bindDismissEvent = function (bannerConfig) {
        var _this = this;
        if (this.$dom) {
            var dismissButtons = this.$dom.querySelectorAll('.js-banner__dismiss');
            // this should always align with the key set by marketplace
            var bannerCacheKey_1 = "banner_" + bannerConfig.id + "_cache";
            if (dismissButtons) {
                this.setState({
                    hasBindedDismissEvent: true
                });
                Array.from(dismissButtons).forEach(function (dismissButton) {
                    dismissButton.addEventListener('click', function (event) {
                        event.preventDefault();
                        var localStorageSupported = !!window.localStorage;
                        if (localStorageSupported) {
                            window.localStorage.setItem(bannerCacheKey_1, 'hidden');
                        }
                        _this.setState({
                            hideBanner: true
                        });
                    });
                });
            }
        }
    };
    HeadBanner.prototype.querySelector = function (selector) {
        if (this.$dom) {
            return this.$dom.querySelector(selector);
        }
        return null;
    };
    HeadBanner.prototype.bindBannerClickEvent = function (bannerConfig) {
        if (this.$dom) {
            var bannerLinkButtons = this.$dom.querySelectorAll('.js-banner__link');
            var bannerId_1 = bannerConfig.id;
            if (bannerLinkButtons) {
                this.setState({
                    hasBindedClickEvent: true
                });
                Array.from(bannerLinkButtons).forEach(function (bannerLinkButton) {
                    bannerLinkButton.addEventListener('click', function (event) {
                        var payload = {
                            actionData: null,
                            name: bannerId_1,
                            productsArray: [
                                {
                                    id: bannerId_1,
                                    name: bannerId_1
                                }
                            ],
                            timestamp: new Date().getTime()
                        };
                        bannerAnalytics_1.reportHeaderBannerClick(payload);
                    });
                });
            }
        }
    };
    return HeadBanner;
}(React.Component));
exports.default = HeadBanner;


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportHeaderBannerClick", function() { return reportHeaderBannerClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(13);


// https://github.com/envato/marketplace/blob/master/app/assets/javascripts/market/shared/google_analytics/_promo.js.coffee
var reportHeaderBannerClick = function reportHeaderBannerClick(payload) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('ec:addPromo', payload);
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('ec:setAction', 'promo_click');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Internal Promotions', 'click', {
    label: payload.name
  });
};

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(259);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(6);

// CONCATENATED MODULE: ./client/components/categoriesMenu/categoryLink.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// FIXME: @shervin: not sure how happy i am with duplicating the routes here..
// Cant really think of a better way though, maybe some way of hooking into
// react router or the history stuff would be able to handle this.
var VALID_PATHS = ['/category/', '/tags/', '/attributes/', '/search'];

// This component given a path will either return a link that will do a
// full page refresh, or a SPA history pushState update
var categoryLink_CategoryLink = function CategoryLink(props) {
  var to = props.to;

  var validPath = VALID_PATHS.some(function (path) {
    return to.indexOf(path) === 0;
  });

  if (validPath) {
    return react_default.a.createElement(es["Link"], props);
  } else {
    return react_default.a.createElement(
      'a',
      _extends({}, props, { href: to, target: '_self' }),
      props.children
    );
  }
};

/* harmony default export */ var categoryLink = (categoryLink_CategoryLink);
// EXTERNAL MODULE: ./client/components/categoriesMenu/categoriesMenu.module.css
var categoriesMenu_module = __webpack_require__(260);
var categoriesMenu_module_default = /*#__PURE__*/__webpack_require__.n(categoriesMenu_module);

// CONCATENATED MODULE: ./client/components/categoriesMenu/categoriesMenu.js







var categoriesMenu_TopLevelMenu = function TopLevelMenu(_ref) {
  var item = _ref.item;

  var cx = bind_default.a.bind(categoriesMenu_module_default.a);
  var hasChildren = item.children.length > 0;
  var isNew = item.isNew;
  var linkClassName = cx(categoriesMenu_module_default.a.link, {
    link: hasChildren,
    linkEmpty: !hasChildren,
    'header-categories__main-link--new-label': hasChildren && isNew,
    linkEmptyWithLabel: !hasChildren && isNew
  });

  return react_default.a.createElement(
    'li',
    { className: categoriesMenu_module_default.a.item },
    react_default.a.createElement(
      categoryLink,
      { to: item.url, className: linkClassName },
      item.name + ' ',
      isNew && react_default.a.createElement(
        'span',
        { className: categoriesMenu_module_default.a.label },
        'New'
      )
    ),
    hasChildren && react_default.a.createElement(categoriesMenu_SubLevelMenu, { items: item.children })
  );
};

var categoriesMenu_SubLevelMenu = function SubLevelMenu(_ref2) {
  var items = _ref2.items;

  var cx = bind_default.a.bind(categoriesMenu_module_default.a);

  return react_default.a.createElement(
    'div',
    { className: categoriesMenu_module_default.a.dropdownContainer },
    react_default.a.createElement(
      'ul',
      { className: categoriesMenu_module_default.a.dropdown },
      items.map(function (item, key) {
        var isTop = item.isTop;
        var isBottom = item.isBottom;
        var linkClassName = cx({ dropdownTop: isTop }, { dropdownBottom: isBottom });
        return react_default.a.createElement(
          'li',
          { className: linkClassName, key: key },
          react_default.a.createElement(
            categoryLink,
            { to: item.url },
            item.name + ' '
          )
        );
      })
    )
  );
};

var categoriesMenu_CategoriesMenu = function CategoriesMenu(_ref3) {
  var items = _ref3.items;

  return react_default.a.createElement(
    'ul',
    { className: categoriesMenu_module_default.a.linksList, 'data-test-selector': 'category-menu' },
    items.map(function (item, key) {
      return react_default.a.createElement(categoriesMenu_TopLevelMenu, { key: key, item: item });
    })
  );
};

/* harmony default export */ var categoriesMenu = (categoriesMenu_CategoriesMenu);
// CONCATENATED MODULE: ./client/components/categoriesMenu/index.js


/* harmony default export */ var components_categoriesMenu = __webpack_exports__["default"] = (categoriesMenu);

/***/ }),
/* 259 */,
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"linksList":"categoriesMenu-module_linksList_35SkS","item":"categoriesMenu-module_item_2rQ2X","dropdownContainer":"categoriesMenu-module_dropdownContainer_3uqnG","dropdown":"categoriesMenu-module_dropdown_3S8_C","dropdownBottom":"categoriesMenu-module_dropdownBottom_2HQll","dropdownTop":"categoriesMenu-module_dropdownTop_35r3a","link":"categoriesMenu-module_link_3FoqK","header-categories__links-separator":"categoriesMenu-module_header-categories__links-separator_4lXcz","linkEmpty":"categoriesMenu-module_linkEmpty_2sMIW","linkEmptyWithLabel":"categoriesMenu-module_linkEmptyWithLabel_quIaY","label":"categoriesMenu-module_label_2-k5M"};

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./config/layout/crossSellLinks.js
/* harmony default export */ var crossSellLinks = ([{
  key: 'elements',
  label: 'Envato Elements',
  imageSrc: '/images/cross-sell__elements.jpg',
  imageSrcSet: ['/images/cross-sell__elements.jpg', '/images/cross-sell__elements--2x.jpg'],
  heading: 'Deliver better projects faster. Photos, templates & courses',
  subHeading: 'Unlimited downloads. Only $29/month',
  url: {
    base: { default: 'https://elements.envato.com/' },
    path: { default: 'all-items' },
    params: {
      themeforest: {
        utm_source: 'themeforest.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'tf_global-footer',
        utm_medium: 'promos'
      },
      codecanyon: {
        utm_source: 'codecanyon.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'cc_global-footer',
        utm_medium: 'promos'
      },
      graphicriver: {
        utm_source: 'graphicriver.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'gr_global-footer',
        utm_medium: 'promos'
      },
      photodune: {
        utm_source: 'photodune.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'pd_global-footer',
        utm_medium: 'promos'
      },
      videohive: {
        utm_source: 'videohive.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'vh_global-footer',
        utm_medium: 'promos'
      },
      audiojungle: {
        utm_source: 'audiojungle.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'aj_global-footer',
        utm_medium: 'promos'
      },
      '3docean': {
        utm_source: '3docean.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: '3do_global-footer',
        utm_medium: 'promos'
      }
    }
  }
}, {
  key: 'tutplus',
  label: 'Tuts+',
  imageSrc: '/images/cross-sell__tutsplus.jpg',
  imageSrcSet: ['/images/cross-sell__tutsplus.jpg', '/images/cross-sell__tutsplus--2x.jpg'],
  heading: 'Learn almost anything with<br>Envato Tuts+ for free',
  subHeading: '25,000+ tutorials and 1,000+ courses',
  url: {
    base: {
      codecanyon: 'https://webdesign.tutsplus.com',
      themeforest: 'https://webdesign.tutsplus.com',
      default: 'http://tutsplus.com'
    },
    path: {
      codecanyon: '/courses/a-beginners-guide-to-using-wordpress',
      themeforest: '/courses/a-beginners-guide-to-using-wordpress',
      default: ''
    },
    params: {
      codecanyon: {
        utm_source: 'EnvatoMarket',
        utm_medium: 'TF_Footer',
        utm_campaign: 'Envato_CC_Footer_FreeWPCourse'
      },
      themeforest: {
        utm_source: 'EnvatoMarket',
        utm_medium: 'CC_Footer',
        utm_campaign: 'Envato_TF_Footer_FreeWPCourse'
      },
      default: {
        utm_source: 'market.envato.com',
        utm_medium: 'referral',
        utm_campaign: 'global_footer'
      }
    }
  }
}, {
  key: 'studio',
  label: 'Envato Studio',
  imageSrc: '/images/cross-sell__studio.jpg',
  imageSrcSet: ['/images/cross-sell__studio.jpg', '/images/cross-sell__studio--2x.jpg'],
  heading: 'Designers matched perfectly to<br>you on Envato Studio',
  subHeading: '2000 artists ready to undertake your work',
  url: {
    base: {
      default: 'https://studio.envato.com'
    },
    path: {
      codecanyon: '/explore/websites-programming',
      videohive: '/explore/video-animation',
      audiojungle: '/explore/audio',
      graphicriver: '/explore/design-graphics',
      photodune: '/explore/photo-editing',
      '3docean': '/explore/3d-design-modeling',
      default: '/explore/wordpress'
    },
    params: {
      '3docean': {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: '3docean'
      },
      audiojungle: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'audiojungle'
      },
      codecanyon: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'codecanyon'
      },
      graphicriver: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'graphicriver'
      },
      photodune: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'photodune'
      },
      themeforest: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'themeforest'
      },
      videohive: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'videohive'
      },
      default: {}
    }
  }
}]);
// EXTERNAL MODULE: ./common/config.ts
var config = __webpack_require__(12);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./client/components/crossSellLinksFooter.js





var crossSellLinksFooter_imageSrc = function imageSrc(path) {
  return config["config"].assets.PUBLIC_PATH + path;
};

var imageSrcSet = function imageSrcSet(paths) {
  return paths.map(function (path) {
    return crossSellLinksFooter_imageSrc(path);
  }).join(', ');
};

var urlFor = function urlFor(urlData, currentSite) {
  return ['base', 'path', 'params'].reduce(function (url, part) {
    var selectedData = urlData[part][currentSite] || urlData[part]['default'];

    if (part === 'params') {
      var serializedParams = Object.keys(selectedData).reduce(function (params, key) {
        return params.concat(key + '=' + selectedData[key]);
      }, []).join('&');
      url = url + '?' + serializedParams;
    } else {
      url = '' + url + selectedData;
    }

    return url;
  }, '');
};

/* harmony default export */ var crossSellLinksFooter = __webpack_exports__["default"] = (function (_ref) {
  var currentSite = _ref.currentSite;

  return react_default.a.createElement(
    'div',
    { className: 'cross-sell' },
    react_default.a.createElement(
      'div',
      { className: 'grid-container' },
      react_default.a.createElement(
        'ul',
        { className: 'cross-sell__list' },
        crossSellLinks.map(function (crossSellLink) {
          return react_default.a.createElement(
            'li',
            { key: crossSellLink.key, className: 'cross-sell__list-item' },
            react_default.a.createElement(
              'a',
              {
                href: urlFor(crossSellLink.url, currentSite),
                className: 'cross-sell__link'
              },
              react_default.a.createElement(
                'figure',
                null,
                react_default.a.createElement(
                  'picture',
                  null,
                  react_default.a.createElement('source', { media: '(max-width: 480px)', srcSet: '' }),
                  react_default.a.createElement('img', {
                    src: crossSellLinksFooter_imageSrc(crossSellLink.imageSrc),
                    className: 'cross-sell__image',
                    alt: crossSellLink.label,
                    srcSet: imageSrcSet(crossSellLink.imageSrcSet)
                  })
                ),
                react_default.a.createElement(
                  'figcaption',
                  { className: 'cross-sell__text-container' },
                  react_default.a.createElement('p', {
                    className: 'fds-c-text-body -color-inherit -size-l -weight-bold h-mb1',
                    dangerouslySetInnerHTML: {
                      __html: crossSellLink.heading
                    }
                  }),
                  react_default.a.createElement(
                    'p',
                    { className: 'fds-c-text-body -color-inherit -size-l h-m0' },
                    react_default.a.createElement(
                      'small',
                      { className: 'cross-sell__text' },
                      crossSellLink.subHeading
                    )
                  )
                )
              )
            )
          );
        })
      )
    )
  );
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./config/layout/footer.js
/* harmony default export */ var footer = ({
  companyLinks: [{ key: 'about', label: 'About Envato', url: 'https://envato.com' }, { key: 'careers', label: 'Careers', url: 'http://careers.envato.com' }, {
    key: 'privacy',
    label: 'Privacy Policy',
    url: 'https://envato.com/privacy/'
  }],
  infoLinks: [{
    key: 'envato',
    titleHtml: 'Envato Market',
    entries: [{
      key: 'terms',
      label: 'Terms',
      url: 'https://themeforest.net/legal/market'
    }, {
      key: 'licenses',
      label: 'Licenses',
      url: 'https://themeforest.net/licenses'
    }, { key: 'api', label: 'Market API', url: 'https://build.envato.com' }, {
      key: 'affiliate',
      label: 'Become an affiliate',
      url: 'https://themeforest.net/affiliate_program'
    }]
  }, {
    key: 'help',
    titleHtml: 'Help',
    entries: [{
      key: 'themeTemplates',
      label: 'Themes and Templates',
      url: 'https://help.market.envato.com'
    }, {
      key: 'websites',
      label: 'Websites',
      url: 'https://envatohosted.zendesk.com/hc/en-us'
    }, {
      key: 'authors',
      label: 'Authors',
      url: 'https://help.market.envato.com/hc/en-us/categories/200216014'
    }, {
      key: 'helpCenter',
      label: 'Help Center',
      url: 'https://help.market.envato.com'
    }]
  }, {
    key: 'community',
    titleHtml: 'Our Community',
    entries: [{
      key: 'community',
      label: 'Community',
      url: 'http://community.envato.com'
    }, {
      key: 'blog',
      label: 'Blog',
      url: 'https://envato.com/blog'
    }, {
      key: 'forums',
      label: 'Forums',
      url: 'https://forums.envato.com'
    }, {
      key: 'meetups',
      label: 'Meetups',
      url: 'http://community.envato.com/#/events'
    }]
  }],
  socialMediaLinks: [{
    key: 'twitter',
    label: 'Twitter',
    url: 'https://twitter.com/envatomarket',
    icon: '/images/icon-twitter.svg'
  }, {
    key: 'facebook',
    label: 'Facebook',
    url: 'https://www.facebook.com/envatomarket/',
    icon: '/images/icon-facebook.svg'
  }, {
    key: 'youtube',
    label: 'YouTube',
    url: 'https://www.youtube.com/user/Envato',
    icon: '/images/icon-youtube.svg'
  }, {
    key: 'instagram',
    label: 'Instagram',
    url: 'https://www.instagram.com/envato/',
    icon: '/images/icon-instagram.svg'
  }, {
    key: 'pinterest',
    label: 'Pinterest',
    url: 'https://www.pinterest.com/envato/',
    icon: '/images/icon-pinterest.svg'
  }]
});
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./client/components/footer/marketplaceStats.module.css
var marketplaceStats_module = __webpack_require__(263);
var marketplaceStats_module_default = /*#__PURE__*/__webpack_require__.n(marketplaceStats_module);

// EXTERNAL MODULE: ./common/utils/formatString.js
var formatString = __webpack_require__(14);

// CONCATENATED MODULE: ./client/components/footer/marketplaceStats.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var marketplaceStats_MarketplaceStats = function (_React$Component) {
  _inherits(MarketplaceStats, _React$Component);

  function MarketplaceStats() {
    _classCallCheck(this, MarketplaceStats);

    return _possibleConstructorReturn(this, (MarketplaceStats.__proto__ || Object.getPrototypeOf(MarketplaceStats)).apply(this, arguments));
  }

  _createClass(MarketplaceStats, [{
    key: 'render',
    value: function render() {
      var stats = this.props.stats;

      return react_default.a.createElement(
        'ul',
        { className: marketplaceStats_module_default.a.list },
        stats && stats.total_users.toString() && react_default.a.createElement(
          'li',
          { className: marketplaceStats_module_default.a.listItem },
          react_default.a.createElement(
            'span',
            { className: marketplaceStats_module_default.a.stats },
            Object(formatString["commaStyleString"])(stats.total_users) + ' '
          ),
          'community members'
        ),
        stats && stats.total_items.toString() && react_default.a.createElement(
          'li',
          { className: marketplaceStats_module_default.a.listItem },
          react_default.a.createElement(
            'span',
            { className: marketplaceStats_module_default.a.stats },
            Object(formatString["commaStyleString"])(stats.total_items) + ' '
          ),
          'items for sale'
        )
      );
    }
  }]);

  return MarketplaceStats;
}(react_default.a.Component);

marketplaceStats_MarketplaceStats.propTypes = {
  stats: prop_types_default.a.object
};


/* harmony default export */ var marketplaceStats = (marketplaceStats_MarketplaceStats);
// EXTERNAL MODULE: ./client/components/usDollarsNotice/usDollarsNoticeContainer.js
var usDollarsNoticeContainer = __webpack_require__(63);

// EXTERNAL MODULE: ./common/config.ts
var config = __webpack_require__(12);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./client/components/footer/siteFooter.module.css
var siteFooter_module = __webpack_require__(266);
var siteFooter_module_default = /*#__PURE__*/__webpack_require__.n(siteFooter_module);

// CONCATENATED MODULE: ./client/components/footer/siteFooter.js









var siteFooter_SiteFooter = function SiteFooter(_ref) {
  var stats = _ref.stats,
      usDollarsNotice = _ref.usDollarsNotice;
  var infoLinks = footer.infoLinks,
      companyLinks = footer.companyLinks,
      socialMediaLinks = footer.socialMediaLinks;


  return react_default.a.createElement(
    'footer',
    { className: siteFooter_module_default.a.footer },
    react_default.a.createElement(
      'div',
      { className: siteFooter_module_default.a.gridWide },
      react_default.a.createElement(
        'div',
        { className: siteFooter_module_default.a.container },
        react_default.a.createElement(
          'nav',
          { className: siteFooter_module_default.a.navContainer },
          react_default.a.createElement('hr', { className: siteFooter_module_default.a.separatorTop }),
          react_default.a.createElement(
            'ul',
            { className: siteFooter_module_default.a.listsContainer },
            infoLinks.map(function (column) {
              return react_default.a.createElement(
                'li',
                { key: column.key, className: siteFooter_module_default.a.listsItem },
                react_default.a.createElement(
                  'ul',
                  { className: siteFooter_module_default.a.sublistContainer },
                  react_default.a.createElement(
                    'li',
                    { className: siteFooter_module_default.a.sublistTitle },
                    column.titleHtml
                  ),
                  column.entries.map(function (entry) {
                    return react_default.a.createElement(
                      'li',
                      { key: entry.key, className: siteFooter_module_default.a.sublistItem },
                      react_default.a.createElement(
                        'a',
                        { className: siteFooter_module_default.a.textLink, href: entry.url },
                        entry.label
                      )
                    );
                  })
                )
              );
            })
          )
        ),
        react_default.a.createElement(
          'div',
          { className: siteFooter_module_default.a.statsContainer },
          react_default.a.createElement('img', {
            className: siteFooter_module_default.a.logo,
            alt: 'Envato Market',
            src: config["config"].assets.PUBLIC_PATH + '/images/logo-envato-market.svg'
          }),
          react_default.a.createElement(marketplaceStats, { stats: stats })
        )
      ),
      react_default.a.createElement('hr', { className: siteFooter_module_default.a.separator }),
      react_default.a.createElement(
        'div',
        { className: siteFooter_module_default.a.container },
        react_default.a.createElement(
          'div',
          { className: siteFooter_module_default.a.companyLinksContainer },
          react_default.a.createElement(
            'ul',
            { className: siteFooter_module_default.a.companyLinksList },
            companyLinks.map(function (entry) {
              return react_default.a.createElement(
                'li',
                { key: entry.key, className: siteFooter_module_default.a.listItem },
                react_default.a.createElement(
                  'a',
                  { className: siteFooter_module_default.a.textLinkFullOpacity, href: entry.url },
                  entry.label
                )
              );
            })
          ),
          react_default.a.createElement('hr', { className: siteFooter_module_default.a.separatorBottom }),
          react_default.a.createElement(usDollarsNoticeContainer["default"], { styleClassName: siteFooter_module_default.a.copyrights }),
          react_default.a.createElement(
            'small',
            { className: siteFooter_module_default.a.copyrights },
            '\xA9 2017 Envato Pty Ltd. Trademarks and brands are the property of their respective owners.'
          )
        ),
        react_default.a.createElement(
          'div',
          { className: siteFooter_module_default.a.socialContainer },
          react_default.a.createElement('link', { itemProp: 'sameAs', href: 'https://instagram.com/envato' }),
          react_default.a.createElement(
            'ul',
            { itemScope: true, itemType: 'http://schema.org/Organization' },
            socialMediaLinks.map(function (entry) {
              var iconSrc = config["config"].assets.PUBLIC_PATH + entry.icon;
              return react_default.a.createElement(
                'li',
                { key: entry.key, className: siteFooter_module_default.a.socialItem },
                react_default.a.createElement(
                  'a',
                  {
                    className: siteFooter_module_default.a.iconLink,
                    itemProp: 'sameAs',
                    rel: 'nofollow',
                    href: entry.url
                  },
                  react_default.a.createElement('img', {
                    className: siteFooter_module_default.a.socialIcon,
                    alt: entry.label,
                    title: entry.label,
                    src: iconSrc
                  })
                )
              );
            })
          )
        )
      )
    )
  );
};

/* harmony default export */ var siteFooter = __webpack_exports__["default"] = (siteFooter_SiteFooter);

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"listItem":"marketplaceStats-module_listItem_2WOiP","list":"marketplaceStats-module_list_1tBW_","stats":"marketplaceStats-module_stats_1SkGL"};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(265);
var USDollarsNotice = function (_a) {
    var notice = _a.notice, styleClassName = _a.styleClassName;
    var noticeMessages = {
        GST: 'All prices are in US Dollars and exclude GST',
        USD: 'All prices are in US Dollars'
    };
    if (notice === null || !noticeMessages[notice]) {
        return null;
    }
    return (React.createElement("span", { className: styleClassName || styles.usDollarsNotice }, noticeMessages[notice]));
};
exports.default = USDollarsNotice;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"usDollarsNotice":"usDollarsNotice-module_usDollarsNotice_3-lTJ"};

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"textLinkFullOpacity":"siteFooter-module_textLinkFullOpacity_BBYbl","textLink":"siteFooter-module_textLink_2oUZO","footer":"siteFooter-module_footer_3GE3e","gridWide":"siteFooter-module_gridWide_3VCmu","container":"siteFooter-module_container_1gocD","separator":"siteFooter-module_separator_1jL4I","separatorTop":"siteFooter-module_separatorTop_1_rtc siteFooter-module_separator_1jL4I","separatorBottom":"siteFooter-module_separatorBottom_1IkzL siteFooter-module_separator_1jL4I","iconLink":"siteFooter-module_iconLink_1YqfN","companyLinksContainer":"siteFooter-module_companyLinksContainer_3t4Up","companyLinksList":"siteFooter-module_companyLinksList_2hS6m","listItem":"siteFooter-module_listItem_2OujB","copyrights":"siteFooter-module_copyrights_16qsK","navContainer":"siteFooter-module_navContainer_13KsU","listsContainer":"siteFooter-module_listsContainer_gPZpa","listsItem":"siteFooter-module_listsItem_2wSvO","socialContainer":"siteFooter-module_socialContainer_WoSUx","socialItem":"siteFooter-module_socialItem_391ir","socialIcon":"siteFooter-module_socialIcon_1N7zB","statsContainer":"siteFooter-module_statsContainer_2ZC-g","logo":"siteFooter-module_logo_1ry7o","sublistContainer":"siteFooter-module_sublistContainer_1Ifsw","sublistItem":"siteFooter-module_sublistItem_1gjOp","sublistTitle":"siteFooter-module_sublistTitle_JJCJg"};

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spinner":"index-module_spinner_mnKXe","rotator":"index-module_rotator_3SlpR","path":"index-module_path_25c-d","dash":"index-module_dash_LWNFS"};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(427);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(9);

// EXTERNAL MODULE: ./common/actions/layout.js
var layout = __webpack_require__(18);

// EXTERNAL MODULE: ./common/actions/user/collection.js
var user_collection = __webpack_require__(121);

// EXTERNAL MODULE: ./common/actions/user/bookmark.js
var bookmark = __webpack_require__(74);

// EXTERNAL MODULE: ./common/selectors/user.js
var user = __webpack_require__(75);

// EXTERNAL MODULE: ./node_modules/react-radio-group/lib/index.js
var react_radio_group_lib = __webpack_require__(157);
var react_radio_group_lib_default = /*#__PURE__*/__webpack_require__.n(react_radio_group_lib);

// EXTERNAL MODULE: ./common/utils/errors.js + 4 modules
var errors = __webpack_require__(8);

// CONCATENATED MODULE: ./client/components/modals/collection/createNewCollectionForm.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var createNewCollectionForm_CreateNewCollectionForm = function (_React$Component) {
  _inherits(CreateNewCollectionForm, _React$Component);

  function CreateNewCollectionForm(props) {
    _classCallCheck(this, CreateNewCollectionForm);

    var _this = _possibleConstructorReturn(this, (CreateNewCollectionForm.__proto__ || Object.getPrototypeOf(CreateNewCollectionForm)).call(this, props));

    _this.state = {
      shouldShowMore: false,
      collectionIsPublic: 'false',
      collectionName: ''
    };
    _this.onVisibleInputChange = _this.onVisibleInputChange.bind(_this);
    _this.onAddNewCollection = _this.onAddNewCollection.bind(_this);
    _this.onCollectionNameInputChange = _this.onCollectionNameInputChange.bind(_this);
    _this.showMore = _this.showMore.bind(_this);
    _this.showLess = _this.showLess.bind(_this);
    return _this;
  }

  _createClass(CreateNewCollectionForm, [{
    key: 'onVisibleInputChange',
    value: function onVisibleInputChange(value) {
      this.setState({
        collectionIsPublic: value
      });
    }
  }, {
    key: 'onCollectionNameInputChange',
    value: function onCollectionNameInputChange(event) {
      this.setState({
        collectionName: event.target.value
      });
    }
  }, {
    key: 'showMore',
    value: function showMore() {
      this.setState({
        shouldShowMore: true
      });
    }
  }, {
    key: 'showLess',
    value: function showLess(event) {
      if (event) event.preventDefault();
      // clean up modal messages when toggle the form section
      var dismissModalMessage = this.props.dismissModalMessage;

      dismissModalMessage();
      this.setState({
        shouldShowMore: false,
        collectionName: ''
      });
    }
  }, {
    key: 'onAddNewCollection',
    value: function onAddNewCollection(event) {
      var _this2 = this;

      var _state = this.state,
          collectionIsPublic = _state.collectionIsPublic,
          collectionName = _state.collectionName;
      var _props = this.props,
          onCreateNewCollectionFormSubmit = _props.onCreateNewCollectionFormSubmit,
          showModalMessage = _props.showModalMessage;

      event.preventDefault();

      if (!collectionName || collectionName === '') {
        showModalMessage({
          type: 'error',
          message: 'You need to name your collection.'
        });
      } else {
        onCreateNewCollectionFormSubmit(collectionName, collectionIsPublic).then(function (action) {
          if (action && action.type === 'addBookmarkSuccess') {
            _this2.setState({
              collectionName: '',
              shouldShowMore: false
            });
          }
        }).catch(errors["logError"]);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          collectionIsPublic = _state2.collectionIsPublic,
          shouldShowMore = _state2.shouldShowMore,
          collectionName = _state2.collectionName;
      var modalMessages = this.props.modalMessages;

      var fromGroupStyle = {
        margin: '16px 0'
      };
      var radioLabelStyle = {
        margin: '0 16px 8px 0'
      };
      var radioInputStyle = {
        marginRight: '8px'
      };
      var whatsThisLinkStyle = {
        fontSize: '11px'
      };
      var cancelButtonStyle = {
        marginLeft: '16px',
        color: '#bababa'
      };
      var messageStyle = {
        margin: '16px 0',
        background: '#c24242',
        color: '#fff',
        padding: '10px',
        display: 'block',
        lineHeight: '10px',
        borderRadius: '2px'
      };

      return react_default.a.createElement(
        'div',
        { className: 'fds-c-modal__section' },
        react_default.a.createElement(
          'div',
          { className: '' },
          react_default.a.createElement(
            'h3',
            { className: 'fds-c-text-heading -size-s' },
            'Create a new Collection'
          ),
          react_default.a.createElement(
            'form',
            {
              className: 'fds-c-form -layout-vertical-inline',
              onSubmit: this.onAddNewCollection
            },
            react_default.a.createElement(
              'div',
              { style: fromGroupStyle, className: 'fds-c-form__group' },
              react_default.a.createElement('input', {
                className: 'fds-c-form-input -type-string -width-full',
                id: 'bookmark_form_name',
                name: 'bookmark_form[name]',
                placeholder: 'Choose a name that is meaningful and descriptive',
                onClick: this.showMore,
                value: collectionName,
                onChange: this.onCollectionNameInputChange,
                type: 'text'
              })
            ),
            shouldShowMore && react_default.a.createElement(
              'div',
              null,
              modalMessages && react_default.a.createElement(
                'div',
                { style: messageStyle, className: 'fds-c-form__group' },
                react_default.a.createElement(
                  'span',
                  { className: '-size-m -color-mid' },
                  modalMessages.message || 'There was an error creating your collection. Please try again.'
                )
              ),
              react_default.a.createElement(
                'div',
                { style: fromGroupStyle, className: 'fds-c-form__group' },
                react_default.a.createElement(
                  react_radio_group_lib["RadioGroup"],
                  {
                    name: 'bookmark_form[publically_visible]',
                    selectedValue: collectionIsPublic,
                    onChange: this.onVisibleInputChange
                  },
                  react_default.a.createElement(
                    'label',
                    { style: radioLabelStyle },
                    react_default.a.createElement(react_radio_group_lib["Radio"], { style: radioInputStyle, value: 'false' }),
                    'Keep it private'
                  ),
                  react_default.a.createElement(
                    'label',
                    { style: radioLabelStyle },
                    react_default.a.createElement(react_radio_group_lib["Radio"], { style: radioInputStyle, value: 'true' }),
                    'Make it public'
                  )
                )
              ),
              react_default.a.createElement(
                'div',
                { style: fromGroupStyle, className: 'fds-c-form__group' },
                react_default.a.createElement(
                  'a',
                  {
                    style: whatsThisLinkStyle,
                    className: 'fds-c-text-link -weight-normal -color-dark -decoration-none',
                    href: 'https://help.market.envato.com/hc/en-us/articles/202821260',
                    rel: 'noopener noreferrer',
                    target: '_blank'
                  },
                  'What\'s this?'
                )
              ),
              react_default.a.createElement(
                'div',
                { style: fromGroupStyle, className: 'fds-c-form__group' },
                react_default.a.createElement('input', {
                  className: 'fds-c-button--3d -color-primary',
                  type: 'submit',
                  value: 'Add new collection'
                }),
                react_default.a.createElement(
                  'a',
                  {
                    href: '#',
                    style: cancelButtonStyle,
                    className: 'fds-c-text-link -color-dark -decoration-none fds-u-mt1',
                    onClick: this.showLess
                  },
                  'Cancel'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CreateNewCollectionForm;
}(react_default.a.Component);

/* harmony default export */ var createNewCollectionForm = (createNewCollectionForm_CreateNewCollectionForm);
// EXTERNAL MODULE: ./client/components/icons/ok.js
var ok = __webpack_require__(40);

// EXTERNAL MODULE: ./client/components/icons/plus.js
var plus = __webpack_require__(158);

// CONCATENATED MODULE: ./client/components/modals/collection/addItemToCollectionList.js
var addItemToCollectionList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function addItemToCollectionList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addItemToCollectionList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function addItemToCollectionList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var addItemToCollectionList_AddItemToCollectionList = function (_React$Component) {
  addItemToCollectionList__inherits(AddItemToCollectionList, _React$Component);

  function AddItemToCollectionList(props) {
    addItemToCollectionList__classCallCheck(this, AddItemToCollectionList);

    var _this = addItemToCollectionList__possibleConstructorReturn(this, (AddItemToCollectionList.__proto__ || Object.getPrototypeOf(AddItemToCollectionList)).call(this, props));

    _this.state = {
      showSaved: false
    };
    return _this;
  }

  addItemToCollectionList__createClass(AddItemToCollectionList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props = this.props,
          item = _props.item,
          collection = _props.collection;

      var currentBookmarkState = collection.bookmarks[item.id];
      var newBookmarkState = nextProps.collection.bookmarks[item.id];
      var bookmarkRemoved = currentBookmarkState && !newBookmarkState;
      var bookmarkAdded = !currentBookmarkState && newBookmarkState;
      if (bookmarkAdded || bookmarkRemoved) {
        this.setState({
          showSaved: true
        });
        setTimeout(function () {
          _this2.setState({
            showSaved: false
          });
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          collection = _props2.collection,
          item = _props2.item,
          onToggleItemInCollectionModal = _props2.onToggleItemInCollectionModal,
          index = _props2.index;
      var showSaved = this.state.showSaved;


      var collectionItemStyle = {
        background: collection.bookmarks[item.id] ? '#e5f2f7' : '#fff',
        padding: '8px 16px',
        marginTop: index === 0 ? '8px' : '0px',
        marginBottom: '8px',
        fontSize: '14px'
      };
      var collectionItemLinkStyle = {
        display: 'block'
      };
      var flashMessageStyle = {
        position: 'absolute',
        right: '20px',
        color: '#0084b4'
      };

      var IconStyle = {};
      if (collection.bookmarks[item.id]) {
        IconStyle.color = '#0084b4';
      }
      var Icon = collection.bookmarks[item.id] ? react_default.a.createElement(ok["default"], null) : react_default.a.createElement(plus["a" /* default */], null);

      return react_default.a.createElement(
        'li',
        { className: 'fds-c-text-body', style: collectionItemStyle },
        react_default.a.createElement(
          'a',
          {
            href: '/collections/' + collection.id + '/bookmarks?item_id=' + item.id,
            onClick: function onClick(event) {
              return onToggleItemInCollectionModal(event, collection, item);
            },
            className: 'fds-c-text-link -color-dark -weight-bold -decoration-none',
            style: collectionItemLinkStyle,
            rel: 'nofollow',
            title: 'Add to Collection ' + collection.name
          },
          react_default.a.createElement(
            'span',
            { style: IconStyle },
            Icon
          ),
          ' ',
          collection.name,
          showSaved && react_default.a.createElement(
            'span',
            { style: flashMessageStyle },
            'saved'
          )
        )
      );
    }
  }]);

  return AddItemToCollectionList;
}(react_default.a.Component);

/* harmony default export */ var addItemToCollectionList = (addItemToCollectionList_AddItemToCollectionList);
// EXTERNAL MODULE: ./client/components/icons/close.js
var icons_close = __webpack_require__(39);

// EXTERNAL MODULE: ./client/components/icons/cog.js
var cog = __webpack_require__(119);

// CONCATENATED MODULE: ./client/components/modals/collection/addItemToCollection.js








/* harmony default export */ var addItemToCollection = (function (_ref) {
  var item = _ref.openModalData.item,
      collections = _ref.collections,
      modalMessages = _ref.modalMessages,
      deleteBookmark = _ref.deleteBookmark,
      addBookmark = _ref.addBookmark,
      showModalMessage = _ref.showModalMessage,
      dismissModalMessage = _ref.dismissModalMessage,
      createCollection = _ref.createCollection,
      closeModal = _ref.closeModal;

  var onCloseClick = function onCloseClick(event) {
    event.preventDefault();
    closeModal();
  };

  var onToggleItemInCollectionModal = function onToggleItemInCollectionModal(event, collection, item) {
    event.preventDefault();
    var isItemInCollection = !!collection.bookmarks[item.id];
    if (isItemInCollection) {
      var bookmark = collections[collection.id].bookmarks[item.id];
      if (bookmark.id && bookmark.optimisticStatus !== 'pending') {
        deleteBookmark(collection.id, item.id, bookmark.id);
      }
    } else {
      addBookmark(collection.id, item.id);
    }
  };

  var onCreateNewCollectionFormSubmit = function onCreateNewCollectionFormSubmit(collectionName, collectionIsPublic) {
    return createCollection({
      name: collectionName,
      isPublic: collectionIsPublic
    }).then(function (action) {
      if (action && action.type === 'createCollectionSuccess') {
        dismissModalMessage();
        var newColectionId = action.payload.id;
        return addBookmark(newColectionId, item.id);
      }
    }).catch(errors["logError"]);
  };

  var renderCollectionList = function renderCollectionList(collections) {
    var collectionsIDsWithoutFavouriteCollection = Object.keys(collections).filter(function (collectionId) {
      return collections[collectionId].special_role !== 'favorite';
    });

    return collectionsIDsWithoutFavouriteCollection.length > 0 ? collectionsIDsWithoutFavouriteCollection.map(function (collectionId) {
      return collections[collectionId];
    }).map(function (collection, index) {
      return react_default.a.createElement(addItemToCollectionList, {
        collection: collection,
        item: item,
        index: index,
        key: index,
        onToggleItemInCollectionModal: onToggleItemInCollectionModal
      });
    }) : react_default.a.createElement(
      'li',
      null,
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s -color-mid fds-u-mt4 fds-u-text-align-center' },
        'You have no Collections yet'
      )
    );
  };

  return react_default.a.createElement(
    'div',
    { className: 'fds-c-modal -width-m modal' },
    react_default.a.createElement(
      'header',
      { className: 'fds-c-modal__header' },
      react_default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading -size-m fds-u-mb1' },
        'Add this Item to a Collection'
      ),
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s -weight-bold' },
        item.name
      ),
      react_default.a.createElement(
        'a',
        { title: 'Close', className: 'fds-c-modal__close', onClick: onCloseClick },
        react_default.a.createElement(icons_close["default"], null)
      )
    ),
    react_default.a.createElement(
      'div',
      { className: 'fds-c-modal__section -padding-none -height-scroll collection__list' },
      react_default.a.createElement(
        'ul',
        { className: 'fds-c-text-list -style-none' },
        renderCollectionList(collections)
      )
    ),
    react_default.a.createElement(createNewCollectionForm, {
      onCreateNewCollectionFormSubmit: onCreateNewCollectionFormSubmit,
      modalMessages: modalMessages,
      dismissModalMessage: dismissModalMessage,
      showModalMessage: showModalMessage
    }),
    react_default.a.createElement(
      'footer',
      { className: 'fds-c-modal__footer' },
      react_default.a.createElement(
        'div',
        { className: '' },
        react_default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-s fds-u-mb0 fds-u-mt1' },
          react_default.a.createElement(
            'a',
            {
              href: '/collections/manage',
              className: 'fds-c-text-link -weight-normal -decoration-none'
            },
            react_default.a.createElement(cog["a" /* default */], null),
            ' Manage my Collections'
          )
        )
      ),
      react_default.a.createElement(
        'a',
        {
          href: '#',
          className: 'fds-c-button--3d -color-primary',
          onClick: onCloseClick
        },
        'Great, I\'m done'
      )
    )
  );
});
// CONCATENATED MODULE: ./client/components/modals/collection/addItemToCollectionContainer.js








var addItemToCollectionContainer_mapStateToProps = function mapStateToProps(state) {
  var modalMessages = state.layout.modalMessages;


  return {
    collections: Object(user["getUserCollections"])(state),
    modalMessages: modalMessages
  };
};

var addItemToCollectionContainer_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch(Object(layout["closeModal"])());
    },
    dismissModalMessage: function dismissModalMessage() {
      return dispatch(Object(layout["dismissModalMessage"])());
    },
    deleteBookmark: function deleteBookmark(collectionID, itemID, id) {
      return dispatch(Object(bookmark["deleteBookmark"])(collectionID, itemID, id));
    },
    addBookmark: function addBookmark(collectionId, itemId) {
      return dispatch(Object(bookmark["addBookmark"])(collectionId, itemId));
    },
    createCollection: function createCollection(payload) {
      return dispatch(Object(user_collection["createCollection"])(payload));
    },
    showModalMessage: function showModalMessage(message) {
      return dispatch(Object(layout["showModalMessage"])(message));
    }
  };
};

var AddItemToCollectionContainer = Object(es["connect"])(addItemToCollectionContainer_mapStateToProps, addItemToCollectionContainer_mapDispatchToProps)(addItemToCollection);

/* harmony default export */ var addItemToCollectionContainer = (AddItemToCollectionContainer);
// EXTERNAL MODULE: ./common/actions/user/cart.js
var cart = __webpack_require__(91);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./client/components/modals/cart/itemMatrixSelector.js



var itemMatrixSelector_renderMatrixLicenseSelector = function renderMatrixLicenseSelector(_ref) {
  var itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      onMatrixLicenseChange = _ref.onMatrixLicenseChange;

  var hasExtendedLicense = itemMatrix && Object.keys(itemMatrix).length > 1;
  if (hasExtendedLicense) {
    return react_default.a.createElement(
      'div',
      { className: 'cart-modal__variant-selector__option' },
      react_default.a.createElement(
        'h4',
        { className: 'fds-c-text-heading -size-s' },
        'Select a License'
      ),
      react_default.a.createElement(
        'select',
        {
          className: 'fds-c-form-select',
          defaultValue: selectedMatrixLicense,
          onChange: onMatrixLicenseChange
        },
        Object.keys(itemMatrix).map(function (matrix, index) {
          return react_default.a.createElement(
            'option',
            { key: index, value: matrix },
            Object(lodash["get"])(itemMatrix[matrix], 'license_label')
          );
        })
      )
    );
  } else {
    return react_default.a.createElement(
      'div',
      null,
      react_default.a.createElement(
        'h4',
        { className: 'fds-c-text-heading -size-s' },
        'License Available'
      ),
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-m' },
        Object(lodash["get"])(itemMatrix[selectedMatrixLicense], 'license_label')
      )
    );
  }
};

var itemMatrixSelector_renderMatrixSupportSelector = function renderMatrixSupportSelector(_ref2) {
  var itemMatrix = _ref2.itemMatrix,
      selectedMatrixLicense = _ref2.selectedMatrixLicense,
      selectedMatrixSupport = _ref2.selectedMatrixSupport,
      onMatrixSupportChange = _ref2.onMatrixSupportChange;

  return react_default.a.createElement(
    'div',
    { className: 'cart-modal__variant-selector__option' },
    react_default.a.createElement(
      'h4',
      { className: 'fds-c-text-heading -size-s' },
      'Select support duration'
    ),
    react_default.a.createElement(
      'select',
      {
        className: 'fds-c-form-select',
        defaultValue: selectedMatrixSupport,
        onChange: onMatrixSupportChange
      },
      Object.keys(itemMatrix[selectedMatrixLicense].support).map(function (supportName, index) {
        return react_default.a.createElement(
          'option',
          { key: index, value: supportName },
          itemMatrix[selectedMatrixLicense].support[supportName].label
        );
      })
    )
  );
};

/* harmony default export */ var itemMatrixSelector = (function (_ref3) {
  var itemMatrix = _ref3.itemMatrix,
      selectedMatrixLicense = _ref3.selectedMatrixLicense,
      selectedMatrixSupport = _ref3.selectedMatrixSupport,
      onMatrixLicenseChange = _ref3.onMatrixLicenseChange,
      onMatrixSupportChange = _ref3.onMatrixSupportChange;

  var hasItemSupport = itemMatrix && Object.keys(itemMatrix).some(function (license) {
    var support = itemMatrix[license].support;

    return Object.keys(support).some(function (supportName) {
      return support[supportName] && supportName !== 'none';
    });
  });
  return react_default.a.createElement(
    'div',
    { className: 'fds-c-modal__section fds-u-text-align-center fds-u-p3 cart-modal__variant-selector' },
    itemMatrixSelector_renderMatrixLicenseSelector({
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      onMatrixLicenseChange: onMatrixLicenseChange
    }),
    hasItemSupport && itemMatrixSelector_renderMatrixSupportSelector({
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      onMatrixSupportChange: onMatrixSupportChange
    })
  );
});
// CONCATENATED MODULE: ./client/components/modals/cart/modalErrorMessage.js


/* harmony default export */ var modalErrorMessage = (function (_ref) {
  var modalMessages = _ref.modalMessages;
  return react_default.a.createElement(
    "div",
    { className: "fds-c-modal__section fds-u-text-align-center fds-u-p3" },
    react_default.a.createElement(
      "p",
      { className: "fds-c-text-body fds-u-mb0" },
      modalMessages.message || 'There was an error adding item to your cart. Please try again.'
    )
  );
});
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./client/components/modals/cart/itemSummary.js




var itemSummary_renderMatrix = function renderMatrix(_ref) {
  var itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      selectedMatrixSupport = _ref.selectedMatrixSupport,
      showChangeDetailsLink = _ref.showChangeDetailsLink,
      goToEditScreen = _ref.goToEditScreen,
      cartEntry = _ref.cartEntry;

  var hasItemSupport = itemMatrix && Object.keys(itemMatrix).some(function (license) {
    var support = itemMatrix[license].support;

    return Object.keys(support).some(function (supportName) {
      return support[supportName] && supportName !== 'none';
    });
  });
  var supportOptions = Object(lodash["get"])(itemMatrix[selectedMatrixLicense], 'support');

  var onGoToEditScreen = function onGoToEditScreen(e) {
    e.preventDefault();
    goToEditScreen();
  };

  return react_default.a.createElement(
    'div',
    { className: 'cart-modal__variant-info' },
    react_default.a.createElement(
      'p',
      { className: 'fds-c-text-heading -size-l' },
      react_default.a.createElement(
        'b',
        { className: 'fds-c-text-currency' },
        Object(lodash["get"])(supportOptions[selectedMatrixSupport], 'price')
      )
    ),
    react_default.a.createElement(
      'p',
      { className: 'fds-c-text-body -weight-bold -size-s fds-u-mb0' },
      react_default.a.createElement(
        'span',
        null,
        'License: '
      ),
      react_default.a.createElement(
        'a',
        {
          href: Object(lodash["get"])(itemMatrix[selectedMatrixLicense], 'terms_url'),
          className: 'fds-c-text-link -size-m -weight-normal -decoration-none'
        },
        Object(lodash["get"])(itemMatrix[selectedMatrixLicense], 'license_label')
      )
    ),
    hasItemSupport && react_default.a.createElement(
      'p',
      { className: 'fds-c-text-body -weight-bold -size-s fds-u-mb0' },
      react_default.a.createElement(
        'span',
        null,
        'Support: '
      ),
      react_default.a.createElement(
        'span',
        { className: 'fds-c-text-body -weight-normal -size-s' },
        Object(lodash["get"])(supportOptions[selectedMatrixSupport], 'label')
      )
    ),
    showChangeDetailsLink && cartEntry && react_default.a.createElement(
      'p',
      { className: 'fds-c-text-body -weight-bold -size-s fds-u-mb0' },
      react_default.a.createElement(
        'a',
        {
          href: '/cart/edit/' + cartEntry.id,
          onClick: onGoToEditScreen,
          className: 'fds-c-text-link -size-m -weight-normal'
        },
        'Change details'
      )
    )
  );
};

var itemSummary_ItemSummary = function ItemSummary(_ref2) {
  var item = _ref2.item,
      itemMatrix = _ref2.itemMatrix,
      selectedMatrixLicense = _ref2.selectedMatrixLicense,
      selectedMatrixSupport = _ref2.selectedMatrixSupport,
      showChangeDetailsLink = _ref2.showChangeDetailsLink,
      goToEditScreen = _ref2.goToEditScreen,
      cartEntry = _ref2.cartEntry;
  return react_default.a.createElement(
    'div',
    { className: 'fds-c-modal__section -background-mid -height-scroll fds-u-p2 ' },
    react_default.a.createElement(
      'div',
      { className: 'cart-modal__thumbnail' },
      react_default.a.createElement('img', { alt: item.name, src: item.ui.smallPreviewUrl })
    ),
    react_default.a.createElement(
      'div',
      { className: 'cart-modal__core-info' },
      react_default.a.createElement(
        'h5',
        { className: 'fds-c-text-heading -size-xxs' },
        item.name
      ),
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s' },
        'by',
        ' ',
        react_default.a.createElement(
          'span',
          { className: 'fds-c-text-body -size-s -style-italic' },
          item.author_username
        )
      )
    ),
    itemMatrix && selectedMatrixLicense && itemSummary_renderMatrix({
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      showChangeDetailsLink: showChangeDetailsLink,
      goToEditScreen: goToEditScreen,
      cartEntry: cartEntry
    })
  );
};

itemSummary_ItemSummary.propTypes = {
  item: prop_types_default.a.object.isRequired,
  itemMatrix: prop_types_default.a.object,
  selectedMatrixLicense: prop_types_default.a.string,
  selectedMatrixSupport: prop_types_default.a.string,
  showChangeDetailsLink: prop_types_default.a.bool,
  goToEditScreen: prop_types_default.a.func,
  cartEntry: prop_types_default.a.object
};

/* harmony default export */ var itemSummary = (itemSummary_ItemSummary);
// CONCATENATED MODULE: ./client/components/modals/cart/loadItemMatrixError.js



/* harmony default export */ var cart_loadItemMatrixError = (function (_ref) {
  var error = _ref.error;

  var errorMsg = Object(lodash["get"])(error, 'response.status') === 404 ? 'Sorry this item is no longer for sale.' : "Hmm, looks like we can't load the matrix of this item.";

  return react_default.a.createElement(
    'div',
    { className: 'fds-c-modal__section fds-u-text-align-center fds-u-p3' },
    react_default.a.createElement(
      'p',
      { className: 'fds-c-text-body fds-u-mb0' },
      errorMsg
    )
  );
});
// CONCATENATED MODULE: ./client/components/modals/cart/addEntry.js








/* harmony default export */ var addEntry = (function (_ref) {
  var item = _ref.item,
      itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      selectedMatrixSupport = _ref.selectedMatrixSupport,
      onMatrixLicenseChange = _ref.onMatrixLicenseChange,
      onMatrixSupportChange = _ref.onMatrixSupportChange,
      loadItemMatrixError = _ref.loadItemMatrixError,
      modalMessages = _ref.modalMessages,
      closeModal = _ref.closeModal,
      onAddToCart = _ref.onAddToCart,
      onEditCartEntry = _ref.onEditCartEntry,
      modalStep = _ref.modalStep,
      isLoading = _ref.isLoading;

  var modalClassName = classnames_default()('fds-c-modal -width-m modal', {
    'is-disabled-loading': isLoading
  });
  return react_default.a.createElement(
    'div',
    { className: modalClassName },
    react_default.a.createElement(
      'header',
      { className: 'fds-c-modal__header fds-u-text-align-center' },
      react_default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading -size-m fds-u-mb0' },
        'Customize Your Selection'
      )
    ),
    itemMatrix && react_default.a.createElement(itemMatrixSelector, {
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      onMatrixLicenseChange: onMatrixLicenseChange,
      onMatrixSupportChange: onMatrixSupportChange
    }),
    loadItemMatrixError && react_default.a.createElement(cart_loadItemMatrixError, { error: loadItemMatrixError }),
    modalMessages && react_default.a.createElement(modalErrorMessage, { modalMessages: modalMessages }),
    react_default.a.createElement(itemSummary, {
      item: item,
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport
    }),
    !loadItemMatrixError && react_default.a.createElement(
      'footer',
      { className: 'fds-c-modal__footer' },
      react_default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-left' },
        react_default.a.createElement(
          'button',
          { className: 'fds-c-button -color-light', onClick: closeModal },
          'Cancel'
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-right' },
        modalStep === 'add' ? react_default.a.createElement(
          'button',
          {
            className: 'fds-c-button--3d -color-primary',
            onClick: onAddToCart
          },
          'Add to Cart'
        ) : react_default.a.createElement(
          'button',
          {
            className: 'fds-c-button--3d -color-primary',
            onClick: onEditCartEntry
          },
          'Save Selection'
        )
      )
    )
  );
});
// EXTERNAL MODULE: ./common/utils/formatString.js
var formatString = __webpack_require__(14);

// CONCATENATED MODULE: ./client/components/modals/cart/itemSupportUpgrade.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var itemSupportUpgrade__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function itemSupportUpgrade__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function itemSupportUpgrade__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function itemSupportUpgrade__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var itemSupportUpgrade_ItemSupportUpgrade = function (_React$Component) {
  itemSupportUpgrade__inherits(ItemSupportUpgrade, _React$Component);

  function ItemSupportUpgrade(props) {
    itemSupportUpgrade__classCallCheck(this, ItemSupportUpgrade);

    var _this = itemSupportUpgrade__possibleConstructorReturn(this, (ItemSupportUpgrade.__proto__ || Object.getPrototypeOf(ItemSupportUpgrade)).call(this, props));

    _this.state = {
      isExtendedSupportSelected: false,
      isUpdatingSupport: false
    };
    _this.onExtendedSupportSelectChange = _this.onExtendedSupportSelectChange.bind(_this);
    return _this;
  }

  itemSupportUpgrade__createClass(ItemSupportUpgrade, [{
    key: 'onExtendedSupportSelectChange',
    value: function onExtendedSupportSelectChange() {
      var _this2 = this;

      var _props = this.props,
          editCartEntry = _props.editCartEntry,
          cartEntry = _props.cartEntry,
          updateMatrixSupport = _props.updateMatrixSupport;

      this.setState({
        isExtendedSupportSelected: !this.state.isExtendedSupportSelected,
        isUpdatingSupport: true
      }, function () {
        var updatedSupportType = _this2.state.isExtendedSupportSelected ? 'bundle_12month' : 'bundle_6month';
        editCartEntry(cartEntry.id, _extends({}, cartEntry, {
          support_key: updatedSupportType
        })).then(function () {
          _this2.setState({
            isUpdatingSupport: false
          }, function () {
            updateMatrixSupport(updatedSupportType);
          });
        }).catch(function () {
          _this2.setState({
            isUpdatingSupport: false
          });
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          selectedMatrixLicense = _props2.selectedMatrixLicense,
          itemMatrix = _props2.itemMatrix;
      var _state = this.state,
          isExtendedSupportSelected = _state.isExtendedSupportSelected,
          isUpdatingSupport = _state.isUpdatingSupport;


      var selectedLicenseSupport = itemMatrix[selectedMatrixLicense].support;

      var bundle12MonthPrice = selectedLicenseSupport['bundle_12month'].price;
      var bundle6MonthPrice = selectedLicenseSupport['bundle_6month'].price;
      var priceVariation = Object(formatString["getPriceVariation"])(bundle6MonthPrice, bundle12MonthPrice);
      return react_default.a.createElement(
        'div',
        { className: 'fds-c-modal__section' },
        react_default.a.createElement(
          'div',
          { className: 'cart-modal__item-support' },
          react_default.a.createElement(
            'label',
            { htmlFor: 'support' },
            react_default.a.createElement('input', {
              className: 'fds-c-form-checkbox fds-u-mr1',
              type: 'checkbox',
              name: 'support',
              disabled: isUpdatingSupport,
              checked: isExtendedSupportSelected,
              onChange: this.onExtendedSupportSelectChange
            }),
            react_default.a.createElement(
              'strong',
              null,
              'Extend support to 12 months. ',
              priceVariation
            )
          )
        )
      );
    }
  }]);

  return ItemSupportUpgrade;
}(react_default.a.Component);

/* harmony default export */ var itemSupportUpgrade = (itemSupportUpgrade_ItemSupportUpgrade);
// EXTERNAL MODULE: ./common/utils/sites.js
var sites = __webpack_require__(23);

// CONCATENATED MODULE: ./client/components/modals/cart/entrySummary.js









/* harmony default export */ var entrySummary = (function (_ref) {
  var item = _ref.item,
      itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      selectedMatrixSupport = _ref.selectedMatrixSupport,
      onMatrixLicenseChange = _ref.onMatrixLicenseChange,
      onMatrixSupportChange = _ref.onMatrixSupportChange,
      loadItemMatrixError = _ref.loadItemMatrixError,
      modalMessages = _ref.modalMessages,
      closeModal = _ref.closeModal,
      editCartEntry = _ref.editCartEntry,
      goToEditScreen = _ref.goToEditScreen,
      cartEntry = _ref.cartEntry,
      updateMatrixSupport = _ref.updateMatrixSupport,
      hasSupportBeenExtended = _ref.hasSupportBeenExtended,
      currentSite = _ref.currentSite;

  // the selected support could be one of none/bundle_6month/bundle_12month
  // and it could be show in the follwing two cases:
  // 1. user has selected a support, and the support is `bundle_6month`
  // 2. user has extended support
  var shouldShowExtendedSupport = selectedMatrixSupport && selectedMatrixSupport === 'bundle_6month' || hasSupportBeenExtended;

  // Temporary link to cart page, will need to set to real checkout page later.
  var currentSiteDomain = Object(sites["getCurrentSiteDomain"])(currentSite);
  var checkoutPageLink = '//' + currentSiteDomain + '/cart';

  return react_default.a.createElement(
    'div',
    { className: 'fds-c-modal -width-m modal' },
    react_default.a.createElement(
      'header',
      { className: 'fds-c-modal__header fds-u-text-align-center fds-u-p3' },
      react_default.a.createElement(
        'h1',
        { className: 'fds-c-text-heading -size-s fds-u-mb0' },
        react_default.a.createElement(ok["default"], { width: '40', height: '40' })
      ),
      react_default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading -size-m fds-u-mb0' },
        'Item added to your cart'
      )
    ),
    loadItemMatrixError && react_default.a.createElement(cart_loadItemMatrixError, null),
    modalMessages && react_default.a.createElement(modalErrorMessage, { modalMessages: modalMessages }),
    react_default.a.createElement(itemSummary, {
      item: item,
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      showChangeDetailsLink: true,
      goToEditScreen: goToEditScreen,
      cartEntry: cartEntry
    }),
    shouldShowExtendedSupport && react_default.a.createElement(itemSupportUpgrade, {
      selectedMatrixLicense: selectedMatrixLicense,
      itemMatrix: itemMatrix,
      editCartEntry: editCartEntry,
      cartEntry: cartEntry,
      updateMatrixSupport: updateMatrixSupport
    }),
    !loadItemMatrixError && react_default.a.createElement(
      'footer',
      { className: 'fds-c-modal__footer' },
      react_default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-left' },
        react_default.a.createElement(
          'button',
          { className: 'fds-c-button -color-light', onClick: closeModal },
          'Keep Browsing'
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-right' },
        react_default.a.createElement(
          'a',
          {
            className: 'fds-c-button--3d -color-primary',
            href: checkoutPageLink
          },
          'Go to Checkout'
        )
      )
    )
  );
});
// EXTERNAL MODULE: ./common/utils/itemMatrix.js
var utils_itemMatrix = __webpack_require__(120);

// EXTERNAL MODULE: ./common/utils/ga.js
var ga = __webpack_require__(13);

// CONCATENATED MODULE: ./common/analytics/cartAnalytics.js



var cartAnalytics_reportEditCartEntryAttempt = function reportEditCartEntryAttempt(_ref) {
  var page = _ref.page;

  Object(ga["default"])('send', {
    hitType: 'pageview',
    page: page,
    title: 'Modal: Edit cart entry'
  });
};

var cartAnalytics_reportCartSupportUpgrade = function reportCartSupportUpgrade(_ref2) {
  var item = _ref2.item,
      currentSite = _ref2.currentSite,
      license = _ref2.license,
      price = _ref2.price,
      support = _ref2.support;

  var currentSiteDomain = Object(sites["getCurrentSiteDomain"])(currentSite);
  Object(ga["default"])('ec:addProduct', {
    id: item.id,
    name: item.name,
    variant: license,
    category: currentSiteDomain + '/' + item.classification,
    brand: item.author_username,
    price: price,
    quantity: '1',
    dimension14: support
  });
  Object(ga["default"])('ec:setAction', 'add');
  Object(ga["default"])('send', 'event', 'Ecommerce', 'click', 'Search support upgrade');
};
// EXTERNAL MODULE: ./common/utils/setGATracker.js + 1 modules
var setGATracker = __webpack_require__(159);

// CONCATENATED MODULE: ./client/components/modals/cart/addItemToCart.js
var addItemToCart__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function addItemToCart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function addItemToCart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function addItemToCart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var addItemToCart_AddItemToCart = function (_React$Component) {
  addItemToCart__inherits(AddItemToCart, _React$Component);

  function AddItemToCart(props) {
    addItemToCart__classCallCheck(this, AddItemToCart);

    // modal step could be add/edit/summary
    var _this = addItemToCart__possibleConstructorReturn(this, (AddItemToCart.__proto__ || Object.getPrototypeOf(AddItemToCart)).call(this, props));

    _this.state = {
      modalStep: 'add',
      cartEntry: null,
      isLoadingItemMatrix: false,
      loadItemMatrixError: null,
      itemMatrix: null,
      selectedMatrixLicense: null,
      selectedMatrixSupport: null,
      hasSupportBeenExtended: false,
      isAddingItem: false
    };
    _this.onAddToCart = _this.onAddToCart.bind(_this);
    _this.onEditCartEntry = _this.onEditCartEntry.bind(_this);
    _this.onMatrixLicenseChange = _this.onMatrixLicenseChange.bind(_this);
    _this.onMatrixSupportChange = _this.onMatrixSupportChange.bind(_this);
    _this.goToEditScreen = _this.goToEditScreen.bind(_this);
    _this.updateMatrixSupport = _this.updateMatrixSupport.bind(_this);
    return _this;
  }

  addItemToCart__createClass(AddItemToCart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        isLoadingItemMatrix: true
      });
      Object(utils_itemMatrix["getItemMatrix"])(this.props.openModalData.item.id).then(function (itemMatrix) {
        var defaultSelectedMatrixLicense = itemMatrix ? Object.keys(itemMatrix)[0] : null;
        var defaultSupportOption = itemMatrix[defaultSelectedMatrixLicense].support;
        var defaultSelectedMatrixSupport = itemMatrix ? Object.keys(defaultSupportOption)[0] : null;
        _this2.setState({
          isLoadingItemMatrix: false,
          itemMatrix: itemMatrix,
          selectedMatrixLicense: defaultSelectedMatrixLicense,
          selectedMatrixSupport: defaultSelectedMatrixSupport
        });
      }).catch(function (error) {
        _this2.setState({
          isLoadingItemMatrix: false,
          loadItemMatrixError: error
        });
      });
    }
  }, {
    key: 'onMatrixLicenseChange',
    value: function onMatrixLicenseChange(e) {
      this.setState({
        selectedMatrixLicense: e.target.value
      });
    }
  }, {
    key: 'onMatrixSupportChange',
    value: function onMatrixSupportChange(e) {
      this.setState({
        selectedMatrixSupport: e.target.value
      });
    }
  }, {
    key: 'updateMatrixSupport',
    value: function updateMatrixSupport(value) {
      var _props = this.props,
          item = _props.openModalData.item,
          currentSite = _props.currentSite;
      var _state = this.state,
          itemMatrix = _state.itemMatrix,
          selectedMatrixLicense = _state.selectedMatrixLicense;

      var selectedMatrixSupportOptions = Object(lodash["get"])(itemMatrix[selectedMatrixLicense], 'support');
      var price = Object(lodash["get"])(selectedMatrixSupportOptions[value], 'price').replace('$', '');
      cartAnalytics_reportCartSupportUpgrade({
        item: item,
        currentSite: currentSite,
        license: selectedMatrixLicense,
        price: price,
        support: value
      });
      this.setState({
        hasSupportBeenExtended: true,
        selectedMatrixSupport: value
      });
    }
  }, {
    key: 'onAddToCart',
    value: function onAddToCart() {
      var _this3 = this;

      var _props2 = this.props,
          item = _props2.openModalData.item,
          addItemToCart = _props2.addItemToCart,
          dismissModalMessage = _props2.dismissModalMessage;
      var _state2 = this.state,
          selectedMatrixLicense = _state2.selectedMatrixLicense,
          selectedMatrixSupport = _state2.selectedMatrixSupport;

      var data = {
        item_id: item.id,
        license_key: selectedMatrixLicense,
        support_key: selectedMatrixSupport
      };

      Object(setGATracker["a" /* default */])().then(function (gaClientId) {
        data.ga_client_id = gaClientId;
        _this3.setState({
          isAddingItem: true
        });
        addItemToCart(data).then(function (action) {
          if (action && action.type === 'addItemToCartSuccess') {
            dismissModalMessage();
            _this3.setState({
              modalStep: 'summary',
              cartEntry: action.payload,
              isAddingItem: false
            });
          } else {
            _this3.setState({
              isAddingItem: false
            });
          }
        }).catch(errors["logError"]);
      });
    }
  }, {
    key: 'onEditCartEntry',
    value: function onEditCartEntry() {
      var _props3 = this.props,
          item = _props3.openModalData.item,
          closeModal = _props3.closeModal,
          editCartEntry = _props3.editCartEntry,
          dismissModalMessage = _props3.dismissModalMessage,
          currentSite = _props3.currentSite;
      var _state3 = this.state,
          cartEntry = _state3.cartEntry,
          selectedMatrixLicense = _state3.selectedMatrixLicense,
          selectedMatrixSupport = _state3.selectedMatrixSupport;


      var data = {
        item_id: item.id,
        license_key: selectedMatrixLicense,
        support_key: selectedMatrixSupport
      };
      editCartEntry(cartEntry.id, data).then(function (action) {
        if (action && action.type === 'editCartEntrySuccess') {
          dismissModalMessage();
          closeModal();
          window.location = '//' + Object(sites["getCurrentSiteDomain"])(currentSite) + '/cart';
        }
      }).catch(errors["logError"]);
    }
  }, {
    key: 'goToEditScreen',
    value: function goToEditScreen() {
      cartAnalytics_reportEditCartEntryAttempt({
        page: '/search/edit-cart-entry' + window.location.search
      });
      this.setState({
        modalStep: 'edit'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          item = _props4.openModalData.item,
          closeModal = _props4.closeModal,
          modalMessages = _props4.modalMessages,
          editCartEntry = _props4.editCartEntry,
          currentSite = _props4.currentSite;
      var _state4 = this.state,
          cartEntry = _state4.cartEntry,
          modalStep = _state4.modalStep,
          itemMatrix = _state4.itemMatrix,
          selectedMatrixLicense = _state4.selectedMatrixLicense,
          selectedMatrixSupport = _state4.selectedMatrixSupport,
          loadItemMatrixError = _state4.loadItemMatrixError,
          hasSupportBeenExtended = _state4.hasSupportBeenExtended,
          isAddingItem = _state4.isAddingItem,
          isLoadingItemMatrix = _state4.isLoadingItemMatrix;


      var isLoading = isLoadingItemMatrix || isAddingItem;

      if (modalStep === 'add' || modalStep === 'edit') {
        return react_default.a.createElement(addEntry, {
          item: item,
          itemMatrix: itemMatrix,
          selectedMatrixLicense: selectedMatrixLicense,
          selectedMatrixSupport: selectedMatrixSupport,
          onMatrixLicenseChange: this.onMatrixLicenseChange,
          onMatrixSupportChange: this.onMatrixSupportChange,
          loadItemMatrixError: loadItemMatrixError,
          modalMessages: modalMessages,
          closeModal: closeModal,
          onAddToCart: this.onAddToCart,
          onEditCartEntry: this.onEditCartEntry,
          modalStep: modalStep,
          isLoading: isLoading
        });
      } else {
        return react_default.a.createElement(entrySummary, {
          item: item,
          itemMatrix: itemMatrix,
          selectedMatrixLicense: selectedMatrixLicense,
          selectedMatrixSupport: selectedMatrixSupport,
          onMatrixLicenseChange: this.onMatrixLicenseChange,
          onMatrixSupportChange: this.onMatrixSupportChange,
          loadItemMatrixError: loadItemMatrixError,
          modalMessages: modalMessages,
          closeModal: closeModal,
          editCartEntry: editCartEntry,
          goToEditScreen: this.goToEditScreen,
          cartEntry: cartEntry,
          updateMatrixSupport: this.updateMatrixSupport,
          hasSupportBeenExtended: hasSupportBeenExtended,
          currentSite: currentSite
        });
      }
    }
  }]);

  return AddItemToCart;
}(react_default.a.Component);

/* harmony default export */ var cart_addItemToCart = (addItemToCart_AddItemToCart);
// CONCATENATED MODULE: ./client/components/modals/cart/addItemToCartContainer.js






var addItemToCartContainer_mapStateToProps = function mapStateToProps(state) {
  var modalMessages = state.layout.modalMessages,
      currentSite = state.common.currentSite;

  return {
    modalMessages: modalMessages,
    currentSite: currentSite
  };
};

var addItemToCartContainer_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch(Object(layout["closeModal"])());
    },
    addItemToCart: function addItemToCart(data) {
      return dispatch(Object(cart["a" /* addItemToCart */])(data));
    },
    editCartEntry: function editCartEntry(entryID, data) {
      return dispatch(Object(cart["b" /* editCartEntry */])(entryID, data));
    },
    dismissModalMessage: function dismissModalMessage() {
      return dispatch(Object(layout["dismissModalMessage"])());
    }
  };
};

var AddItemToCartContainer = Object(es["connect"])(addItemToCartContainer_mapStateToProps, addItemToCartContainer_mapDispatchToProps)(cart_addItemToCart);

/* harmony default export */ var addItemToCartContainer = (AddItemToCartContainer);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/recaptcha-wrapper.js
var recaptcha_wrapper = __webpack_require__(429);
var recaptcha_wrapper_default = /*#__PURE__*/__webpack_require__.n(recaptcha_wrapper);

// EXTERNAL MODULE: ./common/config.ts
var config = __webpack_require__(12);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./client/components/modals/user/signIn.module.css
var signIn_module = __webpack_require__(272);
var signIn_module_default = /*#__PURE__*/__webpack_require__.n(signIn_module);

// CONCATENATED MODULE: ./client/components/modals/user/signIn.js








var signIn_SignInModal = function SignInModal(_ref) {
  var showReCAPTCHA = _ref.showReCAPTCHA,
      show2FA = _ref.show2FA,
      showUsernameMissing = _ref.showUsernameMissing,
      showPasswordMissing = _ref.showPasswordMissing,
      showServerError = _ref.showServerError,
      showLoading = _ref.showLoading,
      data = _ref.data,
      passwordErrorMsg = _ref.passwordErrorMsg,
      twoFAErrorMsg = _ref.twoFAErrorMsg,
      openModalData = _ref.openModalData,
      onSubmit = _ref.onSubmit,
      onInputChange = _ref.onInputChange,
      onReCAPTCHAChange = _ref.onReCAPTCHAChange,
      recaptchaKey = _ref.recaptchaKey;
  var welcomeMsg = openModalData.welcomeMsg,
      welcomeMsgDescription = openModalData.welcomeMsgDescription;

  var logoAssetsPath = config["config"].assets.PUBLIC_PATH + '/images/envato_white.svg';
  var modalClassNames = classnames_default()('fds-c-modal', '-width-s', {
    'is-disabled-loading': showLoading
  });

  // apply invalid status to form when either is missing or wrong details
  var usernameInputStatus = showUsernameMissing || passwordErrorMsg ? 'invalid' : null;
  var passwordInputStatus = showPasswordMissing || passwordErrorMsg ? 'invalid' : null;
  var twoFAInputStats = twoFAErrorMsg ? 'invalid' : null;

  return react_default.a.createElement(
    'div',
    { className: modalClassNames },
    react_default.a.createElement(
      'header',
      { className: 'fds-c-modal__header fds-u-text-align-center fds-c-modal__section -background-dark' },
      react_default.a.createElement(
        'div',
        { className: 'fds-u-py1' },
        react_default.a.createElement('img', { alt: 'Envato', width: '130', src: logoAssetsPath })
      )
    ),
    react_default.a.createElement(
      'div',
      { className: 'fds-c-modal__section -radius-bottom' },
      welcomeMsg && react_default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading fds-u-text-align-center -size-s fds-u-mb0 fds-u-pt2 fds-u-pb2' },
        welcomeMsg
      ),
      welcomeMsgDescription && react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body fds-u-text-align-center -size-s fds-u-mb0 fds-u-pb2' },
        welcomeMsgDescription
      ),
      react_default.a.createElement(
        'form',
        {
          acceptCharset: 'UTF-8',
          onSubmit: onSubmit,
          className: 'fds-c-form -layout-vertical-inline',
          noValidate: true
        },
        react_default.a.createElement(
          'div',
          { className: 'fds-c-form__group fds-u-text-align-center' },
          react_default.a.createElement(
            'div',
            { className: signIn_module_default.a.formLabelInlineGroup },
            react_default.a.createElement(
              'div',
              { className: signIn_module_default.a.formLabel },
              react_default.a.createElement(
                'span',
                null,
                'Username'
              )
            ),
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'a',
                {
                  className: 'fds-c-text-link -decoration-none',
                  href: 'https://account.envato.com/recover_usernames'
                },
                'Remind me'
              )
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'fds-c-form__input' },
            react_default.a.createElement('input', {
              autoFocus: true,
              tabIndex: 1,
              'data-status': usernameInputStatus,
              defaultValue: data.username,
              onChange: onInputChange('username'),
              name: 'username',
              className: 'fds-c-form-input -type-string',
              size: '50',
              type: 'text',
              required: true
            })
          ),
          showUsernameMissing && react_default.a.createElement(
            'div',
            { id: 'missing-username', className: signIn_module_default.a.formResponse },
            'Username is required'
          )
        ),
        react_default.a.createElement(
          'div',
          { className: 'fds-c-form__group fds-u-text-align-center' },
          react_default.a.createElement(
            'div',
            { className: signIn_module_default.a.formLabelInlineGroup },
            react_default.a.createElement(
              'div',
              { className: signIn_module_default.a.formLabel },
              react_default.a.createElement(
                'span',
                null,
                'Password'
              )
            ),
            react_default.a.createElement(
              'div',
              null,
              react_default.a.createElement(
                'a',
                {
                  className: 'fds-c-text-link -decoration-none',
                  href: 'https://account.envato.com/reset_password'
                },
                'Reset'
              )
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'fds-c-form__input' },
            react_default.a.createElement('input', {
              tabIndex: 2,
              'data-status': passwordInputStatus,
              defaultValue: data.password,
              onChange: onInputChange('password'),
              name: 'password',
              className: 'fds-c-form-input -type-string',
              size: '50',
              type: 'password',
              required: true
            })
          ),
          showPasswordMissing && react_default.a.createElement(
            'div',
            { id: 'missing-password', className: signIn_module_default.a.formResponse },
            'Password is required'
          ),
          passwordErrorMsg && react_default.a.createElement(
            'div',
            { id: 'password-error', className: 'fds-c-form__response' },
            passwordErrorMsg
          )
        ),
        showReCAPTCHA && react_default.a.createElement(
          'div',
          { id: 'recaptcha', className: 'fds-c-form__group' },
          react_default.a.createElement(
            'div',
            { className: signIn_module_default.a.captcha },
            react_default.a.createElement(recaptcha_wrapper_default.a, {
              sitekey: recaptchaKey,
              onChange: onReCAPTCHAChange
            })
          )
        ),
        show2FA && react_default.a.createElement(
          'div',
          { id: 'two-fa', className: 'fds-c-form__group' },
          react_default.a.createElement(
            'div',
            { className: signIn_module_default.a.formLabelInlineGroup },
            react_default.a.createElement(
              'div',
              { className: signIn_module_default.a.formLabel },
              'Authentication Code'
            )
          ),
          react_default.a.createElement(
            'div',
            { className: 'fds-c-form__input fds-u-text-align-center' },
            react_default.a.createElement('input', {
              'data-status': twoFAInputStats,
              defaultValue: data.authentication_code,
              onChange: onInputChange('authentication_code'),
              name: 'twoFactor',
              className: 'fds-c-form-input -type-string',
              size: '50',
              type: 'text'
            })
          ),
          twoFAErrorMsg && react_default.a.createElement(
            'div',
            { className: 'fds-c-form__response fds-u-text-align-center' },
            twoFAErrorMsg
          )
        ),
        showServerError && react_default.a.createElement(
          'div',
          {
            id: 'server-error',
            className: 'fds-c-form__group  fds-u-text-align-center'
          },
          react_default.a.createElement(
            'div',
            { className: 'fds-c-form__response' },
            'Whoops! Something went wrong.',
            react_default.a.createElement('br', null),
            'Please try again or sign in via this',
            ' ',
            react_default.a.createElement(
              'a',
              { href: 'https://account.envato.com/' },
              'link'
            ),
            '.'
          )
        ),
        react_default.a.createElement(
          'p',
          { className: 'fds-u-text-align-center' },
          react_default.a.createElement(
            'button',
            {
              tabIndex: 3,
              disabled: showLoading,
              type: 'submit',
              className: 'fds-c-button--3d -color-primary -size-m'
            },
            'Sign in to your account'
          )
        ),
        react_default.a.createElement(
          'p',
          { className: 'fds-u-text-align-center fds-u-mt2 fds-u-mb3' },
          'New here? ',
          ' ',
          react_default.a.createElement(
            'a',
            {
              className: 'fds-c-text-link -decoration-none',
              href: 'https://account.envato.com/'
            },
            'Create an Envato account'
          )
        )
      )
    )
  );
};

/* harmony default export */ var signIn = (signIn_SignInModal);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(60);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(22);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/lodash/omitBy.js
var omitBy = __webpack_require__(191);
var omitBy_default = /*#__PURE__*/__webpack_require__.n(omitBy);

// EXTERNAL MODULE: ./common/utils/axios/interceptors.js
var interceptors = __webpack_require__(113);

// CONCATENATED MODULE: ./common/utils/ssoRequest.js





var ssoServerHost = config["config"].sso.SERVER_HOST;
var TIMEOUT = 15000;

/**
 * A simple function to wrap sso api with default endpoint and request headers
 * @type {Object}
 */
var instance = axios_default.a.create({
  baseURL: ssoServerHost,
  timeout: TIMEOUT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

instance.interceptors.response.use(undefined, interceptors["b" /* timeoutRetryRejectionInterceptor */]);
/* harmony default export */ var ssoRequest = (instance);
// CONCATENATED MODULE: ./client/components/modals/user/signInHelper.js







var ssoHost = config["config"].sso.SERVER_HOST;

var signInHelper_handleSubmit = function handleSubmit(data, _ref) {
  var handleSignInSuccess = _ref.handleSignInSuccess,
      handleSignInError = _ref.handleSignInError,
      handlePassword = _ref.handlePassword,
      handleCaptcha = _ref.handleCaptcha,
      handle2FA = _ref.handle2FA,
      handleSignInVerification = _ref.handleSignInVerification,
      handlePasswordReset = _ref.handlePasswordReset,
      handleEmailConfirmation = _ref.handleEmailConfirmation;

  // remove empty form field
  var formData = omitBy_default()(data, function (value) {
    return !value;
  });
  var payload = query_string_default.a.stringify(formData);

  ssoRequest.post(ssoHost + '/sign_in', payload, { withCredentials: true }).then(function (response) {
    var data = response.data;

    if (data && data.state) {
      switch (data.state) {
        case 'ok':
          {
            var token = data.token;
            axios_default.a.post('/jwt_session', {
              token: token
            }).then(function (response) {
              var token = response.data.token;

              handleSignInSuccess(token);
            }).catch(function (err) {
              handleSignInError(err);
            });
            break;
          }
        case 'password':
          handlePassword(data);
          break;
        case 'captcha':
          handleCaptcha(data);
          break;
        case 'two_factor':
          handle2FA(data);
          break;
        case 'sign_in_verification':
          handleSignInVerification(data);
          break;
        case 'password_reset_required':
          handlePasswordReset(data);
          break;
        case 'email_confirmation_required':
          handleEmailConfirmation(data);
          break;
      }
    }
  }).catch(function (error) {
    handleSignInError(error);
  });
};

var signInHelper_autoSignIn = function autoSignIn(payload, _ref2) {
  var handleAutoSignInSuccess = _ref2.handleAutoSignInSuccess,
      handleAutoSignInError = _ref2.handleAutoSignInError;

  var data = query_string_default.a.stringify(payload);
  ssoRequest.post(ssoHost + '/api/auto_sign_in', data, {
    withCredentials: true
  }).then(function (response) {
    var token = response.data.token;

    if (token) {
      axios_default.a.post('/jwt_session', { token: token }).then(function (response) {
        var token = response.data.token;

        handleAutoSignInSuccess(token);
      }).catch(function (err) {
        handleAutoSignInError(err);
      });
    } else {
      handleAutoSignInError();
    }
  });
};
// CONCATENATED MODULE: ./client/components/modals/user/signInContainer.js
var signInContainer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var signInContainer__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function signInContainer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function signInContainer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function signInContainer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var signInContainer_recaptchaKey = config["config"].sso.RECAPTCHA_KEY;

var signInContainer_SignInModalContainer = function (_React$Component) {
  signInContainer__inherits(SignInModalContainer, _React$Component);

  function SignInModalContainer(props) {
    signInContainer__classCallCheck(this, SignInModalContainer);

    var _this = signInContainer__possibleConstructorReturn(this, (SignInModalContainer.__proto__ || Object.getPrototypeOf(SignInModalContainer)).call(this, props));

    _this.state = {
      showReCAPTCHA: false,
      show2FA: false,
      showLoading: false,
      showUsernameMissing: false,
      showPasswordMissing: false,
      showServerError: false,
      data: {
        username: null,
        password: null,
        to: props.openModalData.currentSite,
        authentication_code: null
      },
      passwordErrorMsg: null,
      twoFAErrorMsg: null
    };

    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onReCAPTCHAChange = _this.onReCAPTCHAChange.bind(_this);
    return _this;
  }

  signInContainer__createClass(SignInModalContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var closeModal = this.props.closeModal;
      var _props$openModalData = this.props.openModalData,
          onSignInSuccess = _props$openModalData.onSignInSuccess,
          currentSite = _props$openModalData.currentSite;

      this.setState({
        showLoading: true
      });
      var payload = {
        to: currentSite
      };
      signInHelper_autoSignIn(payload, {
        handleAutoSignInSuccess: function handleAutoSignInSuccess(token) {
          onSignInSuccess(token).then(function () {
            _this2.setState({
              showLoading: false
            });
            closeModal();
          });
        },
        handleAutoSignInError: function handleAutoSignInError() {
          _this2.setState({
            showLoading: false
          });
        }
      });
    }
  }, {
    key: 'onReCAPTCHAChange',
    value: function onReCAPTCHAChange(recaptchaResponse) {
      this.setState({
        data: signInContainer__extends({}, this.state.data, {
          recaptcha_version: '2',
          recaptcha_site_key: signInContainer_recaptchaKey,
          recaptcha_response: recaptchaResponse
        })
      });
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(name) {
      var _this3 = this;

      return function (event) {
        _this3.setState({
          data: signInContainer__extends({}, _this3.state.data, _defineProperty({}, name, event.target.value))
        });
      };
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      var _this4 = this;

      var closeModal = this.props.closeModal;
      var data = this.state.data;
      var onSignInSuccess = this.props.openModalData.onSignInSuccess;

      event.preventDefault();

      // reset form state on submit
      this.setState({
        showLoading: true,
        showReCAPTCHA: false,
        show2FA: false,
        showUsernameMissing: false,
        showPasswordMissing: false,
        showServerError: false,
        data: signInContainer__extends({}, this.state.data, {
          recaptcha_version: null,
          recaptcha_site_key: null,
          recaptcha_response: null,
          authentication_code: null
        }),
        passwordErrorMsg: null,
        twoFAErrorMsg: null
      });

      if (!data.username) {
        this.setState({
          showLoading: false,
          showUsernameMissing: true
        });
        return;
      }

      if (!data.password) {
        this.setState({
          showLoading: false,
          showPasswordMissing: true
        });
        return;
      }

      signInHelper_handleSubmit(data, {
        handleSignInSuccess: function handleSignInSuccess(token) {
          onSignInSuccess(token).then(function () {
            _this4.setState({
              showLoading: false
            });
            closeModal();
          });
        },
        handleSignInError: function handleSignInError() {
          _this4.setState({
            showLoading: false,
            showServerError: true
          });
        },
        handlePassword: function handlePassword(data) {
          _this4.setState({
            showLoading: false,
            passwordErrorMsg: data.error_message || 'Whoops! Something went wrong.'
          });
        },
        handleCaptcha: function handleCaptcha(data) {
          if (data.error_message) {
            _this4.setState({
              showLoading: false,
              showReCAPTCHA: true,
              passwordErrorMsg: data.error_message || 'Whoops! Something went wrong.'
            });
          } else {
            _this4.setState({
              showLoading: false,
              showReCAPTCHA: true
            });
          }
        },
        handle2FA: function handle2FA(data) {
          if (data.error_message) {
            _this4.setState({
              showLoading: false,
              show2FA: true,
              twoFAErrorMsg: data.error_message
            });
          } else {
            _this4.setState({
              showLoading: false,
              show2FA: true
            });
          }
        },
        handleSignInVerification: function handleSignInVerification(data) {
          if (data.redirect) {
            window.location = data.redirect;
          }
          _this4.setState({
            showLoading: false
          });
        },
        handlePasswordReset: function handlePasswordReset(data) {
          if (data.redirect) {
            window.location = data.redirect;
          }
          _this4.setState({
            showLoading: false
          });
        },
        handleEmailConfirmation: function handleEmailConfirmation(data) {
          if (data.redirect) {
            window.location = data.redirect;
          }
          _this4.setState({
            showLoading: false
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showReCAPTCHA = _state.showReCAPTCHA,
          show2FA = _state.show2FA,
          showUsernameMissing = _state.showUsernameMissing,
          showPasswordMissing = _state.showPasswordMissing,
          showServerError = _state.showServerError,
          showLoading = _state.showLoading,
          data = _state.data,
          passwordErrorMsg = _state.passwordErrorMsg,
          twoFAErrorMsg = _state.twoFAErrorMsg;


      return react_default.a.createElement(signIn, {
        showReCAPTCHA: showReCAPTCHA,
        show2FA: show2FA,
        showUsernameMissing: showUsernameMissing,
        showPasswordMissing: showPasswordMissing,
        showServerError: showServerError,
        showLoading: showLoading,
        data: data,
        passwordErrorMsg: passwordErrorMsg,
        twoFAErrorMsg: twoFAErrorMsg,
        openModalData: this.props.openModalData,
        onSubmit: this.onSubmit,
        onInputChange: this.onInputChange,
        onReCAPTCHAChange: this.onReCAPTCHAChange,
        recaptchaKey: signInContainer_recaptchaKey
      });
    }
  }]);

  return SignInModalContainer;
}(react_default.a.Component);

/* harmony default export */ var signInContainer = (signInContainer_SignInModalContainer);
// CONCATENATED MODULE: ./client/components/modals/index.js







/* harmony default export */ var modals = __webpack_exports__["default"] = (function (_ref) {
  var isModalOpen = _ref.isModalOpen,
      closeModal = _ref.closeModal,
      openModalType = _ref.openModalType,
      openModalData = _ref.openModalData;

  var renderModalContent = function renderModalContent() {
    switch (openModalType) {
      case 'addItemToCollection':
        return react_default.a.createElement(addItemToCollectionContainer, {
          openModalData: openModalData,
          closeModal: closeModal
        });

      case 'addItemToCart':
        return react_default.a.createElement(addItemToCartContainer, { openModalData: openModalData });

      case 'signIn':
        return react_default.a.createElement(signInContainer, {
          closeModal: closeModal,
          openModalData: openModalData
        });

      default:
        return null;
    }
  };

  return react_default.a.createElement(
    lib_default.a,
    {
      isOpen: isModalOpen,
      onRequestClose: closeModal,
      contentLabel: 'Modal',
      className: 'ReactModal__Content',
      overlayClassName: 'ReactModal__Overlay'
    },
    renderModalContent()
  );
});

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var getSimilarItems_1 = __webpack_require__(270);
var sites_1 = __webpack_require__(23);
var searchPage_1 = __webpack_require__(20);
/**
 * fetch similar items
 */
exports.fetchSimilarItems = function (itemID) {
    return function (dispatch, getState) {
        var similarItems = lodash_1.get(getState(), 'searchPage.similarItems');
        var errorOccured = !!(similarItems[itemID] && similarItems[itemID].error);
        var siteName = lodash_1.get(getState(), 'common.currentSite');
        var site = sites_1.getCurrentSiteDomain(siteName);
        if (!similarItems[itemID] || errorOccured) {
            return getSimilarItems_1.getSimilarItems(itemID, site)
                .then(function (similarItemsData) {
                return dispatch(fetchSimilarItemsSuccess({ itemID: itemID, similarItems: similarItemsData }));
            })
                .catch(function (error) {
                return dispatch(fetchSimilarItemsFailure(itemID, error.message));
            });
        }
        else {
            return Promise.resolve(dispatch(fetchSimilarItemsSuccess({
                itemID: itemID,
                similarItems: similarItems[itemID]
            })));
        }
    };
};
var fetchSimilarItemsSuccess = function (_a) {
    var itemID = _a.itemID, similarItems = _a.similarItems;
    var action = {
        type: searchPage_1.TypeKeys.GET_SIMILAR_ITEMS_SUCCESS,
        payload: { itemID: itemID, similarItems: similarItems }
    };
    return action;
};
var fetchSimilarItemsFailure = function (itemID, error) {
    var action = {
        type: searchPage_1.TypeKeys.GET_SIMILAR_ITEMS_FAIL,
        payload: { itemID: itemID, error: error }
    };
    return action;
};
exports.default = exports.fetchSimilarItems;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var axiosVerbose_1 = __webpack_require__(11);
var errors_1 = __webpack_require__(8);
exports.getSimilarItems = function (itemId, site, pageSize) {
    if (site === void 0) { site = null; }
    if (pageSize === void 0) { pageSize = 8; }
    var siteFilter = site ? "&site=" + site : '';
    var url = "/shopfront_api/search/similar?item_id=" + itemId + "&page_size=" + pageSize +
        siteFilter;
    return axiosVerbose_1.default
        .get(url)
        .then(function (res) { return res.data; })
        .catch(function (err) { return Promise.reject(errors_1.logError(err)); });
};


/***/ }),
/* 271 */,
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"formLabelInlineGroup":"signIn-module_formLabelInlineGroup_11klt","formResponse":"signIn-module_formResponse_3beQl","formLabel":"signIn-module_formLabel_pL_Nu","captcha":"signIn-module_captcha_2UXzj"};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/react-icon-base/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./client/components/icons/arrowFillDown.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var arrowFillDown = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Arrow-Fill-Down' },
      props.title || 'Arrow-Fill-Down'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M263.8 438.1c-2.3 2.9-5.3 4.1-8.2 4.1s-6.5-1.2-8.2-4.1l-242.9-295.8c-2.4-2.9-2.9-7-1.2-11.2 1.8-3.5 5.3-5.9 9.4-5.9h485.9c4.1 0 7.6 2.3 9.4 5.9 1.8 4.1 1.2 8.2-1.2 11.2l-243 295.8z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/arrowFillUp.js
var arrowFillUp__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var arrowFillUp = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    arrowFillUp__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Arrow-Fill-Up' },
      props.title || 'Arrow-Fill-Up'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M246.2 92c2.3-2.9 5.2-4.1 8.1-4.1 2.9 0 6.4 1.2 8.1 4.1l240.2 292.4c2.3 2.9 2.9 7 1.2 11-1.7 3.5-5.2 5.8-9.3 5.8h-480.3c-4.1 0-7.5-2.3-9.3-5.8-1.7-4.1-1.2-8.1 1.2-11l240.1-292.4z' })
    )
  );
});
// EXTERNAL MODULE: ./client/components/pageOffCanvasLeft/pageOffLeftMenu.module.css
var pageOffLeftMenu_module = __webpack_require__(274);
var pageOffLeftMenu_module_default = /*#__PURE__*/__webpack_require__.n(pageOffLeftMenu_module);

// CONCATENATED MODULE: ./client/components/pageOffCanvasLeft/pageOffLeftMenu.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var pageOffLeftMenu_PageOffLeftMenuItem = function (_React$Component) {
  _inherits(PageOffLeftMenuItem, _React$Component);

  function PageOffLeftMenuItem(props) {
    _classCallCheck(this, PageOffLeftMenuItem);

    var _this = _possibleConstructorReturn(this, (PageOffLeftMenuItem.__proto__ || Object.getPrototypeOf(PageOffLeftMenuItem)).call(this, props));

    _this.state = { isOpen: false };
    return _this;
  }

  _createClass(PageOffLeftMenuItem, [{
    key: 'hasChildren',
    value: function hasChildren() {
      return Object(lodash["get"])(this.props.config, 'children.length');
    }
  }, {
    key: 'onLinkClick',
    value: function onLinkClick(event) {
      if (!this.hasChildren()) {
        return;
      }
      event.preventDefault();
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          level = _props.level;
      var isOpen = this.state.isOpen;

      var nextLevel = level + 1;
      var linkClass = classnames_default()(pageOffLeftMenu_module_default.a.link, {
        'off-canvas-category-link--empty': level === 1 && !this.hasChildren(),
        'off-canvas-category-link--sub': level > 1 && !this.hasChildren(),
        'off-canvas-category-link': this.hasChildren(),
        'is-open': isOpen
      });
      return react_default.a.createElement(
        'li',
        null,
        react_default.a.createElement(
          'a',
          {
            href: config.url,
            onClick: this.onLinkClick.bind(this),
            className: linkClass
          },
          config.name + ' ',
          config.isNew ? react_default.a.createElement(
            'span',
            { className: 'e-text-label -size-s -color-grey-light' },
            ' New'
          ) : null,
          level === 1 && react_default.a.createElement(
            'span',
            { className: pageOffLeftMenu_module_default.a.icon },
            isOpen ? react_default.a.createElement(arrowFillUp, null) : react_default.a.createElement(arrowFillDown, null)
          )
        ),
        this.hasChildren() ? react_default.a.createElement(pageOffLeftMenu_PageOffLeftMenu, {
          items: config.children,
          level: nextLevel,
          isHidden: !isOpen
        }) : null
      );
    }
  }]);

  return PageOffLeftMenuItem;
}(react_default.a.Component);

pageOffLeftMenu_PageOffLeftMenuItem.propTypes = {
  config: prop_types_default.a.object.isRequired,
  level: prop_types_default.a.number.isRequired
};


var pageOffLeftMenu_PageOffLeftMenu = function PageOffLeftMenu(_ref) {
  var items = _ref.items,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? 1 : _ref$level,
      _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === undefined ? false : _ref$isHidden;

  var className = isHidden ? 'fds-u-is-hidden' : '';
  return react_default.a.createElement(
    'ul',
    { className: className, 'data-test-selector': 'off-canvas-menu' },
    items.map(function (subConfig, index) {
      if (subConfig.divider) {
        return react_default.a.createElement('li', { key: index, className: 'off-canvas-category-spacer' });
      } else {
        return react_default.a.createElement(pageOffLeftMenu_PageOffLeftMenuItem, { key: index, config: subConfig, level: level });
      }
    })
  );
};

pageOffLeftMenu_PageOffLeftMenu.propTypes = {
  items: prop_types_default.a.array.isRequired,
  level: prop_types_default.a.number
};

/* harmony default export */ var pageOffLeftMenu = __webpack_exports__["default"] = (pageOffLeftMenu_PageOffLeftMenu);

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"pageOffLeftMenu-module_link_Gx7oW","icon":"pageOffLeftMenu-module_icon_UCnpE"};

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_searchBar_searchBarForm__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_searchBar_searchBarForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_searchBar_searchBarForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_searchBar_searchBarInput__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_searchBar_searchBarInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_searchBar_searchBarInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_search__ = __webpack_require__(36);






var PageOffLeftSearchBar = function PageOffLeftSearchBar(_ref) {
  var location = _ref.location;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'off-canvas-left__search' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__components_searchBar_searchBarForm___default.a,
      { location: location },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { margin: 0, padding: 0, display: 'inline' } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-field -border-none' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'search-field__input' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_searchBar_searchBarInput___default.a, {
            value: location.query.term,
            className: 'search-field__input-field',
            name: 'term',
            placeholder: 'Search'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'fds-c-button search-field__button', type: 'submit' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_icons_search__["default"], { title: 'search' })
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (PageOffLeftSearchBar);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-helmet/lib/Helmet.js
var Helmet = __webpack_require__(78);
var Helmet_default = /*#__PURE__*/__webpack_require__.n(Helmet);

// EXTERNAL MODULE: ./node_modules/titleize/index.js
var titleize = __webpack_require__(27);
var titleize_default = /*#__PURE__*/__webpack_require__.n(titleize);

// CONCATENATED MODULE: ./common/utils/getRSSFeeds.js


/**
 * Returns flat structure of menu items which are in feeds_categories site config.
 * @param {String} currentSite
 * @param {Array} menuConfig
 * @returns {Array}
 */
var getRSSFeeds_getRSSFeeds = function getRSSFeeds(currentSite, menuConfig, feedsCategories) {
  var getTitle = function getTitle(name) {
    return titleize_default()(currentSite) + ' new ' + name + ' items feed';
  };

  var getFeedUrl = function getFeedUrl(categoryUrl) {
    var urlSection = categoryUrl.split('/').pop();
    return '/feeds/new-' + urlSection + '-items.atom';
  };

  return feedsCategories.map(function (feedCategory) {
    // Look for a category in menu config, return title and url if found
    for (var i = 0; i < menuConfig.length; i++) {
      if (menuConfig[i].url === feedCategory) {
        return {
          title: getTitle(menuConfig[i].name),
          url: getFeedUrl(menuConfig[i].url)
        };
      }

      // Searching second level of the menu
      if (menuConfig[i].children) {
        for (var j = 0; j < menuConfig[i].children.length; j++) {
          if (menuConfig[i].children[j].url === feedCategory) {
            return {
              title: getTitle(menuConfig[i].children[j].name),
              url: getFeedUrl(menuConfig[i].children[j].url)
            };
          }
        }
      }
    }
  })
  // remove feeds which were not found in menu config
  .filter(function (item) {
    return !!item;
  })
  // Add general feed for whole site
  .concat([{
    title: titleize_default()(currentSite) + ' new items feed',
    url: '/feeds/new-' + currentSite + '-items.atom'
  }]);
};

/* harmony default export */ var utils_getRSSFeeds = (getRSSFeeds_getRSSFeeds);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(188);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(101);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(448);
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./common/utils/urlHelper.js
var urlHelper = __webpack_require__(5);

// CONCATENATED MODULE: ./common/constants/canonicalUrlAttributes.js
// https://github.com/envato/marketplace/blob/master/engines/search/app/models/search/faceting_search_service.rb#L216-L230
/* harmony default export */ var canonicalUrlAttributes = (['attribute_key', 'attribute_value', 'category', 'compatible_with', 'price_max', 'resolution_min', 'tags', 'term', 'size', 'sort', 'vocals_in_audio', 'item_id', 'page']);
// EXTERNAL MODULE: ./config/sites/categories/index.js
var categories = __webpack_require__(53);

// CONCATENATED MODULE: ./common/utils/buildCanonicalPath.js








var getTagFromPath = function getTagFromPath(path) {
  return path.split('/')[2];
};

var buildCanonicalPath_isTagAlsoACategory = function isTagAlsoACategory(currentSite, tag) {
  var siteRootCategories = categories["default"][currentSite];

  return !isEmpty_default()(find_default()(siteRootCategories, { path: tag }));
};

var isTagOnlySearch = function isTagOnlySearch(path) {
  return path.indexOf('/tags/') === 0;
};

var isLandingPage = function isLandingPage(location) {
  return location.pathname.indexOf('/free/') === 0;
};

var buildCanonicalPath = function buildCanonicalPath(currentSite, location) {
  if (isLandingPage(location)) {
    return buildCanonicalPathForLandingPage(location);
  } else {
    return buildCanonicalPath_buildCanonicalPathForSearch(currentSite, location);
  }
};

var buildCanonicalPathForLandingPage = function buildCanonicalPathForLandingPage(location) {
  return location.pathname;
};

var buildCanonicalPath_buildCanonicalPathForSearch = function buildCanonicalPathForSearch(currentSite, location) {
  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  var filteredCanonicalQueries = pick_default()(parsedLocation, canonicalUrlAttributes);
  if (filteredCanonicalQueries.page && filteredCanonicalQueries.page.toString() === '1') {
    delete filteredCanonicalQueries.page;
  }
  var canonicalPath = Object(urlHelper["makeLink"])(filteredCanonicalQueries);

  var actualPath = location.pathname;
  if (isTagOnlySearch(actualPath)) {
    var tag = getTagFromPath(actualPath);
    if (buildCanonicalPath_isTagAlsoACategory(currentSite, tag)) {
      canonicalPath = canonicalPath.replace('tags', 'category');
    }
  }
  return canonicalPath;
};

/* harmony default export */ var utils_buildCanonicalPath = (buildCanonicalPath);
// EXTERNAL MODULE: ./config/sites/index.js + 7 modules
var sites = __webpack_require__(10);

// EXTERNAL MODULE: ./config/sites/menus/index.js
var menus = __webpack_require__(117);

// CONCATENATED MODULE: ./client/components/siteMeta/siteMeta.js








/* harmony default export */ var siteMeta = __webpack_exports__["default"] = (function (_ref) {
  var seoMeta = _ref.seoMeta,
      location = _ref.location,
      currentSite = _ref.currentSite,
      noIndex = _ref.noIndex,
      baseUrl = _ref.baseUrl;

  var title = seoMeta.title || '';
  var description = seoMeta.meta_description || seoMeta.description || '';
  var siteConfig = sites["default"][currentSite];

  // Defining meta tags
  var meta = [{ name: 'description', content: description }, { property: 'og:title', content: title }, { property: 'og:description', content: description }];

  // set no index header
  if (noIndex) {
    meta.push({ name: 'robots', content: 'noindex' });
  }

  var canonicalPath = utils_buildCanonicalPath(currentSite, location);

  meta.push({ property: 'og:url', content: baseUrl + canonicalPath });
  // Defining link tags
  var link = [{ rel: 'canonical', href: baseUrl + canonicalPath }];

  // Define extra scripts
  var script = [{
    type: 'application/ld+json',
    innerHTML: '{\n        "@context": "http://schema.org",\n        "@type": "WebSite",\n        "name": "' + siteConfig.name + '",\n        "url": "' + baseUrl + '"\n      }'
  }];

  // rss feeds links
  var menuConfig = menus["default"][currentSite];
  var RSSFeeds = utils_getRSSFeeds(currentSite, menuConfig, siteConfig.feeds_categories || []);
  if (RSSFeeds.length) {
    RSSFeeds.forEach(function (feed) {
      link.push({
        rel: 'alternate',
        type: 'application/atom+xml',
        href: feed.url,
        title: feed.title
      });
    });
  }

  return react_default.a.createElement(Helmet_default.a, {
    title: title,
    defaultTitle: 'Envato Market',
    meta: meta,
    link: link,
    script: script
  });
});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var OldIE = /** @class */ (function (_super) {
    __extends(OldIE, _super);
    function OldIE(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isIE10: false
        };
        return _this;
    }
    OldIE.prototype.componentDidMount = function () {
        var isIE10 = /MSIE 10/.test(navigator.userAgent);
        this.setState({
            isIE10: isIE10
        });
    };
    OldIE.prototype.render = function () {
        var siteName = this.props.siteName;
        var isIE10 = this.state.isIE10;
        return (React.createElement("div", null,
            isIE10 && (React.createElement("div", { dangerouslySetInnerHTML: {
                    __html: this.renderIE10String(siteName)
                } })),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: this.renderIE9String(siteName) } })));
    };
    OldIE.prototype.renderIE9String = function (siteName) {
        return "\n        <!--[if lte IE 9]>\n          <div class=\"alert-ie\">\n            " + siteName + ".net no longer actively supports this version of Internet Explorer. We suggest that you <a href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\">upgrade to a newer version</a> or <a href=\"http://browsehappy.com/\">try a different browser</a>.\n          </div>\n        <![endif]-->\n      ";
    };
    OldIE.prototype.renderIE10String = function (siteName) {
        return "\n        <div class=\"alert-ie\">\n          " + siteName + ".net no longer actively supports this version of Internet Explorer. We suggest that you <a href=\"http://windows.microsoft.com/en-us/internet-explorer/download-ie\">upgrade to a newer version</a> or <a href=\"http://browsehappy.com/\">try a different browser</a>.\n        </div>\n      ";
    };
    return OldIE;
}(React.Component));
exports.default = OldIE;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(97);
var PROPS = ['am-grid', 'am-grid-col', 'am-grid-row'];
/*
 React removes custom attributes from DOM and current design depend on am-grid-col and amd-grid-row attributes.
 The only way to add those is to do it directly on DOM after component mounted. That's why we need this component.
 It allows to set AmGrid custom attributes.
 */
var AmGrid = /** @class */ (function (_super) {
    __extends(AmGrid, _super);
    function AmGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AmGrid.prototype.componentDidMount = function () {
        var _this = this;
        var dom = react_dom_1.findDOMNode(this);
        PROPS.forEach(function (attributeName) {
            if (typeof _this.props[attributeName] !== 'undefined') {
                dom.setAttribute(attributeName, _this.props[attributeName]);
            }
        });
    };
    AmGrid.prototype.render = function () {
        return React.createElement("div", { className: this.props.className }, this.props.children);
    };
    return AmGrid;
}(React.Component));
exports.default = AmGrid;


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./client/pages/errorPage.js


var errorPage_ErrorPage = function ErrorPage(_ref) {
  var title = _ref.title,
      children = _ref.children;

  return react_default.a.createElement(
    "section",
    { className: "page-section" },
    react_default.a.createElement(
      "div",
      { className: "grid-container" },
      react_default.a.createElement(
        "header",
        { className: "fds-u-text-align-center" },
        react_default.a.createElement(
          "h1",
          { className: "fds-c-text-heading -size-xxl" },
          title
        ),
        children
      )
    )
  );
};

/* harmony default export */ var errorPage = (errorPage_ErrorPage);
// CONCATENATED MODULE: ./client/pages/searchOfflinePage.js




/* harmony default export */ var searchOfflinePage = __webpack_exports__["default"] = (function (_ref) {
  var popularFilesUrl = _ref.popularFilesUrl,
      siteDisplayName = _ref.siteDisplayName;
  return react_default.a.createElement(
    errorPage,
    { title: 'Search is unavailable' },
    react_default.a.createElement(
      'p',
      { className: 'fds-c-text-body -size-xl' },
      '...but don\'t worry, you can still discover.',
      react_default.a.createElement('br', null),
      'We are working hard to fix this. Meanwhile you can',
      react_default.a.createElement('br', null),
      react_default.a.createElement('br', null),
      '- Browse',
      ' ',
      react_default.a.createElement(
        'a',
        { className: 'fds-c-text-link -decoration-none', href: popularFilesUrl },
        'popular files'
      ),
      ' ',
      'in ',
      siteDisplayName,
      react_default.a.createElement('br', null),
      '-',
      ' ',
      react_default.a.createElement(
        'a',
        {
          className: 'fds-c-text-link -decoration-none',
          href: 'javascript:history.back()'
        },
        ' ',
        'Go Back'
      ),
      ' ',
      'to where you were before',
      react_default.a.createElement('br', null),
      '- Try search again in few mintures'
    )
  );
});

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerWrapper":"app-module_headerWrapper_263qC","headerCategoriesWrapper":"app-module_headerCategoriesWrapper_1zqtN","headerCategories":"app-module_headerCategories_1YSeA","gridWide":"app-module_gridWide_2MZSC","contentSection":"app-module_contentSection_9jznX"};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./client/components/icons/search.js
var search = __webpack_require__(36);

// CONCATENATED MODULE: ./client/components/autosuggest/highlightSearchTerm.js
/* harmony default export */ var highlightSearchTerm = (function (suggestionText, term, styles) {
  return suggestionText.split(term).map(function (match) {
    return "<span class='" + styles.highlightedText + "'>" + match + "</span>";
  }).join("<span>" + term + "</span>");
});
// CONCATENATED MODULE: ./client/components/autosuggest/suggestionsListItem.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var suggestionsListItem_SuggestionsListItem = function SuggestionsListItem(props) {
  var _classNames;

  var styles = props.styles,
      focusedIndex = props.focusedIndex,
      inputValue = props.inputValue,
      onMenuClick = props.onMenuClick,
      handleMenuMouseEnter = props.handleMenuMouseEnter,
      handleMenuMouseLeave = props.handleMenuMouseLeave,
      index = props.index,
      suggestion = props.suggestion,
      showSeparator = props.showSeparator;


  return react_default.a.createElement(
    'li',
    {
      className: classnames_default()(styles.listItem, (_classNames = {}, _defineProperty(_classNames, styles.focusedListItem, focusedIndex === index), _defineProperty(_classNames, styles.separator, showSeparator), _classNames)),
      onMouseDown: function onMouseDown(event) {
        return onMenuClick(suggestion, event);
      },
      onMouseEnter: function onMouseEnter() {
        return handleMenuMouseEnter(index);
      },
      onMouseLeave: function onMouseLeave() {
        return handleMenuMouseLeave(index);
      }
    },
    react_default.a.createElement(
      'a',
      {
        className: 'fds-c-text-link -color-dark -decoration-none',
        href: suggestion.link
      },
      react_default.a.createElement(
        'span',
        { className: classnames_default()(styles.suggestionText, 'h-text-truncate') },
        react_default.a.createElement('span', {
          dangerouslySetInnerHTML: {
            __html: highlightSearchTerm(suggestion.text, inputValue.trim(), styles)
          }
        }),
        suggestion.category && react_default.a.createElement(
          'span',
          {
            className: classnames_default()(styles.categoryText, 'h-text-truncate')
          },
          'in ',
          suggestion.category
        )
      )
    )
  );
};

suggestionsListItem_SuggestionsListItem.propTypes = {
  suggestion: prop_types_default.a.object,
  styles: prop_types_default.a.object,
  focusedIndex: prop_types_default.a.number,
  inputValue: prop_types_default.a.string,
  onMenuClick: prop_types_default.a.func,
  handleMenuMouseEnter: prop_types_default.a.func,
  handleMenuMouseLeave: prop_types_default.a.func,
  index: prop_types_default.a.number,
  showSeparator: prop_types_default.a.bool
};

/* harmony default export */ var suggestionsListItem = (suggestionsListItem_SuggestionsListItem);
// CONCATENATED MODULE: ./client/components/autosuggest/suggestionsList.js





var suggestionsList_SuggestionsList = function SuggestionsList(props) {
  var suggestions = props.suggestions,
      styles = props.styles,
      focusedIndex = props.focusedIndex,
      inputValue = props.inputValue,
      textInputRef = props.textInputRef,
      wrapperRef = props.wrapperRef,
      setMenuRef = props.setMenuRef,
      onMenuClick = props.onMenuClick,
      handleMenuMouseEnter = props.handleMenuMouseEnter,
      handleMenuMouseLeave = props.handleMenuMouseLeave;
  /**
   * Hack inline style :magic:
   */

  var wrapperStyle = {
    position: 'absolute',
    top: textInputRef.clientHeight,
    width: wrapperRef.clientWidth
  };

  return react_default.a.createElement(
    'div',
    { className: styles.wrapper, style: wrapperStyle },
    react_default.a.createElement(
      'section',
      { ref: setMenuRef, className: styles.suggestions },
      react_default.a.createElement(
        'ul',
        { className: 'fds-c-text-list -style-none' },
        suggestions.map(function (suggestion, index) {
          var showSeparator = false;
          if (index > 0 && suggestions[index - 1].type !== suggestions[index].type) {
            showSeparator = true;
          }

          return react_default.a.createElement(suggestionsListItem, {
            styles: styles,
            focusedIndex: focusedIndex,
            inputValue: inputValue,
            onMenuClick: onMenuClick,
            handleMenuMouseLeave: handleMenuMouseLeave,
            handleMenuMouseEnter: handleMenuMouseEnter,
            key: index,
            suggestion: suggestion,
            index: index,
            showSeparator: showSeparator
          });
        })
      )
    )
  );
};

suggestionsList_SuggestionsList.propTypes = {
  suggestions: prop_types_default.a.array,
  styles: prop_types_default.a.object,
  focusedIndex: prop_types_default.a.number,
  inputValue: prop_types_default.a.string,
  textInputRef: prop_types_default.a.object,
  wrapperRef: prop_types_default.a.object,
  setMenuRef: prop_types_default.a.func,
  onMenuClick: prop_types_default.a.func,
  handleMenuMouseEnter: prop_types_default.a.func,
  handleMenuMouseLeave: prop_types_default.a.func,
  showCategories: prop_types_default.a.bool
};

/* harmony default export */ var suggestionsList = (suggestionsList_SuggestionsList);
// CONCATENATED MODULE: ./client/components/autosuggest/autosuggest.js







var autosuggest_AutoSuggest = function AutoSuggest(props) {
  var isOpen = props.isOpen,
      inputValue = props.inputValue,
      currentSite = props.currentSite,
      suggestions = props.suggestions,
      inputName = props.inputName,
      placeholder = props.placeholder,
      type = props.type,
      ariaLabel = props.ariaLabel,
      styles = props.styles,
      setWrapperRef = props.setWrapperRef,
      setTextInputRef = props.setTextInputRef,
      handleInputChange = props.handleInputChange,
      handleInputFocus = props.handleInputFocus,
      handleKeyDown = props.handleKeyDown,
      handleKeyUp = props.handleKeyUp,
      focusedIndex = props.focusedIndex,
      textInputRef = props.textInputRef,
      wrapperRef = props.wrapperRef,
      setMenuRef = props.setMenuRef,
      onMenuClick = props.onMenuClick,
      handleMenuMouseEnter = props.handleMenuMouseEnter,
      handleMenuMouseLeave = props.handleMenuMouseLeave;


  var inputStyle = {
    borderRadius: isOpen && suggestions.length ? '7px 0 0 0' : '7px 0 0 7px'
  };

  var buttonStyle = {
    borderRadius: isOpen && suggestions.length ? '0 7px 0 0' : '0 7px 7px 0'
  };

  return react_default.a.createElement(
    'div',
    {
      ref: setWrapperRef,
      className: styles.mainWrapper,
      'data-test-selector': 'autosuggest'
    },
    react_default.a.createElement('input', {
      ref: setTextInputRef,
      className: styles.input,
      style: inputStyle,
      placeholder: placeholder || '',
      autoComplete: 'off',
      type: type || 'search',
      'aria-label': ariaLabel || 'search',
      name: inputName || '',
      value: inputValue,
      onChange: handleInputChange,
      onFocus: handleInputFocus,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp
    }),
    react_default.a.createElement(
      'button',
      {
        className: classnames_default()(styles.button, styles['-theme-' + currentSite]),
        style: buttonStyle,
        defaultValue: 'Submit'
      },
      react_default.a.createElement(search["default"], null)
    ),
    isOpen && inputValue && suggestions && suggestions.length > 0 && react_default.a.createElement(suggestionsList, {
      suggestions: suggestions,
      styles: styles,
      focusedIndex: focusedIndex,
      inputValue: inputValue,
      textInputRef: textInputRef,
      wrapperRef: wrapperRef,
      setMenuRef: setMenuRef,
      onMenuClick: onMenuClick,
      handleMenuMouseEnter: handleMenuMouseEnter,
      handleMenuMouseLeave: handleMenuMouseLeave
    })
  );
};

autosuggest_AutoSuggest.propTypes = {
  suggestions: prop_types_default.a.array.isRequired,
  onInputChange: prop_types_default.a.func.isRequired,
  placeholder: prop_types_default.a.string,
  onSelectOption: prop_types_default.a.func.isRequired,
  inputName: prop_types_default.a.string,
  inputValue: prop_types_default.a.string.isRequired,
  styles: prop_types_default.a.object.isRequired,
  currentSite: prop_types_default.a.string
};

/* harmony default export */ var autosuggest = __webpack_exports__["default"] = (autosuggest_AutoSuggest);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var localStorageHelpers_1 = __webpack_require__(43);
var urlHelper_1 = __webpack_require__(5);
var RecentSearch = /** @class */ (function () {
    function RecentSearch() {
    }
    RecentSearch.addItem = function (item) {
        var recentSearch = localStorageHelpers_1.getLocalStorageItem(RecentSearch.RECENT_SEARCH, []);
        RecentSearch.updateRecentSearch(recentSearch, item);
    };
    RecentSearch.getRecentSearch = function () {
        var recentSearch = localStorageHelpers_1.getLocalStorageItem(RecentSearch.RECENT_SEARCH, []);
        return recentSearch.map(function (item) { return RecentSearch.createSuggestion(item); });
    };
    RecentSearch.updateRecentSearch = function (recentSearch, item) {
        if (recentSearch.includes(item)) {
            RecentSearch.bringItemToFront(recentSearch, item);
        }
        else {
            RecentSearch.ensureItemCount(recentSearch, RecentSearch.MAX_COUNT - 1);
            recentSearch.unshift(item);
        }
        localStorageHelpers_1.setLocalStorageItem(RecentSearch.RECENT_SEARCH, recentSearch);
    };
    RecentSearch.bringItemToFront = function (recentSearch, item) {
        var itemIndex = recentSearch.indexOf(item);
        recentSearch.splice(itemIndex, 1);
        recentSearch.unshift(item);
    };
    RecentSearch.ensureItemCount = function (recentSearch, maxCount) {
        if (recentSearch.length > maxCount) {
            recentSearch.pop();
        }
    };
    RecentSearch.createSuggestion = function (item) {
        var nextQueries = __assign({}, urlHelper_1.parseLocation(location), { term: item });
        var link = urlHelper_1.makeLink(nextQueries);
        return {
            link: link,
            text: item,
        };
    };
    RecentSearch.RECENT_SEARCH = 'recentSearch';
    RecentSearch.MAX_COUNT = 5;
    return RecentSearch;
}());
exports.default = RecentSearch;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var cx = __webpack_require__(7);
var React = __webpack_require__(0);
var SearchHeader = function (_a) {
    var currentSite = _a.currentSite, children = _a.children, _b = _a.styles, styles = _b === void 0 ? {} : _b;
    var pageSectionClassNames = cx(styles.pageSection, 'page-section', '-size-xcompact', "-theme-" + (currentSite || 'themeforest'));
    return (React.createElement("div", { id: "search-header" },
        React.createElement("div", { className: pageSectionClassNames },
            React.createElement("div", { className: cx(styles.pageSectionContent, 'page-section__content') },
                React.createElement("div", { className: cx(styles.pageSectionBackground, 'page-section__background') }),
                React.createElement("div", { className: cx(styles.pageSectionForm, 'search-header__form-wrapper') }, children)))));
};
exports.default = SearchHeader;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var xss = __webpack_require__(452);
var SafeInnerHtml = function (_a) {
    var html = _a.html;
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: xss(html) } });
};
exports.default = SafeInnerHtml;


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usDollarsNotice_usDollarsNoticeContainer__ = __webpack_require__(63);





var Magnifier = function Magnifier(_ref) {
  var item = _ref.item,
      width = _ref.width,
      height = _ref.height,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'magnifier', style: { width: width } },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'size-limiter', style: { height: height } },
      children
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'strong',
      null,
      item.name
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'info' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'author-category' },
        'by ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'author' },
          item.author_username
        )
      ),
      item.ui.price ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'price' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'cost' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'sup',
            null,
            '$'
          ),
          item.ui.price
        ),
        item.ui.pricePeriod && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'price-period' },
          '/',
          item.ui.pricePeriod,
          '*'
        )
      ) : null
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'footer' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'category' },
        item.ui.formattedClassification
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__usDollarsNotice_usDollarsNoticeContainer__["default"], { styleClassName: 'gst-notice' })
    )
  );
};

Magnifier.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["default"] = (Magnifier);

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var pageSection_1 = __webpack_require__(467);
exports.default = pageSection_1.default;


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_seoHeadings_seoHeadings__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_seoHeadings_seoHeadings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_seoHeadings_seoHeadings__);





var ResultsInfo = function ResultsInfo(_ref) {
  var location = _ref.location,
      seoMeta = _ref.seoMeta,
      styles = _ref.styles,
      TagName = _ref.TagName;

  var parsedLocation = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils_urlHelper__["parseLocation"])(location);
  var shouldShowSubheading = (!parsedLocation.page || parsedLocation.page && parsedLocation.page === '1') && seoMeta.subHeading;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_seoHeadings_seoHeadings___default.a, {
    TagName: TagName,
    heading: seoMeta.heading,
    subHeading: shouldShowSubheading && seoMeta.subHeading,
    finePrint: seoMeta.finePrint,
    styles: styles
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ResultsInfo);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(6);

// EXTERNAL MODULE: ./common/utils/urlHelper.js
var urlHelper = __webpack_require__(5);

// CONCATENATED MODULE: ./client/components/searchHeader/didYouMeanBy.js





var didYouMeanBy_DidYouMeanBy = function DidYouMeanBy(_ref) {
  var location = _ref.location,
      didYouMeanByTerms = _ref.didYouMeanByTerms,
      styles = _ref.styles;

  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  return react_default.a.createElement(
    'p',
    { className: styles.didYouMeanText },
    react_default.a.createElement(
      'strong',
      null,
      'Did you mean: '
    ),
    didYouMeanByTerms.map(function (term, index) {
      var nextQuery = Object.assign({}, parsedLocation, {
        term: term
      });
      return react_default.a.createElement(
        'span',
        { key: index },
        react_default.a.createElement(
          es["Link"],
          { to: Object(urlHelper["makeLink"])(nextQuery), className: styles.didYouMeanLink },
          term
        ),
        index < didYouMeanByTerms.length - 1 ? ', ' : null
      );
    }),
    '?'
  );
};

/* harmony default export */ var didYouMeanBy = (didYouMeanBy_DidYouMeanBy);
// CONCATENATED MODULE: ./client/components/searchHeader/authorSuggestions.js


var authorSuggestions_AuthorSuggestions = function AuthorSuggestions(_ref) {
  var authorSuggestion = _ref.authorSuggestion,
      styles = _ref.styles;
  return react_default.a.createElement(
    'p',
    { className: styles.authorText },
    'We found an author by that name: ',
    authorSuggestion ? react_default.a.createElement(
      'a',
      { className: styles.authorLink, href: authorSuggestion.url },
      authorSuggestion.username
    ) : null
  );
};

/* harmony default export */ var authorSuggestions = (authorSuggestions_AuthorSuggestions);
// CONCATENATED MODULE: ./client/components/searchHeader/suggestions.js





var suggestions_Suggestions = function Suggestions(props) {
  var didYouMeanByTerms = props.didYouMeanByTerms,
      authorSuggestion = props.authorSuggestion,
      styles = props.styles;


  return react_default.a.createElement(
    'div',
    { className: styles.suggestionsContainer },
    authorSuggestion ? react_default.a.createElement(authorSuggestions, props) : null,
    didYouMeanByTerms.length ? react_default.a.createElement(didYouMeanBy, props) : null
  );
};

/* harmony default export */ var suggestions = __webpack_exports__["default"] = (suggestions_Suggestions);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["default"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Grid' },
      props.title || 'Grid'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M2.1 0h114.3v114.3h-114.3zM200.1 0h114.3v114.3h-114.3zM397.7 0h114.3v114.3h-114.3zM2.1 197.8h114.3v114.3h-114.3zM200.1 197.8h114.3v114.3h-114.3zM397.7 197.8h114.3v114.3h-114.3zM2.1 396.7h114.3v114.3h-114.3zM200.1 396.7h114.3v114.3h-114.3zM397.7 396.7h114.3v114.3h-114.3z' })
    )
  );
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["default"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'List' },
      props.title || 'List'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M2.1 0h114.3v114.3h-114.3zM200.1 0h311.9v114.3h-311.9zM2.1 197.8h114.3v114.3h-114.3zM200.1 197.8h311.9v114.3h-311.9zM2.1 396.7h114.3v114.3h-114.3zM200.1 396.7h311.9v114.3h-311.9z' })
    )
  );
});

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"trending":"trendingSash-module_trending_3oQJK"};

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"defaultTheme":"itemActions-module_defaultTheme_z7_4l","transparentTheme":"itemActions-module_transparentTheme_3RlPJ","actionsContainer":"itemActions-module_actionsContainer_3Aqtb","action":"itemActions-module_action_ynHWV","active":"itemActions-module_active_2lLlY","icon":"itemActions-module_icon_-ugTk","nonAudioTheme":"itemActions-module_nonAudioTheme_HBeE4"};

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spaceBetween":"audioPlayerLarge-module_spaceBetween_3oGwP","waveformContainer":"audioPlayerLarge-module_waveformContainer_HJ29_","timeContainer":"audioPlayerLarge-module_timeContainer_1jKIW","icon":"audioPlayerLarge-module_icon_M7BxM","spinningIcon":"audioPlayerLarge-module_spinningIcon_F84JX audioPlayerLarge-module_icon_M7BxM","spin":"audioPlayerLarge-module_spin_21SFC"};

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"listAudio-module_container_GGAn2","itemDescription":"listAudio-module_itemDescription_2Menn","flexColumn":"listAudio-module_flexColumn_3pmRv","spaceBetween":"listAudio-module_spaceBetween_10AmB","meta":"listAudio-module_meta_2fW6R listAudio-module_spaceBetween_10AmB","itemSummary":"listAudio-module_itemSummary_14l41","thumbnail":"listAudio-module_thumbnail_1KJCs"};

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"audioPlayerSmall-module_container_16wYs","playButton":"audioPlayerSmall-module_playButton_37F_g","progressBarContainer":"audioPlayerSmall-module_progressBarContainer_3wq89","progressBar":"audioPlayerSmall-module_progressBar_279tw","icon":"audioPlayerSmall-module_icon_2OfgP","whiteIcon":"audioPlayerSmall-module_whiteIcon_3_GER audioPlayerSmall-module_icon_2OfgP","spinningIcon":"audioPlayerSmall-module_spinningIcon_32ro5 audioPlayerSmall-module_icon_2OfgP","spin":"audioPlayerSmall-module_spin_2kbrQ"};

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"itemView":"gridAudio-module_itemView_11GKV","itemName":"gridAudio-module_itemName_16nQO","actionContainer":"gridAudio-module_actionContainer_1g0Fx","footer":"gridAudio-module_footer_mrlFK","thumbnail":"gridAudio-module_thumbnail_zGLL3","miniAudioPlayerContainer":"gridAudio-module_miniAudioPlayerContainer_5Od3E"};

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"gridVideo-module_container_1_IOL","videoContainer":"gridVideo-module_videoContainer_24Vwl","videoLink":"gridVideo-module_videoLink_1Bqu4","video":"gridVideo-module_video_350t8","overlay":"gridVideo-module_overlay_1gzeX","itemActions":"gridVideo-module_itemActions_27pvf","titleContainer":"gridVideo-module_titleContainer_4p3d9","title":"gridVideo-module_title_27qO4","meta":"gridVideo-module_meta_1WKWO","price":"gridVideo-module_price_wYGD3","duration":"gridVideo-module_duration_2lmj6"};

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grid":"gridVideo-module_grid_1GL6j","result":"gridVideo-module_result__y9fZ"};

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"experimentContainer":"index-module_experimentContainer_31LmU","preloaderOverlay":"index-module_preloaderOverlay_H52Vf"};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var preloader_1 = __webpack_require__(301);
exports.default = preloader_1.default;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var _1 = __webpack_require__(64);
var styles = __webpack_require__(302);
var Preloader = function () {
    return (React.createElement("div", { className: styles.loading },
        React.createElement(_1.default, { width: "50", height: "50", strokeColor: "hsl(0, 0%, 66%)" })));
};
exports.default = Preloader;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loading":"preloader-module_loading_2_X14"};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"relatedSearches-module_root_344P1","title":"relatedSearches-module_title_1I--y","bold":"relatedSearches-module_bold_17U36","list":"relatedSearches-module_list_VsSmJ","listItem":"relatedSearches-module_listItem_1KfB7","link":"relatedSearches-module_link_3mcSW"};

/***/ }),
/* 304 */,
/* 305 */
/***/ (function(module, exports) {

module.exports = [{"match":"cg-textures","title":"More Textures","content":"The CG textures you'll find here are made specifically for 3d. If you just need flat, tiled textures, be sure to check out the <a href=\"https://graphicriver.net/category/textures\">textures category</a> on GraphicRiver. ","button_label":"Browse Textures","icon_source":"photo_v4.png","link":"https://3docean.net/category/cg-textures"}]

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = [{"match":"sound","title":"Making a Mobile App?","content":"Find some great SFX for your new game or app?  Be sure to check out our <a href=\"https://codecanyon.net/category/mobile\">Android and iOS mobile templates</a> over on CodeCanyon as well. ","button_label":"Browse Mobile Templates","icon_source":"robot_v1.png","link":"https://codecanyon.net/category/mobile"},{"match":["logos-idents","music","music-packs"],"title":"Media Players","content":"Embed music and videos directly into your website with these cutting-edge <a href=\"https://codecanyon.net/category/html5/media\">HTML5 media players</a> on CodeCanyon. ","button_label":"Browse Media Players","icon_source":"games_v1.png","link":"https://codecanyon.net/category/html5/media"}]

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = [{"match":"javascript","title":"Web Graphics","content":"Like the scripts you see here, but don't love the look? Check out all the <a href=\"https://graphicriver.net/category/web-elements\">web graphics</a> on GraphicRiver.","button_label":"Browse Graphics","icon_source":null,"link":"https://graphicriver.net/category/web-elements"},{"match":"mobile","title":"Mobile Themes","content":"Be sure to check out all our <a href=\"https://themeforest.net/category/site-templates/mobile\">premium mobile themes</a> on ThemeForest.","button_label":"Browse Mobile Themes","icon_source":"wordpress.png","link":"https://themeforest.net/category/site-templates/mobile"},{"match":"plugins/magento-extensions","title":"Magento Themes","content":"Be sure to check out all our <a href=\"https://themeforest.net/category/ecommerce/magento\">premium Magento themes</a> on ThemeForest.","button_label":"Browse Magento Themes","icon_source":"magneto-4d6853a18507111dc928627d1a4c1032.png","link":"https://themeforest.net/category/ecommerce/magento"},{"match":"plugins/opencart","title":"OpenCart Themes","content":"Showcase your products in style with beautifully designed <a href=\"https://themeforest.net/category/ecommerce/opencart\">OpenCart themes</a> from ThemeForest. ","button_label":"Browse Themes","link":"https://themeforest.net/category/ecommerce/opencart"},{"match":"plugins/prestashop","title":"PrestaShop Themes","content":"Browse professionally designed <a href=\"https://themeforest.net/category/ecommerce/prestashop\">PrestaShop themes</a>, designed for functionality and conversion. ","button_label":"Browse Themes","link":"https://themeforest.net/category/ecommerce/prestashop"},{"match":"wordpress/ecommerce","title":"eCommerce WordPress Themes","content":"Turn your site into an online store with <a href=\"https://themeforest.net/category/wordpress/ecommerce\">eCommerce compatible WordPress themes</a> from ThemeForest. ","button_label":"Browse Themes","link":"https://themeforest.net/category/wordpress/ecommerce"},{"match":"wordpress/ecommerce/woocommerce","title":"WooCommerce WordPress Themes","content":"Create multi-functional WooCommerce websites using <a href=\"https://themeforest.net/category/wordpress/ecommerce/woocommerce\">WooCommerce compatible themes</a> from ThemeForest. ","button_label":"Browse Themes","link":"https://themeforest.net/category/wordpress/ecommerce/woocommerce"}]

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = [{"match":"graphics","title":"Customize your graphics","content":"Have an Envato Studio expert customize your graphics, starting from&nbsp;$20.","button_label":"Customize Now","icon_source":"envato-studio.png","link":"https://studio.envato.com/explore/customize-graphics?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=CustomizeGraphics"},{"match":"print-templates/newsletters","title":"Get your copy right","content":"Hire a professional Copywriter on Envato Studio to create engaging content to share with your&nbsp;customers.","button_label":"Find Copywriters","icon_source":"envato-studio.png","link":"https://studio.envato.com/explore/copywriting?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=GetYourCopyRight"},{"match":"print-templates/stationery/resumes","title":"Improve your resume","content":"Hire an expert Copywriter on Envato Studio to craft the perfect resume for&nbsp;you.","button_label":"Find Copywriters","icon_source":"envato-studio.png","link":"https://studio.envato.com/explore/resumes-cover-letters?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=ImproveYourResume"},{"match":"logo-templates","title":"Animate your logo","content":"Have an Envato Studio expert animate your logo and bring your brand to&nbsp;life.","button_label":"Get Animated","icon_source":"envato-studio.png","link":"https://studio.envato.com/explore/logo-animation?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=AnimateYourLogo"},{"match":"graphics/3d-renders","title":"Need 3D Models?","content":"If you need more than the layered 3D renders we sell right here, check out the thousands of <a href=\"https://3docean.net/category/3d-models\">stock 3D models</a> on our sister site, <a href=\"https://3docean.net/\">3dOcean</a>. ","button_label":"Browse 3D Models","icon_source":"3d.png","link":"https://3docean.net/category/3d-models"},{"match":"presentation-templates","title":"Hello World","content":"If you want your <a href=\"https://graphicriver.net/category/presentation-templates/keynote-templates\">Keynote</a> or <a href=\"https://graphicriver.net/category/presentation-templates/powerpoint-templates\">Powerpoint presentation templates</a> to really stand out, you need the <a href=\"https://audiojungle.net/category/music\">right music</a>, which you can find on <a href=\"https://audiojungle.net\">AudioJungle</a>.","button_label":"Browse Stock Music","icon_source":"audio_v2.png","link":"https://audiojungle.net/category/logos-idents"},{"match":"web-elements","title":"Full CSS","content":"If rather than just buying the web element graphics, you'd prefer it to be fully functional, be sure to check out the CSS category on CodeCanyon.","button_label":"Browse CSS","icon_source":"code_2.png","link":"https://codecanyon.net/category/css"}]

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = []

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = [{"match":"ecommerce","title":"eCommerce Plugins","content":"Add more features to your WordPress store with premium <a href=\"https://codecanyon.net/category/wordpress/ecommerce\">eCommerce plugins for WordPress</a>. ","button_label":"Browse Plugins","link":"https://codecanyon.net/category/wordpress/ecommerce"},{"match":"ecommerce/prestashop","title":"PrestaShop Modules","content":"Add more features to your PrestaShop store with premium <a href=\"https://codecanyon.net/category/plugins/prestashop\">PrestaShop modules</a> and Addons. ","button_label":"Browse Modules","link":"https://codecanyon.net/category/plugins/prestashop"},{"match":"ecommerce/opencart","title":"OpenCart Extensions","content":"Add more features to your OpenCart store with premium <a href=\"https://codecanyon.net/category/plugins/opencart\">OpenCart extensions</a>. ","button_label":"Browse Extensions","link":"https://codecanyon.net/category/plugins/opencart"},{"match":"ecommerce/magento","title":"Magento Plugins","content":"Once you've found the perfect Magento theme for your store, be sure to enhance it with <a href=\"https://codecanyon.net/category/plugins/magento-extensions\">premium Magento plugins on CodeCanyon</a>. ","button_label":"Browse Magento Plugins","icon_source":"magneto.png","link":"https://codecanyon.net/category/plugins/magento-extensions"},{"match":"marketing","title":"Web Elements","content":"Need some marketing-related graphics to go along with your marketing template? If so, check out the <a href=\"https://graphicriver.net/category/web-elements\">web elements</a> on GraphicRiver.","button_label":"Browse Web Elements","icon_source":"learn_v1.png","link":"https://graphicriver.net/category/web-elements"},{"match":"psd-templates","title":"Full HTML Templates","content":"If you'are looking for a fully functional web template, rather than just a PSD, check out the <a href=\"https://themeforest.net/category/site-templates\">Site Templates</a> category on ThemeForest. ","button_label":"Browse Site Templates","icon_source":"learn_v1.png","link":"https://themeforest.net/category/site-templates"},{"match":"wordpress","title":"Learn how to use WordPress","content":"Check out our <a href=\"https://webdesign.tutsplus.com/courses/a-beginners-guide-to-using-wordpress?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_FreeWPCourse\">beginner's guide to WordPress</a> on Tuts+. You will learn how to to install WordPress, customise your theme and much more.","button_label":"Start Free Course","icon_source":"envato-tuts-black.png","link":"https://webdesign.tutsplus.com/courses/a-beginners-guide-to-using-wordpress?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_FreeWPCourse"},{"match":"wordpress","title":"Get your theme installed","content":"Hire an expert to install your WordPress theme for you, starting from $50 on Envato Studio.","button_label":"Install Theme Now","icon_source":"envato-studio.png","link":"https://studio.envato.com/themeforest-installation?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_WPInstall"},{"match":"wordpress/ecommerce","title":"WordPress Plugins","content":"Add powerful features to your online shop with thousands of unique <a href=\"https://codecanyon.net/category/wordpress\">WordPress plugins</a> on CodeCanyon. ","button_label":"Browse Plugins","link":"https://codecanyon.net/category/wordpress"},{"match":"wordpress/ecommerce/woocommerce","title":"WooCommerce Plugins","content":"Add more features to your WooCommerce store with premium <a href=\"https://codecanyon.net/category/wordpress/ecommerce/woocommerce\">WooCommerce plugins</a>. ","button_label":"Browse Plugins","link":"https://codecanyon.net/category/wordpress/ecommerce/woocommerce"}]

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = [{"match":"after-effects-project-files","title":"Need Music?","content":"What good is an AE Project if it doesn't have the perfect music to go along with it? Find <a href=\"https://audiojungle.net/category/music\">beautiful stock music</a> on AudioJungle.","button_label":"Browse Stock Music","icon_source":"audio_v2.png","link":"https://audiojungle.net/category/music"},{"match":"motion-graphics","title":"Need Sound Effects?","content":"What good is a video if it doesn't have the perfect sound effects to go along with it? Find <a href=\"https://audiojungle.net/category/sound\">amazing stock sound effects</a> on AudioJungle.","button_label":"Browse Sound Effects","icon_source":"audio_v2.png","link":"https://audiojungle.net/category/music"},{"match":"cinema-4d-templates","title":"Need C4D Models?","content":"Need 3D models to go along with your Cinema 4D templates? If so, check out all the <a href=\"https://3docean.net/attributes/created-in/cinema%204d%20r10\">amazing C4D models</a> on 3dOcean. ","button_label":"Browse C4D Models","icon_source":"3d.png","link":"https://3docean.net/attributes/created-in/cinema%204d%20r10"},{"match":"stock-footage","title":"Need Music?","content":"What good is a video if it doesn't have the perfect music to go along with it? Find <a href=\"https://audiojungle.net/category/music\">beautiful stock music</a> on AudioJungle.","button_label":"Browse Stock Music","icon_source":"audio_v1.png","link":"https://audiojungle.net/category/music"},{"match":"after-effects-project-files/logo-stings","title":"Audio Logo/Idents","content":"Find the perfect audio Logo/Ident for your Logo Sting in our dedicated <nobr>Logos & Idents</nobr> category on AudioJungle.","button_label":"Browse Audio Idents","icon_source":"games_v1.png","link":"https://audiojungle.net/category/logos-idents"}]

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./common/utils/user.js
var utils_user = __webpack_require__(47);

// EXTERNAL MODULE: ./common/utils/auth.js
var auth = __webpack_require__(122);

// EXTERNAL MODULE: ./common/actions/user/cart.js
var cart = __webpack_require__(91);

// EXTERNAL MODULE: ./common/config.ts
var config = __webpack_require__(12);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./common/utils/bootIntercom.js


var intercomAppId = config["config"].analytics.intercom.APP_ID;

/* harmony default export */ var bootIntercom = ({
  boot: function boot(user) {
    if (window.Intercom) {
      if (!user) {
        window.Intercom('boot', {
          app_id: intercomAppId
        });
      } else {
        window.Intercom('boot', {
          app_id: intercomAppId,
          email: user.profile.email,
          user_id: user.profile.envato_id,
          user_hash: user.misc.intercom_user_hash,
          created_at: user.profile.created_at
        });
      }
    }
  }
});
// EXTERNAL MODULE: ./common/utils/errors.js + 4 modules
var errors = __webpack_require__(8);

// EXTERNAL MODULE: ./common/analytics/userAnalytics.js
var userAnalytics = __webpack_require__(38);

// EXTERNAL MODULE: ./common/actions/user/session.js
var session = __webpack_require__(73);

// CONCATENATED MODULE: ./common/actions/user/profile.js
/**
 * Get user profile actions
 */
var getUserRequestAction = function getUserRequestAction() {
  return { type: 'getUserRequest' };
};
var getUserSuccessAction = function getUserSuccessAction(user) {
  return {
    type: 'getUserSuccess',
    payload: user
  };
};
var getUserFailureAction = function getUserFailureAction() {
  return { type: 'getUserFailure' };
};

var getGuestUserAction = function getGuestUserAction() {
  return {
    type: 'getGuestUser'
  };
};
// CONCATENATED MODULE: ./common/actions/user/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserProfile", function() { return user_getUserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return user_getUser; });











/**
 * When SSO request failed
 */
var user_handleUnAuthenticatedAction = function handleUnAuthenticatedAction() {
  return function (dispatch) {
    dispatch(getGuestUserAction());
    bootIntercom.boot();
    // get guest user cart
    return dispatch(Object(cart["c" /* getGuestUserCart */])());
  };
};

var getUSDollarsNotice = function getUSDollarsNotice(usDollarsNotice) {
  return {
    type: 'getUSDollarsNotice',
    payload: { usDollarsNotice: usDollarsNotice }
  };
};

var user_getUserProfile = function getUserProfile(jwtToken) {
  return function (dispatch) {
    dispatch(getUserRequestAction());
    return Object(utils_user["m" /* getUserProfileRequest */])(jwtToken).then(utils_user["j" /* formatUserResponse */]).then(function (user) {
      bootIntercom.boot(user);
      var envatoId = Object(lodash["get"])(user, 'profile.envato_id');
      Object(userAnalytics["setGAUserID"])(envatoId);
      return dispatch(getUserSuccessAction(user));
    }).catch(function (err) {
      return Promise.reject(Object(errors["logError"])(err));
    }).catch(function () {
      return dispatch(getUserFailureAction());
    });
  };
};

var user_getUser = function getUser() {
  return function (dispatch, getState) {
    dispatch(Object(session["getSessionRequestAction"])());

    return Object(auth["a" /* getSession */])().then(function (res) {
      dispatch(Object(session["getSessionSuccessAction"])(res.data.token));
      dispatch(user_getUserProfile(res.data.token));
      dispatch(getUSDollarsNotice(res.headers['x-display-us-dollars-notice']));
    }).catch(function (err) {
      if (err.statusCode === 401) {
        dispatch(getUSDollarsNotice(err.responseHeaders['x-display-us-dollars-notice']));
        return dispatch(user_handleUnAuthenticatedAction());
      } else {
        return dispatch(Object(session["getSessionFailureAction"])());
      }
    });
  };
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_common__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getProxyApiUrl__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getProxyApiUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_getProxyApiUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_axios_axiosVerbose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_activeFeatures__ = __webpack_require__(116);








var fetchLandingPageContent = function fetchLandingPageContent(parsedUrl, opts) {
  return function (dispatch, getState) {
    var apiUrlPrefix = __WEBPACK_IMPORTED_MODULE_4__utils_getProxyApiUrl___default()(opts);
    var site = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(getState(), 'common.currentSite') || 'themeforest';
    var queryString = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify({
      site: site,
      path: parsedUrl.pathname
    });

    return __WEBPACK_IMPORTED_MODULE_5__utils_axios_axiosVerbose__["default"].get(apiUrlPrefix + '/shopfront_api/landing_page?' + queryString).then(function (res) {
      var _res$data = res.data,
          title = _res$data.title,
          meta_description = _res$data.meta_description,
          html = _res$data.html,
          css = _res$data.css,
          published = _res$data.published;


      if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_activeFeatures__["default"])(parsedUrl.query).includes('sneakpeek')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_common__["noIndex"])());
      } else if (!published) {
        throw new __WEBPACK_IMPORTED_MODULE_3__utils_errors__["LandingPageUnpublishedError"]();
      }

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_common__["setSeoMeta"])({ title: title, meta_description: meta_description }));

      return dispatch(fetchLandingPageContentSuccess({ html: html, css: css }));
    }).catch(function (err) {
      if (err.statusCode !== 404) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["logError"])(err);
      }

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_common__["noIndex"])());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_common__["setErrorPage"])('NotFoundContainer'));

      return dispatch(fetchLandingPageContentFailure(err));
    });
  };
};

var fetchLandingPageContentSuccess = function fetchLandingPageContentSuccess(content) {
  return {
    type: 'fetchLandingPageContentSuccess',
    payload: content
  };
};

var fetchLandingPageContentFailure = function fetchLandingPageContentFailure(error) {
  return {
    type: 'fetchLandingPageContentFailure',
    error: true,
    httpStatus: error.statusCode || 404
  };
};

/* harmony default export */ __webpack_exports__["default"] = (fetchLandingPageContent);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./common/actions/user/bookmark.js
var bookmark = __webpack_require__(74);

// EXTERNAL MODULE: ./common/utils/item.js
var item = __webpack_require__(28);

// EXTERNAL MODULE: ./common/utils/axios/axiosVerbose.js
var axiosVerbose = __webpack_require__(11);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./common/config.ts
var config = __webpack_require__(12);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./common/utils/urlHelper.js
var urlHelper = __webpack_require__(5);

// EXTERNAL MODULE: ./common/constants/filterParamsConfig.js + 8 modules
var filterParamsConfig = __webpack_require__(16);

// EXTERNAL MODULE: ./common/utils/errors.js + 4 modules
var errors = __webpack_require__(8);

// CONCATENATED MODULE: ./common/utils/eventsApi.js








/**
 * Log success search result or timed out result to events api
 * @param {Object/null} results
 * @param {Object} query
 * @param {Object} user
 * @param {Boolean} timeout
 */
var eventsApi_logSearchResult = function logSearchResult(results, location, currentSite) {
  var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var query = Object.assign({}, Object(urlHelper["parseLocation"])(location), {
    site: currentSite + '.net'
  });
  var data = {
    event: 'item.keyword',
    search_phrase: query.term,
    timed_out: timeout,
    site: query.site,
    param_view: 'list',
    param_page: 1
  };

  if (results) {
    data['took'] = results.took;
    data['total_hits'] = results.total_hits;
    data['param_item_ids'] = Object(lodash["get"])(results, 'matches.length') && results.matches.map(function (item) {
      return item.id;
    });
  }

  if (user) {
    data['param_view'] = Object(lodash["get"])(user, 'preferences.searchResultsViewType') || 'list';
    if (user.profile) {
      data['username'] = user.profile.username;
      data['user_id'] = user.profile.id;
      data['envato_id'] = user.profile.envato_id;
    }
  }

  var params = Object.keys(query).filter(function (param) {
    return ['term', 'site'].indexOf(param) === -1;
  });

  params.forEach(function (param) {
    var paramConfig = filterParamsConfig["default"][param];
    var isMultiple = param !== 'category' && paramConfig && paramConfig.isMultiple;
    var value = isMultiple ? query[param].split(',') : query[param];

    if (value !== 0 && value) {
      data['param_' + param] = value;
    }
  });

  if ('sendBeacon' in navigator) {
    navigator.sendBeacon(config["config"].eventsApi.URL + '/search', JSON.stringify(data));
  } else {
    axiosVerbose["default"].post(config["config"].eventsApi.URL + '/search', data, { withCredentials: true }).catch(errors["logError"]);
  }
};
// EXTERNAL MODULE: ./common/utils/tracking/trackSearchCount.js
var trackSearchCount = __webpack_require__(94);

// CONCATENATED MODULE: ./common/utils/tracking/trackSearchResultsDisplay.js


var trackSearchResultsDisplay_trackSearchResultsDisplay = function trackSearchResultsDisplay(currentSite, _location) {
  if (Object(trackSearchCount["shouldTrackSearchCount"])(currentSite)) {
    Object(trackSearchCount["countSearchFor"])(currentSite);
  }
};
// CONCATENATED MODULE: ./common/actions/search/onSearchPageDidUpdate.js





var onSearchPageDidUpdate_onSearchPageDidUpdate = function onSearchPageDidUpdate(location, prevUser, prevResults) {
  return function (dispatch, getState) {
    var state = getState();
    var _state$searchPage = state.searchPage,
        results = _state$searchPage.results,
        timeout = _state$searchPage.timeout;
    var currentSite = state.common.currentSite;
    var user = state.user;

    // Log to events api only when:
    // - user data will be loaded on search results page for the first time (initial search page render)
    // - successful search will be done after initial render
    // - timeout will happen (we need to log timeouts also)

    var newUserLoadAttempt = !prevUser.hasLoadAttempt && user.hasLoadAttempt;
    var isNewSearch = !Object(item["isSearchResultMatchesEqual"])(results.matches, prevResults.matches);
    var isTimeout = user.hasLoadAttempt && timeout;
    if (newUserLoadAttempt || isNewSearch || isTimeout) {
      eventsApi_logSearchResult(results, location, currentSite, user, timeout);
      trackSearchResultsDisplay_trackSearchResultsDisplay(currentSite, location);
    }
    if (newUserLoadAttempt || isNewSearch) {
      dispatch(Object(bookmark["getBookmarksForItems"])(results.matches.map(function (match) {
        return match.id;
      })));
    }
  };
};

/* harmony default export */ var search_onSearchPageDidUpdate = __webpack_exports__["default"] = (onSearchPageDidUpdate_onSearchPageDidUpdate);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_config__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["default"] = (function (store, parsedUrl, routes, opts) {
  var branch = Object(__WEBPACK_IMPORTED_MODULE_0_react_router_config__["matchRoutes"])(routes, parsedUrl.pathname);
  return branch.map(function (_ref) {
    var route = _ref.route,
        match = _ref.match;

    return route.component.loadData ? route.component.loadData(store, parsedUrl, opts) : Promise.resolve({
      // resolve empty action
      type: 'noopAction'
    });
  });
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);


/* harmony default export */ __webpack_exports__["default"] = (function (obj1, obj2) {
  return Object.keys(obj1).reduce(function (result, key) {
    if (!obj2[key]) {
      result.push(key);
    } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(obj1[key], obj2[key])) {
      var resultKeyIndex = result.indexOf(key);
      result.splice(resultKeyIndex, 1);
    }
    return result;
  }, Object.keys(obj2));
});

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(9);
var react_router_config_1 = __webpack_require__(89);
var react_router_dom_1 = __webpack_require__(6);
var routes_v0_1 = __webpack_require__(423);
var pendingNavDataLoader_1 = __webpack_require__(211);
var App = function (_a) {
    var store = _a.store;
    return (React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(react_router_dom_1.BrowserRouter, null,
            React.createElement(pendingNavDataLoader_1.default, { store: store, routes: routes_v0_1.default }, react_router_config_1.renderRoutes(routes_v0_1.default)))));
};
exports.default = App;


/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __webpack_require__(193);
var homePage_1 = __webpack_require__(450);
var landingPage_1 = __webpack_require__(198);
var notFoundPage_1 = __webpack_require__(161);
var searchPage_1 = __webpack_require__(492);
var appContainer_1 = __webpack_require__(208);
var homePageContainer_1 = __webpack_require__(510);
var landingPageContainer_1 = __webpack_require__(209);
var notFoundContainer_1 = __webpack_require__(107);
var searchPageContainer_1 = __webpack_require__(210);
/* tslint:enable */
var routeConfig = [
    {
        component: appContainer_1.default(app_1.default),
        path: '/',
        routes: [
            {
                component: homePageContainer_1.default(homePage_1.default),
                exact: true,
                path: '/'
            },
            {
                component: searchPageContainer_1.default(searchPage_1.default),
                key: 'search',
                path: '/category/*'
            },
            {
                component: searchPageContainer_1.default(searchPage_1.default),
                key: 'search',
                path: '/tags/:tags'
            },
            {
                component: searchPageContainer_1.default(searchPage_1.default),
                key: 'search',
                path: '/attributes/:key/:value'
            },
            {
                component: searchPageContainer_1.default(searchPage_1.default),
                key: 'search',
                path: '/search'
            },
            {
                component: landingPageContainer_1.default(landingPage_1.default),
                path: '/free/:page'
            },
            {
                component: notFoundContainer_1.default(notFoundPage_1.default),
                path: '/*'
            }
        ]
    }
];
exports.default = routeConfig;


/***/ }),
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var sites_1 = __webpack_require__(10);
var autosuggest_1 = __webpack_require__(281);
var autoSuggestDataContainer_1 = __webpack_require__(127);
var autoSuggestLogicContainer_1 = __webpack_require__(128);
var searchHeader_1 = __webpack_require__(283);
var seoHeadings_1 = __webpack_require__(162);
var communitySection_1 = __webpack_require__(455);
var featuredItemsSection_1 = __webpack_require__(462);
var freeItemSection_1 = __webpack_require__(470);
var marketingSection_1 = __webpack_require__(473);
var newestItemSection_1 = __webpack_require__(479);
var pageSection_1 = __webpack_require__(286);
var tutorialsSection_1 = __webpack_require__(482);
var autoSuggestStyles = __webpack_require__(488);
var searchHeaderStyles = __webpack_require__(489);
var seoHeadingsStyles = __webpack_require__(490);
var styles = __webpack_require__(491);
var AutoSuggestContainer = autoSuggestDataContainer_1.default(autoSuggestLogicContainer_1.default(autosuggest_1.default));
var HomePage = function (_a) {
    var location = _a.location, currentSite = _a.currentSite, isSignedIn = _a.isSignedIn, metadata = _a.metadata, newestItemsData = _a.newestItemsData, featuredItems = _a.featuredItems, fetchNewestItemsByCategory = _a.fetchNewestItemsByCategory, preferences = _a.preferences, muteVideo = _a.muteVideo;
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.searchHeaderSection },
            React.createElement(searchHeader_1.default, { currentSite: currentSite, styles: searchHeaderStyles },
                React.createElement(seoHeadings_1.default, { TagName: "h1", heading: "38,385 WordPress Themes & Website Templates From $2", subHeading: "WordPress themes, web templates and more. Brought to you by the largest global community of creatives.", styles: seoHeadingsStyles }),
                React.createElement(AutoSuggestContainer, { inputName: "term", value: "", placeholder: sites_1.getConfigBySite(currentSite, 'home_search_placeholder'), currentSite: currentSite, location: location, styles: autoSuggestStyles, showCategories: true }))),
        metadata && (React.createElement(featuredItemsSection_1.default, { items: featuredItems.slice(0, 10), metadata: metadata.featured_items, muteVideo: muteVideo, videoMuted: preferences.searchVideoMuted })),
        newestItemsData.items &&
            metadata && (React.createElement(pageSection_1.default, null,
            React.createElement(newestItemSection_1.default, { currentSite: currentSite, fetchNewestItemsByCategory: fetchNewestItemsByCategory, metadata: metadata.newest_items, newestItemsData: newestItemsData, muteVideo: muteVideo, videoMuted: preferences.searchVideoMuted }))),
        newestItemsData.items &&
            metadata && (React.createElement(pageSection_1.default, { borderTop: true },
            React.createElement(freeItemSection_1.default, { isSignedIn: isSignedIn, items: newestItemsData.items.slice(0, 6), metadata: metadata.free_items, muteVideo: muteVideo, videoMuted: preferences.searchVideoMuted }))),
        metadata && (React.createElement(pageSection_1.default, { borderTop: true, spaceBottom: true },
            React.createElement(marketingSection_1.default, { blocks: metadata.marketing_blocks }))),
        metadata && (React.createElement(pageSection_1.default, { borderTop: true, darkBackground: true },
            React.createElement(communitySection_1.default, { metadata: metadata.community }))),
        metadata && (React.createElement(pageSection_1.default, null,
            React.createElement(tutorialsSection_1.default, { metadata: metadata.tutorials })))));
};
exports.default = HomePage;


/***/ }),
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var communitySection_1 = __webpack_require__(456);
exports.default = communitySection_1.default;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var config_1 = __webpack_require__(12);
var button_1 = __webpack_require__(108);
var sectionDescription_1 = __webpack_require__(80);
var styles = __webpack_require__(461);
var CommunitySection = function (_a) {
    var metadata = _a.metadata;
    return (React.createElement("div", { "data-test-selector": "communitySection" },
        React.createElement(sectionDescription_1.default, { metadata: metadata, HTag: "h6" }),
        React.createElement("div", { className: styles.buttonSection },
            React.createElement(button_1.default, { primary: true, href: "https://community.envato.com/" }, "Visit Our Forums")),
        React.createElement("div", null,
            React.createElement("img", { alt: "vist our forums", src: config_1.config.assets.PUBLIC_PATH + "/images/home-page/community.png", className: styles.img }))));
};
exports.default = CommunitySection;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = __webpack_require__(7);
var React = __webpack_require__(0);
var styles = __webpack_require__(458);
var Button = function (props) {
    var className = props.className, children = props.children, large = props.large, primary = props.primary, fixedWidth = props.fixedWidth, nextProps = __rest(props, ["className", "children", "large", "primary", "fixedWidth"]);
    var Tag = nextProps.href ? 'a' : 'button';
    var nextClassName = classnames(styles.button, className, (_a = {},
        _a[styles.large] = large,
        _a[styles.primary] = primary,
        _a[styles.fixedWidth] = fixedWidth,
        _a));
    return (React.createElement(Tag, __assign({ className: nextClassName }, nextProps), children));
    var _a;
};
exports.default = Button;


/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button-module_button_2k5pG","fixedWidth":"button-module_fixedWidth_1tpxb","primary":"button-module_primary_3ViUq","large":"button-module_large_2kt2y"};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var classnames = __webpack_require__(7);
var React = __webpack_require__(0);
var styles = __webpack_require__(460);
var SectionDescription = function (_a) {
    var children = _a.children, metadata = _a.metadata, HTag = _a.HTag, hideOnMobile = _a.hideOnMobile;
    var rootClassNames = classnames((_b = {},
        _b[styles.hideOnMobile] = hideOnMobile,
        _b));
    return (React.createElement("div", { className: rootClassNames },
        React.createElement(HTag, { className: styles.centralHeading }, metadata.heading),
        React.createElement("p", { className: styles.centralBody }, metadata.sub_heading),
        children && React.createElement("div", { className: styles.centralSection }, children)));
    var _b;
};
exports.default = SectionDescription;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"heading":"sectionDescription-module_heading_1ZBbM","centralHeading":"sectionDescription-module_centralHeading_Q9bFG sectionDescription-module_heading_1ZBbM","centralBody":"sectionDescription-module_centralBody_2X9-n","centralSection":"sectionDescription-module_centralSection_1-A2Q","hideOnMobile":"sectionDescription-module_hideOnMobile_1B1h5"};

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"communitySection-module_buttonSection_2_y02","img":"communitySection-module_img_n9h3H"};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var featuredItemsSection_1 = __webpack_require__(463);
exports.default = featuredItemsSection_1.default;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var button_1 = __webpack_require__(108);
var itemPreviewer_1 = __webpack_require__(164);
var itemThumbnailCarousel_1 = __webpack_require__(165);
var pageSection_1 = __webpack_require__(286);
var sectionDescription_1 = __webpack_require__(80);
var styles = __webpack_require__(469);
var FeaturedItemsSection = function (_a) {
    var items = _a.items, metadata = _a.metadata, videoMuted = _a.videoMuted, muteVideo = _a.muteVideo;
    return (React.createElement("div", { className: styles.section, "data-test-selector": "featuredItemSection" },
        React.createElement(sectionDescription_1.default, { metadata: metadata, HTag: "h4" }),
        React.createElement(pageSection_1.default, null,
            React.createElement(itemThumbnailCarousel_1.default, null, items.map(function (item) {
                return (React.createElement(itemPreviewer_1.default, { item: item, key: item.id, videoMuted: videoMuted, muteVideo: muteVideo }));
            })),
            React.createElement("div", { className: styles.buttonSection, "data-test-selector": "featuredItemButtonSection" },
                React.createElement(button_1.default, { primary: true, href: "/feature" }, "View More Featured Items")))));
};
exports.default = FeaturedItemsSection;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"img":"index-module_img_2V4ex","annotation":"index-module_annotation_2Q6t7","magnifier":"index-module_magnifier_10Pb7"};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(466);
var ItemThumbnailCarousel = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: styles.itemListWrapper },
        React.createElement("ul", { className: styles.itemListContainer }, React.Children.map(children, function (child) {
            return React.createElement("li", { className: styles.itemList }, child);
        }))));
};
exports.default = ItemThumbnailCarousel;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"itemListContainer":"itemThumbnailCarousel-module_itemListContainer_1IE7u","itemList":"itemThumbnailCarousel-module_itemList_1sWSL"};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var classnames = __webpack_require__(7);
var React = __webpack_require__(0);
var styles = __webpack_require__(468);
var PageSection = function (_a) {
    var children = _a.children, borderTop = _a.borderTop, darkBackground = _a.darkBackground, spaceBottom = _a.spaceBottom;
    var sectionClassName = classnames(styles.pageSection, (_b = {},
        _b[styles.borderTop] = borderTop,
        _b[styles.darkBackground] = darkBackground,
        _b[styles.spaceBottom] = spaceBottom,
        _b));
    return (React.createElement("section", { className: sectionClassName },
        React.createElement("div", { className: styles.gridContainer }, children)));
    var _b;
};
exports.default = PageSection;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pageSection":"pageSection-module_pageSection_2ki2P","gridContainer":"pageSection-module_gridContainer_2aIeW","borderTop":"pageSection-module_borderTop_32lgU","darkBackground":"pageSection-module_darkBackground_3eHIa","spaceBottom":"pageSection-module_spaceBottom_22EeD"};

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"section":"featuredItemsSection-module_section_1h0U6","featuredItemsListDesktop":"featuredItemsSection-module_featuredItemsListDesktop_2r4dX","buttonSection":"featuredItemsSection-module_buttonSection_2O1Mr"};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var freeItemSection_1 = __webpack_require__(471);
exports.default = freeItemSection_1.default;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(3);
var React = __webpack_require__(0);
var sites_1 = __webpack_require__(10);
var button_1 = __webpack_require__(108);
var itemPreviewer_1 = __webpack_require__(164);
var itemThumbnailCarousel_1 = __webpack_require__(165);
var sectionDescription_1 = __webpack_require__(80);
var styles = __webpack_require__(472);
var FreeItemSection = function (_a) {
    var items = _a.items, metadata = _a.metadata, isSignedIn = _a.isSignedIn, videoMuted = _a.videoMuted, muteVideo = _a.muteVideo;
    return (React.createElement("div", { "data-test-selector": "freeItemSection" },
        React.createElement(sectionDescription_1.default, { metadata: metadata, HTag: "h6" }),
        React.createElement(itemThumbnailCarousel_1.default, null, items.map(function (item) {
            var siteConfig = item.site &&
                lodash_1.find(sites_1.default, function (config) { return config.domain === item.site; });
            var siteName = siteConfig && siteConfig.name;
            return (React.createElement(itemPreviewer_1.default, { item: item, key: item.id, annotation: siteName, videoMuted: videoMuted, muteVideo: muteVideo }));
        })),
        !isSignedIn && (React.createElement("div", { className: styles.buttonSection },
            React.createElement(button_1.default, { primary: true, href: "/sign_up" }, "Sign Up")))));
};
exports.default = FreeItemSection;


/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"freeItemSection-module_buttonSection_1qgRk"};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var marketingSection_1 = __webpack_require__(474);
exports.default = marketingSection_1.default;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var config_1 = __webpack_require__(12);
var marketingBlock_1 = __webpack_require__(475);
var styles = __webpack_require__(478);
var MarketingSection = function (_a) {
    var blocks = _a.blocks;
    var items = Object.keys(blocks).map(function (key, index) {
        var post = blocks[key];
        return (React.createElement("div", { className: styles.block, key: index },
            React.createElement(marketingBlock_1.default, { imgSrc: config_1.config.assets.PUBLIC_PATH + "/images/home-page/marketing/" + key + ".png", title: post.title, description: post.text })));
    });
    return (React.createElement("div", { className: styles.root, "data-test-selector": "marketingSection" }, items));
};
exports.default = MarketingSection;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var marketingBlock_1 = __webpack_require__(476);
exports.default = marketingBlock_1.default;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(477);
var MarketingBlock = function (_a) {
    var imgSrc = _a.imgSrc, title = _a.title, description = _a.description;
    return (React.createElement("article", { className: styles.root },
        React.createElement("header", null,
            React.createElement("div", { className: styles.imgWrapper },
                React.createElement("img", { src: imgSrc })),
            React.createElement("p", { className: styles.title }, title)),
        React.createElement("section", { className: styles.description }, description)));
};
exports.default = MarketingBlock;


/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"marketingBlock-module_root_1sVqP","title":"marketingBlock-module_title_3wdum","imgWrapper":"marketingBlock-module_imgWrapper_3degi","description":"marketingBlock-module_description_1X2lD"};

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"marketingSection-module_root_1Y21N","block":"marketingSection-module_block_-Kb4I"};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var newestItemSection_1 = __webpack_require__(480);
exports.default = newestItemSection_1.default;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = __webpack_require__(7);
var React = __webpack_require__(0);
var resultAnalytics_1 = __webpack_require__(48);
var item_1 = __webpack_require__(28);
var categories_1 = __webpack_require__(53);
var button_1 = __webpack_require__(108);
var dropdown_1 = __webpack_require__(65);
var itemPreviewer_1 = __webpack_require__(164);
var itemThumbnailCarousel_1 = __webpack_require__(165);
var sectionDescription_1 = __webpack_require__(80);
var styles = __webpack_require__(481);
var NewestItemSection = /** @class */ (function (_super) {
    __extends(NewestItemSection, _super);
    function NewestItemSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewestItemSection.prototype.componentDidMount = function () {
        var _a = this.props, newestItemsData = _a.newestItemsData, currentSite = _a.currentSite;
        resultAnalytics_1.reportProductsImpressions({
            currentSite: currentSite,
            itemRankOffset: 1,
            items: newestItemsData.items,
            page: 'Homepage',
            section: 'New items'
        });
    };
    NewestItemSection.prototype.componentDidUpdate = function (nextProps) {
        var _a = this.props, newestItemsData = _a.newestItemsData, currentSite = _a.currentSite;
        if (!item_1.isSearchResultMatchesEqual(nextProps.newestItemsData.items, newestItemsData.items)) {
            resultAnalytics_1.reportProductsImpressions({
                currentSite: currentSite,
                itemRankOffset: 1,
                items: nextProps.newestItemsData.items,
                page: 'Homepage',
                section: 'New items'
            });
        }
    };
    NewestItemSection.prototype.render = function () {
        var _a = this.props, currentSite = _a.currentSite, newestItemsData = _a.newestItemsData, metadata = _a.metadata, fetchNewestItemsByCategory = _a.fetchNewestItemsByCategory, videoMuted = _a.videoMuted, muteVideo = _a.muteVideo;
        var categoriesOptions = [
            {
                name: 'All categories',
                path: 'all'
            }
        ].concat(categories_1.default[currentSite]).map(function (category) {
            return {
                label: category.name,
                value: category.path
            };
        });
        return (React.createElement("div", { className: styles.section },
            React.createElement("div", null,
                React.createElement("h4", { className: styles.heading }, metadata.main_heading)),
            React.createElement("div", { className: styles.categoriesListDesktop }, categoriesOptions.map(function (category, index) {
                var buttonSelected = newestItemsData.itemsPendingCategory === category.value ||
                    (!newestItemsData.itemsPendingCategory &&
                        newestItemsData.itemsCategory === category.value);
                var categoryClassName = classNames(styles.categoryLink, (_a = {},
                    _a[styles.activeCategoryLink] = buttonSelected,
                    _a));
                return (React.createElement("button", { "data-test-selector": "newestItemSectionCategory", className: categoryClassName, key: category.value, onClick: function () {
                        fetchNewestItemsByCategory(category.value);
                    } }, category.label));
                var _a;
            })),
            React.createElement("div", { className: styles.categoriesListMobile },
                React.createElement(dropdown_1.default, { className: styles.select, options: categoriesOptions, onChange: function (event) {
                        fetchNewestItemsByCategory(event.target.value);
                    }, value: newestItemsData.itemsPendingCategory ||
                        newestItemsData.itemsCategory })),
            React.createElement("div", { "data-test-selector": "newestItemSectionList" },
                React.createElement(itemThumbnailCarousel_1.default, null, newestItemsData.items.map(function (item) { return (React.createElement(itemPreviewer_1.default, { item: item, key: item.id, videoMuted: videoMuted, muteVideo: muteVideo })); }))),
            React.createElement(sectionDescription_1.default, { metadata: metadata, HTag: "h5", hideOnMobile: true },
                React.createElement(button_1.default, { large: true, fixedWidth: true, href: "/category/all?sort=date" }, "All New Items"),
                React.createElement(button_1.default, { large: true, fixedWidth: true, href: "/page/top_sellers" }, "Popular Files"),
                React.createElement(button_1.default, { large: true, fixedWidth: true, href: "/category" }, "Browse Categories")),
            React.createElement("div", { className: newestItemsData.itemsPendingCategory &&
                    !newestItemsData.loadingCachedCategory
                    ? styles.loading
                    : '' })));
    };
    return NewestItemSection;
}(React.Component));
exports.default = NewestItemSection;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"section":"newestItemSection-module_section_12kBI","loading":"newestItemSection-module_loading_2uP5M","heading":"newestItemSection-module_heading_1FAwv","categoriesListDesktop":"newestItemSection-module_categoriesListDesktop_3Qrra","categoriesListMobile":"newestItemSection-module_categoriesListMobile_1RxkP","select":"newestItemSection-module_select_2SENN","categoryLink":"newestItemSection-module_categoryLink_K_8iZ","activeCategoryLink":"newestItemSection-module_activeCategoryLink_3ekrL"};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tutorialsSection_1 = __webpack_require__(483);
exports.default = tutorialsSection_1.default;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var config_1 = __webpack_require__(12);
var sectionDescription_1 = __webpack_require__(80);
var tutorialPost_1 = __webpack_require__(484);
var styles = __webpack_require__(487);
var TutorialsSection = function (_a) {
    var metadata = _a.metadata;
    var posts = metadata.posts;
    var tutorialPostComponents = posts &&
        Object.keys(posts).map(function (key, index) {
            var post = posts[key];
            return (React.createElement(tutorialPost_1.default, { imgSrc: config_1.config.assets.PUBLIC_PATH + "/images/home-page/tutorials/" + key + ".png", title: post.link_text, link: post.link_url, description: post.description, key: index }));
        });
    return (React.createElement("div", { className: styles.root, "data-test-selector": "tutorialsSection" },
        React.createElement(sectionDescription_1.default, { metadata: metadata, HTag: "h6" }),
        React.createElement("div", { className: styles.badgesList }, tutorialPostComponents)));
};
exports.default = TutorialsSection;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tutorialPost_1 = __webpack_require__(485);
exports.default = tutorialPost_1.default;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var safeInnerHtml_1 = __webpack_require__(163);
var styles = __webpack_require__(486);
var TutorialPost = function (_a) {
    var imgSrc = _a.imgSrc, title = _a.title, link = _a.link, description = _a.description;
    return (React.createElement("article", { className: styles.root },
        React.createElement("header", null,
            React.createElement("a", { href: link },
                React.createElement("img", { src: imgSrc, className: styles.img })),
            React.createElement("a", { href: link, className: styles.title }, title)),
        React.createElement("section", { className: styles.description },
            React.createElement(safeInnerHtml_1.default, { html: description }))));
};
exports.default = TutorialPost;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"tutorialPost-module_root_1PNAO","img":"tutorialPost-module_img_2wVGf","title":"tutorialPost-module_title_3PU42","description":"tutorialPost-module_description_1yT3P"};

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"badgesList":"tutorialsSection-module_badgesList_3ECrZ","root":"tutorialsSection-module_root_331CU"};

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"homepage-module_button_2ZZBa","-theme-3docean":"homepage-module_-theme-3docean_3As6n","-theme-photodune":"homepage-module_-theme-photodune_2OA9R","-theme-graphicriver":"homepage-module_-theme-graphicriver_osEaM","-theme-audiojungle":"homepage-module_-theme-audiojungle_30Lbi","-theme-videohive":"homepage-module_-theme-videohive_3tgSl","-theme-codecanyon":"homepage-module_-theme-codecanyon_165N8","-theme-themeforest":"homepage-module_-theme-themeforest_1gmqS","input":"homepage-module_input_3Qbnn","mainWrapper":"homepage-module_mainWrapper_2XmIw","wrapper":"homepage-module_wrapper_1K3Wl","suggestions":"homepage-module_suggestions_jWbrE","separator":"homepage-module_separator_K-GTC","focusedListItem":"homepage-module_focusedListItem_2jEAb","suggestionText":"homepage-module_suggestionText_22h7k","categoryText":"homepage-module_categoryText_3Uq_9","highlightedText":"homepage-module_highlightedText_20-Y6"};

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pageSectionForm":"homepage-module_pageSectionForm_1p_in"};

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"seoHeading":"homepage-module_seoHeading_3LZtD","seoSubHeading":"homepage-module_seoSubHeading_nhxcT"};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchHeaderSection":"homePage-module_searchHeaderSection_12EAO"};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var lodash_1 = __webpack_require__(3);
var urlHelper_1 = __webpack_require__(5);
var alertsStreamContainer_1 = __webpack_require__(493);
var autosuggest_1 = __webpack_require__(281);
var autoSuggestDataContainer_1 = __webpack_require__(127);
var autoSuggestLogicContainer_1 = __webpack_require__(128);
var searchHeader_1 = __webpack_require__(283);
var searchResultHeaders_1 = __webpack_require__(199);
var searchPageArticle_1 = __webpack_require__(200);
var searchPageRelatedPosts_1 = __webpack_require__(201);
var searchContentSection_1 = __webpack_require__(496);
var autoSuggestStyles = __webpack_require__(501);
var resultHeadersDefault_1 = __webpack_require__(502);
var searchHeaderStyles = __webpack_require__(503);
var styles = __webpack_require__(504);
var renderSurvey_1 = __webpack_require__(505);
var AutoSuggestContainer = autoSuggestDataContainer_1.default(autoSuggestLogicContainer_1.default(autosuggest_1.default));
var SearchPage = /** @class */ (function (_super) {
    __extends(SearchPage, _super);
    function SearchPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchPage.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, location = _a.location, onSearchPageDidUpdate = _a.onSearchPageDidUpdate;
        onSearchPageDidUpdate(location, prevProps.user, prevProps.results);
    };
    SearchPage.prototype.render = function () {
        var _a = this.props, user = _a.user, location = _a.location, results = _a.results, loading = _a.loading, searchHeadings = _a.searchHeadings, ingestedContent = _a.ingestedContent, currentSite = _a.currentSite, baseUrl = _a.baseUrl, relatedSearches = _a.relatedSearches, studioRecommendations = _a.studioRecommendations;
        var didYouMeanByTerms = lodash_1.get(results, 'suggestions');
        var authorSuggestion = lodash_1.get(results, 'matching_author');
        var flattenLocation = urlHelper_1.getFlattenLocation(location);
        var parsedLocation = urlHelper_1.parseLocation(location);
        var seoMeta = {
            heading: searchHeadings.heading,
            subHeading: searchHeadings.sub_heading,
            finePrint: searchHeadings.fine_print
        };
        return (React.createElement("div", { className: "canvas_body" },
            loading ? React.createElement("div", { className: "loading-cover" }) : null,
            React.createElement("div", { className: styles.searchHeaderSection },
                React.createElement(searchHeader_1.default, { currentSite: currentSite, styles: searchHeaderStyles },
                    React.createElement(AutoSuggestContainer, { inputName: "term", value: parsedLocation.term, placeholder: "Search within these results", currentSite: currentSite, location: location, styles: autoSuggestStyles }),
                    React.createElement(searchResultHeaders_1.default, { location: location, totalHits: results.total_hits, didYouMeanByTerms: didYouMeanByTerms, authorSuggestion: authorSuggestion, seoMeta: seoMeta, styles: resultHeadersDefault_1.default, TagName: "h1" }))),
            React.createElement(renderSurvey_1.default, { location: location, currentSite: currentSite }),
            React.createElement(alertsStreamContainer_1.default, null),
            React.createElement("div", { className: "content-main--basic" },
                React.createElement("div", { className: "faceted-search" },
                    React.createElement(searchContentSection_1.default, { user: user, baseUrl: baseUrl, results: results, location: location, loading: loading, currentSite: currentSite, relatedSearches: relatedSearches, studioRecommendations: studioRecommendations })),
                ingestedContent && (React.createElement("div", { className: "search-page-content" },
                    !!ingestedContent.article && (React.createElement(searchPageArticle_1.default, { html: ingestedContent.article })),
                    ingestedContent.related_posts &&
                        ingestedContent.related_posts.length === 3 && (React.createElement(searchPageRelatedPosts_1.default, { posts: ingestedContent.related_posts })))))));
    };
    return SearchPage;
}(React.Component));
exports.default = SearchPage;


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(9);

// EXTERNAL MODULE: ./common/actions/common.ts
var common = __webpack_require__(37);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-transition-group/CSSTransitionGroup.js
var CSSTransitionGroup = __webpack_require__(696);
var CSSTransitionGroup_default = /*#__PURE__*/__webpack_require__.n(CSSTransitionGroup);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./client/components/icons/cancel.js
var cancel = __webpack_require__(166);

// EXTERNAL MODULE: ./node_modules/react-icon-base/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./client/components/icons/flag.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var flag = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Flag' },
      props.title || 'Flag'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M85.79 83.572c0 7.571-1.892 14.463-5.65 20.624-3.813 6.156-8.927 11.412-15.396 15.647v335.649c0 2.992-1.017 5.479-3.022 7.625-2.034 2.146-4.549 3.164-7.486 3.164h-21.61c-2.965 0-5.397-1.018-7.345-3.164-1.921-2.146-2.91-4.633-2.91-7.625v-335.649c-6.468-4.235-11.666-9.491-15.647-15.647-3.955-6.16-5.935-13.053-5.935-20.624 0-11.638 4.154-21.636 12.459-30.057 8.305-8.416 18.361-12.597 30.169-12.597 11.639 0 21.611 4.181 29.914 12.597 8.307 8.421 12.459 18.419 12.459 30.057zm407.426 6.101c5.34-2.992 9.688-3.502 12.994-1.695 3.336 1.866 5.001 5.822 5.001 11.923v207.172c0 5.708-1.725 11.639-5.144 17.853-3.415 6.215-7.708 10.734-12.853 13.731-20.875 12.542-40.001 20.619-57.343 24.233-17.347 3.562-32.487 5.031-45.424 4.294-15.14-.79-28.532-3.842-40.142-9.15-9.438-4.974-18.615-9.772-27.57-14.292-8.957-4.521-18.133-8.476-27.541-11.923-9.438-3.391-19.352-6.103-29.775-8.137-10.451-2.033-21.948-3.051-34.491-3.051-10.169.339-21.609 2.033-34.35 4.972-10.904 2.6-24.125 6.779-39.747 12.488-15.593 5.703-32.994 13.84-52.203 24.349-5.337 2.938-9.83 3.336-13.417 1.13-3.616-2.261-5.423-6.382-5.423-12.484v-206.326c0-6.102 1.808-12.204 5.423-18.251 3.586-6.102 8.079-10.621 13.417-13.613 19.209-10.115 36.556-18.079 52.063-23.788 15.507-5.763 28.813-9.885 39.887-12.483 12.938-2.938 24.379-4.579 34.35-4.972 12.543 0 24.041 1.017 34.491 3.051 10.426 2.034 20.338 4.746 29.775 8.19 9.408 3.39 18.529 7.345 27.398 11.864 8.871 4.52 18.107 9.265 27.713 14.295 11.608 5.365 25.002 8.416 40.142 9.094 12.937.791 28.077-.678 45.424-4.294 17.344-3.556 36.47-11.637 57.345-24.18z' })
    )
  );
});
// EXTERNAL MODULE: ./client/components/icons/ok.js
var ok = __webpack_require__(40);

// CONCATENATED MODULE: ./client/components/icons/alert.js
var alert__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var icons_alert = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    alert__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Alert' },
      props.title || 'Alert'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M200.4 54.1c-1.9-18.7 8.4-32.9 25.8-32.9h63.1c17.4 0 27.7 14.2 25.8 32.9l-27.7 242.2c-1.9 17.4-13.5 28.3-29.6 28.3s-27.7-11-29.6-28.3l-27.8-242.2zm57.3 313.1c32.2 0 56 23.8 56 54.8v1.3c0 30.9-23.8 54.8-56 54.8s-56-23.8-56-54.8v-1.3c0-31 23.8-54.8 56-54.8z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/alerts/alertBox.js









var alertBox_AlertBox = function AlertBox(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'warning' : _ref$type,
      onDismiss = _ref.onDismiss,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === undefined ? true : _ref$showIcon;

  var mainClasses = classnames_default()('fds-c-alert-box', 'fds-u-mt2', {
    '-type-success': type === 'success',
    '-type-alert': type === 'failure'
  });

  var onDismissWrapper = function onDismissWrapper(event) {
    event.preventDefault();
    onDismiss(event);
  };

  var icon = void 0;
  switch (type) {
    case 'warning':
      icon = react_default.a.createElement(flag, null);
      break;
    case 'success':
      icon = react_default.a.createElement(ok["default"], null);
      break;
    case 'failure':
      icon = react_default.a.createElement(icons_alert, null);
      break;
    default:
      icon = null;
  }

  return react_default.a.createElement(
    'div',
    { className: mainClasses },
    showIcon ? react_default.a.createElement(
      'div',
      { className: 'fds-c-alert-box__icon' },
      icon
    ) : null,
    react_default.a.createElement(
      'div',
      { className: 'fds-c-alert-box__message' },
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s fds-u-m0' },
        children
      )
    ),
    onDismiss ? react_default.a.createElement(AlertBox.DismissButton, { onClick: onDismissWrapper }) : null
  );
};

alertBox_AlertBox.propTypes = {
  type: prop_types_default.a.oneOf(['warning', 'success', 'failure']),
  onDismiss: prop_types_default.a.func
};

alertBox_AlertBox.DismissButton = function (_ref2) {
  var onClick = _ref2.onClick;

  return react_default.a.createElement(
    'div',
    { className: 'fds-c-alert-box__dismiss' },
    react_default.a.createElement(
      'a',
      { onClick: onClick, className: 'fds-c-alert-box__dismiss-icon' },
      react_default.a.createElement(cancel["a" /* default */], null)
    )
  );
};

alertBox_AlertBox.DismissButton.propTypes = {
  onClick: prop_types_default.a.func
};

/* harmony default export */ var alertBox = (alertBox_AlertBox);
// CONCATENATED MODULE: ./client/components/alerts/alertsStream.js





var alertsStream_AlertsStream = function AlertsStream(_ref) {
  var _ref$alerts = _ref.alerts,
      alerts = _ref$alerts === undefined ? [] : _ref$alerts,
      hideAlert = _ref.hideAlert;

  return react_default.a.createElement(
    'div',
    { className: 'grid-container' },
    react_default.a.createElement(
      CSSTransitionGroup_default.a,
      {
        transitionName: {
          enter: '-animate--enter',
          enterActive: '-animate--enter-active',
          leave: '-animate--leave',
          leaveActive: '-animate--leave-active'
        },
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 300
      },
      alerts.map(function (_ref2, index) {
        var message = _ref2.message,
            type = _ref2.type,
            canBeDismissed = _ref2.canBeDismissed;

        if (canBeDismissed) {
          return react_default.a.createElement(
            alertBox,
            {
              key: index,
              type: type,
              onDismiss: hideAlert.bind(null, message)
            },
            message
          );
        } else {
          return react_default.a.createElement(
            alertBox,
            { key: index, type: type },
            message
          );
        }
      })
    )
  );
};

/* harmony default export */ var alertsStream = (alertsStream_AlertsStream);
// CONCATENATED MODULE: ./client/components/alerts/alertsStreamContainer.js





var mapStateToProps = function mapStateToProps(state) {
  var alerts = state.common.alerts;

  return {
    alerts: alerts
  };
};

var alertsStreamContainer_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideAlert: function hideAlert(message) {
      dispatch(Object(common["hideAlert"])(message));
    }
  };
};

var AlertsStreamContainer = Object(es["connect"])(mapStateToProps, alertsStreamContainer_mapDispatchToProps)(alertsStream);

/* harmony default export */ var alertsStreamContainer = __webpack_exports__["default"] = (AlertsStreamContainer);

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(3);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(7);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/titleize/index.js
var titleize = __webpack_require__(27);
var titleize_default = /*#__PURE__*/__webpack_require__.n(titleize);

// EXTERNAL MODULE: ./node_modules/humanize-string/index.js
var humanize_string = __webpack_require__(361);
var humanize_string_default = /*#__PURE__*/__webpack_require__.n(humanize_string);

// EXTERNAL MODULE: ./node_modules/keycode/index.js
var keycode = __webpack_require__(33);
var keycode_default = /*#__PURE__*/__webpack_require__.n(keycode);

// EXTERNAL MODULE: ./node_modules/react-router-dom/es/index.js + 30 modules
var es = __webpack_require__(6);

// CONCATENATED MODULE: ./client/components/clickOutside.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/**
 * code from https://github.com/tj/react-click-outside
 */


var clickOutside_ClickOutside = function (_Component) {
  _inherits(ClickOutside, _Component);

  function ClickOutside(props) {
    _classCallCheck(this, ClickOutside);

    var _this = _possibleConstructorReturn(this, (ClickOutside.__proto__ || Object.getPrototypeOf(ClickOutside)).call(this, props));

    _this.handle = function (e) {
      var onClickOutside = _this.props.onClickOutside;

      var el = _this.container;
      if (!el.contains(e.target)) onClickOutside(e);
    };

    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    return _this;
  }

  _createClass(ClickOutside, [{
    key: 'setWrapperRef',
    value: function setWrapperRef(ref) {
      if (ref !== null) {
        this.container = ref;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return react_default.a.createElement(
        'div',
        { ref: this.setWrapperRef },
        children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handle, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handle, true);
    }
  }]);

  return ClickOutside;
}(react["Component"]);

clickOutside_ClickOutside.propTypes = {
  onClickOutside: prop_types_default.a.func.isRequired
};
/* harmony default export */ var clickOutside = (clickOutside_ClickOutside);
// CONCATENATED MODULE: ./client/components/onKeyDown.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var onKeyDown__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function onKeyDown__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function onKeyDown__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function onKeyDown__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var onKeyDown_OnKeyDown = function (_Component) {
  onKeyDown__inherits(OnKeyDown, _Component);

  function OnKeyDown(props) {
    onKeyDown__classCallCheck(this, OnKeyDown);

    var _this = onKeyDown__possibleConstructorReturn(this, (OnKeyDown.__proto__ || Object.getPrototypeOf(OnKeyDown)).call(this, props));

    _this.handle = function (e) {
      var onKeyDown = _this.props.onKeyDown;

      var el = _this.container;
      if (!el.contains(e.target)) onKeyDown(e);
    };

    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    return _this;
  }

  onKeyDown__createClass(OnKeyDown, [{
    key: 'setWrapperRef',
    value: function setWrapperRef(ref) {
      if (ref !== null) {
        this.container = ref;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return react_default.a.createElement(
        'div',
        _extends({}, props, { ref: this.setWrapperRef }),
        children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handle, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handle, true);
    }
  }]);

  return OnKeyDown;
}(react["Component"]);

onKeyDown_OnKeyDown.propTypes = {
  onKeyDown: prop_types_default.a.func.isRequired
};
/* harmony default export */ var onKeyDown = (onKeyDown_OnKeyDown);
// EXTERNAL MODULE: ./common/utils/urlHelper.js
var urlHelper = __webpack_require__(5);

// CONCATENATED MODULE: ./client/components/filters/filtersPanel/utils.js
var showMoreThreshold = {
  category: 10,
  tags: 12,
  compatible_with: 12,
  platform: 12,
  file_formats: 12
};


// EXTERNAL MODULE: ./node_modules/react-icon-base/lib/index.js
var lib = __webpack_require__(2);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./client/components/icons/preview.js
var preview__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var preview = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    preview__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Preview' },
      props.title || 'Preview'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M507 256.3c0 6.4-1.9 12.8-5.6 19.3-26.1 43-61.3 77.3-105.4 103.2s-90.8 38.8-139.9 38.8-95.7-13-139.9-38.9c-44.1-26-79.3-60.3-105.4-103.1-3.7-6.5-5.6-12.9-5.6-19.3 0-6.3 1.9-12.8 5.6-19.3 26.1-42.8 61.3-77.1 105.4-103.1 44.2-25.9 90.8-38.9 139.9-38.9s95.7 13 139.9 38.9c44.1 26 79.3 60.3 105.4 103.1 3.7 6.5 5.6 13 5.6 19.3zm-35.9 0c-28.4-44.1-63.9-77-106.7-98.9 11.4 19.4 17.1 40.4 17.1 63 0 34.5-12.3 64.1-36.8 88.6-24.5 24.5-54.1 36.8-88.6 36.8s-64.1-12.2-88.6-36.8-36.8-54.1-36.8-88.6c0-22.6 5.7-43.6 17.1-63-42.8 21.8-78.3 54.8-106.7 98.9 24.8 38.3 55.9 68.7 93.4 91.4 37.4 22.7 77.9 34 121.6 34s84.2-11.4 121.6-34c37.5-22.7 68.6-53.1 93.4-91.4zm-205.5-98c2.6-2.6 3.9-5.8 3.9-9.5s-1.3-6.9-3.9-9.5c-2.6-2.6-5.8-3.9-9.5-3.9-23.4 0-43.4 8.3-60.1 25-16.7 16.7-25.1 36.7-25.1 60.1 0 3.8 1.3 6.9 3.9 9.5 2.6 2.7 5.8 3.9 9.6 3.9 3.7 0 6.9-1.3 9.5-3.9 2.6-2.6 3.9-5.8 3.9-9.5 0-16 5.7-29.8 17.1-41.2 11.4-11.4 25.1-17.1 41.2-17.1 3.7 0 6.9-1.3 9.5-3.9z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/filters/filtersPanel/panelFooter.js






var panelFooter_PanelFooter = function PanelFooter(props) {
  var toggleOption = props.toggleOption,
      isExpanded = props.isExpanded,
      isExpandable = props.isExpandable,
      moreOptionCount = props.moreOptionCount,
      togglePanel = props.togglePanel;


  var expandableContainerClassNames = classnames_default()('search-facet-panel-toggle', {
    'is-expanded': isExpanded && isExpandable
  });

  var expandableToggleClassNames = classnames_default()('search-facet-panel-toggle__link', {
    'is-expanded': isExpanded && isExpandable
  });

  var onSubmit = function onSubmit() {
    togglePanel();
  };

  return react_default.a.createElement(
    'div',
    { className: expandableContainerClassNames },
    react_default.a.createElement(
      'a',
      { className: expandableToggleClassNames, href: '', onClick: toggleOption },
      react_default.a.createElement(
        'span',
        null,
        react_default.a.createElement(preview, null),
        react_default.a.createElement(
          'span',
          { className: 'search-facet-panel-toggle__remaining' },
          'Show remaining ',
          moreOptionCount,
          ' options'
        )
      ),
      react_default.a.createElement(
        'span',
        null,
        'Hide options'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: 'search-facet-panel__action' },
      react_default.a.createElement(
        'button',
        {
          onClick: onSubmit,
          className: 'fds-c-button--3d -color-primary -width-full'
        },
        'Done'
      )
    )
  );
};

panelFooter_PanelFooter.propTypes = {
  toggleOption: prop_types_default.a.func.isRequired,
  togglePanel: prop_types_default.a.func.isRequired,
  isExpanded: prop_types_default.a.bool.isRequired,
  isExpandable: prop_types_default.a.bool.isRequired,
  moreOptionCount: prop_types_default.a.number.isRequired
};

/* harmony default export */ var panelFooter = (panelFooter_PanelFooter);
// EXTERNAL MODULE: ./common/utils/formatString.js
var formatString = __webpack_require__(14);

// EXTERNAL MODULE: ./common/constants/filterParamsConfig.js + 8 modules
var filterParamsConfig = __webpack_require__(16);

// CONCATENATED MODULE: ./client/components/filters/filtersPanel/panelBody.js












var panelBody_PanelBody = function PanelBody(props) {
  var items = props.items,
      isExpandable = props.isExpandable,
      isExpanded = props.isExpanded,
      parsedLocation = props.parsedLocation,
      togglePanel = props.togglePanel,
      type = props.type;


  var optionListClassNames = classnames_default()('search-facet-single-select-in-panel', {
    'is-expanded': isExpanded && isExpandable
  });

  var highestCount = items.map(function (item) {
    return item.count;
  }).reduce(function (pre, cur) {
    return pre > cur ? pre : cur;
  }, 0);

  // calculate the width of the category based on the count
  var calcWidthPercentage = function calcWidthPercentage(count) {
    var percentage = count / highestCount * 100;
    return percentage.toFixed(2);
  };

  var renderOption = function renderOption(item, idx) {
    var newQuery = Object.assign({}, parsedLocation);
    newQuery[type] = item.key;
    // reset page
    delete newQuery.page;

    // grep the last part of the chose category
    var displayName = titleize_default()(item.key);

    if (type === 'category') {
      displayName = titleize_default()(displayName.split('/') // eslint-disable-next-line
      [displayName.split('/').length - 1].split('-').join(' '));
    }

    var listClassName = classnames_default()({
      // only apply fds-u-is-hidden class when the list is expanded and has more than 10 items
      'fds-u-is-hidden': !isExpanded && idx >= showMoreThreshold[type]
    });

    var linkStyle = {
      minWidth: '50%',
      width: 'calc(' + calcWidthPercentage(item.count) + '% - 30px)'
    };

    return react_default.a.createElement(
      'li',
      { key: idx, className: listClassName },
      react_default.a.createElement(
        es["Link"],
        {
          style: linkStyle,
          onClick: togglePanel,
          to: Object(urlHelper["makeLink"])(newQuery),
          rel: 'nofollow'
        },
        react_default.a.createElement(
          'div',
          { className: 'search-facet-single-select-panel__title' },
          react_default.a.createElement(
            'div',
            { className: 'search-facet-single-select-panel__title-inner' },
            displayName
          )
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'search-facet-single-select-panel__count' },
        Object(formatString["commaStyleString"])(item.count)
      )
    );
  };

  // show category list if there are more than 0 item in the list
  if (items && items.length > 0) {
    return react_default.a.createElement(
      'ul',
      { className: optionListClassNames },
      items.map(function (item, idx) {
        return renderOption(item, idx);
      })
    );
    // if there's no more category to show, show the ran out of categoreis section
  } else {
    var parentQuery = Object.assign({}, parsedLocation);
    var delimiter = Object(lodash["get"])(filterParamsConfig["default"], type + '.delimiter');
    var optionArray = parsedLocation[type].split(delimiter);
    parentQuery[type] = optionArray.slice(0, optionArray.length - 1).join(delimiter);
    var parentQueryLink = Object(urlHelper["makeLink"])(parentQuery);
    return react_default.a.createElement(
      'div',
      { className: 'search-facet-panel__more-results' },
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body fds-u-mt4' },
        'Sorry, we ran out of options :)'
      ),
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body' },
        react_default.a.createElement(
          es["Link"],
          {
            className: 'fds-c-text-link -decoration-reversed',
            to: parentQueryLink,
            rel: 'nofollow'
          },
          'Take me back to the previous option'
        )
      )
    );
  }
};

panelBody_PanelBody.propTypes = {
  items: prop_types_default.a.array.isRequired,
  parsedLocation: prop_types_default.a.object.isRequired,
  isExpanded: prop_types_default.a.bool.isRequired,
  isExpandable: prop_types_default.a.bool.isRequired,
  togglePanel: prop_types_default.a.func.isRequired,
  type: prop_types_default.a.string.isRequired
};

/* harmony default export */ var panelBody = (panelBody_PanelBody);
// CONCATENATED MODULE: ./client/components/icons/arrowFillRight.js
var arrowFillRight__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var arrowFillRight = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    arrowFillRight__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Arrow-Fill-Right' },
      props.title || 'Arrow-Fill-Right'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M412.6 248.4c2.9 2.3 4.1 5.3 4.1 8.2 0 2.9-1.2 6.5-4.1 8.2l-295.6 242.7c-2.9 2.4-7 2.9-11.1 1.2-3.5-1.8-5.9-5.3-5.9-9.4v-485.5c0-4.1 2.3-7.6 5.9-9.4 4.1-1.8 8.2-1.2 11.1 1.2l295.6 242.8z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/filters/filtersPanel/panelHeader.js











var panelHeader_PanelHeader = function PanelHeader(props) {
  var togglePanel = props.togglePanel,
      parsedLocation = props.parsedLocation,
      rootCount = props.rootCount,
      type = props.type,
      breadcrumbsLabel = props.breadcrumbsLabel;


  var chosenOption = parsedLocation[type] || '';
  var delimiter = Object(lodash["get"])(filterParamsConfig["default"], type + '.delimiter');
  var chosenOptionArray = chosenOption.split(delimiter);
  var chosenOptionLength = chosenOptionArray.length;
  var chosenOptionDisplayName = titleize_default()(humanize_string_default()(chosenOptionArray[chosenOptionLength - 1]));

  var BreadLinks = [];
  for (var i = 0; i < chosenOptionLength; i++) {
    // return empty link for last item
    if (i === chosenOptionLength - 1) {
      BreadLinks.push(react_default.a.createElement(
        'a',
        { href: '', key: i, className: 'is-last' },
        react_default.a.createElement(arrowFillRight, {
          width: '9',
          height: '13',
          className: 'breadcrumbs__icon'
        }),
        chosenOptionDisplayName
      ));
    } else {
      var newQuery = Object.assign({}, parsedLocation);
      newQuery[type] = chosenOption.substring(0, chosenOption.indexOf(chosenOptionArray[i]) + chosenOptionArray[i].length);
      delete newQuery.page;
      var link = Object(urlHelper["makeLink"])(newQuery);
      BreadLinks.push(react_default.a.createElement(
        es["Link"],
        { onClick: togglePanel, key: i, rel: 'nofollow', to: link },
        react_default.a.createElement(arrowFillRight, {
          width: '9',
          height: '13',
          className: 'breadcrumbs__icon'
        }),
        titleize_default()(humanize_string_default()(chosenOptionArray[i]))
      ));
    }
  }

  // top level option link
  var rootQuery = Object.assign({}, parsedLocation);
  delete rootQuery[type];
  var rootLink = Object(urlHelper["makeLink"])(rootQuery);

  return react_default.a.createElement(
    'div',
    { className: 'search-facet-panel__breadcrumbs-wrapper' },
    react_default.a.createElement(
      'div',
      { className: 'search-facet-panel__breadcrumbs-intro' },
      react_default.a.createElement(
        'span',
        { className: 'fds-c-text-body -size-s' },
        'Show:'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: 'search-facet-panel__breadcrumbs' },
      react_default.a.createElement(
        'nav',
        { className: 'breadcrumbs -line-wrap -color-grey -icon-fill fds-u-text-truncate' },
        react_default.a.createElement(
          es["Link"],
          { onClick: togglePanel, rel: 'nofollow', to: rootLink },
          'All ',
          breadcrumbsLabel,
          react_default.a.createElement(
            'span',
            { className: 'breadcrumbs__count' },
            rootCount
          )
        ),
        BreadLinks
      )
    )
  );
};

panelHeader_PanelHeader.propTypes = {
  togglePanel: prop_types_default.a.func.isRequired,
  parsedLocation: prop_types_default.a.object.isRequired,
  rootCount: prop_types_default.a.number.isRequired,
  type: prop_types_default.a.string.isRequired,
  breadcrumbsLabel: prop_types_default.a.string.isRequired
};

/* harmony default export */ var panelHeader = (panelHeader_PanelHeader);
// EXTERNAL MODULE: ./client/components/icons/close.js
var icons_close = __webpack_require__(39);

// CONCATENATED MODULE: ./client/components/filters/filtersPanel/singleSelect.js
var singleSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function singleSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function singleSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function singleSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var singleSelect_FiltersSingleSelectPanel = function (_React$Component) {
  singleSelect__inherits(FiltersSingleSelectPanel, _React$Component);

  function FiltersSingleSelectPanel(props) {
    singleSelect__classCallCheck(this, FiltersSingleSelectPanel);

    var _this = singleSelect__possibleConstructorReturn(this, (FiltersSingleSelectPanel.__proto__ || Object.getPrototypeOf(FiltersSingleSelectPanel)).call(this, props));

    _this.state = {
      isExpanded: false
    };

    _this.toggleOption = _this.toggleOption.bind(_this);
    return _this;
  }

  singleSelect__createClass(FiltersSingleSelectPanel, [{
    key: 'toggleOption',
    value: function toggleOption(event) {
      event.preventDefault();
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isExpanded = this.state.isExpanded;
      var _props = this.props,
          items = _props.items,
          showPanel = _props.showPanel,
          togglePanel = _props.togglePanel,
          rootCount = _props.rootCount,
          parsedLocation = _props.parsedLocation,
          type = _props.type,
          breadcrumbsLabel = _props.breadcrumbsLabel;

      var isExpandable = items.length > showMoreThreshold[type];

      var panelBodyClassNames = classnames_default()('search-facet-panel__body', {
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: panelBodyClassNames },
        react_default.a.createElement(
          'div',
          { className: 'search-facet-panel__body-inner' },
          react_default.a.createElement(
            'button',
            {
              className: 'search-facet-panel__body-close fds-c-button',
              onClick: togglePanel
            },
            react_default.a.createElement(icons_close["default"], null)
          ),
          react_default.a.createElement(panelHeader, {
            togglePanel: togglePanel,
            parsedLocation: parsedLocation,
            rootCount: rootCount,
            type: type,
            breadcrumbsLabel: breadcrumbsLabel
          }),
          react_default.a.createElement(panelBody, {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            togglePanel: togglePanel,
            parsedLocation: parsedLocation,
            items: items,
            type: type
          }),
          isExpandable && react_default.a.createElement(panelFooter, {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            moreOptionCount: items.length - showMoreThreshold[type],
            toggleOption: this.toggleOption,
            togglePanel: togglePanel
          })
        )
      );
    }
  }]);

  return FiltersSingleSelectPanel;
}(react_default.a.Component);

singleSelect_FiltersSingleSelectPanel.propTypes = {
  items: prop_types_default.a.array.isRequired,
  parsedLocation: prop_types_default.a.object.isRequired,
  showPanel: prop_types_default.a.bool.isRequired,
  togglePanel: prop_types_default.a.func.isRequired,
  rootCount: prop_types_default.a.number.isRequired,
  type: prop_types_default.a.string.isRequired,
  breadcrumbsLabel: prop_types_default.a.string.isRequired
};

/* harmony default export */ var singleSelect = (singleSelect_FiltersSingleSelectPanel);
// EXTERNAL MODULE: ./common/utils/ga.js
var ga = __webpack_require__(13);

// CONCATENATED MODULE: ./common/analytics/filtersAnalytics.js


var filtersAnalytics_reportOpenSearchFilterPanel = function reportOpenSearchFilterPanel(panelName) {
  Object(ga["default"])('send', 'event', 'Search', 'click', 'open panel ' + panelName);
};
// EXTERNAL MODULE: ./client/components/icons/folder.js
var folder = __webpack_require__(147);

// EXTERNAL MODULE: ./client/components/icons/rightOpen.js
var rightOpen = __webpack_require__(34);

// CONCATENATED MODULE: ./client/components/filters/filtersCategory.js
var filtersCategory__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersCategory__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersCategory__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersCategory__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var filtersCategory_FiltersCategory = function (_React$Component) {
  filtersCategory__inherits(FiltersCategory, _React$Component);

  function FiltersCategory(props) {
    filtersCategory__classCallCheck(this, FiltersCategory);

    var _this = filtersCategory__possibleConstructorReturn(this, (FiltersCategory.__proto__ || Object.getPrototypeOf(FiltersCategory)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersCategory__createClass(FiltersCategory, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        filtersAnalytics_reportOpenSearchFilterPanel('Category');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }

    /**
     * because the result returned from api does include the top and sub category
     * we have to filter them and only keep the one that needs to be displayed in the UI
     */

  }, {
    key: 'filterOption',
    value: function filterOption(items, chosenCategory) {
      return items.filter(function (item, idx) {
        return item.key.indexOf(chosenCategory) > -1 && item.key !== chosenCategory;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          categoryRootCount = _props.categoryRootCount;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);

      var chosenCategory = parsedLocation.category || '';
      var chosenCategoryArray = chosenCategory.split('/');
      var chosenCategoryLength = chosenCategoryArray.length;
      var filteredCategoryItems = this.filterOption(items, chosenCategory);

      var renderChosenCategory = function renderChosenCategory() {
        var categoriesInBox = void 0;
        // show the top level categories if there's no selected category
        if (chosenCategory === '') {
          categoriesInBox = react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    titleize_default()(humanize_string_default()(item.key))
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
          // if there's a chosen category, show the breadcrumb menu
        } else {
          var getChosenCategoryDisplayName = function getChosenCategoryDisplayName(chosenCategory) {
            return chosenCategoryArray.map(function (categoryName, index) {
              var isLast = index === chosenCategoryLength - 1;
              return react_default.a.createElement(
                'div',
                { key: index, className: 'search-facet-panel__status-title' },
                titleize_default()(humanize_string_default()(categoryName)),
                !isLast && react_default.a.createElement(arrowFillRight, {
                  width: '10',
                  height: '15',
                  className: 'search-facet-panel__status-icon'
                })
              );
            });
          };
          categoriesInBox = react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              getChosenCategoryDisplayName(chosenCategory)
            )
          );
        }
        return categoriesInBox;
      };

      var panelHeaderClassNames = classnames_default()('search-facet-panel__header--start', {
        'is-active': showPanel
      });

      // TODO: fix animation for showing and hiding the panel
      // and possibly merge `OnKeyDown` and `ClickOutside` component
      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'category-filter' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(folder["a" /* default */], null),
            ' Category',
            react_default.a.createElement(
              'span',
              { style: { float: 'right' } },
              react_default.a.createElement(rightOpen["a" /* default */], null)
            )
          ),
          renderChosenCategory()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(singleSelect, {
              rootCount: categoryRootCount,
              showPanel: showPanel,
              items: filteredCategoryItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel,
              breadcrumbsLabel: 'categories',
              type: 'category'
            })
          )
        )
      );
    }
  }]);

  return FiltersCategory;
}(react_default.a.Component);

filtersCategory_FiltersCategory.propTypes = {
  items: prop_types_default.a.array.isRequired,
  location: prop_types_default.a.object.isRequired,
  categoryRootCount: prop_types_default.a.number.isRequired
};

var FiltersCategoryComponent = filtersCategory_FiltersCategory;
/* harmony default export */ var filtersCategory = (Object(es["withRouter"])(filtersCategory_FiltersCategory));
// CONCATENATED MODULE: ./client/components/filters/filtersPanel/multiSelectPanelFooter.js






var multiSelectPanelFooter_MultiSelectPanelFooter = function MultiSelectPanelFooter(props) {
  var onToggleOption = props.onToggleOption,
      onUpdateOption = props.onUpdateOption,
      togglePanel = props.togglePanel,
      isExpanded = props.isExpanded,
      isExpandable = props.isExpandable,
      moreOptionCount = props.moreOptionCount;


  var expandableContainerClassNames = classnames_default()('search-facet-panel-toggle', {
    'is-expanded': isExpanded && isExpandable
  });

  var expandableToggleClassNames = classnames_default()('search-facet-panel-toggle__link', {
    'is-expanded': isExpanded && isExpandable
  });

  // only show border top when the panel is expandable
  var expandableContainerStyle = isExpandable ? {} : {
    borderTop: 0
  };

  var onSubmit = function onSubmit() {
    togglePanel();
    onUpdateOption();
  };

  return react_default.a.createElement(
    'div',
    {
      style: expandableContainerStyle,
      className: expandableContainerClassNames
    },
    isExpandable && react_default.a.createElement(
      'a',
      {
        className: expandableToggleClassNames,
        href: '',
        onClick: onToggleOption
      },
      react_default.a.createElement(
        'span',
        null,
        react_default.a.createElement(preview, null),
        react_default.a.createElement(
          'span',
          { className: 'search-facet-panel-toggle__remaining' },
          'Show remaining ',
          moreOptionCount,
          ' options'
        )
      ),
      react_default.a.createElement(
        'span',
        null,
        'Hide options'
      )
    ),
    react_default.a.createElement(
      'div',
      { className: 'search-facet-panel__action' },
      react_default.a.createElement(
        'button',
        {
          onClick: onSubmit,
          className: 'fds-c-button--3d -color-primary -width-full'
        },
        'Done'
      )
    )
  );
};

multiSelectPanelFooter_MultiSelectPanelFooter.propTypes = {
  onToggleOption: prop_types_default.a.func.isRequired,
  onUpdateOption: prop_types_default.a.func.isRequired,
  togglePanel: prop_types_default.a.func.isRequired,
  isExpanded: prop_types_default.a.bool.isRequired,
  isExpandable: prop_types_default.a.bool.isRequired,
  moreOptionCount: prop_types_default.a.number.isRequired
};

/* harmony default export */ var multiSelectPanelFooter = (multiSelectPanelFooter_MultiSelectPanelFooter);
// EXTERNAL MODULE: ./client/components/icons/ok.js
var ok = __webpack_require__(40);

// EXTERNAL MODULE: ./client/components/icons/cancel.js
var cancel = __webpack_require__(166);

// CONCATENATED MODULE: ./client/components/filters/filtersPanel/multiSelectPanelBody.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var multiSelectPanelBody_MultiSelectPanelBody = function MultiSelectPanelBody(props) {
  var selectedOption = props.selectedOption,
      type = props.type,
      items = props.items,
      isExpandable = props.isExpandable,
      isExpanded = props.isExpanded,
      onSelectOption = props.onSelectOption;


  var listClassNames = classnames_default()('search-facet-multi-select-in-panel', {
    'is-expanded': isExpanded && isExpandable
  });

  var highestCount = items.map(function (item) {
    return item.count;
  }).reduce(function (pre, cur) {
    return pre > cur ? pre : cur;
  }, 0);

  // calculate the width of the category based on the count
  var calcWidthPercentage = function calcWidthPercentage(count) {
    var percentage = count / highestCount * 100;
    return percentage.toFixed(2);
  };

  var renderList = function renderList(item, idx) {
    // grep the last part of the chose category
    var displayName = item.label || titleize_default()(item.key);
    var listClassName = classnames_default()('search-facet-multi-select-panel__option', {
      'is-active': selectedOption.split(',').indexOf(item.key) >= 0,
      // only apply fds-u-is-hidden class when the list is expanded and has more than 10 items
      'fds-u-is-hidden': !isExpanded && idx >= showMoreThreshold[type]
    });

    var linkStyle = {
      minWidth: '50%',
      width: 'calc(' + calcWidthPercentage(item.count) + '% - 30px)'
    };

    var labelClassName = classnames_default()(_defineProperty({
      'search-panel-facet-colours__link': type === 'colors'
    }, '-color-' + item.key, type === 'colors'));

    var onClickHandler = function onClickHandler(e) {
      e.preventDefault();
      onSelectOption(item.key);
    };

    return react_default.a.createElement(
      'li',
      { key: idx, className: listClassName },
      react_default.a.createElement(
        'label',
        { className: labelClassName, onClick: onClickHandler },
        react_default.a.createElement(
          'div',
          {
            className: 'search-facet-multi-select-panel__title',
            style: linkStyle
          },
          react_default.a.createElement(
            'div',
            { className: 'search-facet-multi-select-panel__title-inner' },
            displayName
          )
        ),
        react_default.a.createElement(
          'div',
          { className: 'search-facet-multi-select-panel__count' },
          Object(formatString["commaStyleString"])(item.count)
        ),
        react_default.a.createElement(
          'div',
          { className: 'search-facet-multi-select-panel__status' },
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(ok["default"], { title: 'selection active' })
          ),
          react_default.a.createElement(
            'div',
            null,
            react_default.a.createElement(cancel["a" /* default */], { title: 'remove selection' })
          )
        ),
        react_default.a.createElement('input', { name: type + '[]', type: 'checkbox', value: item.key })
      )
    );
  };

  // show category list if there are more than 0 item in the list
  if (items && items.length > 0) {
    return react_default.a.createElement(
      'ul',
      { className: listClassNames },
      items.map(function (item, idx) {
        return renderList(item, idx);
      })
    );
    // if there's no more category to show, show the ran out of categoreis section
  } else {
    return react_default.a.createElement(
      'div',
      { className: 'search-facet-panel__more-results' },
      react_default.a.createElement(
        'p',
        { className: 'fds-c-text-body fds-u-mt4' },
        'Sorry, we ran out of option :)'
      )
    );
  }
};

multiSelectPanelBody_MultiSelectPanelBody.propTypes = {
  type: prop_types_default.a.string.isRequired,
  items: prop_types_default.a.array.isRequired,
  parsedLocation: prop_types_default.a.object.isRequired,
  selectedOption: prop_types_default.a.string.isRequired,
  isExpanded: prop_types_default.a.bool.isRequired,
  isExpandable: prop_types_default.a.bool.isRequired,
  onSelectOption: prop_types_default.a.func.isRequired
};

/* harmony default export */ var multiSelectPanelBody = (multiSelectPanelBody_MultiSelectPanelBody);
// CONCATENATED MODULE: ./client/components/filters/filtersPanel/multiSelect.js
var multiSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function multiSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function multiSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function multiSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var multiSelect_FiltersMultiSelectPanel = function (_React$Component) {
  multiSelect__inherits(FiltersMultiSelectPanel, _React$Component);

  function FiltersMultiSelectPanel(props) {
    multiSelect__classCallCheck(this, FiltersMultiSelectPanel);

    var _this = multiSelect__possibleConstructorReturn(this, (FiltersMultiSelectPanel.__proto__ || Object.getPrototypeOf(FiltersMultiSelectPanel)).call(this, props));

    _this.state = {
      isExpanded: false,
      selectedOption: props.parsedLocation[props.type] || ''
    };

    _this.onToggleOption = _this.onToggleOption.bind(_this);
    _this.onUpdateOption = _this.onUpdateOption.bind(_this);
    _this.onSelectOption = _this.onSelectOption.bind(_this);
    return _this;
  }

  multiSelect__createClass(FiltersMultiSelectPanel, [{
    key: 'onToggleOption',
    value: function onToggleOption(event) {
      event.preventDefault();
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: 'onSelectOption',
    value: function onSelectOption(option) {
      var selectedOption = this.state.selectedOption;

      var selectedOptionArray = selectedOption !== '' ? selectedOption.split(',') : [];
      if (selectedOptionArray.indexOf(option) >= 0) {
        this.setState({
          selectedOption: selectedOptionArray.filter(function (opts) {
            return opts !== option;
          }).join(',')
        });
      } else {
        this.setState({
          selectedOption: [].concat(_toConsumableArray(selectedOptionArray), [option]).join(',')
        });
      }
    }
  }, {
    key: 'onUpdateOption',
    value: function onUpdateOption() {
      var selectedOption = this.state.selectedOption;
      var _props = this.props,
          parsedLocation = _props.parsedLocation,
          history = _props.history,
          type = _props.type;


      var newQuery = Object.assign({}, parsedLocation);
      newQuery[type] = selectedOption;

      // reset page param
      delete newQuery.page;

      history.push(Object(urlHelper["makeLink"])(newQuery));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isExpanded = _state.isExpanded,
          selectedOption = _state.selectedOption;
      var _props2 = this.props,
          items = _props2.items,
          showPanel = _props2.showPanel,
          togglePanel = _props2.togglePanel,
          parsedLocation = _props2.parsedLocation,
          type = _props2.type;

      var isExpandable = items.length > showMoreThreshold[type];

      var panelBodyClassNames = classnames_default()('search-facet-panel__body', {
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: panelBodyClassNames },
        react_default.a.createElement(
          'div',
          { className: 'search-facet-panel__body-inner' },
          react_default.a.createElement(
            'button',
            {
              className: 'search-facet-panel__body-close fds-c-button',
              onClick: togglePanel
            },
            react_default.a.createElement(icons_close["default"], null)
          ),
          react_default.a.createElement(multiSelectPanelBody, {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            onSelectOption: this.onSelectOption,
            parsedLocation: parsedLocation,
            selectedOption: selectedOption,
            items: items,
            type: type
          }),
          react_default.a.createElement(multiSelectPanelFooter, {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            moreOptionCount: items.length - showMoreThreshold[type],
            onToggleOption: this.onToggleOption,
            togglePanel: togglePanel,
            onUpdateOption: this.onUpdateOption
          })
        )
      );
    }
  }]);

  return FiltersMultiSelectPanel;
}(react_default.a.Component);

multiSelect_FiltersMultiSelectPanel.propTypes = {
  type: prop_types_default.a.string.isRequired,
  items: prop_types_default.a.array.isRequired,
  parsedLocation: prop_types_default.a.object.isRequired,
  showPanel: prop_types_default.a.bool.isRequired,
  togglePanel: prop_types_default.a.func.isRequired
};

/* harmony default export */ var multiSelect = (Object(es["withRouter"])(multiSelect_FiltersMultiSelectPanel));
// EXTERNAL MODULE: ./client/components/icons/tag.js
var tag = __webpack_require__(148);

// CONCATENATED MODULE: ./client/components/filters/filtersTags.js
var filtersTags__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersTags__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersTags__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersTags__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var filtersTags_FiltersTags = function (_React$Component) {
  filtersTags__inherits(FiltersTags, _React$Component);

  function FiltersTags(props) {
    filtersTags__classCallCheck(this, FiltersTags);

    var _this = filtersTags__possibleConstructorReturn(this, (FiltersTags.__proto__ || Object.getPrototypeOf(FiltersTags)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersTags__createClass(FiltersTags, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        filtersAnalytics_reportOpenSearchFilterPanel('Tags');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);
      var chosenTags = parsedLocation.tags || '';

      var renderChosenTags = function renderChosenTags() {
        if (chosenTags === '') {
          return react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.key
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenTags.split(',').join(', ')
              )
            )
          );
        }
      };

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'tags-filter' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(tag["a" /* default */], null),
            ' Tags',
            react_default.a.createElement(
              'span',
              { style: { float: 'right' } },
              react_default.a.createElement(rightOpen["a" /* default */], null)
            )
          ),
          renderChosenTags()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(multiSelect, {
              type: 'tags',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersTags;
}(react_default.a.Component);

filtersTags_FiltersTags.propTypes = {
  location: prop_types_default.a.object.isRequired,
  items: prop_types_default.a.array
};

var FiltersTagsComponent = filtersTags_FiltersTags;
/* harmony default export */ var filtersTags = (Object(es["withRouter"])(filtersTags_FiltersTags));
// EXTERNAL MODULE: ./client/components/icons/dollar.js
var dollar = __webpack_require__(149);

// EXTERNAL MODULE: ./client/components/icons/search.js
var search = __webpack_require__(36);

// CONCATENATED MODULE: ./client/components/filters/filtersPrice.js
var filtersPrice__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersPrice__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersPrice__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersPrice__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var filtersPrice_FiltersPrice = function (_React$Component) {
  filtersPrice__inherits(FiltersPrice, _React$Component);

  function FiltersPrice(props) {
    filtersPrice__classCallCheck(this, FiltersPrice);

    var _this = filtersPrice__possibleConstructorReturn(this, (FiltersPrice.__proto__ || Object.getPrototypeOf(FiltersPrice)).call(this, props));

    var query = props.location.query;


    _this.state = {
      priceMin: query ? query.price_min : '',
      priceMax: query ? query.price_max : ''
    };
    return _this;
  }

  filtersPrice__createClass(FiltersPrice, [{
    key: 'onPriceMinChange',
    value: function onPriceMinChange(event) {
      this.setState({ priceMin: event.target.value });
    }
  }, {
    key: 'onPriceMaxChange',
    value: function onPriceMaxChange(event) {
      this.setState({ priceMax: event.target.value });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var parsedLocation = Object(urlHelper["parseLocation"])(this.props.location);

      var nextQuery = Object.assign({}, parsedLocation, {
        price_min: this.state.priceMin,
        price_max: this.state.priceMax
      });
      delete nextQuery.page;

      if (!this.state.priceMin) {
        delete nextQuery.price_min;
      }

      if (!this.state.priceMax) {
        delete nextQuery.price_max;
      }

      this.props.history.push(Object(urlHelper["makeLink"])(nextQuery));
    }
  }, {
    key: 'onEnter',
    value: function onEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextQuery = nextProps.location.query;

      if (nextQuery.price_min !== this.state.priceMin) {
        this.setState({ priceMin: nextQuery.price_min || '' });
      }

      if (nextQuery.price_max !== this.state.priceMax) {
        this.setState({ priceMax: nextQuery.price_max || '' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isAtTop = this.props.isAtTop;

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-box__inner': !isAtTop
      });
      var searchFacetBoxClassNames = classnames_default()({
        'search-facet-box': !isAtTop
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'price-filter' },
        react_default.a.createElement(
          'div',
          { className: searchFacetBoxClassNames },
          react_default.a.createElement(
            'div',
            { className: panelHeaderClassNames },
            react_default.a.createElement(
              'h2',
              { className: 'search-facet-box__heading' },
              react_default.a.createElement(dollar["a" /* default */], null),
              ' Price',
              react_default.a.createElement(
                'span',
                { style: { float: 'right' } },
                react_default.a.createElement(rightOpen["a" /* default */], null)
              )
            ),
            react_default.a.createElement(
              'div',
              { className: 'search-facet-range__inputs' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input--with-prefix' },
                react_default.a.createElement(
                  'label',
                  null,
                  'From'
                ),
                react_default.a.createElement(
                  'span',
                  null,
                  '$'
                ),
                react_default.a.createElement('input', {
                  type: 'number',
                  className: 'e-input',
                  placeholder: this.props.cost ? this.props.cost.min / 100 : '',
                  value: this.state.priceMin,
                  onChange: this.onPriceMinChange.bind(this),
                  onKeyPress: this.onEnter.bind(this)
                })
              ),
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input--with-prefix' },
                react_default.a.createElement(
                  'label',
                  null,
                  'To'
                ),
                react_default.a.createElement(
                  'span',
                  null,
                  '$'
                ),
                react_default.a.createElement('input', {
                  type: 'number',
                  className: 'e-input',
                  placeholder: this.props.cost ? this.props.cost.max / 100 : '',
                  value: this.state.priceMax,
                  onChange: this.onPriceMaxChange.bind(this),
                  onKeyPress: this.onEnter.bind(this)
                })
              ),
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input--submit' },
                react_default.a.createElement(
                  'button',
                  {
                    type: 'button',
                    className: 'fds-c-button fds-u-p0 no-label',
                    onClick: this.onSubmit.bind(this)
                  },
                  react_default.a.createElement(search["default"], { title: 'Apply' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FiltersPrice;
}(react_default.a.Component);

filtersPrice_FiltersPrice.propTypes = {
  cost: prop_types_default.a.object,
  location: prop_types_default.a.object.isRequired
};


var FiltersPriceComponent = filtersPrice_FiltersPrice;
/* harmony default export */ var filtersPrice = (Object(es["withRouter"])(filtersPrice_FiltersPrice));
// EXTERNAL MODULE: ./client/components/icons/code.js
var code = __webpack_require__(103);

// CONCATENATED MODULE: ./client/components/filters/filtersCompatibleWith.js
var filtersCompatibleWith__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersCompatibleWith__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersCompatibleWith__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersCompatibleWith__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var filtersCompatibleWith_FiltersCompatibleWith = function (_React$Component) {
  filtersCompatibleWith__inherits(FiltersCompatibleWith, _React$Component);

  function FiltersCompatibleWith(props) {
    filtersCompatibleWith__classCallCheck(this, FiltersCompatibleWith);

    var _this = filtersCompatibleWith__possibleConstructorReturn(this, (FiltersCompatibleWith.__proto__ || Object.getPrototypeOf(FiltersCompatibleWith)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersCompatibleWith__createClass(FiltersCompatibleWith, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        filtersAnalytics_reportOpenSearchFilterPanel('Compatible with');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);

      var chosenCompatibleWith = parsedLocation.compatible_with || '';

      var renderChosenOptions = function renderChosenOptions() {
        if (chosenCompatibleWith === '') {
          return react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.key
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenCompatibleWith.split(',').join(', ')
              )
            )
          );
        }
      };

      var isAtTop = this.props.isAtTop;

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--one-facet': isAtTop,
        'search-facet-panel__header--end': !isAtTop,
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'compatible-with-filter' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(code["a" /* default */], null),
            ' Compatible with',
            react_default.a.createElement(
              'span',
              { style: { float: 'right' } },
              react_default.a.createElement(rightOpen["a" /* default */], null)
            )
          ),
          renderChosenOptions()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(multiSelect, {
              type: 'compatible_with',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersCompatibleWith;
}(react_default.a.Component);

filtersCompatibleWith_FiltersCompatibleWith.propTypes = {
  items: prop_types_default.a.array.isRequired,
  location: prop_types_default.a.object.isRequired
};

/* harmony default export */ var filtersCompatibleWith = (filtersCompatibleWith_FiltersCompatibleWith);
// CONCATENATED MODULE: ./client/components/filters/filtersSoftwareVersion.js
var filtersSoftwareVersion__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersSoftwareVersion__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersSoftwareVersion__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersSoftwareVersion__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var filtersSoftwareVersion_FiltersSoftwareVersion = function (_React$Component) {
  filtersSoftwareVersion__inherits(FiltersSoftwareVersion, _React$Component);

  function FiltersSoftwareVersion(props) {
    filtersSoftwareVersion__classCallCheck(this, FiltersSoftwareVersion);

    var _this = filtersSoftwareVersion__possibleConstructorReturn(this, (FiltersSoftwareVersion.__proto__ || Object.getPrototypeOf(FiltersSoftwareVersion)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersSoftwareVersion__createClass(FiltersSoftwareVersion, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        filtersAnalytics_reportOpenSearchFilterPanel('Software version');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(items, chosenPlatform) {
      return items.filter(function (item, idx) {
        return item.key.indexOf(chosenPlatform) > -1 && item.key !== chosenPlatform;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          platformRootCount = _props.platformRootCount;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);

      var chosenPlatform = parsedLocation.platform || '';
      var chosenPlatformArray = chosenPlatform.split(' ');
      var chosenPlatformLength = chosenPlatformArray.length;
      var filteredPlatformItems = this.filterOption(items, chosenPlatform);

      var renderChosenPlatform = function renderChosenPlatform() {
        if (chosenPlatform === '') {
          return react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    titleize_default()(item.key)
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          var getChosenPlatformDisplayName = function getChosenPlatformDisplayName(chosenPlatform) {
            return chosenPlatformArray.map(function (platformName, index) {
              var isLast = index === chosenPlatformLength - 1;
              return react_default.a.createElement(
                'div',
                { key: index, className: 'search-facet-panel__status-title' },
                titleize_default()(platformName),
                !isLast && react_default.a.createElement(arrowFillRight, null)
              );
            });
          };
          return react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              getChosenPlatformDisplayName(chosenPlatform)
            )
          );
        }
      };

      var isAtTop = this.props.isAtTop;
      var isAtBottom = this.props.isAtBottom;

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop && !isAtBottom,
        'search-facet-panel__header--one-facet': isAtTop && isAtBottom,
        'search-facet-panel__header--end': isAtBottom,
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'software-version-filter' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(code["a" /* default */], null),
            ' Software version',
            react_default.a.createElement(
              'span',
              { style: { float: 'right' } },
              react_default.a.createElement(rightOpen["a" /* default */], null)
            )
          ),
          renderChosenPlatform()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(singleSelect, {
              rootCount: platformRootCount,
              showPanel: showPanel,
              items: filteredPlatformItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel,
              breadcrumbsLabel: 'software versions',
              type: 'platform'
            })
          )
        )
      );
    }
  }]);

  return FiltersSoftwareVersion;
}(react_default.a.Component);

filtersSoftwareVersion_FiltersSoftwareVersion.propTypes = {
  items: prop_types_default.a.array.isRequired,
  location: prop_types_default.a.object.isRequired,
  platformRootCount: prop_types_default.a.number.isRequired
};

/* harmony default export */ var filtersSoftwareVersion = (filtersSoftwareVersion_FiltersSoftwareVersion);
// EXTERNAL MODULE: ./client/components/icons/polygon.js
var polygon = __webpack_require__(152);

// CONCATENATED MODULE: ./client/components/filters/filtersPolygons.js
var filtersPolygons__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersPolygons__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersPolygons__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersPolygons__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var filtersPolygons_FiltersPolygons = function (_React$Component) {
  filtersPolygons__inherits(FiltersPolygons, _React$Component);

  function FiltersPolygons(props) {
    filtersPolygons__classCallCheck(this, FiltersPolygons);

    var _this = filtersPolygons__possibleConstructorReturn(this, (FiltersPolygons.__proto__ || Object.getPrototypeOf(FiltersPolygons)).call(this, props));

    var query = props.location.query;

    _this.state = {
      value: query && query.poly_count ? query.poly_count : ''
    };
    return _this;
  }

  filtersPolygons__createClass(FiltersPolygons, [{
    key: 'onChange',
    value: function onChange(event) {
      this.setState({ value: event.target.value });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var parsedLocation = Object(urlHelper["parseLocation"])(this.props.location);

      var nextQuery = Object.assign({}, parsedLocation, {
        poly_count: this.state.value
      });

      delete nextQuery.page;

      this.props.history.push(Object(urlHelper["makeLink"])(nextQuery));
    }
  }, {
    key: 'onEnter',
    value: function onEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextQuery = nextProps.location.query;

      if (nextQuery && nextQuery.poly_count !== this.state.value) {
        this.setState({ value: nextQuery.poly_count || '' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var items = this.props.items;

      var placeholder = items.avg + ', ' + items.min + '-' + items.max;

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'polygons-filter' },
        react_default.a.createElement(
          'div',
          { className: 'search-facet-box--start' },
          react_default.a.createElement(
            'div',
            { className: 'search-facet-box__inner' },
            react_default.a.createElement(
              'h2',
              { className: 'search-facet-box__heading' },
              react_default.a.createElement(polygon["a" /* default */], null),
              ' Polygons'
            ),
            react_default.a.createElement(
              'div',
              { className: 'search-facet-range__inputs' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input--single' },
                react_default.a.createElement(
                  'label',
                  {
                    className: 'fds-u-is-visually-hidden',
                    htmlFor: 'poly_count'
                  },
                  'Polygons'
                ),
                react_default.a.createElement('input', {
                  type: 'text',
                  id: 'poly_count',
                  className: 'e-input',
                  placeholder: placeholder,
                  pattern: '(\\d+\\s*\\-\\s*\\d+|\\d+)',
                  value: this.state.value,
                  onChange: this.onChange.bind(this),
                  onKeyPress: this.onEnter.bind(this)
                })
              ),
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input--submit' },
                react_default.a.createElement(
                  'button',
                  {
                    type: 'button',
                    className: 'fds-c-button fds-u-p0',
                    onClick: this.onSubmit.bind(this)
                  },
                  react_default.a.createElement(search["default"], { title: 'Apply' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FiltersPolygons;
}(react_default.a.Component);

filtersPolygons_FiltersPolygons.propTypes = {
  location: prop_types_default.a.object.isRequired,
  items: prop_types_default.a.object.isRequired
};


var FiltersPolygonsComponent = filtersPolygons_FiltersPolygons;
/* harmony default export */ var filtersPolygons = (Object(es["withRouter"])(filtersPolygons_FiltersPolygons));
// EXTERNAL MODULE: ./client/components/icons/document.js
var icons_document = __webpack_require__(156);

// CONCATENATED MODULE: ./client/components/filters/filtersFileType.js
var filtersFileType__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersFileType__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersFileType__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersFileType__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var filtersFileType_FiltersFileType = function (_React$Component) {
  filtersFileType__inherits(FiltersFileType, _React$Component);

  function FiltersFileType(props) {
    filtersFileType__classCallCheck(this, FiltersFileType);

    var _this = filtersFileType__possibleConstructorReturn(this, (FiltersFileType.__proto__ || Object.getPrototypeOf(FiltersFileType)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersFileType__createClass(FiltersFileType, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);
      var formattedItems = items.map(function (item) {
        return Object.assign({}, item, {
          label: Object(lodash["get"])(filterParamsConfig["default"], 'file_formats.labels.' + item.key)
        });
      });

      var chosenFileType = parsedLocation.file_formats || '';

      var renderChosenOptions = function renderChosenOptions() {
        if (chosenFileType === '') {
          return react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            formattedItems.map(function (item, index) {
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.label
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenFileType.split(',').join(', ')
              )
            )
          );
        }
      };

      var isAtTop = this.props.isAtTop;

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--one-facet': isAtTop,
        'search-facet-panel__header--end': !isAtTop,
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'file-type-filter' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(icons_document["a" /* default */], null),
            ' File type'
          ),
          renderChosenOptions()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(multiSelect, {
              type: 'file_formats',
              showPanel: showPanel,
              items: formattedItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersFileType;
}(react_default.a.Component);

filtersFileType_FiltersFileType.propTypes = {
  items: prop_types_default.a.array.isRequired,
  location: prop_types_default.a.object.isRequired
};

/* harmony default export */ var filtersFileType = (filtersFileType_FiltersFileType);
// EXTERNAL MODULE: ./node_modules/lodash/intersection.js
var intersection = __webpack_require__(362);
var intersection_default = /*#__PURE__*/__webpack_require__.n(intersection);

// CONCATENATED MODULE: ./client/components/filters/selectedFilters/filterItem.js







/**
 * A function to render the selected filter link
 * @param  {String} the type of the param, can be category, tags
 * @param  {String} the displayName of the filter
 * @param  {String} the link to the filter
 * @param  {Number} the index of the current option
 * @return {HTML} HTML for the option
 */
var filterItem_FilterItem = function FilterItem(_ref) {
  var paramType = _ref.paramType,
      displayName = _ref.displayName,
      link = _ref.link,
      index = _ref.index;

  var Icon = filterParamsConfig["default"][paramType].icon;
  // only show icon for the first item
  return react_default.a.createElement(
    'li',
    { key: index },
    react_default.a.createElement(
      'div',
      { className: 'search-facet-actives__facet' },
      react_default.a.createElement(
        'span',
        { className: 'search-facet-actives__icon' },
        index === 0 ? react_default.a.createElement(Icon, null) : null
      ),
      react_default.a.createElement(
        'span',
        { className: 'search-facet-actives__text' },
        displayName
      ),
      react_default.a.createElement(
        es["Link"],
        { to: link, className: 'search-facet-actives__glyph-cancel' },
        react_default.a.createElement(cancel["a" /* default */], null)
      )
    )
  );
};

filterItem_FilterItem.propTypes = {
  paramType: prop_types_default.a.string.isRequired,
  displayName: prop_types_default.a.string.isRequired,
  link: prop_types_default.a.string.isRequired,
  index: prop_types_default.a.number.isRequired
};

/* harmony default export */ var filterItem = (filterItem_FilterItem);
// EXTERNAL MODULE: ./client/components/filters/selectedFilters/filterList.js
var filterList = __webpack_require__(202);

// CONCATENATED MODULE: ./client/components/filters/selectedFilters/index.js











var selectedFilters_SelectedFilters = function SelectedFilters(props) {
  var location = props.location;


  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  // check there are selected filters and the selected filters are in the filter param config
  var hasSelectedFilter = Object.keys(parsedLocation).length > 0 &&
  // has valid filters
  intersection_default()(Object.keys(parsedLocation), Object.keys(filterParamsConfig["default"])).length > 0;

  var clearAllLink = parsedLocation.term ? Object(urlHelper["makeLink"])({ category: 'all', term: parsedLocation.term }) : Object(urlHelper["makeLink"])({ category: 'all' });

  var filteredFilters = Object.keys(parsedLocation).sort(function (param1, param2) {
    return Object(lodash["get"])(filterParamsConfig["default"], param1 + '.order') > Object(lodash["get"])(filterParamsConfig["default"], param2 + '.order');
  });

  // if price_min and price_max are selected at the same time, only show one of them.
  if (parsedLocation.price_min && parsedLocation.price_max) {
    filteredFilters = filteredFilters.filter(function (filter) {
      return filter !== 'price_min';
    });
  }

  // if length_min and length_max are selected at the same time, only show one of them.
  if (parsedLocation.length_min && parsedLocation.length_max) {
    filteredFilters = filteredFilters.filter(function (filter) {
      return filter !== 'length_min';
    });
  }

  return react_default.a.createElement(
    'div',
    { id: 'selected-filters' },
    !hasSelectedFilter && react_default.a.createElement(
      'div',
      { className: 'search-facet-refine' },
      'Refine your results:'
    ),
    hasSelectedFilter && react_default.a.createElement(
      'div',
      { className: 'search-facet' },
      react_default.a.createElement(
        'div',
        { className: 'search-facet-actives__remove-all' },
        'Your filters:',
        react_default.a.createElement(
          es["Link"],
          { to: clearAllLink },
          'Clear all'
        )
      ),
      react_default.a.createElement(
        'div',
        { className: 'search-facet-actives__facet-wrapper' },
        filteredFilters.map(function (param, key) {
          return react_default.a.createElement(filterList["a" /* default */], {
            FilterItem: filterItem,
            parsedLocation: parsedLocation,
            param: param,
            key: key
          });
        })
      )
    )
  );
};

selectedFilters_SelectedFilters.propTypes = {
  location: prop_types_default.a.object.isRequired
};

/* harmony default export */ var selectedFilters = (selectedFilters_SelectedFilters);
// EXTERNAL MODULE: ./client/components/icons/ruler.js
var ruler = __webpack_require__(154);

// CONCATENATED MODULE: ./client/components/filters/filtersSize.js
var filtersSize__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var filtersSize__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersSize__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersSize__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersSize__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var sizeFilterLabels = filterParamsConfig["default"].sizes.labels;

var filtersSize_FiltersSize = function (_React$Component) {
  filtersSize__inherits(FiltersSize, _React$Component);

  function FiltersSize(props) {
    filtersSize__classCallCheck(this, FiltersSize);

    var _this = filtersSize__possibleConstructorReturn(this, (FiltersSize.__proto__ || Object.getPrototypeOf(FiltersSize)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersSize__createClass(FiltersSize, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        filtersAnalytics_reportOpenSearchFilterPanel('Size');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);
      var chosenSizes = parsedLocation.sizes || '';

      var renderChosenSizes = function renderChosenSizes() {
        if (chosenSizes === '') {
          return react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              var label = sizeFilterLabels[item.key] || item.key;
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    label
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          var chosenSizesLabels = chosenSizes.split(',').map(function (key) {
            return sizeFilterLabels[key] || key;
          }).join(', ');
          return react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenSizesLabels
              )
            )
          );
        }
      };

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'is-active': showPanel
      });

      // append the label to the items object
      var formatItems = function formatItems(items) {
        return items.map(function (item) {
          return filtersSize__extends({
            label: sizeFilterLabels[item.key] || item.key
          }, item);
        });
      };

      var formattedItems = formatItems(items);

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(ruler["a" /* default */], null),
            ' Sizes',
            react_default.a.createElement(
              'span',
              { style: { float: 'right' } },
              react_default.a.createElement(rightOpen["a" /* default */], null)
            )
          ),
          renderChosenSizes()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(multiSelect, {
              type: 'sizes',
              showPanel: showPanel,
              items: formattedItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersSize;
}(react_default.a.Component);

filtersSize_FiltersSize.propTypes = {
  location: prop_types_default.a.object.isRequired,
  items: prop_types_default.a.array
};

/* harmony default export */ var filtersSize = (filtersSize_FiltersSize);
// EXTERNAL MODULE: ./client/components/icons/palette.js
var palette = __webpack_require__(153);

// CONCATENATED MODULE: ./client/components/filters/filtersColors.js
var filtersColors__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersColors__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersColors__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersColors__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var filtersColors_FiltersColors = function (_React$Component) {
  filtersColors__inherits(FiltersColors, _React$Component);

  function FiltersColors(props) {
    filtersColors__classCallCheck(this, FiltersColors);

    var _this = filtersColors__possibleConstructorReturn(this, (FiltersColors.__proto__ || Object.getPrototypeOf(FiltersColors)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersColors__createClass(FiltersColors, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        filtersAnalytics_reportOpenSearchFilterPanel('colors');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop,
          isAtBottom = _props.isAtBottom;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);

      var chosenColors = parsedLocation.colors || '';

      var renderChosenColors = function renderChosenColors() {
        if (chosenColors === '') {
          return react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.key
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenColors.split(',').join(', ')
              )
            )
          );
        }
      };

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'search-facet-panel__header--end': isAtBottom,
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'colors-filter' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(palette["a" /* default */], null),
            ' Colors'
          ),
          renderChosenColors()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(multiSelect, {
              type: 'colors',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersColors;
}(react_default.a.Component);

filtersColors_FiltersColors.propTypes = {
  location: prop_types_default.a.object.isRequired,
  items: prop_types_default.a.array
};

/* harmony default export */ var filtersColors = (filtersColors_FiltersColors);
// EXTERNAL MODULE: ./common/utils/time.js
var time = __webpack_require__(168);

// EXTERNAL MODULE: ./client/components/icons/clock.js
var clock = __webpack_require__(88);

// CONCATENATED MODULE: ./client/components/filters/filtersLength.js
var filtersLength__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersLength__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersLength__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersLength__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var filtersLength_FiltersLength = function (_React$Component) {
  filtersLength__inherits(FiltersLength, _React$Component);

  function FiltersLength(props) {
    filtersLength__classCallCheck(this, FiltersLength);

    var _this = filtersLength__possibleConstructorReturn(this, (FiltersLength.__proto__ || Object.getPrototypeOf(FiltersLength)).call(this, props));

    var query = props.location.query;

    _this.state = {
      lengthMin: Object(time["a" /* getMinutesSecondsTime */])(query.length_min),
      lengthMax: Object(time["a" /* getMinutesSecondsTime */])(query.length_max)
    };
    return _this;
  }

  filtersLength__createClass(FiltersLength, [{
    key: 'onLengthMinChange',
    value: function onLengthMinChange(event) {
      this.setState({ lengthMin: event.target.value });
    }
  }, {
    key: 'onLengthMaxChange',
    value: function onLengthMaxChange(event) {
      this.setState({ lengthMax: event.target.value });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var parsedLocation = Object(urlHelper["parseLocation"])(this.props.location);

      var nextQuery = Object.assign({}, parsedLocation, {
        length_min: Object(time["a" /* getMinutesSecondsTime */])(this.state.lengthMin),
        length_max: Object(time["a" /* getMinutesSecondsTime */])(this.state.lengthMax)
      });

      delete nextQuery.page;

      if (!this.state.lengthMin) {
        delete nextQuery.length_min;
      }

      if (!this.state.lengthMax) {
        delete nextQuery.length_max;
      }

      this.props.history.push(Object(urlHelper["makeLink"])(nextQuery));
    }
  }, {
    key: 'onEnter',
    value: function onEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextQuery = nextProps.location.query;

      if (nextQuery.length_min !== this.state.lengthMin) {
        this.setState({ lengthMin: Object(time["a" /* getMinutesSecondsTime */])(nextQuery.length_min) });
      }

      if (nextQuery.length_max !== this.state.lengthMax) {
        this.setState({ lengthMax: Object(time["a" /* getMinutesSecondsTime */])(nextQuery.length_max) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isAtTop = this.props.isAtTop;

      var searchFacetBoxClassNames = classnames_default()({
        'search-facet-box': !isAtTop,
        'search-facet-box--start': isAtTop
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'length-filter' },
        react_default.a.createElement(
          'div',
          { className: searchFacetBoxClassNames },
          react_default.a.createElement(
            'div',
            { className: 'search-facet-box__inner' },
            react_default.a.createElement(
              'h2',
              { className: 'search-facet-box__heading' },
              react_default.a.createElement(clock["a" /* default */], null),
              ' Length'
            ),
            react_default.a.createElement(
              'div',
              { className: 'search-facet-range__inputs' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input' },
                react_default.a.createElement(
                  'label',
                  null,
                  'Length'
                ),
                react_default.a.createElement('input', {
                  type: 'text',
                  className: 'e-input',
                  placeholder: this.props.length ? Object(time["a" /* getMinutesSecondsTime */])(this.props.length.min) : '',
                  value: this.state.lengthMin,
                  onChange: this.onLengthMinChange.bind(this),
                  onKeyPress: this.onEnter.bind(this)
                })
              ),
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input' },
                react_default.a.createElement(
                  'label',
                  null,
                  'To'
                ),
                react_default.a.createElement('input', {
                  type: 'text',
                  className: 'e-input',
                  placeholder: this.props.length ? Object(time["a" /* getMinutesSecondsTime */])(this.props.length.max) : '',
                  value: this.state.lengthMax,
                  onChange: this.onLengthMaxChange.bind(this),
                  onKeyPress: this.onEnter.bind(this)
                })
              ),
              react_default.a.createElement(
                'div',
                { className: 'search-facet-range__input--submit' },
                react_default.a.createElement(
                  'button',
                  {
                    type: 'button',
                    className: 'fds-c-button fds-u-p0 no-label',
                    onClick: this.onSubmit.bind(this)
                  },
                  react_default.a.createElement(search["default"], { title: 'Apply' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FiltersLength;
}(react_default.a.Component);

filtersLength_FiltersLength.propTypes = {
  length: prop_types_default.a.object,
  location: prop_types_default.a.object.isRequired
};


var FiltersLengthComponent = filtersLength_FiltersLength;
/* harmony default export */ var filtersLength = (Object(es["withRouter"])(filtersLength_FiltersLength));
// EXTERNAL MODULE: ./client/components/icons/vocals.js
var vocals = __webpack_require__(155);

// CONCATENATED MODULE: ./client/components/filters/filtersVocals.js
var filtersVocals__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtersVocals__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function filtersVocals__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function filtersVocals__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var filtersVocals_FiltersVocals = function (_React$Component) {
  filtersVocals__inherits(FiltersVocals, _React$Component);

  function FiltersVocals(props) {
    filtersVocals__classCallCheck(this, FiltersVocals);

    var _this = filtersVocals__possibleConstructorReturn(this, (FiltersVocals.__proto__ || Object.getPrototypeOf(FiltersVocals)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  filtersVocals__createClass(FiltersVocals, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === keycode_default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        filtersAnalytics_reportOpenSearchFilterPanel('Vocals');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop;

      var parsedLocation = Object(urlHelper["parseLocation"])(location);
      var chosenVocals = parsedLocation.vocals_in_audio || '';

      var renderChosenVocals = function renderChosenVocals() {
        if (chosenVocals === '') {
          return react_default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return react_default.a.createElement(
                'li',
                { key: index },
                react_default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    titleize_default()(item.key)
                  ),
                  react_default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return react_default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            react_default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              react_default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenVocals.split(',').join(', ')
              )
            )
          );
        }
      };

      var panelHeaderClassNames = classnames_default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'is-active': showPanel
      });

      return react_default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'vocals-filter' },
        react_default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(vocals["a" /* default */], null),
            ' Vocals',
            react_default.a.createElement(
              'span',
              { style: { float: 'right' } },
              react_default.a.createElement(rightOpen["a" /* default */], null)
            )
          ),
          renderChosenVocals()
        ),
        showPanel && react_default.a.createElement(
          onKeyDown,
          { onKeyDown: this.onKeyDownHandler },
          react_default.a.createElement(
            clickOutside,
            { onClickOutside: this.togglePanel },
            react_default.a.createElement(multiSelect, {
              type: 'vocals_in_audio',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersVocals;
}(react_default.a.Component);

filtersVocals_FiltersVocals.propTypes = {
  location: prop_types_default.a.object.isRequired,
  items: prop_types_default.a.array
};

var FiltersVocalsComponent = filtersVocals_FiltersVocals;
/* harmony default export */ var filtersVocals = (Object(es["withRouter"])(filtersVocals_FiltersVocals));
// EXTERNAL MODULE: ./client/components/dropdown.tsx
var dropdown = __webpack_require__(65);
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown);

// CONCATENATED MODULE: ./client/components/filters/filtersDropdown.js
function filtersDropdown__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function filtersDropdown__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











var filtersDropdown_FiltersDropdown = function FiltersDropdown(_ref) {
  var name = _ref.name,
      label = _ref.label,
      location = _ref.location,
      history = _ref.history,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      _ref$ignoreOptions = _ref.ignoreOptions,
      ignoreOptions = _ref$ignoreOptions === undefined ? [] : _ref$ignoreOptions,
      _ref$prependShowAllOp = _ref.prependShowAllOption,
      prependShowAllOption = _ref$prependShowAllOp === undefined ? true : _ref$prependShowAllOp,
      isAtBottom = _ref.isAtBottom,
      isAtTop = _ref.isAtTop;

  var config = filterParamsConfig["default"][name];
  var id = name + '-filter';
  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  var chosenOption = parsedLocation[name] || '';
  var prependLabel = label + ': ';

  var prependActiveLabel = function prependActiveLabel(option) {
    return {
      value: option.value,
      label: chosenOption === option.value ? '' + prependLabel + option.label : option.label
    };
  };

  var filterIgnoredOptions = function filterIgnoredOptions(option) {
    return !ignoreOptions.includes(option.key);
  };

  var sortOptions = function sortOptions(opt1, opt2) {
    if (config.labels) {
      var keys = Object.keys(config.labels);
      return keys.indexOf(opt1.key) - keys.indexOf(opt2.key);
    }

    return opt1.key > opt2.key;
  };

  var applyLabels = function applyLabels(option) {
    var label = void 0;

    if (option.key) {
      label = config.labels && config.labels[option.key] || config.format && config.format(option.key) || option.key;
      label = option.count !== '' && option.count !== 0 ? label + ' - ' + Object(formatString["commaStyleString"])(option.count) : label;
    } else {
      label = 'Show All';
    }

    return {
      value: option.key,
      label: label
    };
  };

  // build the show all option
  var showAllOption = {
    count: '',
    description: null,
    key: ''
  };

  var options = (prependShowAllOption ? [showAllOption].concat(filtersDropdown__toConsumableArray(items)) : items).filter(filterIgnoredOptions).sort(sortOptions).map(applyLabels).map(prependActiveLabel);

  var onSelectionChange = function onSelectionChange(event) {
    var value = event.target.value;

    var newQuery = Object.assign({}, parsedLocation, filtersDropdown__defineProperty({}, name, value));
    delete newQuery.page;

    if (newQuery[name] === '') {
      delete newQuery[name];
    }

    history.push(Object(urlHelper["makeLink"])(newQuery));
  };

  var panelHeaderClassNames = classnames_default()('group-select', {
    '-border-top-none': !isAtTop,
    '-border-radius-none': !isAtBottom && !isAtTop,
    '-border-radius-bottom': isAtBottom,
    '-border-radius-top': isAtTop
  });

  var Icon = config.icon;

  return react_default.a.createElement(
    'div',
    { id: id },
    react_default.a.createElement(
      'div',
      { className: panelHeaderClassNames },
      react_default.a.createElement(
        'div',
        { className: 'search-facet-header' },
        react_default.a.createElement(
          'h2',
          null,
          react_default.a.createElement(Icon, null)
        )
      ),
      react_default.a.createElement(
        'label',
        { className: 'fds-u-is-visually-hidden', htmlFor: name },
        label
      ),
      react_default.a.createElement(dropdown_default.a, {
        name: name,
        options: options,
        onChange: onSelectionChange,
        value: chosenOption
      })
    )
  );
};

filtersDropdown_FiltersDropdown.propTypes = {
  name: prop_types_default.a.string.isRequired,
  label: prop_types_default.a.string.isRequired,
  location: prop_types_default.a.object.isRequired,
  history: prop_types_default.a.object.isRequired,
  items: prop_types_default.a.array,
  ignoreOptions: prop_types_default.a.array,
  isAtBottom: prop_types_default.a.bool,
  isAtTop: prop_types_default.a.bool
};

var FiltersDropdownComponent = filtersDropdown_FiltersDropdown;
/* harmony default export */ var filtersDropdown = (Object(es["withRouter"])(filtersDropdown_FiltersDropdown));
// EXTERNAL MODULE: ./node_modules/lodash/isUndefined.js
var isUndefined = __webpack_require__(701);
var isUndefined_default = /*#__PURE__*/__webpack_require__.n(isUndefined);

// CONCATENATED MODULE: ./client/components/filters/filtersBooleanBody.js







var filtersBooleanBody_FiltersBooleanBody = function FiltersBooleanBody(_ref) {
  var name = _ref.name,
      label = _ref.label,
      onChange = _ref.onChange,
      isChecked = _ref.isChecked,
      isAtTop = _ref.isAtTop,
      isAtBottom = _ref.isAtBottom,
      count = _ref.count,
      icon = _ref.icon;

  icon = icon || name;
  var id = name + '-filter';
  var boxClass = classnames_default()({
    'search-facet-box--start': isAtTop,
    'search-facet-box': !isAtTop && !isAtBottom,
    'search-facet-box--end': isAtBottom
  });

  return react_default.a.createElement(
    'div',
    { className: 'search-facet--no-margin', id: id },
    react_default.a.createElement(
      'div',
      { className: boxClass },
      react_default.a.createElement(
        'div',
        { className: 'search-facet-box__inner' },
        react_default.a.createElement(
          'h2',
          { className: 'search-facet-box__heading' },
          icon,
          ' ',
          label
        ),
        react_default.a.createElement(
          'label',
          { className: 'search-facet-boolean' },
          react_default.a.createElement('input', {
            type: 'checkbox',
            name: name,
            value: '1',
            checked: isChecked,
            onChange: onChange
          }),
          react_default.a.createElement(
            'span',
            { className: 'search-facet-boolean__label' },
            'Yes'
          ),
          !isUndefined_default()(count) && react_default.a.createElement(
            'span',
            { className: 'search-facet-result-count' },
            Object(formatString["commaStyleString"])(count)
          )
        )
      )
    )
  );
};

filtersBooleanBody_FiltersBooleanBody.propTypes = {
  name: prop_types_default.a.string.isRequired,
  label: prop_types_default.a.string.isRequired,
  onChange: prop_types_default.a.func.isRequired,
  isChecked: prop_types_default.a.bool.isRequired,
  icon: prop_types_default.a.element,
  isAtBottom: prop_types_default.a.bool,
  count: prop_types_default.a.number
};

/* harmony default export */ var filtersBooleanBody = (filtersBooleanBody_FiltersBooleanBody);
// CONCATENATED MODULE: ./client/components/filters/filtersBoolean.js








var filtersBoolean_FiltersBoolean = function FiltersBoolean(_ref) {
  var name = _ref.name,
      label = _ref.label,
      location = _ref.location,
      history = _ref.history,
      isAtTop = _ref.isAtTop,
      isAtBottom = _ref.isAtBottom,
      count = _ref.count;

  var config = filterParamsConfig["default"][name];
  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  var isChecked = !!parsedLocation[name];

  var onChange = function onChange(event) {
    var checkedValue = event.target.checked;
    var newQuery = Object.assign({}, parsedLocation);
    delete newQuery.page;

    if (checkedValue) {
      newQuery[name] = 1;
    } else {
      delete newQuery[name];
    }

    history.push(Object(urlHelper["makeLink"])(newQuery));
  };

  var Icon = config.icon;

  return react_default.a.createElement(filtersBooleanBody, {
    name: name,
    label: label,
    onChange: onChange,
    isChecked: isChecked,
    isAtTop: isAtTop,
    isAtBottom: isAtBottom,
    count: count,
    icon: react_default.a.createElement(Icon, null)
  });
};

filtersBoolean_FiltersBoolean.propTypes = {
  name: prop_types_default.a.string.isRequired,
  label: prop_types_default.a.string.isRequired,
  location: prop_types_default.a.object.isRequired,
  history: prop_types_default.a.object.isRequired,
  isAtTop: prop_types_default.a.bool,
  isAtBottom: prop_types_default.a.bool,
  count: prop_types_default.a.number
};

var FiltersBooleanComponent = filtersBoolean_FiltersBoolean;
/* harmony default export */ var filtersBoolean = (Object(es["withRouter"])(filtersBoolean_FiltersBoolean));
// CONCATENATED MODULE: ./client/components/icons/performingRightsOrganizations.js
var performingRightsOrganizations__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var performingRightsOrganizations = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    performingRightsOrganizations__extends({ viewBox: '0 0 100 100' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Performing-Rights-Organizations' },
      props.title || 'Performing-Rights-Organizations'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M90.2 53.7c-.8-1.9-.8-4 0-5.9l3.8-9.2c1.6-4-.3-8.3-4-10l-9.2-3.8c-1.9-1.1-3.2-2.4-4-4.6L73 11c-1.6-4-6.2-5.9-10-4.3l-9.2 3.8c-1.9.8-4 .8-5.9 0l-9.2-3.8c-4-1.6-8.3.3-10 4l-3.8 9.2c-.8 1.9-2.4 3.5-4.3 4l-9.4 4c-3.8 1.6-5.7 5.9-4 10l3.8 9.2c.8 1.9.8 4 0 5.9l-3.8 9.2c-1.6 4 .3 8.3 4 10l9.2 3.8c1.9.8 3.5 2.4 4 4.3l3.8 9.2c1.6 4 6.2 5.9 10 4.3l9.2-3.8c1.9-.8 4-.8 5.9 0l9.2 3.8c4 1.6 8.3-.3 10-4l3.8-9.2c.8-1.9 2.4-3.5 4.3-4l9.2-3.8c4-1.6 5.9-6.2 4.3-10l-3.9-9.1zm-20.5 9.8c.1 2.6-2 5.6-5.2 7.4-4.2 2.4-8.9 2.1-10.5-.7-1.6-2.8.5-6.9 4.7-9.3 2.4-1.3 5-1.9 7.1-1.5V39.6H42.5v24c0 2.6-2 5.5-5.2 7.3-4.2 2.4-8.9 2.1-10.5-.7-1.6-2.8.5-6.9 4.7-9.3 2.4-1.3 5-1.9 7.1-1.5V31h31.1v32.5z' })
    )
  );
});
// CONCATENATED MODULE: ./client/components/filters/filtersProMusic.js








var filtersProMusic_FiltersProMusic = function FiltersProMusic(_ref) {
  var location = _ref.location,
      history = _ref.history,
      isAtBottom = _ref.isAtBottom,
      count = _ref.count;

  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  var isChecked = parsedLocation.include_pro_affiliated !== 'false';

  var onChange = function onChange(event) {
    var checkedValue = event.target.checked;
    var newQuery = Object.assign({}, parsedLocation);
    delete newQuery.page;

    newQuery.include_pro_affiliated = !!checkedValue;

    history.push(Object(urlHelper["makeLink"])(newQuery));
  };

  return react_default.a.createElement(filtersBooleanBody, {
    name: 'include_pro_affiliated',
    label: 'Include P.R.O. Music',
    onChange: onChange,
    isChecked: isChecked,
    isAtBottom: isAtBottom,
    count: count,
    icon: react_default.a.createElement(performingRightsOrganizations, null)
  });
};

filtersProMusic_FiltersProMusic.propTypes = {
  location: prop_types_default.a.object.isRequired,
  history: prop_types_default.a.object.isRequired,
  isAtBottom: prop_types_default.a.bool,
  count: prop_types_default.a.number
};

var FiltersProMusicComponent = filtersProMusic_FiltersProMusic;
/* harmony default export */ var filtersProMusic = (Object(es["withRouter"])(filtersProMusic_FiltersProMusic));
// CONCATENATED MODULE: ./client/components/filters/searchFilters.js
var searchFilters__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















var searchFilters_SearchFilters = function SearchFilters(_ref) {
  var aggregations = _ref.aggregations,
      location = _ref.location,
      currentSite = _ref.currentSite;

  var basicFilters = [{
    Component: filtersCategory,
    isActive: !!Object(lodash["get"])(aggregations, 'category.length'),
    props: {
      categoryRootCount: Object(lodash["get"])(aggregations, 'category_root_count.count'),
      items: aggregations.category
    }
  }, {
    Component: filtersTags,
    isActive: !!Object(lodash["get"])(aggregations, 'tags.length'),
    props: {
      items: aggregations.tags
    }
  }, {
    Component: filtersPrice,
    isActive: true,
    props: {
      cost: aggregations.cost
    }
  }, {
    Component: filtersDropdown,
    isActive: true,
    props: {
      name: 'sales',
      label: 'Sales',
      ignoreOptions: ['varies'],
      items: aggregations.sales_count
    }
  }, {
    Component: filtersDropdown,
    isActive: Object(lodash["get"])(aggregations, 'rating.length') > 0,
    props: {
      name: 'rating_min',
      label: 'Rating',
      prependShowAllOption: false,
      items: aggregations.rating
    }
  }];

  var extraFilters = [{
    Component: filtersBoolean,
    isActive: Object(lodash["get"])(aggregations, 'hosting_setup.count') > 0,
    props: {
      name: 'hosting_setup',
      label: 'Hosting & Setup',
      count: Object(lodash["get"])(aggregations, 'hosting_setup.count')
    }
  }, {
    Component: filtersSoftwareVersion,
    isActive: Object(lodash["get"])(aggregations, 'platform.length') > 0,
    props: {
      items: aggregations.platform,
      platformRootCount: Object(lodash["get"])(aggregations, 'platform_root_count.count')
    }
  }, {
    Component: filtersCompatibleWith,
    isActive: Object(lodash["get"])(aggregations, 'compatible_with.length') > 0,
    props: {
      items: aggregations.compatible_with
    }
  }, {
    Component: filtersPolygons,
    isActive: aggregations.poly_count,
    props: {
      items: aggregations.poly_count
    }
  }, {
    Component: filtersFileType,
    isActive: Object(lodash["get"])(aggregations, 'file_formats.length') > 0,
    props: {
      items: aggregations.file_formats
    }
  }, {
    Component: filtersDropdown,
    isActive: Object(lodash["get"])(aggregations, 'orientation.length') > 0,
    props: {
      name: 'orientation',
      label: 'Orientation',
      items: aggregations.orientation
    }
  }, {
    Component: filtersDropdown,
    isActive: Object(lodash["get"])(aggregations, 'resolution.length') > 0,
    props: {
      name: 'resolution_min',
      label: 'Minimum resolution',
      items: aggregations.resolution
    }
  }, {
    Component: filtersDropdown,
    isActive: Object(lodash["get"])(aggregations, 'frame_rate.length') > 0,
    props: {
      name: 'frame_rate',
      label: 'Frame rate',
      items: aggregations.frame_rate
    }
  }, {
    Component: filtersDropdown,
    isActive: Object(lodash["get"])(aggregations, 'requires_plugins.length') > 0,
    props: {
      name: 'requires_plugins',
      label: 'Requires Plugins',
      items: aggregations.requires_plugins
    }
  }, {
    Component: filtersSize,
    isActive: Object(lodash["get"])(aggregations, 'size.length') > 0,
    props: {
      items: aggregations.size
    }
  }, {
    Component: filtersColors,
    isActive: Object(lodash["get"])(aggregations, 'colors.length') > 0,
    props: {
      items: aggregations.colors
    }
  }, {
    Component: filtersLength,
    isActive: !!aggregations.length,
    props: {
      length: aggregations.length
    }
  }, {
    Component: filtersVocals,
    isActive: Object(lodash["get"])(aggregations, 'vocals_in_audio.length') > 0,
    props: {
      items: aggregations.vocals_in_audio
    }
  }, {
    Component: filtersDropdown,
    isActive: Object(lodash["get"])(aggregations, 'tempo.length') > 0,
    props: {
      name: 'tempo',
      label: 'Tempo',
      ignoreOptions: ['varies'],
      items: aggregations.tempo
    }
  }, {
    Component: filtersBoolean,
    isActive: !!aggregations.alpha,
    props: {
      name: 'alpha',
      label: 'Alpha channel',
      count: Object(lodash["get"])(aggregations, 'alpha.count')
    }
  }, {
    Component: filtersBoolean,
    isActive: !!aggregations.looped,
    props: {
      name: 'looped',
      label: 'Looped',
      count: Object(lodash["get"])(aggregations, 'looped.count')
    }
  }, {
    Component: filtersProMusic,
    isActive: currentSite === 'audiojungle'
  }];

  var activeBasicFilters = basicFilters.filter(function (filter) {
    return filter.isActive;
  });
  var activeExtraFilters = extraFilters.filter(function (filter) {
    return filter.isActive;
  });

  return react_default.a.createElement(
    'div',
    {
      className: 'search-facet-panel',
      'data-test-selector': 'search-filters-default'
    },
    react_default.a.createElement(selectedFilters, { location: location, currentSite: currentSite }),
    react_default.a.createElement(
      'div',
      { className: 'search-facet fds-u-is-hidden--no-js' },
      activeBasicFilters.map(function (filter, index, list) {
        return react_default.a.createElement(filter.Component, searchFilters__extends({
          key: index,
          location: location,
          isAtTop: index === 0,
          isAtBottom: list.length === index + 1
        }, filter.props));
      })
    ),
    !!activeExtraFilters.length && react_default.a.createElement(
      'div',
      { className: 'search-facet fds-u-is-hidden--no-js' },
      activeExtraFilters.map(function (filter, index, list) {
        return react_default.a.createElement(filter.Component, searchFilters__extends({
          key: index,
          location: location,
          isAtTop: index === 0,
          isAtBottom: list.length === index + 1
        }, filter.props));
      })
    )
  );
};

searchFilters_SearchFilters.propTypes = {
  aggregations: prop_types_default.a.object,
  location: prop_types_default.a.object.isRequired,
  currentSite: prop_types_default.a.string
};

searchFilters_SearchFilters.defaultProps = {
  aggregations: {}
};

/* harmony default export */ var searchFilters = (searchFilters_SearchFilters);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(9);

// EXTERNAL MODULE: ./common/actions/user/preference.js
var preference = __webpack_require__(44);

// EXTERNAL MODULE: ./common/utils/item.js
var utils_item = __webpack_require__(28);

// EXTERNAL MODULE: ./config/sites/defaults.js
var defaults = __webpack_require__(100);

// EXTERNAL MODULE: ./config/sites/index.js + 7 modules
var sites = __webpack_require__(10);

// EXTERNAL MODULE: ./client/components/icons/sort.js
var icons_sort = __webpack_require__(150);

// CONCATENATED MODULE: ./client/pages/search/result/sortByDropdown.js
var sortByDropdown__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function sortByDropdown__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sortByDropdown__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sortByDropdown__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var searchQueryConfigs = defaults["a" /* default */]['search_query'];
var defaultSortByOptions = searchQueryConfigs['defalut_sort_by_options'];

/**
 * A sort by menu which has lots of business logic
 */

var sortByDropdown_SortByDropdown = function (_React$Component) {
  sortByDropdown__inherits(SortByDropdown, _React$Component);

  function SortByDropdown(props) {
    sortByDropdown__classCallCheck(this, SortByDropdown);

    var _this = sortByDropdown__possibleConstructorReturn(this, (SortByDropdown.__proto__ || Object.getPrototypeOf(SortByDropdown)).call(this, props));

    _this.onSortBySelectionChange = _this.onSortBySelectionChange.bind(_this);
    return _this;
  }

  sortByDropdown__createClass(SortByDropdown, [{
    key: 'getSelectSortByValue',
    value: function getSelectSortByValue(parsedLocation) {
      var sortOrder = void 0;

      if (parsedLocation.sort_by) {
        if (parsedLocation.sort_by === 'price' && parsedLocation.sort_direction) {
          sortOrder = 'price-' + parsedLocation.sort_direction;
        } else {
          sortOrder = parsedLocation.sort_by;
        }
      } else {
        if (parsedLocation.term) {
          sortOrder = 'relevance';
        } else {
          sortOrder = Object(sites["getConfigBySite"])(this.props.currentSite, 'search_query.defalut_sort_by');
        }
      }

      return sortOrder;
    }
  }, {
    key: 'onSortBySelectionChange',
    value: function onSortBySelectionChange(event) {
      var location = this.props.location;


      var parsedLocation = Object(urlHelper["parseLocation"])(location);

      var sort = event.target.value;
      var newQuery = Object.assign({}, parsedLocation, {
        sort: sort
      });
      delete newQuery.sort_by;
      delete newQuery.sort_direction;

      this.props.history.push(Object(urlHelper["makeLink"])(newQuery));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          currentSite = _props.currentSite;


      var parsedLocation = Object(urlHelper["parseLocation"])(location);

      var sortByOptions = Object(utils_item["filterSortByOptions"])(currentSite, parsedLocation, defaultSortByOptions);
      var selectedSortByValue = this.getSelectSortByValue(parsedLocation);

      // Append "Sort by:" to selected label
      var sortByOptionsWithLabel = sortByOptions.map(function (option) {
        if (option.value === selectedSortByValue) {
          return Object.assign({}, option, {
            label: 'Sort by: ' + option.label
          });
        } else {
          return option;
        }
      });

      return react_default.a.createElement(
        'div',
        { className: 'inline-select-wrapper' },
        react_default.a.createElement(
          'div',
          { className: 'search-facet-header--horizontal' },
          react_default.a.createElement(
            'h2',
            null,
            react_default.a.createElement(icons_sort["a" /* default */], { title: 'Sort by' })
          )
        ),
        react_default.a.createElement(
          'div',
          { className: '-border-top-none -border-radius-none inline-select' },
          react_default.a.createElement(
            'label',
            { htmlFor: 'sortby', className: 'fds-u-is-visually-hidden' },
            'Sort by:',
            ' '
          ),
          react_default.a.createElement(dropdown_default.a, {
            name: 'sortby',
            options: sortByOptionsWithLabel,
            onChange: this.onSortBySelectionChange,
            value: selectedSortByValue
          })
        )
      );
    }
  }]);

  return SortByDropdown;
}(react_default.a.Component);

sortByDropdown_SortByDropdown.propTypes = {
  location: prop_types_default.a.object.isRequired,
  currentSite: prop_types_default.a.string.isRequired
};


/* harmony default export */ var sortByDropdown = (Object(es["withRouter"])(sortByDropdown_SortByDropdown));
// CONCATENATED MODULE: ./client/components/icons/mute.js
var mute__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var mute = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    mute__extends({ viewBox: '0 0 18 18' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Mute' },
      props.title || 'Mute'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', {
        d: 'M9 1L6.91 3.09 9 5.18V1zM1.27 0L0 1.27 4.73 6H0v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L16.73 18 18 16.73l-9-9L1.27 0zM16 9c0 .94-.2 1.82-.54 2.64l1.51 1.51C17.63 11.91 18 10.5 18 9c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-2.5 0c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63z',
        fillRule: 'evenodd'
      })
    )
  );
});
// CONCATENATED MODULE: ./client/components/icons/unmute.js
var unmute__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var unmute = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    unmute__extends({ viewBox: '0 0 18 18' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Unmute' },
      props.title || 'Unmute'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', {
        d: 'M11 0v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77C18 4.49 15.01.91 11 0zm2.5 8.77c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM0 5.77v6h4l5 5v-16l-5 5H0z',
        fillRule: 'evenodd'
      })
    )
  );
});
// EXTERNAL MODULE: ./client/pages/search/result/muteSwitcher.module.css
var muteSwitcher_module = __webpack_require__(497);
var muteSwitcher_module_default = /*#__PURE__*/__webpack_require__.n(muteSwitcher_module);

// CONCATENATED MODULE: ./client/pages/search/result/muteSwitcher.js






var muteSwitcher_MuteSwitcher = function MuteSwitcher(_ref) {
  var muted = _ref.muted,
      _ref$onMute = _ref.onMute,
      onMute = _ref$onMute === undefined ? function () {} : _ref$onMute,
      _ref$onUnmute = _ref.onUnmute,
      onUnmute = _ref$onUnmute === undefined ? function () {} : _ref$onUnmute;
  return react_default.a.createElement(
    'div',
    null,
    muted ? react_default.a.createElement(
      'span',
      { className: muteSwitcher_module_default.a.iconContainer, onClick: onUnmute },
      react_default.a.createElement(mute, { width: '14', height: '14' }),
      react_default.a.createElement(
        'span',
        { className: muteSwitcher_module_default.a.iconLabel },
        'Unmute'
      )
    ) : react_default.a.createElement(
      'span',
      { className: muteSwitcher_module_default.a.iconContainer, onClick: onMute },
      react_default.a.createElement(unmute, { width: '14', height: '14' }),
      react_default.a.createElement(
        'span',
        { className: muteSwitcher_module_default.a.iconLabel },
        'Mute'
      )
    )
  );
};

/* harmony default export */ var muteSwitcher = (muteSwitcher_MuteSwitcher);
// EXTERNAL MODULE: ./client/components/usDollarsNotice/usDollarsNoticeContainer.js
var usDollarsNoticeContainer = __webpack_require__(63);

// EXTERNAL MODULE: ./client/components/icons/calendar.js
var calendar = __webpack_require__(151);

// EXTERNAL MODULE: ./client/components/layoutSwitcher/index.tsx
var layoutSwitcher = __webpack_require__(203);
var layoutSwitcher_default = /*#__PURE__*/__webpack_require__.n(layoutSwitcher);

// CONCATENATED MODULE: ./client/pages/search/result/searchResultHeader.js













var dateFilterLabels = ['Any date', 'In the last year', 'In the last month', 'In the last week', 'In the last day'];

var searchResultHeader_SearchResultHeader = function SearchResultHeader(_ref) {
  var currentSite = _ref.currentSite,
      location = _ref.location,
      date = _ref.date,
      preferences = _ref.preferences,
      history = _ref.history,
      setUserVideoPlayerStatus = _ref.setUserVideoPlayerStatus;

  var view = preferences.searchResultsViewType;
  var muted = preferences.searchVideoMuted;

  var query = location.query;

  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  var shouldShowVideoMuteSwitcher = currentSite === 'videohive';

  var onMute = function onMute() {
    return setUserVideoPlayerStatus(true);
  };
  var onUnmute = function onUnmute() {
    return setUserVideoPlayerStatus(false);
  };

  var onDateSelectionChange = function onDateSelectionChange(event) {
    var date = event.target.value;

    var newQuery = Object.assign({}, parsedLocation, {
      date: date
    });

    delete newQuery.page;

    if (newQuery.date === '') {
      delete newQuery.date;
    }

    history.push(Object(urlHelper["makeLink"])(newQuery));
  };

  var getSelectDateDefaultValue = function getSelectDateDefaultValue() {
    return parsedLocation.date || '';
  };

  var renderDateFilter = function renderDateFilter() {
    var selectedDateFilterIndex = date.map(function (d) {
      return d.key;
    }).indexOf(query.date || '');
    // build the date options
    var dateFilterOptions = date.map(function (d, index) {
      /**
       * The label will choose whether to show count based on the current selected date
       * if it's filtered by year, it will show all the count
       * if it's filtered by month, it will not show year count but all the others
       * same rule applies to week/day
       */
      var label = d.count && index >= selectedDateFilterIndex ? dateFilterLabels[index] + ' - ' + Object(formatString["commaStyleString"])(d.count) : dateFilterLabels[index];
      label = index === selectedDateFilterIndex ? 'Added: ' + label : label;
      return {
        value: d.key,
        label: label
      };
    });

    return react_default.a.createElement(
      'div',
      { className: 'inline-select-wrapper -hide-phone' },
      react_default.a.createElement(
        'div',
        { className: 'search-facet-header--horizontal' },
        react_default.a.createElement(
          'h2',
          null,
          react_default.a.createElement(calendar["a" /* default */], { title: 'Added' })
        )
      ),
      react_default.a.createElement(
        'div',
        { className: '-border-top-none -border-radius-none inline-select' },
        react_default.a.createElement(
          'label',
          { htmlFor: 'date', className: 'fds-u-is-visually-hidden' },
          'Added'
        ),
        react_default.a.createElement(dropdown_default.a, {
          name: 'date',
          options: dateFilterOptions,
          onChange: onDateSelectionChange,
          value: getSelectDateDefaultValue()
        })
      )
    );
  };

  return react_default.a.createElement(
    'div',
    {
      className: 'fds-u-is-hidden--no-js search-facet-horizontal-form',
      id: 'search-result-header'
    },
    react_default.a.createElement(sortByDropdown, { location: location, currentSite: currentSite }),
    renderDateFilter(),
    react_default.a.createElement(layoutSwitcher_default.a, {
      location: location,
      currentSite: currentSite,
      currentView: view
    }),
    shouldShowVideoMuteSwitcher && react_default.a.createElement(
      'div',
      { className: 'fds-u-diplay-inlineblock fds-u-pull-right fds-c-text-body -size-xs -weight-bold fds-u-mt1' },
      react_default.a.createElement(muteSwitcher, { muted: muted, onMute: onMute, onUnmute: onUnmute })
    ),
    react_default.a.createElement(usDollarsNoticeContainer["default"], null)
  );
};

searchResultHeader_SearchResultHeader.propTypes = {
  location: prop_types_default.a.object.isRequired,
  date: prop_types_default.a.array,
  view: prop_types_default.a.string,
  preferences: prop_types_default.a.object,
  usDollarsNotice: prop_types_default.a.string
};

searchResultHeader_SearchResultHeader.defaultProps = {
  date: []
};

var SearchResultHeaderComponent = searchResultHeader_SearchResultHeader;
/* harmony default export */ var searchResultHeader = (Object(es["withRouter"])(searchResultHeader_SearchResultHeader));
// CONCATENATED MODULE: ./client/pages/search/result/searchResultHeaderContainer.js





var mapStateToProps = function mapStateToProps(state) {
  var currentSite = state.common.currentSite,
      preferences = state.user.preferences;


  return {
    currentSite: currentSite,
    preferences: preferences
  };
};

var searchResultHeaderContainer_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setUserVideoPlayerStatus: function setUserVideoPlayerStatus(type) {
      return dispatch(Object(preference["setUserVideoPlayerStatus"])(type));
    }
  };
};

var SearchResultHeaderContainer = Object(react_redux_es["connect"])(mapStateToProps, searchResultHeaderContainer_mapDispatchToProps)(searchResultHeader);

/* harmony default export */ var searchResultHeaderContainer = (SearchResultHeaderContainer);
// EXTERNAL MODULE: ./client/pages/search/result/searchResultBody.js + 33 modules
var searchResultBody = __webpack_require__(204);

// CONCATENATED MODULE: ./client/components/icons/cactus.js
var cactus__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var cactus = (function (props) {
  return react_default.a.createElement(
    lib_default.a,
    cactus__extends({ viewBox: '0 0 512 512' }, props),
    react_default.a.createElement(
      'title',
      { id: 'Cactus' },
      props.title || 'Cactus'
    ),
    react_default.a.createElement(
      'g',
      null,
      react_default.a.createElement('path', { d: 'M413.9 220.4c-1.2-2.3-5.3-2.7-9.7-1-.2-5.7-.4-10.9-.5-15.4-.6-12.8-.9-20.1-.9-20.1-.2-4.2-1.2-8.2-2.8-11.8.6-.5 1.1-1.1 1.6-1.8 3.7-4.5 4.7-9.7 2.3-11.7-2.3-1.8-6.7 0-10.3 4-4.9-5.2-11.5-8.7-19-9.8v-.9c-.5-5.8-3.4-10.3-6.4-10-3.1.3-5.2 5.2-4.7 10.9v.1c-14.7 2.8-26 15.4-26.7 31 0 0-.2 5.5-.7 15.3-4.9-.5-9.1.9-9.6 3.6-.6 3 3.5 6.4 9.2 7.5-.2 5-.4 10.5-.6 16.7-.1 4.5-.3 9.2-.5 14.2-.1 1.8-.5 10.8-1.1 13.1-.4 2.8-1.2 6.9-2.3 10.9-.6 2-1.2 4-1.9 6-4.1-1.8-8-1.7-9.4.4-1.5 2.4.7 6.5 4.8 9.5-3.2 5.7-7.2 10.8-11.4 14.3-2.7 2-5.2 3.6-7.6 4.6-1.6.5-3 .9-4.5 1.1v-59.1l1.7-.4c5.5-1.7 9.3-5.5 8.4-8.4-.8-2.6-5.1-3.7-10-2.6v-117.2l2-.9c5.1-2.8 8-7.2 6.6-9.9-1.2-2.1-4.7-2.5-8.6-1.3v-48.2c0-5.1-.9-10-2.6-14.5l.6-.5c4.4-3.8 6.3-8.8 4.3-11.1-1.8-2.1-6.1-1.3-10.1 1.5-7.3-10.4-19.2-17.4-32.8-18.1-.7-5.4-3.4-9.5-6.3-9.3-2.9.3-4.9 4.7-4.7 10.1-15.1 3.2-27.3 14.3-31.9 28.9-4.8-1.6-9.2-1.1-10.3 1.5-1.2 2.8 2.1 7 7.4 9.3l1 .4c0 .6-.1 1.2-.1 1.7v100.1c-4.6-.4-8.4 1-9 3.5-.7 3 3.3 6.4 9 7.7v87.2h-.9l-5.4-.3c-1.3 0-1.1-.2-1-.2l.1-.1-.6-.2c-.5-.2-1.1-.3-1.7-.5-2.3-1-4.8-2.6-7.3-4.6-5.1-4.3-9.9-11-13.3-18.4-3.6-7.3-5.8-15.4-6.8-23.1-.1-.6-.2-1.2-.2-1.7 5.2-1.1 9-4.1 8.5-7-.4-2.7-4.4-4.3-9.3-4-.2-4.8-.3-9.3-.5-13.5-.4-8.9-.8-16.7-1.1-23.1-.4-7.5-.8-13.1-1-16.4.5-.1.9-.2 1.4-.4 5.5-1.9 9.1-5.8 8.1-8.7-1-2.8-5.9-3.6-11.1-2-3.5-11.6-13.1-20.6-25.4-23-.1-4.5-1.8-8-4.3-8.3-2.7-.4-5.5 3.1-6.6 7.9-14.1 2-25.6 13-28 27.3-4.7.6-8.3 2.8-8.3 5.4 0 2.5 3.1 4.6 7.4 5.3-.2 3.3-.4 7.6-.8 12.8-.2 4-.4 8.7-.7 13.8-5.5.2-10 2.6-10 5.5s4.1 5.2 9.4 5.5c-.1 3.9-.3 8.1-.5 12.4-.1 2.2-.1 5.5 0 9 .1 3.4 0 6.8.4 10.3.4 5 1.1 10.1 2 15.4-4.9 1.1-8.4 3.9-8 6.7.4 2.9 5 4.6 10.3 4.1 1.6 6.3 3.5 12.6 6.1 19.1 3.6 8.5 8.1 17.1 14 25.5-4.4 2.5-7 6.2-5.9 8.7 1.3 2.8 6.6 3.1 11.9.7l.8-.4c3.3 3.9 6.9 7.7 10.9 11.3 7.8 6.9 17 13.1 27.7 17.8 2.7 1.2 5.5 2.1 8.3 3 1.4.5 2.7.9 4.3 1.4l5.4 1.2 5.4 1c1.9.3 3.8.6 4.3.6l5.4.4 3.9.1h2.0999999999999996v58c-4.9-.6-9 .8-9.6 3.5-.7 3 3.4 6.5 9.1 7.7.2 0 .4.1.5.1v70.2c-3.2.3-5.7 1.6-6.1 3.6-.5 2.4 2.1 5.2 6.1 6.8v33.2h85.4v-71.9l.3-.1c5.5-1.7 9.3-5.5 8.4-8.4-.8-2.4-4.4-3.5-8.7-2.8v-51.3c11.9-.4 23.4-3.2 33.8-7.5 3.4-1.5 6.6-3.2 9.6-4.9v.1c3.5 4.7 8.3 7 10.7 5.1 2.4-1.8 1.7-6.7-1.5-11.2 3-2.2 5.9-4.4 8.5-6.8 15.2-14 24.8-30.1 31.3-45.6 1.3-3.1 2.4-6.2 3.4-9.2 5.1 2.3 10.2 2.1 11.5-.6 1.3-2.8-1.8-7.1-7-9.6l-1.3-.6.8-3.1c1.6-7.5 2.8-14.7 3.4-22.8.6-8.6.3-10.1.3-18.3-.1-3.5-.2-6.7-.3-9.9.8-.3 1.7-.6 2.6-1.1 6-2.9 9-7.3 7.5-10z' })
    )
  );
});
// CONCATENATED MODULE: ./client/pages/search/result/searchNoResults.js







var searchNoResults_SearchNoResults = function SearchNoResults(_ref) {
  var location = _ref.location;

  var renderClearFiltersLink = function renderClearFiltersLink() {
    var link = react_default.a.createElement(
      es["Link"],
      {
        to: Object(urlHelper["makeLink"])(Object(urlHelper["queryWithoutFilters"])(location)),
        className: 'fds-c-text-link -decoration-reversed'
      },
      'clearing your filters'
    );

    return react_default.a.createElement(
      'span',
      null,
      'Try ',
      link,
      '.'
    );
  };

  return react_default.a.createElement(
    'div',
    { className: 'fds-c-box -background-light fds-u-mb2 fds-u-p2' },
    react_default.a.createElement(
      'div',
      { className: 'search-no-results' },
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(cactus, { width: '100', height: '150' })
      ),
      react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(
          'h2',
          { className: 'fds-c-text-heading -size-xs' },
          'You\'ve ventured too far out into the desert!',
          ' ',
          urlHelper["activeFiltersParams"].length ? renderClearFiltersLink() : 'Time to head back'
        ),
        react_default.a.createElement(
          'p',
          { className: 'fds-c-text-body' },
          Object(urlHelper["activeFiltersParams"])(location).length ? "We couldn't find any results for your search within the filters you've set." : "We couldn't find any results for your search. Use more generic words or double check your spelling."
        )
      )
    )
  );
};

searchNoResults_SearchNoResults.propTypes = {
  location: prop_types_default.a.object
};

/* harmony default export */ var searchNoResults = (searchNoResults_SearchNoResults);
// EXTERNAL MODULE: ./client/pages/search/result/relatedSearches.tsx
var result_relatedSearches = __webpack_require__(205);
var relatedSearches_default = /*#__PURE__*/__webpack_require__.n(result_relatedSearches);

// EXTERNAL MODULE: ./client/components/banners/elementsBanner.tsx
var elementsBanner = __webpack_require__(499);
var elementsBanner_default = /*#__PURE__*/__webpack_require__.n(elementsBanner);

// EXTERNAL MODULE: ./client/components/banners/studioRecommendationsBanner.tsx
var studioRecommendationsBanner = __webpack_require__(500);
var studioRecommendationsBanner_default = /*#__PURE__*/__webpack_require__.n(studioRecommendationsBanner);

// EXTERNAL MODULE: ./client/components/pagination/pagination.js + 1 modules
var pagination = __webpack_require__(206);

// EXTERNAL MODULE: ./client/components/banners/crossPromoBanner.js + 1 modules
var crossPromoBanner = __webpack_require__(207);

// CONCATENATED MODULE: ./client/pages/search/searchContentSection.js
















var searchContentSection_SearchContentSection = function SearchContentSection(_ref) {
  var user = _ref.user,
      baseUrl = _ref.baseUrl,
      results = _ref.results,
      location = _ref.location,
      loading = _ref.loading,
      currentSite = _ref.currentSite,
      relatedSearches = _ref.relatedSearches,
      studioRecommendations = _ref.studioRecommendations;

  var shouldShowRecommendedSearches = !loading && relatedSearches && relatedSearches.recommendations.length > 0;

  var totalHits = results.total_hits;
  var matches = results.matches;
  var aggregations = Object(lodash["get"])(results, 'aggregations');
  var haveResults = !!(matches && matches.length);
  var shouldShowPagination = totalHits > 0;
  var flattenLocation = Object(urlHelper["getFlattenLocation"])(location);
  var pageSize = Object(sites["getConfigBySite"])(currentSite, 'common.search_page_size');
  var maxPagesCount = Object(sites["getConfigBySite"])(currentSite, 'common.max_pages_count');
  var parsedLocation = Object(urlHelper["parseLocation"])(location);
  var currentCategory = parsedLocation.category;
  var viewType = Object(lodash["get"])(user, 'preferences.searchResultsViewType');

  var containerClassNames = classnames_default()('grid-container', {
    '-layout-videohive': currentSite === 'videohive' && viewType === 'grid'
  });

  return react_default.a.createElement(
    'div',
    { className: containerClassNames },
    react_default.a.createElement(
      'aside',
      { className: 'sidebar-s -size-fixed-tablet fds-u-hide-small-and-below' },
      react_default.a.createElement(searchFilters, {
        aggregations: aggregations,
        location: flattenLocation,
        currentSite: currentSite
      }),
      react_default.a.createElement(crossPromoBanner["default"], {
        currentSite: currentSite,
        currentCategory: currentCategory
      })
    ),
    react_default.a.createElement(
      'div',
      { className: 'content-l -size-scale-tablet content-right' },
      react_default.a.createElement(searchResultHeaderContainer, {
        date: Object(lodash["get"])(aggregations, 'date'),
        location: location
      }),
      haveResults ? react_default.a.createElement(searchResultBody["default"], { location: location, matches: matches }) : react_default.a.createElement(searchNoResults, { location: location }),
      shouldShowRecommendedSearches && react_default.a.createElement(relatedSearches_default.a, relatedSearches),
      shouldShowPagination && react_default.a.createElement(pagination["default"], {
        currentPage: Number(location.query.page) || 1,
        currentSite: currentSite,
        totalItemsCount: totalHits,
        pageSize: pageSize,
        location: location,
        baseUrl: baseUrl,
        maxPagesCount: maxPagesCount
      }),
      haveResults && react_default.a.createElement(elementsBanner_default.a, { currentSite: currentSite }),
      haveResults && react_default.a.createElement(studioRecommendationsBanner_default.a, {
        config: studioRecommendations,
        currentSite: currentSite,
        category: parsedLocation.category,
        term: parsedLocation.term
      })
    )
  );
};

/* harmony default export */ var searchContentSection = __webpack_exports__["default"] = (searchContentSection_SearchContentSection);

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"muteSwitcher-module_iconContainer_2lKEi","iconLabel":"muteSwitcher-module_iconLabel_CJtFY"};

/***/ }),
/* 498 */,
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SiteShortNameMap = {
    themeforest: 'tf',
    codecanyon: 'cc',
    videohive: 'vh',
    audiojungle: 'aj',
    graphicriver: 'gr',
    photodune: 'pd',
    '3docean': '3d'
};
var redirectUrl = function (site) {
    if (SiteShortNameMap[site]) {
        return "https://elements.envato.com/all-items/?utm_campaign=elements_mkt-search_26JUNE2017&amp;utm_content=" + SiteShortNameMap[site] + "_search-results&amp;utm_medium=promos&amp;utm_source=" + site + ".net";
    }
    else {
        return 'https://elements.envato.com/all-items';
    }
};
var ElementsBanner = function (_a) {
    var currentSite = _a.currentSite;
    return (React.createElement("div", { className: "elements-promo fds-u-mb4" },
        React.createElement("div", { className: "elements-promo__copy-wrapper" },
            React.createElement("div", { className: "elements-promo__content" },
                React.createElement("a", { className: "elements-promo__logo-white", href: redirectUrl(currentSite) }, "Envato Elements"),
                React.createElement("h2", { className: "elements-heading fds-c-text-heading -size-l fds-u-mb0" }, "Deliver better projects faster"),
                React.createElement("p", { className: "elements-heading fds-c-text-body fds-u-mb0" }, "Unlimited photos, web templates, graphic assets & courses."),
                React.createElement("div", { className: "elements-promo__button-wrapper" },
                    React.createElement("a", { className: "elements-promo__button", href: redirectUrl(currentSite) }, "View all"))))));
};
exports.default = ElementsBanner;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var queryString = __webpack_require__(22);
var React = __webpack_require__(0);
var StudioRecommendationsBanner = function (_a) {
    var config = _a.config, currentSite = _a.currentSite, category = _a.category, term = _a.term;
    var items = config.items;
    var generation = config.generation;
    var getLinkParams = function (itemId) {
        var params = {
            utm_campaign: 'shervinator',
            utm_source: 'marketplace',
            utm_medium: currentSite,
            utm_term: category || term,
            utm_content: generation + "_" + items.map(function (item) { return item.id; }).join('_') + "_" + itemId
        };
        var queries = queryString.stringify(params);
        return queries;
    };
    return (React.createElement("div", { className: "studio-recommendations fds-u-mb4 fds-u-p1" },
        React.createElement("a", { className: "studio-recommendations__logo fds-u-m1 fds-u-mb2", href: "https://studio.envato.com/" }),
        React.createElement("div", { className: "studio-recommendations__list" },
            React.createElement("ul", { className: "fds-c-text-list -style-none" }, items.map(function (item) { return (React.createElement("li", { className: "fds-c-text-body fds-u-m1", key: item.id },
                React.createElement("a", { href: item.url + '?' + getLinkParams(item.id), className: "fds-c-text-link -decoration-reversed" }, item.name),
                ' ',
                "from $",
                item.price_from)); })))));
};
exports.default = StudioRecommendationsBanner;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"searchpage-module_button_137oG","-theme-3docean":"searchpage-module_-theme-3docean_3l3cC","-theme-photodune":"searchpage-module_-theme-photodune_3ziBW","-theme-graphicriver":"searchpage-module_-theme-graphicriver_353eu","-theme-audiojungle":"searchpage-module_-theme-audiojungle_3cbxp","-theme-videohive":"searchpage-module_-theme-videohive_kmb4h","-theme-codecanyon":"searchpage-module_-theme-codecanyon_NreME","-theme-themeforest":"searchpage-module_-theme-themeforest_3km2d","input":"searchpage-module_input_TqHQX","mainWrapper":"searchpage-module_mainWrapper_2kaTp","wrapper":"searchpage-module_wrapper_2POoE","suggestions":"searchpage-module_suggestions_3BqPe","separator":"searchpage-module_separator_1-34N","focusedListItem":"searchpage-module_focusedListItem_3Z6SO","suggestionText":"searchpage-module_suggestionText_12Aq2","categoryText":"searchpage-module_categoryText_3Z0A6","highlightedText":"searchpage-module_highlightedText_2GQlq"};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    mainContainer: 'search-header__results-count fds-u-pt2',
    seoHeading: 'fds-c-text-heading -color-light -size-xs h-remove-margin -weight-normal',
    seoSubHeading: 'fds-c-text-heading -color-light -size-xs -weight-normal fds-u-hide-small-and-below',
    seoFinePrint: 'search-header__fine-print fds-c-text-heading -color-light -weight-normal',
    suggestionsContainer: 'search-header__extras',
    authorText: 'author-search-result'
};


/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pageSectionForm":"searchpage-module_pageSectionForm_HXWEV"};

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchHeaderSection":"searchPage-module_searchHeaderSection_NM7-_"};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var localStorageHelpers_1 = __webpack_require__(43);
var themeforestEaseOfUseSurvey_1 = __webpack_require__(506);
var experiment_1 = __webpack_require__(172);
var variant_1 = __webpack_require__(173);
var RenderSurvey = function (props) {
    var location = props.location, currentSite = props.currentSite;
    var cache = {
        get: function (cacheKey) { return localStorageHelpers_1.getLocalStorageItem(cacheKey); },
        set: function (cacheKey, variantId) {
            return localStorageHelpers_1.setLocalStorageItem(cacheKey, variantId);
        }
    };
    if (props.currentSite === 'themeforest') {
        return (React.createElement(experiment_1.default, { id: "XHbr8E-VSVeHER8HvTH5gQ", location: location, cache: cache, defaultVariantId: 0, forcedVariantId: location.query.variant && parseInt(location.query.variant, 10) },
            React.createElement(variant_1.default, { variantId: 0 },
                React.createElement(themeforestEaseOfUseSurvey_1.default, { currentSite: currentSite, surveyUrl: "https://www.surveymonkey.com/r/55YD5HT" })),
            React.createElement(variant_1.default, { variantId: 1 },
                React.createElement(themeforestEaseOfUseSurvey_1.default, { currentSite: currentSite, surveyUrl: "https://www.surveymonkey.com/r/55YD5HT" })),
            React.createElement(variant_1.default, { variantId: 2 },
                React.createElement(themeforestEaseOfUseSurvey_1.default, { currentSite: currentSite, surveyUrl: "https://www.surveymonkey.com/r/NBSBSC7" })),
            React.createElement(variant_1.default, { variantId: 3 },
                React.createElement(themeforestEaseOfUseSurvey_1.default, { currentSite: currentSite, surveyUrl: "https://www.surveymonkey.com/r/NBSBSC7" })),
            React.createElement(variant_1.default, { variantId: 4 },
                React.createElement(themeforestEaseOfUseSurvey_1.default, { currentSite: currentSite, surveyUrl: "https://www.surveymonkey.com/r/NBNMN7Z" })),
            React.createElement(variant_1.default, { variantId: 5 },
                React.createElement(themeforestEaseOfUseSurvey_1.default, { currentSite: currentSite, surveyUrl: "https://www.surveymonkey.com/r/NBNMN7Z" }))));
    }
    else {
        return null;
    }
};
exports.default = RenderSurvey;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var trackSearchCount_1 = __webpack_require__(94);
var searchSurveyBanner_1 = __webpack_require__(507);
var ThemeforestEaseOfUseSurvey = function (props) {
    var currentSite = props.currentSite, surveyUrl = props.surveyUrl;
    var shouldShowBanner = props.currentSite === 'themeforest' && trackSearchCount_1.searchesCount('themeforest') > 3;
    if (!shouldShowBanner) {
        return null;
    }
    return (React.createElement("div", { className: "tfEaseOfSurveyContainer" },
        React.createElement(searchSurveyBanner_1.default, { siteId: "tf", surveyUrl: props.surveyUrl, bannerText: "How's your search going? Rewarding? Frustrating? We'd love to know." })));
};
exports.default = ThemeforestEaseOfUseSurvey;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var surveyBannerAnalytics_1 = __webpack_require__(508);
var localStorageHelpers_1 = __webpack_require__(43);
var close_1 = __webpack_require__(39);
var ok_1 = __webpack_require__(40);
var styles = __webpack_require__(509);
var SurveyLink = function (_a) {
    var onClick = _a.onClick, surveyUrl = _a.surveyUrl, bannerText = _a.bannerText;
    var classNames = styles.surveyText + " fds-u-hide-medium-and-above";
    return (React.createElement("a", { onClick: onClick, href: surveyUrl, target: "_blank", className: classNames }, bannerText));
};
var SurveyButton = function (_a) {
    var onClick = _a.onClick, surveyUrl = _a.surveyUrl;
    var classNames = "fds-u-hide-medium-and-below fds-c-button--3d -color-primary";
    return (React.createElement("a", { onClick: onClick, href: surveyUrl, target: "_blank", className: classNames }, "Share your experience"));
};
var SearchSurveyBanner = /** @class */ (function (_super) {
    __extends(SearchSurveyBanner, _super);
    function SearchSurveyBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.onDismiss = function (event) {
            event.preventDefault();
            _this.dismiss();
        };
        _this.onStartSurvey = function (event) {
            surveyBannerAnalytics_1.reportStartSurveyClick(_this.gaLabel());
            _this.dismiss();
        };
        _this.state = { dismissed: _this.isDismissed() };
        return _this;
    }
    SearchSurveyBanner.prototype.componentDidMount = function () {
        if (!this.state.dismissed) {
            surveyBannerAnalytics_1.reportViewSurveyBanner(this.gaLabel());
        }
    };
    SearchSurveyBanner.prototype.render = function () {
        var _a = this.props, surveyUrl = _a.surveyUrl, bannerText = _a.bannerText;
        if (this.state.dismissed) {
            return null;
        }
        // Search Survey Banner temporarily uses Alert styles until there is a Survey Component in Design System.
        // Alert styles should be replaced with appropriate Survey Component styles by Sept 2017
        return (React.createElement("div", { className: "grid-container" },
            React.createElement("div", { className: "fds-c-alert-box " + styles.backgroundDark + " fds-u-mt2 -type-success" },
                React.createElement("div", { className: "fds-c-alert-box__icon" },
                    React.createElement(ok_1.default, null)),
                React.createElement("div", { className: "fds-c-alert-box__message" },
                    React.createElement("div", { className: "fds-c-text-body -size-s fds-u-m0" },
                        React.createElement("p", { className: styles.surveyText },
                            React.createElement("span", { className: "fds-u-hide-medium-and-below" }, bannerText),
                            React.createElement(SurveyLink, { onClick: this.onStartSurvey, surveyUrl: surveyUrl, bannerText: bannerText })))),
                React.createElement(SurveyButton, { onClick: this.onStartSurvey, surveyUrl: surveyUrl }),
                React.createElement("span", { onClick: this.onDismiss, className: styles.surveyDismissIcon },
                    React.createElement(close_1.default, null)))));
    };
    SearchSurveyBanner.prototype.localStorageKey = function () {
        return this.props.siteId + "-search-survey-banner-visibility";
    };
    SearchSurveyBanner.prototype.gaLabel = function () {
        return this.props.siteId.toUpperCase() + " Search Survey";
    };
    SearchSurveyBanner.prototype.dismiss = function () {
        localStorageHelpers_1.setLocalStorageItem(this.localStorageKey(), 'hidden');
        this.setState({ dismissed: true });
    };
    SearchSurveyBanner.prototype.isDismissed = function () {
        return localStorageHelpers_1.getLocalStorageItem(this.localStorageKey(), 'visible') === 'hidden';
    };
    return SearchSurveyBanner;
}(React.Component));
exports.default = SearchSurveyBanner;


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportViewSurveyBanner", function() { return reportViewSurveyBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportStartSurveyClick", function() { return reportStartSurveyClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(13);


var reportViewSurveyBanner = function reportViewSurveyBanner(surveyName) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Survey', 'View', surveyName, { nonInteraction: true });
};

var reportStartSurveyClick = function reportStartSurveyClick(surveyName) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["default"])('send', 'event', 'Survey', 'click', surveyName);
};

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backgroundDark":"searchSurveyBanner-module_backgroundDark_2g__D","surveyText":"searchSurveyBanner-module_surveyText_JELCg","surveyDismissIcon":"searchSurveyBanner-module_surveyDismissIcon_FbkfA"};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = __webpack_require__(9);
var fetchNewestItemsByCategory_1 = __webpack_require__(142);
var homePage_1 = __webpack_require__(143);
var preference_1 = __webpack_require__(44);
var searchResults_1 = __webpack_require__(109);
var mapStateToProps = function (state) {
    var currentSite = state.common.currentSite, _a = state.user, isSignedIn = _a.isSignedIn, preferences = _a.preferences, _b = state.homePage, newestItemMatches = _b.newestItems, metadata = _b.metadata, newestItemsCategory = _b.newestItemsCategory, newestItemsPendingCategory = _b.newestItemsPendingCategory, featuredItemsMatches = _b.featuredItems;
    var newestItems = [];
    var featuredItems = [];
    var loadingCachedCategory = false;
    if (newestItemMatches) {
        var newestItemMatchesForPendingCategory = newestItemsPendingCategory &&
            newestItemMatches[newestItemsPendingCategory];
        loadingCachedCategory = !!newestItemMatchesForPendingCategory;
        var newestItemMatchesForCategory = newestItemMatchesForPendingCategory ||
            newestItemMatches[newestItemsCategory];
        newestItems =
            (newestItemMatchesForCategory &&
                newestItemMatchesForCategory.matches.map(function (match) {
                    return searchResults_1.decorateSearchResult(state, match);
                })) ||
                [];
        featuredItems =
            (featuredItemsMatches &&
                featuredItemsMatches.matches.map(function (match) {
                    return searchResults_1.decorateSearchResult(state, match);
                })) ||
                [];
    }
    return {
        currentSite: currentSite,
        metadata: metadata,
        isSignedIn: isSignedIn,
        newestItemsData: {
            loadingCachedCategory: loadingCachedCategory,
            items: newestItems,
            itemsCategory: newestItemsCategory,
            itemsPendingCategory: newestItemsPendingCategory
        },
        featuredItems: featuredItems,
        preferences: preferences
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        fetchNewestItemsByCategory: function (category) {
            return dispatch(fetchNewestItemsByCategory_1.fetchNewestItemsByCategory(category));
        },
        muteVideo: function () { return dispatch(preference_1.setUserVideoPlayerStatus(true)); }
    };
};
var createHomePageContainer = function (component) {
    var pageComponent = component;
    pageComponent.loadData = function (store, parsedUrl, opts) {
        return store.dispatch(homePage_1.fetchHomePageDataBySite(parsedUrl, opts));
    };
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(pageComponent);
};
exports.default = createHomePageContainer;


/***/ }),
/* 511 */,
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(364);
module.exports = __webpack_require__(906);


/***/ }),
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_dom_1 = __webpack_require__(97);
var react_hot_loader_1 = __webpack_require__(392);
var configureStore_1 = __webpack_require__(216);
var legacyAffiliates_1 = __webpack_require__(253);
var app_1 = __webpack_require__(419);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(317);
// this only runs on initial hydrating
var initialState = window.INITIAL_STATE;
delete window.INITIAL_STATE;
var store = configureStore_1.default(initialState);
legacyAffiliates_1.default(window.location);
react_dom_1.hydrate(React.createElement(react_hot_loader_1.AppContainer, null,
    React.createElement(app_1.default, { store: store })), document.querySelector('#react-view'));
if (false) {
    module.hot.accept('./app', function () {
        var NewApp = require('./app').default;
        react_dom_1.hydrate(React.createElement(react_hot_loader_1.AppContainer, null,
            React.createElement(NewApp, { store: store })), document.querySelector('#react-view'));
    });
}


/***/ })
],[704]);


// WEBPACK FOOTER //
// v0-71a05232586afd351ea5.js